angular.module('adminApp', ['rms.common']);
angular.module('jmsApp', ['rms.common']);
angular.module('recruiterPalApp', ['rms.common']);

angular.module('rms.common', ['sodCommon', 'ngRoute', 'ui.tinymce']);



angular.module('rmsApp', ['rms.common']);

angular.module('tmsApp', ['rms.common']);
(function () {
    'use strict';

    HttpInterceptor.$inject = ['$q', '$window', '$log', 'lodash', '$location', '$injector'];
    angular
        .module('rms.common')
        .factory('HttpInterceptor', HttpInterceptor)
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('HttpInterceptor');
        }]);

    function HttpInterceptor($q, $window, $log, lodash, $location, $injector) {
        return {
            responseError: function(error) {
                if (error.status === 401) {
                    const DialogManager = $injector.get('DialogManager');
                    const PanelManager = $injector.get('PanelManager');
                    $q.when([
                        DialogManager.destroyAll(),
                        PanelManager.destroyAll()
                    ]).then(function() {
                        var redirect_destination = lodash.get(error, 'data.actions.redirect.destination', null);
                        if (!redirect_destination) {
                            $window.location.reload();
                        } else {
                            $location.path(error.data.actions.redirect.destination);
                        }
                        return $q.reject(error);
                    });
                } else {
                    console.log('responseError', error);
                    return $q.reject(error);
                }
            }
        }
    }
})();
(function() {
    'use strict';

    runFunc.$inject = ['$q', '$rootScope', 'Path'];
    angular
        .module('adminApp')
        .run(runFunc);

    //function runFunc($templateCache, $http, $q, $rootScope, Path, MasterLayoutService) {
    function runFunc($q, $rootScope,Path) {
        // $q.defer() allow us to delay processing until they are done processing.
        $rootScope.initPortalLoader = $q.defer();
        //var masterTemplateDataDefer = $q.defer();

        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/admin/structure/', '/api');
        $rootScope.initPortalLoader.resolve();

        //var navUrl = '/api/admin/rms/structure/navbar';
        //Path.setMasterLayoutDataPath(navUrl);
        //$http.get(navUrl).then(function (res) {
        //    if (res.data.success) {
        //        MasterLayoutService.set(res.data.structure);
        //    }
        //    masterTemplateDataDefer.resolve();
        //}, function () {
        //    masterTemplateDataDefer.resolve();
        //});
        //
        //$q.all([masterTemplateDataDefer.promise]).then(function () {
        //    $rootScope.initPortalLoader.resolve();
        //});

    }
})();
(function() {
    'use strict';

    configFunc.$inject = ['RmsEnumProvider'];
    runFunc.$inject = ['$q', '$rootScope', 'Path'];
    angular
        .module('jmsApp')
        .config(configFunc)
        .run(runFunc);
    function runFunc($q, $rootScope,Path) {
        $rootScope.initPortalLoader = $q.defer();
        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/jms/structure/', '/api');
        $rootScope.initPortalLoader.resolve();
    }
    function configFunc(RmsEnumProvider) {
        RmsEnumProvider.changePath('/api/v1/app/form/enum/getEnum/');
    }
})();
(function() {
    'use strict';

    runFunc.$inject = ['$q', '$rootScope', 'Path'];
    angular
        .module('recruiterPalApp')
        .run(runFunc);

    //function runFunc($templateCache, $http, $q, $rootScope, Path, MasterLayoutService) {
    function runFunc($q, $rootScope,Path) {
        // $q.defer() allow us to delay processing until they are done processing.
        $rootScope.initPortalLoader = $q.defer();
        //var masterTemplateDataDefer = $q.defer();

        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/recruiterpal/structure/', '/api');
        $rootScope.initPortalLoader.resolve();

        //var navUrl = '/api/admin/rms/structure/navbar';
        //Path.setMasterLayoutDataPath(navUrl);
        //$http.get(navUrl).then(function (res) {
        //    if (res.data.success) {
        //        MasterLayoutService.set(res.data.structure);
        //    }
        //    masterTemplateDataDefer.resolve();
        //}, function () {
        //    masterTemplateDataDefer.resolve();
        //});
        //
        //$q.all([masterTemplateDataDefer.promise]).then(function () {
        //    $rootScope.initPortalLoader.resolve();
        //});

    }
})();
(function() {
    'use strict';

    runFunc.$inject = ['$q', '$rootScope', 'Path'];
    angular
        .module('rmsApp')
        .run(runFunc);

    //function runFunc($templateCache, $http, $q, $rootScope, Path, MasterLayoutService) {
    function runFunc($q, $rootScope,Path) {
        // $q.defer() allow us to delay processing until they are done processing.
        $rootScope.initPortalLoader = $q.defer();
        //var masterTemplateDataDefer = $q.defer();

        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/rms/structure/', '/api');
        $rootScope.initPortalLoader.resolve();

        //var navUrl = '/api/admin/rms/structure/navbar';
        //Path.setMasterLayoutDataPath(navUrl);
        //$http.get(navUrl).then(function (res) {
        //    if (res.data.success) {
        //        MasterLayoutService.set(res.data.structure);
        //    }
        //    masterTemplateDataDefer.resolve();
        //}, function () {
        //    masterTemplateDataDefer.resolve();
        //});
        //
        //$q.all([masterTemplateDataDefer.promise]).then(function () {
        //    $rootScope.initPortalLoader.resolve();
        //});

    }
})();
(function() {
    'use strict';
    configFunc.$inject = ['$routeProvider', '$locationProvider'];
    angular
        .module('rms.common')
        .config(configFunc);

    function configFunc($routeProvider, $locationProvider) {
        $routeProvider
            .when('/*', {
                template: '<div layout-generator="layoutGenerator"></div>',
                resolve: {
                    load: function() {
                    }
                }
            });
        $locationProvider.html5Mode(true);
    }
})();
(function() {
    'use strict';

    configFunc.$inject = ['RmsEnumProvider'];
    runFunc.$inject = ['$q', '$rootScope', 'Path'];
    angular
        .module('tmsApp')
        .config(configFunc)
        .run(runFunc);

    //function runFunc($templateCache, $http, $q, $rootScope, Path, MasterLayoutService) {
    function runFunc($q, $rootScope,Path) {
        // $q.defer() allow us to delay processing until they are done processing.
        $rootScope.initPortalLoader = $q.defer();
        //var masterTemplateDataDefer = $q.defer();

        angular.element('.no-js-wrapper').remove();
        Path.init('/api/admin/tms/structure/', '/api');
        $rootScope.initPortalLoader.resolve();

        //var navUrl = '/api/admin/rms/structure/navbar';
        //Path.setMasterLayoutDataPath(navUrl);
        //$http.get(navUrl).then(function (res) {
        //    if (res.data.success) {
        //        MasterLayoutService.set(res.data.structure);
        //    }
        //    masterTemplateDataDefer.resolve();
        //}, function () {
        //    masterTemplateDataDefer.resolve();
        //});
        //
        //$q.all([masterTemplateDataDefer.promise]).then(function () {
        //    $rootScope.initPortalLoader.resolve();
        //});

    }

    function configFunc(RmsEnumProvider) {
        RmsEnumProvider.changePath('/api/v1/app/form/enum/getEnum/');
    }
})();
(function () {
    'use strict';

    rmsGenericMultiSelect.$inject = ['lodash', '$timeout'];
    rmsGenericMultiSelectCtrl.$inject = ['$scope', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsGenericMultiSelect', rmsGenericMultiSelect);

    function rmsGenericMultiSelect(lodash, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                onChange: '=',
                label: '=',
            },
            controller: rmsGenericMultiSelectCtrl,
            controllerAs: "vm",
            templateUrl: 'common/app/components/generic-multi-select',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.setModelValue = setModelValue;

                // ctrl.$formatters.push(function (modelValue) {
                //     return modelValue;
                // });

                ctrl.$render = function () {
                    vm.options = scope.options.map(function (option) {
                        var requiredTemplate = '&nbsp;<i class="fa fa-lock fa-inherit-color" aria-hidden="true"></i>'
                        if (option.required && !option.label.includes(requiredTemplate) ) {
                            option.label += requiredTemplate;
                        }

                        return option;
                    });

                    vm.selected = ctrl.$viewValue;
                };

                function setModelValue(value) {
                    return ctrl.$setViewValue(value);
                }
            }
        };
    }

    function rmsGenericMultiSelectCtrl($scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.label = $scope.label;
            vm.selected = [];

            vm.toggleSelect = toggleSelect;
        }

        function toggleSelect(item) {
            if (item.required) {
                return;
            }
            $timeout(function () {
                $scope.$apply(function () {
                    var exists = vm.selected.some(function (selection) {
                        return selection.value === item.value
                    });

                    if (exists) {
                        vm.selected = vm.selected.filter(function (selection) {
                            return item.value !== selection.value;
                        })
                    } else {
                        vm.selected.push(item);
                    }

                    $scope.onChange();
                    vm.setModelValue(vm.selected);
                })
            })
        }
    }
})();
(function () {
    'use strict';

    rmsGenericSearchSelect.$inject = ['lodash', '$timeout'];
    rmsGenericSearchSelectCtrl.$inject = ['$scope', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsGenericSearchSelect', rmsGenericSearchSelect);

    function rmsGenericSearchSelect(lodash, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                onChange: '=',
                label: '=',
            },
            controller: rmsGenericSearchSelectCtrl,
            controllerAs: "vm",
            templateUrl: 'common/app/components/generic-search-select',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.setModelValue = setModelValue;

                scope.$watch('options', function (newValue, oldValue) {
                    vm.options = newValue;
                    vm.filterOptions();
                });

                ctrl.$render = function () {
                    vm.selected = ctrl.$viewValue;
                };

                function setModelValue(value) {
                    return ctrl.$setViewValue(value);
                }
            }
        };
    }

    function rmsGenericSearchSelectCtrl($scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.options = $scope.options;
            vm.availableOptions = vm.options.slice();
            vm.label = $scope.label;
            vm.selected = null;
            vm.searchText = '';
            vm.dropdownActive = false;

            vm.toggleDropdown = toggleDropdown;
            vm.selectOption = selectOption;
            vm.filterOptions = filterOptions;
        }

        function filterOptions() {
            $timeout(function () {
                if (vm.searchText.length === 0) {
                    return vm.availableOptions = vm.options.slice();
                }
                vm.availableOptions = vm.options.slice().filter(function (item) {
                    var textConcat = lodash.get(item, 'text_concat', '');
                    var label = lodash.get(item, 'label', '');
                    return label.toLowerCase().includes(vm.searchText.toLowerCase()) || textConcat.toLowerCase().includes(vm.searchText.toLowerCase());
                });
            });
        }

        function toggleDropdown(state) {
            return vm.dropdownActive = state;
        }

        function selectOption(option) {
            // vm.availableOptions = vm.availableOptions.filter(function(item) {
            //    return item.id !== option.id;
            // });
            vm.setModelValue(option);
            $scope.onChange();
        }
    }
})();
(function () {
    'use strict';

    rmsGenericToggle.$inject = ['lodash'];
    rmsGenericToggleCtrl.$inject = ['$scope', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsGenericToggle', rmsGenericToggle);

    function rmsGenericToggle(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                data: '=',
            },
            controller: rmsGenericToggleCtrl,
            controllerAs: "vm",
            templateUrl: 'common/app/components/generic-toggle',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;

                vm.toggleSelector = toggleSelector;
                vm.setModelValue = setModelValue;

                // ctrl.$formatters.push(function (modelValue) {
                //     return modelValue;
                // });]

                ctrl.$render = function () {
                    if (ctrl.$viewValue) {
                        vm.model = new vm.Model(ctrl.$viewValue['choice']);
                    }
                };

                scope.$watch('vm.model', function () {
                    setModelValue(vm.model);
                }, true);

                function setModelValue(value) {
                    return ctrl.$setViewValue(value);
                }

                function toggleSelector(value) {
                    return vm.model.choice === value ? vm.setValue('nil') : vm.setValue(value)
                }
            }
        };
    }

    function rmsGenericToggleCtrl($scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.model = null;
            vm.states = $scope.options;
            vm.Model = Model;

            vm.setValue = setValue;
        }

        function setValue(value) {
            return $timeout(function () {
                vm.model = new Model(value);
                return vm.setModelValue(vm.model);
            })
        }

        function Model(choice) {
            this.value = $scope.data.value;
            this.choice = choice;
            this.required = $scope.data.required;
        }
    }
})();
(function () {
    'use strict';

    rmsInformationNotificationSubmenuCtrl.$inject = ['GenericModel', 'lodash', '$scope', '$rootScope', 'DialogManager'];
    angular
        .module('rms.common')
        .directive('rmsInformationNotificationSubmenu', rmsInformationNotificationSubmenu);

    function rmsInformationNotificationSubmenu() {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            controller: rmsInformationNotificationSubmenuCtrl,
            controllerAs: 'in_submenu_ctrl',
            bindToController: true,
            templateUrl: 'common/app/components/information-notification-submenu'
        };
    }

    function rmsInformationNotificationSubmenuCtrl(GenericModel, lodash, $scope, $rootScope, DialogManager) {

        var in_submenu_ctrl = this;
        var endpoint = '';
        var method = '';
        var data = [];

        this.$onInit = function() {
            in_submenu_ctrl.action = action;
            in_submenu_ctrl.mark_all_as_read = markAllAsRead;

            refresh();

            var event_name = lodash.get(in_submenu_ctrl.options, 'refresh_event', 'notification_badge_refresh');
            $scope.listener_instance = $rootScope.$on(event_name, function () {
                refresh();
            });

            $scope.$on('$destroy', function () {
                $scope.listener_instance();
            });
        }


        function refresh() {
            endpoint = lodash.get(in_submenu_ctrl.options, 'datasource.url', '');
            method = lodash.get(in_submenu_ctrl.options, 'datasource.method', 'get');
            const model = GenericModel(endpoint);

            model[method]().$promise.then(function (res) {
                in_submenu_ctrl.unread_count = (!!res.unread_count) ? res.unread_count : null;
                in_submenu_ctrl.rows = (!!res.rows) ? res.rows : null;
                in_submenu_ctrl.total = (!!res.total) ? res.total : res.count;
                in_submenu_ctrl.unread_count = (!!res.unread_count) ? res.unread_count : 0;
            });
        }

        // action();
        // ng-click="in_submenu_ctrl.action(row)"

        function action(item) {
            if (item.read_status.key == 'urd') {
                endpoint = lodash.get(in_submenu_ctrl.options, 'datasource_update.url', '');
                method = lodash.get(in_submenu_ctrl.options, 'datasource_update.method', 'put');
                const model = GenericModel(endpoint);

                data = {
                    selected: [{id: item.id}]
                };

                model[method]({}, data).$promise.then(function (res) {
                    refresh();
                });
            }

            switch (item.title_click_event) {
                case 1:
                    window.open(item.link, "_blank");
                    break;
                case 2:
                    DialogManager.init($scope.id, {
                        dialog_id: $scope.id,
                        dialog_options: {
                            modalSize: 'small',
                            modalClass: null,
                            hideModalHeader: true,
                            templates: item,
                        },
                        controller: "DialogAsyncCtrl",
                        controllerAs: "vm",
                        template: '<div class="modal annoucement display-block"><div class="modal-dialog <%vm.options.modalSize%> <%vm.options.modalClass%>  ">' +
                            '<div class="modal-content" style="padding: 0px;">' +
                            '<div class="modal-header" style="padding: 1rem;">' +
                            '<h4 class="modal-title"><div ng-bind="vm.options.templates.title" style="color:white;padding-right:30px;"></div></h4>' +
                            '<button class="close modal-close-btn" ng-click="vm.dismiss()"><i class="fa fa-times" style="color:white;padding: 10px;"></i></button>' +
                            '</div>' +
                            '<div class="modal-body">' +
                            '<div ng-bind-html="vm.options.templates.content"></div>' +
                            '</div>' +
                            '</div>' +
                            '</div></div>',
                    });
                    break;
                default:
                    break;
            }
        }

        function markAllAsRead() {
            endpoint = lodash.get(in_submenu_ctrl.options, 'datasource_update.url', '');
            method = lodash.get(in_submenu_ctrl.options, 'datasource_update.method', 'put');
            const model = GenericModel(endpoint);
            data = {
                isMassSelectedItems: true,
                selectAllFlag: true,
            };

            model[method]({}, data).$promise.then(function (res) {
                refresh();
            });
        }

    }
})();

(function () {
    'use strict';

    rmsOptionsSelector.$inject = ['lodash'];
    rmsOptionsSelectorCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsOptionsSelector', rmsOptionsSelector);

    function rmsOptionsSelector(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=?',
                refresh: '=?',
                readonly: '=?',
            },
            controller: rmsOptionsSelectorCtrl,
            templateUrl: 'common/app/components/options-selector',
            link: function (scope, elem, attr, ctrl) {
                scope.ngModelCtrl = ctrl;
                var vm = scope.scCtrl;/**/
                vm.available_is_active = false;

                ctrl.$formatters.push(function(modelValue) {
                    return lodash.sortBy(modelValue, [vm.sortField]);
                });

                ctrl.$render = function() {
                    vm.selected = ctrl.$viewValue;
                    vm.available = lodash.differenceBy(lodash.get(scope.options, 'options', []), ctrl.$viewValue, vm.valueField);
                    if (vm.selected.length === 0) {
                        vm.available_is_active = true;
                    }
                };

                vm.available_is_active = false; // will always be false on default
                vm.openAvailable = openAvailable;
                vm.closeAvailable = closeAvailable;
                vm.addItem = addItem;
                vm.removeItem = removeItem;
                vm.addAll = addAll;
                vm.removeAll = removeAll;
                vm.isReadOnly = isReadOnly;
                scope.refresh = refresh;

                function refresh() {
                    ctrl.$render();
                }

                function addItem(item) {
                    var itemObj = lodash.remove(vm.available, {[vm.valueField]: item[vm.valueField]});
                    vm.selected = vm.selected.concat(itemObj);
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function removeItem(item) {
                    var itemObj = lodash.remove(vm.selected, {[vm.valueField]: item[vm.valueField]});
                    vm.available = vm.available.concat(itemObj);
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function addAll() {
                    vm.selected = vm.selected.concat(vm.available);
                    vm.available = [];
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function removeAll() {
                    vm.available = vm.available.concat(vm.selected);
                    vm.selected = [];
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function openAvailable() {
                    console.log('test test test test test');
                    vm.available_is_active = true;
                }

                function closeAvailable() {
                    vm.available_is_active = false;
                }

                function isReadOnly() {
                    return lodash.get(scope, 'readonly', false);
                }
            }
        };
    }

    function rmsOptionsSelectorCtrl($scope, lodash) {
        this.$onInit = function() {
            $scope.scCtrl = {
                labelField: lodash.get($scope.options, 'labelField', 'label'),
                valueField: lodash.get($scope.options, 'valueField', 'value'),
                sortField: lodash.get($scope.options, 'sortField', 'position'),
            };
            var vm = $scope.scCtrl;

            vm.selectedConfig = {
                placeholder: function () {
                    return '<li class="drop-here"><i class="fa fa-bars"></i></i><span>Drop Here</span></li>'
                },
                hint: function (element) {
                    var text = element.find('span').text();
                    return '<div class="options-selector-hint">' + text + '</div>'
                },
                disabled: '.disabled-item',
                change: function(e) {
                    var oldIndex = e.oldIndex,
                        newIndex = e.newIndex;

                    var itemMoved = vm.selected[oldIndex];
                    vm.selected.splice(oldIndex, 1);
                    vm.selected.splice(newIndex, 0, itemMoved);
                    // $timeout(function() {
                    vm.reorderItems();
                    $scope.ngModelCtrl.$setViewValue(vm.selected);
                    // });
                }
            };

            vm.reorderItems = function() {
                vm.selected = vm.selected.map(function(item, index) {
                    item[vm.sortField] = index + 1;
                    return item;
                });
            }
        }
    }
})();
(function () {
        'use strict';

        rmsOptionsSelector.$inject = ['lodash'];
        rmsSchedulePickerCtrl.$inject = ['$scope', 'lodash', '$timeout'];
        angular
            .module('rms.common')
            .directive('rmsSchedulePicker', rmsOptionsSelector);

        function rmsOptionsSelector(lodash) {
            return {
                restrict: 'E',
                require: 'ngModel',
                scope: {
                    options: '=?',
                    validations: '=?',
                    refresh: '=?',
                    readonly: '=?',
                },
                controller: rmsSchedulePickerCtrl,
                controllerAs: 'vm',
                templateUrl: 'common/app/components/schedule-picker',
                link: function (scope, elem, attr, ctrl) {
                    scope.ngModelCtrl = ctrl;
                    var vm = scope.vm;

                    var dpObj = null;
                    var tpObj = null;
                    //
                    // scope.$watch(function() { return vm.scheduleActive}, function() {
                    //     if (vm.scheduleActive) {
                    dpObj = elem.find('input.date');
                    tpObj = elem.find('input.time');

                    dpObj.datepicker(vm.dateOption);
                    tpObj.timepicker(vm.timeOption);
                        // } else {
                    //         vm.dpObj.off();
                    //         vm.dbObj.datepicker('destroy');
                    //         vm.tpObj.off();
                    //         vm.tpObj.timepicker('destroy');
                    //         vm.dpObj = null;
                    //         vm.tpObj = null;
                    //     }
                    // });

                    ctrl.$formatters.push(function (modelValue) {
                        vm.repeatCount = lodash.get(modelValue, 'recurrence_repeat_count', 1);
                        vm.repeatFrequencyType = lodash.get(modelValue, 'recurrence_type', 1);
                        vm.selectedMonthDay = lodash.get(modelValue, 'recurrence_month_day', null);
                        vm.selectedWeekDays = lodash.get(modelValue, 'recurrence_week_days', []);
                        vm.startDate = lodash.get(modelValue, 'effective_from');
                        vm.startTime = lodash.get(modelValue, 'recurrence_time');
                        vm.selectedTimezone = lodash.get(modelValue, 'timezone_id');

                        vm.showDayOfMonth = vm.repeatFrequencyType == '3';
                        vm.showDayOfWeek = vm.repeatFrequencyType == '2';
                    });

                    ctrl.$render = function () {
                        // vm.updateNgModel();
                    };

                    scope.$watch(function() {
                        return vm.startDate +  vm.startTime;
                    }, function() {
                        vm.updateNgModel();
                    });
                }
            };
        }

        function rmsSchedulePickerCtrl($scope, lodash, $timeout) {
            var vm = this;
            this.$onInit = function() {
                //ng-models
                vm.repeatCount = undefined;
                vm.repeatFrequencyType = undefined;
                vm.selectedMonthDay = undefined;
                vm.scheduleActive = true; //default should be false, hardcode true to disable scheduling check
                vm.startDate = undefined;
                vm.startTime = undefined;
                vm.selectedWeekDays = [];
                vm.selectedTimezone = undefined;
                vm.moment_date_format = 'DD/MM/YYYY';
                vm.moment_time_format  = 'HH:mm:00';
                vm.picker_date_format = 'dd/mm/yyyy';
                vm.picker_time_format = 'h:mm a';

                //state
                // vm.showDayOfWeek = false;
                // vm.showDayOfMonth = false;

                //enums
                vm.monthDays = lodash.get($scope.options, 'enums.month_days', []);
                vm.weekDays = lodash.get($scope.options, 'enums.week_days', []);
                vm.repeatFrequencyOptions = lodash.get($scope.options, 'enums.repeat_frequency_type', []);
                vm.timezones = lodash.get($scope.options, 'enums.timezones', [])

                var lang =  angular.element('html').attr('lang');
                // replace this with kendo data source?
                vm.dateOption = {
                    // change: ƒ change()
                    // format: 'dd/MM/yyyy',
                    // min: new Date(Date.now()).toTimeString(),
                    //
                    // month: {
                    //     empty: '<div style="color:\\#ccc;line-height: 1.833em">#= data.value #</div>'
                    // }
                    language:lang,
                    startDate: moment().format(vm.moment_date_format),
                    format: vm.picker_date_format,
                    autoclose: true,
                    forceParse: false,
                }

                vm.timeOption =  angular.extend(
                    {
                        'showDuration': true,
                        'timeFormat': 'g:i A',
                        'language': lang,
                        // 'minTime': '2:00pm',
                    }
                    // lodash.get(scope, 'options', {})
                );

                vm.defaultSelectizeConfig = {
                    labelField: 'label',
                    valueField: 'value',
                    maxItems: 1,
                    persist: true,
                    create: false,
                    onIntialize: function (selectize) {
                    }
                }



                vm.updateNgModel = function () {
                    var modelValues = new ModelInstance();
                    $scope.ngModelCtrl.$setViewValue(modelValues);
                    // console.log('Model Changed: ', modelValues);
                }
            }

            function ModelInstance() {
                this.sch_effect_from = vm.startDate;
                this.sch_recurrence_time = vm.startTime;
                this.sch_recurrence_repeat_count = vm.repeatCount;
                this.sch_recurrence_type = vm.repeatFrequencyType;
                this.sch_recurrence_weekdays = vm.selectedWeekDays;
                this.sch_recurrence_month_day = vm.selectedMonthDay;
                this.sch_status = vm.scheduleActive;
                this.sch_timezone = vm.selectedTimezone;
            }

            vm.repeatFrequencyChange = function () {
                $timeout(function () {
                    vm.showDayOfWeek = false;
                    vm.showDayOfMonth = false;

                    switch (vm.repeatFrequencyType) {
                        case "2":
                            vm.showDayOfWeek = true;
                            break;
                        case "3":
                            vm.activeWeekday = 0;
                            vm.showDayOfMonth = true;
                            break;
                        default:
                            break;
                    }

                    vm.updateNgModel();
                })
            }

            vm.toggleIsActive = function (day) {
                return vm.selectedWeekDays.indexOf(day) !== -1;
            }

            vm.toggleWeekday = function (day) {
                $timeout(function () {
                    var selectedIndex = vm.selectedWeekDays.indexOf(day);
                    selectedIndex === -1 ? vm.selectedWeekDays.push(day) : lodash.pull(vm.selectedWeekDays, day);

                    vm.updateNgModel();
                })
            }
        }
    }

)();
(function () {
    'use strict';

    rmsSecondarySelectionCtrl.$inject = ['lodash', '$timeout', '$scope', 'GenericModel'];
    angular
        .module('rms.common')
        .directive('rmsSecondarySelection', rmsSecondarySelection);

    function rmsSecondarySelection() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                primaryModel: '=',
                primaryChanged: '=',
            },
            require: 'ngModel',
            controller: rmsSecondarySelectionCtrl,
            templateUrl: 'common/app/components/secondary-selection',
            link: function(scope, elem, attr, ctrl) {
                scope.refresh = refresh;
                scope.ngModelCtrl = ctrl;

                ctrl.$render = function() {
                    scope.scopeModel.selected = ctrl.$viewValue;
                }

                function refresh() {
                    console.log(scope.getData());
                }
            }
        };
    }

    function rmsSecondarySelectionCtrl(lodash, $timeout, $scope, GenericModel) {
        var primary_select_id = 'primary_select_id';

        this.$onInit = function() {
            $scope.scopeModel = {
                sources: [],
                data: [],
                selected: [],
            };

            if (!$scope.options.name) {
                $scope.options.name = 'secondary-selection-' + $scope.$id;
            }

            primary_select_id = lodash.get($scope.options, 'primary_select_id', 'primary_select_id');

            refreshModel();

            $scope.primaryChanged = primaryChanged;
            $scope.events = {
                selectOnLoad: selectOnLoad,
                selectionChanged: selectionChanged,
                primaryOnLoad: primaryOnLoad,
            }
        }

        function primaryChanged() {
            console.log('primaryChanged');
            primaryOnLoad();
            selectionChanged();
            selectOnLoad();
        }

        function primaryOnLoad() {
            $scope.scopeModel.data = $scope.scopeModel.sources.filter(function(_item) {
                return lodash.filter($scope.primaryModel, {select_id: _item[primary_select_id]}).length > 0;
            });
        }

        function selectionChanged() {
            $scope.scopeModel.selected = $scope.scopeModel.data.reduce(function(result, item) {
               if (item.selected) {
                   result.push({id: item.id, select_id: item.select_id});
               }
               return result;
            }, []);
            $scope.ngModelCtrl.$setViewValue($scope.scopeModel.selected);
        }

        function selectOnLoad() {
            $timeout(function() {
                $scope.scopeModel.data.map(function(item) {
                    if (lodash.filter($scope.scopeModel.selected, {select_id: item.select_id}).length > 0) {
                        item.selected = true;
                    }
                    return item;
                });
            });

        }

        function refreshModel() {
            const url = lodash.get($scope.options, 'datasource.url', '');
            const method = lodash.get($scope.options, 'datasource.method', 'get');
            const params = lodash.get($scope.options, 'datasource.params', {})
            const model = new GenericModel(url);

            model[method](params).$promise.then(function (res) {
                var dataSchema = lodash.get($scope.options, 'datasource.schema.data', 'data');
                $scope.scopeModel.sources = lodash.get(res, dataSchema, []);
                primaryOnLoad();
                selectOnLoad();
            }, function (res) {
            });
        }
        

    }
})();

(function () {
    'use strict';

    rmsSortSelector.$inject = ['lodash', 'CommonHelper'];
    rmsSortSelectorCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsSortSelector', rmsSortSelector);

    function rmsSortSelector(lodash, CommonHelper) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                available: '=',
                options: '=?',
                refresh: '=?',
                readonly: '=?',
            },
            controller: rmsSortSelectorCtrl,
            templateUrl: 'common/app/components/sort-selector',
            link: function (scope, elem, attr, ctrl) {
                scope.ngModelCtrl = ctrl;
                var vm = scope.scCtrl;/**/
                vm.available_is_active = false;

                ctrl.$render = function() {
                    vm.available = lodash.differenceBy(vm.appliedAvailable, ctrl.$viewValue, vm.valueField);
                    if (CommonHelper.isEmpty(vm.appliedAvailable)) {
                        return;
                    }
                    const previousSelector = angular.copy(vm.selected);
                    vm.selected = lodash.intersectionBy(ctrl.$viewValue, vm.appliedAvailable, vm.valueField).map(function(_selectedItem, index) {
                        const previous = lodash.find(previousSelector, { [vm.valueField]: _selectedItem[vm.valueField]});
                        if (previous) {
                            _selectedItem.sort = previous.sort;
                            _selectedItem[vm.sortField] = previous[vm.sortField];
                        }
                        return _selectedItem;
                    });
                    vm.selected = lodash.sortBy(vm.selected, [vm.sortField]);
                    ctrl.$setViewValue(vm.selected);
                    if (vm.selected.length === 0) {
                        vm.available_is_active = true;
                    }
                };

                scope.$watch('available', function(newVal) {
                   if (!lodash.isEqual(newVal, vm.appliedAvailable)) {
                       vm.appliedAvailable = lodash.filter(angular.copy(newVal), { sortable: true });
                       ctrl.$render();
                   }
                });

                vm.available_is_active = false; // will always be false on default
                vm.openAvailable = openAvailable;
                vm.closeAvailable = closeAvailable;
                vm.addItem = addItem;
                vm.removeItem = removeItem;
                vm.addAll = addAll;
                vm.removeAll = removeAll;
                vm.toggleSortDirection = toggleSortDirection;
                vm.isReadOnly = isReadOnly;
                scope.refresh = refresh;

                function refresh() {
                    ctrl.$render();
                }

                function addItem(item) {
                    const sortNum = vm.selected.reduce((result, _selected) => {
                        return Math.max(result, _selected[vm.sortField]);
                    }, 0);
                    var itemObj = lodash.remove(vm.available, {[vm.valueField]: item[vm.valueField]}).map((_item) => {
                        _item.sort = 'asc';
                        _item[vm.sortField] = (sortNum + 1);
                        return _item;
                    });
                    vm.selected = vm.selected.concat(itemObj);
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function removeItem(item) {
                    var itemObj = lodash.remove(vm.selected, {[vm.valueField]: item[vm.valueField]});
                    vm.available = vm.available.concat(itemObj);
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function addAll() {
                    let index = 0;
                    vm.selected = vm.selected.concat(vm.available).map((_item) => {
                        _item.sort = 'asc';
                        _item[vm.sortField] = index++;
                        return _item;
                    });
                    vm.available = [];
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function removeAll() {
                    vm.available = vm.available.concat(vm.selected);
                    vm.selected = [];
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function openAvailable() {
                    vm.available_is_active = true;
                }

                function closeAvailable() {
                    vm.available_is_active = false;
                }

                function toggleSortDirection(item) {
                    item.sort = (item.sort === 'asc') ? 'desc' : 'asc';
                }

                function isReadOnly() {
                    return lodash.get(scope, 'readonly', false);
                }
            }
        };
    }

    function rmsSortSelectorCtrl($scope, lodash) {

        this.$onInit = function() {
            $scope.scCtrl = {
                labelField: lodash.get($scope.options, 'labelField', 'label'),
                valueField: lodash.get($scope.options, 'valueField', 'value'),
                sortField: lodash.get($scope.options, 'sortField', 'sort_position'),
                appliedAvailable: null,
            };
            var vm = $scope.scCtrl;

            vm.selectedConfig = {
                placeholder: function () {
                    return '<li class="drop-here"><i class="fa fa-bars"></i></i><span>Drop Here</span></li>'
                },
                hint: function (element) {
                    var text = element.find('span').text();
                    return '<div class="options-selector-hint">' + text + '</div>'
                },
                disabled: '.disabled-item',
                change: function(e) {
                    var oldIndex = e.oldIndex,
                        newIndex = e.newIndex;

                    var itemMoved = vm.selected[oldIndex];
                    vm.selected.splice(oldIndex, 1);
                    vm.selected.splice(newIndex, 0, itemMoved);
                    // $timeout(function() {
                    vm.reorderItems();
                    $scope.ngModelCtrl.$setViewValue(vm.selected);
                    // });
                }
            };

            vm.reorderItems = function() {
                vm.selected = vm.selected.map(function(item, index) {
                    item[vm.sortField] = index + 1;
                    return item;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    rmsStandardHeaderActionsCtrl.$inject = ['lodash', '$timeout', '$scope'];
    angular
        .module('rms.common')
        .directive('rmsStandardHeaderActions', rmsStandardHeaderActions);

    function rmsStandardHeaderActions() {
        return {
            restrict: 'E',
            scope: {
                form: '='
            },
            controller: rmsStandardHeaderActionsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/standard-header-actions'
        };
    }

    function rmsStandardHeaderActionsCtrl(lodash, $timeout, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.loading = false;
            vm.hasForm = hasForm;

            $scope.$watch(function() {
                return vm.form;
            }, function() {
                vm.loading = true;
                $timeout(function() {
                    vm.loading = false;
                }, 100);
            });
        }

        function hasForm() {
            return !lodash.isEmpty(vm.form) && !vm.loading;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('candidateTagHeaderBar', candidateTagHeaderBar);

    function candidateTagHeaderBar() {
        return {
            restrict: 'E',
            controller: candidateTagHeaderBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: "="
            },
            templateUrl: "rms/custom/candidate-tag-header-bar"
        };
    }

    function candidateTagHeaderBarCtrl() {
        var vm = this;

    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('careerTabSwitchReset', careerTabSwitchReset);

    function careerTabSwitchReset() {
        return {
            restrict: 'A',
            link: function(scope, elem, attr) {
                var nonActiveTabs = elem.find('.k-tabstrip > ul > li');
                var targetClass = attr.targetClass;
                nonActiveTabs.click(function() {
                    var currentElem = $(this);

                    if (currentElem.hasClass('.k-state-active')) {
                        return;
                    }
                    $(targetClass).show();
                    if (typeof scope.func.showList === typeof function() {}) {
                        scope.func.showList();
                        scope.$apply();
                    }
                });

                scope.$on('$destroy', function() {
                    nonActiveTabs.off();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    EmployeeSelectionDialogCtrl.$inject = ['close', '$timeout', 'dialogOptions', 'lodash'];
    angular
        .module('rms.common')
        .controller('EmployeeSelectionDialogCtrl', EmployeeSelectionDialogCtrl);

    function EmployeeSelectionDialogCtrl(close, $timeout, dialogOptions, lodash) {
        const vm = this;
        vm.options = dialogOptions.options;
        vm.employee = dialogOptions.employee;

        vm.selected = dialogOptions.employee || [];
        vm.is_selected = dialogOptions.is_selected;
        vm.dismiss = function () {
            close(false);
        };

        vm.confirm = function () {
            if (!!vm.employee) {
                close({
                    selected: vm.selected
                });
            } else {
                close(true);
            }
        };

        $timeout(function () {
            vm.show = true;
        });
    }
})();
(function () {
    'use strict';

    OnboardingEmployeeSelectionController.$inject = ['$scope', 'lodash', 'GenericModel', '$q', 'ActionManager', '$timeout'];
    angular
        .module('rms.common')
        .controller('EmployeeSelectionController', OnboardingEmployeeSelectionController);

    function OnboardingEmployeeSelectionController($scope, lodash, GenericModel, $q, ActionManager, $timeout) {
        const panelCtrl = getPanelCtrl($scope);
        const panelState = lodash.get(panelCtrl, 'panelState', null);
        const panelOption = lodash.get(panelState, 'structure.options', null);
        const panelModel = lodash.get(panelState, 'model', null);
        const panelForm = lodash.get(panelState, 'structure.component', null);


        loading(true);
        $q.all([
            loadDs('employeeListing', panelOption.employee_listing.datasource)
        ]).then(function (test) {
            $timeout(function () {
                loading(false);
            });
        });

        panelState.events = {
            select: select,
            isSelected: isSelected,
            getEmployeeItem: getEmployeeItem,
            removeSelected: removeSelected,
            addSelected:addSelected
        };

        $scope.$on('$destroy', function () {
            ActionManager('dm-close-dialog', {});
        });

        panelState.structure.refreshViewer = refresh;

        function refresh(){
            loading(true);
            $q.all([
                loadDs('employeeListing', panelOption.employee_listing.datasource)
            ]).then(function (test) {
                $timeout(function () {
                    loading(false);
                });
            });
        }

        $scope.colorCodeArray = [
            "#339E42",
            "#039BE5",
            "#EF6C00",
            "#A1887F",
            "#607D8B",
            "#039BE5",
            "#009688"
       ];

        function select(item) {
            const selected = isSelected(item);

            if (lodash.isEmpty(item) && selected) {
                return;
            }

            var template = 'tms/templates/onboarding/employee-selection-dialog';
            if (item.type == 'new_employee') {
                template = 'tms/templates/onboarding/new-employee-selection-dialog';
            }
            
            return $q.when(ActionManager('dm-open-dialog', {
                    controller: 'EmployeeSelectionDialogCtrl',
                    templateUrl: template,
                    dialog_options: {

                        employee: lodash.assign(item, {banner_options: panelOption.banner_options}),
                        hideModalHeader: true,
                        is_selected: selected,
                        options: panelOption.dialog_options
                    }
                }),

                function (res) {
                    res.modal.closed.then(function (dialogResult) {
                        if (dialogResult !== false) {
                            addSelected(item);
                        }
                    });
                }
            );
                
        }

        function isSelected(item) {
            const field_name = 'hid_selected_data';
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                if(_item !== undefined) {
                    return _item.user_id === item.user_id;
                }
            });
            return filtered.length > 0;
        }

        function addSelected(provider) {
            const field_name = 'hid_selected_data';
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                if(_item !== undefined) {
                    return _item.user_id === provider.user_id;
                }
            });
            if (filtered.length > 0) {
                return;
            }

            panelModel[field_name] = []; 

            panelModel[field_name] = {
                employee: provider,
                type: provider.type
            };
        }

        function removeSelected(e,provider) {
            e.stopPropagation();
            const field_name = 'hid_selected_data';
            const existingValue = lodash.get(panelModel, field_name, []);

            panelModel[field_name] = lodash.filter(existingValue, function (_item) {
                if(_item !== undefined) {
                    return _item.user_id !== provider.user_id;
                }
            });

            panelModel[field_name] = []; 
        }

        function getEmployeeItem(item) {
            if (lodash.has(panelState, 'employeeListing')) {
                return lodash.find(panelState.employeeListing, {select_id: item.user_id});
            }
            return null;
        }

        function loading(isloading) {
            var template = 'tms/templates/onboarding/loading';
            panelState.loading = isloading;
            if(isloading){
                $q.when(ActionManager('dm-open-dialog', {
                        controller: 'LoadingDialogCtrl',
                        templateUrl: template,
                        dialog_options: {
                            title: lodash.get(panelOption,'syncing_loader.title'),
                            message: lodash.get(panelOption,'syncing_loader.message'),
                            options: {
                                hideModalHeader: true,
                                modalSize: 'small',
                                modalClass: null
                            }
                        }
                    }));
            } else {
                ActionManager('dm-close-dialog', {});
            }   
        }

        function loadDs(name, _datasource) {
            panelState['error_data'] = null;
            lodash.set(panelOption, 'button_visibility.btn_save', false);
            const url = lodash.get(_datasource, 'url');
            const method = lodash.get(_datasource, 'method', 'get');
            const model = new GenericModel(url);
            const promise = model[method]().$promise.then(function (res) {
                if (res.success && res.status_code == 200) { //res
                    panelState[name] = res.rows; 

                    lodash.set(panelOption, 'button_visibility.btn_save', true);
                    panelState['success'] = true;
                    return res.rows;
                }
                else {
                    // console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    panelState['success'] = false;
                }
            }, function (res) {
                // console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                // console.warn(res); // eslint-disable-line no-console
                panelState['error_data'] = lodash.get(res, 'data', null);
                
                panelState['success'] = false;
            });
            return promise;
        }

        function getPanelCtrl(_scope) {
            const _vm = lodash.get(_scope, 'vm', null);
            if (!!_vm && _vm.constructor.name == 'asyncPanelCtrl') {
                return _vm;
            }
            if (lodash.has(_scope, '$parent')) {
                return getPanelCtrl(_scope.$parent);
            }
            return null;
        }
    }
})();
(function () {
    'use strict';

    LoadingDialogCtrl.$inject = ['close', '$timeout', 'dialogOptions', 'lodash'];
    angular
        .module('rms.common')
        .controller('LoadingDialogCtrl', LoadingDialogCtrl);

    function LoadingDialogCtrl(close, $timeout, dialogOptions, lodash) {
        const vm = this;
        vm.options = dialogOptions.options;
        vm.title = dialogOptions.title;
        vm.message = dialogOptions.message;

        vm.dismiss = function () {
            close(false);
        };


        $timeout(function () {
            vm.show = true;
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('sodProfileScoreBreakdown', sodProfileScoreBreakdown);

    function sodProfileScoreBreakdown() {
        return {
            restrict: 'E',
            scope: {
                scoreBreakdown: "="
            },
            controller: sodProfileScoreBreakdownCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'tms/templates/jobs/score-breakdown'
        };
    }

    function sodProfileScoreBreakdownCtrl() {}
})();
(function () {
	'use strict';
	rankingCandidates.$inject = ['$document'];
    rankCandidateCtrl.$inject = ['$scope', 'lodash', 'GenericModel'];
	angular
		.module('rms.common')
		.directive('rankingCandidates', rankingCandidates);

	function rankingCandidates($document) {
		return {
			restrict: 'E',
            controller: rankCandidateCtrl,
            bindToController: true,
            controllerAs: 'apr_ctrl',
			templateUrl: 'common/app/components/ranking-candidates',
			link(scope, elem, attrs, ctrl) {

				scope.sortRankedOptions = {
					cursor : "move",
					connectWith: "#sortableLeft",
					dropOnEmpty:true,
         			scroll:true,
				}

				scope.sortUnRankOptions = {
					cursor : "move",
					connectWith: "#sortableRight",
					dropOnEmpty:true,
         			scroll:true,
				}

    			scope.endRightHandler = function (e) {
	
					// prevent the sortable from modifying the DOM
					if (e.action == 'remove') {
						e.sender._draggable.dropped = true;
						e.sender._defaultPrevented = true;
					}
					if (e.action == 'receive') {
						e._defaultPrevented = true;
						e.sender._defaultPrevented = true;
						var id = e.item[0].id
						scope.apr_ctrl.push_ranked_list(id);
						scope.apr_ctrl.remove_unrank_list(id);
						// update the model and let Angular update the DOM
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;
						scope.apr_ctrl.ranked_list.splice(
							newIndex, 0, scope.apr_ctrl.ranked_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
					if (e.action == 'sort') {
						e.sender._draggable.dropped = true;
						e._defaultPrevented = true;
						// update the model and let Angular update the DOM
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;
						scope.apr_ctrl.ranked_list.splice(
							newIndex, 0, scope.apr_ctrl.ranked_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
						
				};
	
				scope.endLeftHandler = function (e) {
	
					// prevent the sortable from modifying the DOM
					if (e.action == 'remove') {
						e.sender._draggable.dropped = true;
						e.sender._defaultPrevented = true;
					}
					if (e.action == 'receive') {
						e._defaultPrevented = true;
						e.sender._defaultPrevented = true;
						var id = e.item[0].id;
						scope.apr_ctrl.push_unrank_list(id);
						scope.apr_ctrl.remove_ranked_list(id);
						// update the model and let Angular update the DOM					
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;
						scope.apr_ctrl.unrank_list.splice(
							newIndex, 0, scope.apr_ctrl.unrank_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
					if (e.action == 'sort') {
						e.sender._draggable.dropped = true;
						e._defaultPrevented = true;
						// update the model and let Angular update the DOM	
						var oldIndex = e.oldIndex,
							newIndex = e.newIndex;				
						scope.apr_ctrl.unrank_list.splice(
							newIndex, 0, scope.apr_ctrl.unrank_list.splice(oldIndex, 1)[0]
						);
						scope.apr_ctrl.reorderItems();
					}
					
				};
	
				scope.placeholder = function (element) {
					const elementClone = element.clone();
                        elementClone.addClass('sortable-placeholder');
                        elementClone.find('.item-content').html('<div>Drop Here</div>');
                        return elementClone;
				};
				scope.hint = function (element) {
					return element.clone().addClass('sortable-hint');
				};
			}
		}
	}

	function rankCandidateCtrl($scope, lodash, GenericModel) {
        var apr_ctrl = this;
		this.$onInit = function() {
			apr_ctrl.options = lodash.get($scope, '$parent.vm.panelState.structure.options', {});
			apr_ctrl.model = lodash.get($scope, '$parent.vm.panelState.model', {});
			apr_ctrl.unrank_is_empty = false;        
			apr_ctrl.loading = true;
			apr_ctrl.unrank_list = [];
			apr_ctrl.ranked_list = [];
			
			apr_ctrl.remove_unrank_list = remove_unrank_list;
			apr_ctrl.remove_ranked_list = remove_ranked_list;
			apr_ctrl.push_unrank_list = push_unrank_list;
			apr_ctrl.push_ranked_list = push_ranked_list;
			apr_ctrl.unrank_list_exists = unrank_list_exists;
			apr_ctrl.ranked_list_exists = ranked_list_exists;
			apr_ctrl.reorderItems = reorderItems;
			apr_ctrl.clear_ranked_list = clear_ranked_list;
			
			var url = lodash.get(apr_ctrl.options, 'datasource.url', null);
			var method = lodash.get(apr_ctrl.options, 'datasource.method', 'get');
			if (!!url) {
				var resource = GenericModel(url);
				resource[method]({
					selected: lodash.get(apr_ctrl.model, 'selected', []),
					type: lodash.get(apr_ctrl.options, 'type', null),
				}).$promise.then(function(res) {
					apr_ctrl.loading = false;
					apr_ctrl.unrank_list = lodash.get(res, 'unrank_formatted', []);
					apr_ctrl.ranked_list = lodash.get(res, 'ranked_formatted', []);
					lodash.set($scope, 'apr_ctrl.unrank_list',  apr_ctrl.unrank_list);
					lodash.set($scope, 'apr_ctrl.ranked_list',  apr_ctrl.ranked_list);
					
					lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(row) {
						return {id: row.id};
					}));

					apr_ctrl.unrank_is_empty = !(apr_ctrl.unrank_list.length > 0);		
		
				});
			}
		}

		function reorderItems () {
			apr_ctrl.ranked_list = apr_ctrl.ranked_list.map(function(item, index) {
					item.ranking = index + 1;
					return item;
			});


			lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(row) {
				return {id: row.id};
			}));
        }

        function remove_unrank_list(id) {
			// if (unrank_list_exists(id)) {
				lodash.remove(apr_ctrl.unrank_list, {id: id});
				// lodash.set($scope, 'apr_ctrl.unrank_list', apr_ctrl.unrank_list);
			// }
        }

		function remove_ranked_list(id) {
			// if (ranked_list_exists(id)) {
				lodash.remove(apr_ctrl.ranked_list, {id: id});
				// lodash.set($scope, 'apr_ctrl.ranked_list', apr_ctrl.ranked_list);
				
				// lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(id) {
			    //       return {id: id};
		        //   }));
				
			// }
        }
		function push_unrank_list(id) {
			if(!unrank_list_exists(id)) {
				var _obj = apr_ctrl.ranked_list.find(x => x.id === id);
				
				apr_ctrl.unrank_list.push(_obj);

			}
			
		}

		function push_ranked_list(id) {
			if (!ranked_list_exists(id)) {
				var _obj = apr_ctrl.unrank_list.find(x => x.id === id);
				
				apr_ctrl.ranked_list.push(_obj);
	
				// lodash.set($scope, '$parent.vm.panelState.model.ranked_ids', apr_ctrl.ranked_list.map(function(id) {
				// 	return {id: id};
				// }));
			}
		}

		function ranked_list_exists(id) {
			var row = apr_ctrl.ranked_list.find(x => x.id === id);
			
			return row;
		}

		function unrank_list_exists(id) {
			var row = apr_ctrl.unrank_list.find(x => x.id === id);

			return row;
		}

		function clear_ranked_list() {
			apr_ctrl.ranked_list.forEach( function (row) {
				apr_ctrl.unrank_list.push(row);	
			});
			apr_ctrl.ranked_list = [];
			lodash.set($scope, '$parent.vm.panelState.model.ranked_ids',[]);
		}
		
    }

})();
(function () {
    'use strict';

    rmsRequisitionMassApprovalCtrl.$inject = ['GenericModel', 'lodash', '$scope'];
    angular
        .module('rms.common')
        .controller('rmsRequisitionMassApprovalCtrl', rmsRequisitionMassApprovalCtrl);


    function rmsRequisitionMassApprovalCtrl(GenericModel, lodash, $scope) {
        var apr_ctrl = this;
        apr_ctrl.options = lodash.get($scope, '$parent.vm.options.structure.options', {});
        apr_ctrl.model = lodash.get($scope, '$parent.vm.options.model', {});
        apr_ctrl.loading = true;
        apr_ctrl.is_empty = false;
        apr_ctrl.allowed_list = [];
        apr_ctrl.disallowed_list = [];
        apr_ctrl.tab_const = {
            SELECTED: 'selected',
            UNAFFECTED: 'unaffected',
        };
        apr_ctrl.active_tab = apr_ctrl.tab_const.SELECTED;

        apr_ctrl.remove_from_list = remove_from_list;

        var url = lodash.get(apr_ctrl.options, 'datasource.url', null);
        var method = lodash.get(apr_ctrl.options, 'datasource.method', 'get');
        var type = lodash.get(apr_ctrl.options, 'type', null);
        if (!!url) {
            var resource = GenericModel(url);
            resource[method]({
                selected: lodash.get(apr_ctrl.model, 'selected', []),
                type: lodash.get(apr_ctrl.options, 'type', null),
            }).$promise.then(function(res) {
                apr_ctrl.loading = false;
                apr_ctrl.allowed_list = lodash.get(res, 'allowed_formatted', []);
                apr_ctrl.disallowed_list = lodash.get(res, 'disallowed_formatted', []);
                lodash.set($scope, '$parent.vm.options.model.allowed_ids',  lodash.get(res, 'allowed_ids', []));
                apr_ctrl.is_empty = !(apr_ctrl.allowed_list.length > 0);
                apr_ctrl.type = type;
                // apr.
            });
        }

        function remove_from_list(row) {
            lodash.remove(apr_ctrl.allowed_list, {id: row.id});

            lodash.set($scope, '$parent.vm.options.model.allowed_ids', apr_ctrl.allowed_list.map(function(_row) {
                return {id: _row.id};
            }));
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['RmsEnum', '$q'];
    angular
        .module('ActionManager')
        .factory('action-rms-load-enum', actionFunc);

    function actionFunc(RmsEnum, $q) {
        return function(options) {
            return $q.all(options.enums.map(function(enumName) {
                return RmsEnum.load(enumName);
            }));
        };
    }
})();
(function () {
    'use strict';

    MassApplyController.$inject = ['$scope', 'lodash', 'GenericModel'];
    angular
        .module('rms.common')
        .controller('MassApplyController', MassApplyController);

    function MassApplyController($scope, lodash, GenericModel) {
        var options = $scope.$parent.panel.data.options.massApply;
        console.log(options);

        $scope.events = {
            // test: test
            validateForm: validateForm,
            submitApplication: submitApplication,
        };

        $scope.model = {
            application: {
                rad_shift_work_interest: 1,
            },
            selected_jobs: [],
        }


        function test() {
            // if ($scope.events.getModel) {
            //     console.log($scope.events.getModel());
            //     $scope.model.application = $scope.events.getModel();
            //
            //
            // }
        }

        function validateForm() {
            if (lodash.has(options, 'validate_datasource')) {
                var application_form_model = $scope.model.application;

                var url = lodash.get(options, 'validate_datasource.url', '');
                var method = lodash.get(options, 'validate_datasource.method', 'get');
                var model = new GenericModel(url);
                return model[method]({data: application_form_model}).$promise;
            }
        }

        function submitApplication() {
            if (lodash.has(options, 'submission_datasource')) {
                var application_form_model = $scope.model;


                var url = lodash.get(options, 'submission_datasource.url', '');
                var method = lodash.get(options, 'submission_datasource.method', 'post');
                var model = new GenericModel(url);
                return model[method]({data: application_form_model}).$promise;
            }
        }
    }
})();
(function () {
    'use strict';

    PageDirtyConfirmationCtrl.$inject = ['close', '$timeout'];
    angular
        .module('rms.common')
        .controller('PageDirtyConfirmationCtrl', PageDirtyConfirmationCtrl);

    function PageDirtyConfirmationCtrl(close, $timeout) {
        const vm = this;
        vm.dismiss = dismiss;
        vm.confirm = confirm;

        $timeout( function () {
            vm.show = true;
        } );


        function dismiss() {
            close(false, 250);
        }

        function confirm() {
            close(true, 250);
        }
    }
})();
(function () {
    'use strict';

    rmsEnumSelectorCtrl.$inject = ['RmsEnum', '$q'];
    angular
        .module('rms.common')
        .directive('rmsEnumSelector', rmsEnumSelector);

    function rmsEnumSelector() {
        return {
            restrict: 'E',
            controller: rmsEnumSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                name: '@',
                config: '=?'
            },
            template: `<selectize config="vm.selectConfig" options='vm.ds' ng-model="vm.selected"></selectize>`,
            link: rmsEnumSelectorLink
        };

        function rmsEnumSelectorLink(scope, elem, link, ngModelCtrl) {
            const vm = scope.vm;
            vm.ngModelCtrl = ngModelCtrl;

            vm.ngModelCtrl.$render = function() {
                vm.selected = vm.ngModelCtrl.$viewValue;
            };

        }
    }

    function rmsEnumSelectorCtrl(RmsEnum, $q) {
        var vm = this;
        this.$onInit = function() {
            $q.when(RmsEnum.getList(vm.name)).then(function(ds) {
                vm.ds = ds;
            });
            vm.config = (vm.config === undefined) ? {} : vm.config;

            vm.selectConfig = angular.merge(
                {
                    create: false,
                    valueField: 'value',
                    labelField: 'label',
                    maxItems: 1,
                    onChange: function(value) {
                        vm.ngModelCtrl.$setViewValue(value);
                    }
                },
                vm.config
            )
        }
    }
})();
(function () {
    'use strict';

    rmsTemplateCtrl.$inject = ['$scope', '$compile', '$element', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsTemplate', rmsTemplate);

    function rmsTemplate() {
        return {
            restrict: 'E',
            scope: {
                template: '=',
                data: '=?',
                options: '=?',
                refreshContent: '=?',
                actionSave: '=?'
            },
            controller: rmsTemplateCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsTemplateCtrl($scope, $compile, $element, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.refreshContent = refreshContent;

            callEventChanged();
            initContent();
        }

        function refreshContent() {
            if (typeof vm.refresh === typeof function () {}) {
                vm.refresh(vm.data);
            } else {
                initContent();
            }
            callEventChanged();
        }

        function callEventChanged() {
            if (lodash.has(vm.options, 'event.changed')) {
                $scope.$emit(vm.options.event.changed, vm.data);
            }
        }

        function destroyChildScope() {
            if (vm.childScope !== null && vm.childScope !== undefined) {
                vm.childScope.$destroy();
            }
        }

        function removeElementClone() {
            if (vm.elementClone !== null && vm.elementClone !== undefined) {
                vm.elementClone.remove();
            }
        }

        function initContent() {
            $element.html(vm.template);

            destroyChildScope();
            removeElementClone();

            vm.childScope = $scope.$new();
            vm.elementClone = $compile($element.contents())(vm.childScope);
            $scope.$on('$destroy', () => {
                destroyChildScope();
                removeElementClone();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsToggle', rmsToggle);

    function rmsToggle() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {},
            transclude: true,
            template: `<label><button type="button" ng-click="toggleButton()" class="button blue hollow default-button checkbox-fa small"><span><i class="fa" ng-class="{\'fa-check\':toggleData}"></i></span></button><span><ng-transclude></ng-transclude></span></label>`,
            link: rmsToggleLink
        };

        function rmsToggleLink(scope, elem, link, ngModelCtrl) {
            ngModelCtrl.$formatters.push(function(modelValue) {
                if (modelValue === undefined) {
                    return false;
                }
                return modelValue;
            });

            ngModelCtrl.$render = function() {
                scope.toggleData = ngModelCtrl.$viewValue;
            };

            scope.toggleButton = function() {
                scope.toggleData = !scope.toggleData;
                ngModelCtrl.$setViewValue(scope.toggleData);
            }
        }
    }
})();

(function () {
    'use strict';

    selectizeObjectSelector.$inject = ['lodash'];
    selectizeObjectSelectorCtrl.$inject = ['$scope', 'lodash', 'GenericModel'];
    angular
        .module('sodCommon')
        .directive('selectizeObjectSelector', selectizeObjectSelector);

    function selectizeObjectSelector(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                config: '=',
                options: '=?',
            },
            controller: selectizeObjectSelectorCtrl,
            templateUrl: 'common/components/selectize-object',
            link: function (scope, elem, attrs, ngModelCtrl) {
                const valueKey = lodash.get(scope.myConfig, 'valueField', 'id');

                ngModelCtrl.$formatters.push(function (modelValue) {
                    return lodash.get(modelValue, valueKey, modelValue);
                });

                ngModelCtrl.$render = function() {
                    scope.myModel = ngModelCtrl.$viewValue;
                };

                ngModelCtrl.$parsers.push(function(viewValue) {
                    const value = lodash.find(scope.options, { [valueKey]: viewValue });
                    return value || viewValue;
                });

                scope.onModelChange = function () {
                    ngModelCtrl.$setViewValue(scope.myModel);
                    if (lodash.has(scope.config, 'events.change')) {
                        var option = lodash.find(scope.options, function(option) {
                            return option[valueKey] == scope.myModel;
                        }); // { [valueKey]: scope.myModel });
                        scope.$emit(scope.config.events.change, {
                            model: scope.myModel,
                            label: option.label
                        });
                    }
                };

            },
            // template: '<selectize options="options" config="config" ng-model="myModel" ng-change="onModelChange()"></selectize>'

        };
    }

    function selectizeObjectSelectorCtrl($scope, lodash, GenericModel) {
        this.$onInit = function() {
            if ($scope.options === undefined) {
                $scope.options = [];
            }
            $scope.myConfig = angular.merge(
                {
                    highlight: true,
                    create: false,
                    labelField: 'label',
                    valueField: 'value',
                    maxItems: 1,
                    searchField: ['label'],
                    plugins: ['remove_button'],
                    onInitialize: function(selectize) {
                        $scope.selectizeObject = selectize;
                        loadRemoteData();
                    }
                },
                $scope.config
            );
        }

        function loadRemoteData() {
            if (lodash.has($scope.config, 'datasource.url')) {
                $scope.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function(res) {
                    $scope.isLoading = false;
                    $scope.options = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel($scope.config.datasource.url);
            var method = lodash.get($scope.config.datasource, 'method', 'get');
            return model[method]({}).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    return null;
                }
            }, function(res) {
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('showEmails', showEmails);

    function showEmails() {
        return {
            restrict        : 'E',
            scope: {
                emails: '=',
                options: '=?'
            },
            controller      : showEmailsCtrl,
            controllerAs    : 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/view-email',
            link: showEmailsLink
        };

        function showEmailsLink() {

        }
    }

    function showEmailsCtrl() {
        const vm = this;
        this.$onInit = function() {
            vm.max = 2;
            vm.showControls = vm.max < vm.emails.length;
            vm.toggleState = false;

            vm.showRecipientsCount = showRecipientsCount;
            vm.showRecipients = showRecipients;
            vm.showShowMore = showShowMore;
            vm.showHide = showHide;
            vm.toggle = toggle;
        }

        function showRecipientsCount() {
            return (vm.showControls) ? !vm.toggleState : false;
        }

        function showRecipients() {
            return (vm.showControls) ? vm.toggleState : true;
        }

        function showShowMore() {
            return (vm.showControls) ? !vm.toggleState : false;
        }

        function showHide() {
            return (vm.showControls) ? vm.toggleState : false;
        }

        function toggle() {
            vm.toggleState = !vm.toggleState;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .filter('emailLabel', emailLabel);

    function emailLabel() {
        return function(value) {
            return `${value.full_name || ''} (${value.email || ''})`;
        };
    }
})();
(function () {
    'use strict';

    objectSummary.$inject = ['lodash', 'RmsEnum', '$q'];
    angular
        .module('rms.common')
        .filter('objectSummary', objectSummary);

    function objectSummary(lodash, RmsEnum, $q) {
        return function(value, options) {
            if (typeof options === typeof undefined) {
                return '';
            }

            const fields = lodash.get(options, 'fields', []);
            const enumsFields = lodash.get(options, 'enum_fields', {});

            const delimiter = lodash.get(options, 'delimiter', ', ');
            if (!(fields instanceof Array)) {
                return '';
            }
            return fields.reduce(function(result, field) {
                let val = lodash.get(value, field, '').toString();

                if (lodash.isEmpty(val)) {
                    return result;
                }

                if (lodash.has(enumsFields,field)) {
                    val = RmsEnum.get(enumsFields[field], val, '');
                }

                if (lodash.isEmpty(result)) {
                    return val;
                }
                return [result, val].join(delimiter);
            }, '');
        };
    }
})();
(function () {
    'use strict';

    filterBarAdapter.$inject = ['lodash'];
    angular
        .module('rms.common')
        .factory('filterBarAdapter', filterBarAdapter);

    function filterBarAdapter(lodash) {
        return function(query) {
            const results = {};

            results.filter = query.filters.map((filter) => {
                return {
                    field: filter.name,
                    operator: filter.operator,
                    value: filter.value
                };
            });

            if (!lodash.isEmpty(query.search)) {
                results.filter.push({
                    field: 'filter_search_text',
                    operator: 'contains',
                    value: query.search
                });
            }

            if (!lodash.isEmpty(query.order_by)) {
                results.sort = [query.order_by];
            }

            return results;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('entitySidePanel', entitySidePanel);

    function entitySidePanel() {
        return {
            restrict: 'A',
            scope: {
                onBackdropClick: '=',
            },
            link: function(scope, elem) {
                // var
                var backdrop = elem.find('.sp-backdrop');
                backdrop.bind('click', function(e) {
                    e.preventDefault();
                    if (scope.onBackdropClick && scope.onBackdropClick.length > 0) {
                        var eventData = {
                            target: elem,
                            event: e
                        };

                        scope.$emit(scope.onBackdropClick, eventData);
                        // scope.$apply();
                    }
                });

                scope.$on('$destroy', function() {
                   backdrop.off();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('listViewToolbar', listViewToolbar);

    function listViewToolbar() {
        return {
            restrict: 'E',
            controller: listViewToolbarCtrl,
            templateUrl: 'common/app/components/list-editable/toolbar'
        };
    }

    function listViewToolbarCtrl() {
        var vm = this;

    }
})();
(function () {
    'use strict';

    asyncPanelListViewCtrl.$inject = ['lodash', 'GenericModel', '$scope', '$element', 'DatasourceRegistry'];
    angular
        .module('rms.common')
        .directive('asyncPanelListView', asyncPanelListView);

    function asyncPanelListView() {
        return {
            restrict: 'E',
            controller: asyncPanelListViewCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                model: '=',
                options: '=',
                getModel: '=?',
                setValidationModel: '=?'
            },
            templateUrl: 'common/app/components/list-editable/index'
        };
    }

    function asyncPanelListViewCtrl(lodash, GenericModel, $scope, $element, DatasourceRegistry) {
        var vm = this;
        var dataSource = null;
        this.$onInit = function() {
            vm.no_records = false;

            // var kendoListDom = $element.find('.empty-list-wrapper');

            vm.getModel = getModel;
            vm.setValidationModel = setValidationModel;
            vm.dataItemAction = dataItemAction;
            vm.normalAction = normalAction;
            vm.showButton = showButton;
            vm.showSection = showButton;
            vm.refresh = refresh;
            // vm.getGaEvent = getGaEvent;

            dataSource = prepareDataSource();
            if (lodash.has(vm.options, 'list.identifier')) {
                DatasourceRegistry.add(vm.options.list.identifier, dataSource);

                $scope.$on('$destroy', function() {
                    DatasourceRegistry.remove(vm.options.list.identifier);
                });
            }

            vm.kendoOptions = angular.merge(
                {
                    dataSource: dataSource
                },
                lodash.get(vm.options,'list', {})
            );
        }

        function getModel() {
            return dataSource.data();
        }

        function setValidationModel(validationData) {
            dataSource.fetch(function() {
                var dataTemp = dataSource.data();
                dataTemp = dataTemp.map(function(d, i) {
                    const vdt = lodash.get(validationData, `[${i}]`, false);
                    const dt = Object.assign({}, d);
                    if (!vdt) {
                        delete dt.validation_rules;
                        return dt;
                    } else {
                        delete dt.validation_rules;
                        return angular.merge({}, dt, { validation_rules: vdt });
                    }
                });
                dataSource.data(dataTemp);
            });
        }

        function prepareDataSource() {
            if (lodash.has(vm.options, 'list.datasource')) {
                return new kendo.data.DataSource({
                    transport: {
                        read: readDataSource
                    },
                    change: function() {
                        if (lodash.has(vm.options, 'list.no_records')) {
                            vm.no_records = (this.view().length === 0);
                        }
                    }
                })
            } else {
                if (lodash.has(vm.options, 'list.data')) {
                    return new kendo.data.DataSource({
                        data: lodash.get(vm.options, 'list.data', [])
                    });
                } else {
                    return new kendo.data.DataSource({
                        data: vm.model || []
                    });
                }
            }
        }

        function readDataSource(readOptions) {
            const method = lodash.get(vm.options, 'list.datasource.method', 'query');
            const url = lodash.get(vm.options, 'list.datasource.url', '');
            const params = lodash.get(vm.options, 'list.datasource.params', {});
            const data = generateResourceOptions(readOptions.data, params, method);
            // prepare filter, and sort.
            var model = new GenericModel(url);
            model[method](data).$promise.then(function (res) {
                readOptions.success(res.rows);
            }, function (res) {
                readOptions.error(res);
            });
        }

        function generateResourceOptions(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);
            if (method == 'search') {
                params = {'data': params};
            }
            return params;
        }

        function dataItemAction(action, dataItem) {
            $scope.$emit(vm.options.dataitem_event_prefix+'.'+action, { model: dataItem });
            // if (action === 'preview') {
            //     $scope.listFilterService.showDetailView(dataItem);
            // } else {
            //     $scope.listFilterService.emitDataItemEvent(action, dataItem);
            // }
        }

        function showButton(type, dataItem) {
            const rules = lodash.get(vm.options, 'row_button_rules', {});
            if (!lodash.has(rules, type)) return true;
            const rule = rules[type];
            if (typeof rule === 'string') {
	            return lodash.get(dataItem, rules[type], false);
            }
            if (typeof rule === typeof {}) {
                const key = lodash.get(rule, 'key', '');
                const value = lodash.get(dataItem, key, false);
                if (lodash.has(rule, 'matches')) {
                    return value === rule.matches;
                }
                return !!value;
            }
            return true;
        }

        function refresh() {
            dataSource.read();
        }

        function normalAction(action) {
            $scope.$emit(vm.options.prefix+'.'+action, {});
        }
    }
})();
(function () {
    'use strict';

    scoreRadar.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('scoreRadar', scoreRadar);

    function scoreRadar(lodash) {
        return {
            retrict: 'E',
            scope: {
                score: '=?',
                labels: "=?",
                labelTitle: "=?",
                options: "=?"
            },
            "template": "<div style='width: 280px;height: 320px;'><canvas></canvas></div>",
            link: function (scope, elem) {
                const options = lodash.extend({
                    elements: {
                        line: {
                            borderWidth: 1
                        }
                    }
                }, scope.options || {});

                const container = elem.find("canvas")[0];
                const myNewChart = new Chart(container, {
                    type: 'radar',
                    data: {
                        labels: scope.labels,
                        datasets: [{
                            label: scope.labelTitle,
                            data: scope.score.toJSON(),
                            borderWidth: 1
                        }]
                    },
                    options: options
                });
            },
        };
    }
})();
(function () {
    "use strict";

    rmsDatatableToggleManager.$inject = ['lodash', '$document', '$timeout'];
    angular
        .module("rms.common")
        .directive("rmsDatatableToggleManager", rmsDatatableToggleManager);

    function rmsDatatableToggleManager(lodash, $document, $timeout) {
        rmsDatatableToggleManagerCtrl.$inject = ['$scope', 'lodash', 'GenericModel'];
        return {
            restrict: "E",
            require: ["ngModel"],
            scope: {
                options: "=",
                refresh: "=?",
                readonly: "=?",
                hasError: "=?",
                errorMessage: "=?"
            },
            controller: rmsDatatableToggleManagerCtrl,
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "common/app/components/datatable-toggle-manager",
            link: {
                post: function (scope, elem, attr, ctrl) {
                    var vm = scope.vm;
                    vm.ngModelCtrl = ctrl[0];

                    vm.ngModelCtrl.$render = function () {
                        console.log('hi');
                        var modelValue = vm.ngModelCtrl.$viewValue;
                        //
                        if (modelValue && modelValue.length > 0) {
                            // get required columns
                            var requiredColumns = vm.y.filter(function (column) {
                                return column.required;
                            });

                            // get all selected & required columns values

                            var selectedColumnValues = getColumnsByValue(modelValue);
                            var requiredColumnValues = requiredColumns.map(function (requiredColumn) {
                                return requiredColumn.value.toString();
                            });

                            // determine missing columns by difference.
                            var differenceColumns = lodash.difference(requiredColumnValues, selectedColumnValues);

                            // for each missing column create a new Y object and append to model value
                            vm.selected = modelValue.map(function (row) {
                                differenceColumns.forEach(function (difference) {
                                    row.y.push(new vm.Y(lodash.find(requiredColumns, {'value': parseInt(difference)})))
                                });

                                return row;
                            });

                            // generate new selected columns by selected rows
                            var newSelectedColumns = getColumnsByValue(vm.selected);

                            // determine selected columns by filtering all columns with selected columns
                            vm.columns = vm.y.filter(function (item) {
                                return newSelectedColumns.includes(item.value.toString());
                            });

                            vm.x = vm.x.filter(function ($x) {
                                return !lodash.find(vm.selected, {'value': $x.value});
                            });

                            vm.originalColumns = vm.columns.slice();
                            vm.originalSelected = lodash.cloneDeep(vm.selected);
                        } else {
                            vm.init();
                        }
                    };

                    function getColumnsByValue(model) {
                        // take all y values and flatten. then group by their value
                        return Object.keys(lodash.groupBy(lodash.flatten(model.map(function (value) {
                            return value.y;
                        }, [])), 'value'));
                    }
                }
            }
        };

        function rmsDatatableToggleManagerCtrl($scope, lodash, GenericModel) {
            var vm = this;
            this.$onInit = function() {
                var options = vm.options.options;

                vm.x = options.x;
                vm.y = options.y;
                vm.keyX = options.key_x;
                vm.keyY = options.key_y;
                vm.legend = options.legend;
                vm.currentY = null;
                vm.currentX = null;
                vm.originalColumns = [];
                vm.originalSelected = [];

                // vm.filteredX = [];

                vm.columns = [];
                vm.selected = [];

                vm.addX = addX;
                vm.removeX = removeX;
                vm.updateY = updateY;
                vm.getYIndex = getYIndex;
                vm.resetTable = resetTable;
                vm.Y = Y;

                vm.init = init;
            }

            function init() {
                var required = vm.y.filter(function (column) {
                    return column.required;
                });

                $timeout(function () {
                    required.forEach(function (required_col) {
                        vm.columns.push(required_col);
                    });
                    vm.originalColumns = vm.columns.slice();
                })
            }

            function updateNgModel(value) {
                vm.ngModelCtrl.$setViewValue(value);
            }

            function addX() {
                if (vm.currentX !== null) {
                    var isDupe = vm.selected.some(function (selection) {
                        return selection.value === vm.currentX.value;
                    });

                    if (isDupe) {
                        return;
                    }

                    $timeout(function () {
                        $scope.$apply(function () {
                            var columns = vm.columns.map(function (column) {
                                return new Y(column);
                            });

                            vm.selected.unshift(Object.assign({y: columns}, vm.currentX));
                            vm.x = vm.x.filter(function (item) {
                                if (typeof item !== "undefined") {
                                    return item.value !== vm.currentX.value;
                                }
                            });
                        });
                        updateNgModel(vm.selected);
                    })
                }
            }

            function removeX(value) {
                $timeout(function () {
                    $scope.$apply(function () {
                        vm.selected = vm.selected.filter(function (selection) {
                            return selection.value !== value;
                        });

                        var currentXOptions = vm.x.slice();
                        currentXOptions.unshift(lodash.find(vm.options.x, {value: value}));
                        vm.x= currentXOptions;
                    });

                    updateNgModel(vm.selected);
                })
            }

            function updateY() {
                $timeout(function () {
                    $scope.$apply(function () {
                        vm.selected = vm.selected.map(function (selection) {
                            var copy = Object.assign({}, selection);
                            var existingY = copy.y.slice();

                            copy.y = vm.columns.reduce(function (carry, column) {
                                var index = existingY.findIndex(function (element) {
                                    if (element === null) return false;
                                    return element.value === column.value
                                });

                                index === -1
                                    ? carry.push(new Y(column))
                                    : carry.push(existingY[index]);

                                return carry;
                            }, []);

                            return copy;
                        });
                        updateNgModel(vm.selected);
                    })
                })
            }

            function getYIndex(selected_x, column) {
                return lodash.findIndex(selected_x.y, function (_y) {
                    return _y.value === column.value
                });
            }

            function resetTable() {
                $timeout(function () {
                    $scope.$apply(function () {
                        vm.columns = vm.originalColumns.slice();
                        vm.selected = lodash.cloneDeep(vm.originalSelected);
                        updateNgModel(vm.selected);
                    })
                })
            }

            function Y(data) {
                this.value = data.value;
                this.choice = 'nil'
            }

            function ModelValue(selection, requiredY) {
                this.selection = selection;
                this.required_y = requiredY
            }
        }
    }
})();

(function () {
    'use strict';

    rmsFilterBarStandaloneCtrl.$inject = ['MainFilterBarService', '$scope', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarStandalone', rmsFilterBarStandalone);

    function rmsFilterBarStandalone() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getQuery: '=',
                resetQuery: '=?',
                refreshGrid: '&',
                refresh: '=?',
                setQuery: '=?',
            },
            controller: rmsFilterBarStandaloneCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/wrapper-standalone'
        };
    }

    function rmsFilterBarStandaloneCtrl(MainFilterBarService, $scope, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = lodash.get(vm.options, 'identifier', $scope.$id);
            MainFilterBarService.init(vm, vm.filterBarIdentifier, vm.options || {});

            vm.getQuery = () => {
                return vm.filterBarService().getGeneratedQuery();
            };

            vm.resetQuery = () => {
                vm.filterBarService().reset();
            };

            vm.refresh = () => {
                vm.filterBarService().refresh();
            };

            vm.setQuery = function(filters) {
                vm.filterBarService().setQuery(filters);
            };

            init();
        }

        function init() {
            vm.filterBarService().registerEvent('refreshGrid', vm.refreshGrid);
        }

        $scope.$on('$destroy', () => {
            MainFilterBarService.destroy(vm.filterBarIdentifier);
        });
    }
})();
(function () {
    'use strict';

    rmsFilterBarCtrl.$inject = ['MainFilterBarService', '$scope'];
    angular
        .module('rms.common')
        .directive('rmsFilterBar', rmsFilterBar);

    function rmsFilterBar() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getQuery: '=',
                resetQuery: '=',
                refreshGrid: '&',
                refresh: '=?',
                setQuery: '=?',
            },
            controller: rmsFilterBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/wrapper'
        };
    }

    function rmsFilterBarCtrl(MainFilterBarService, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$id;
            MainFilterBarService.init(vm, vm.filterBarIdentifier, vm.options || {});

            vm.getQuery = function () {
                return vm.filterBarService().getGeneratedQuery();
            };

            vm.resetQuery = function () {
                vm.filterBarService().reset();
            };

            vm.refresh = function () {
                return vm.filterBarService().refresh();
            };

            vm.setQuery = function (filters) {
                vm.filterBarService().setQuery(filters);
            };

            init();

            $scope.$on('$destroy', function () {
                MainFilterBarService.destroy(vm.filterBarIdentifier);
            });
        }

        function init() {
            vm.filterBarService().registerEvent('refreshGrid', vm.refreshGrid);
        }
    }
})();
(function () {
    'use strict';

    directiveCtrl.$inject = ['SodLogger', '$scope', '$timeout', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsListEditable', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                model: '=',
                options: '=',
                getModel: '='
            },
            controllerAs: 'vm',
            controller: directiveCtrl,
            bindToController: true,
            templateUrl: 'common/app/components/list-editable/index'
        };
    }

    function directiveCtrl(SodLogger, $scope, $timeout, lodash) {
        const vm = this;
        this.$onInit = function() {
            $timeout(function() {
                try {
                    const modelPath = getModelPath();
                    if (lodash.get(vm, modelPath.join('.'), []).length > 0) {
                        vm.refs.list.select(vm.refs.list.element.children().first());
                    }
                } catch (e) {
                    SodLogger.error('ERROR IN GETTING FIRST OBJECT', e);
                }
            });
        }

        function getModelPath() {
            const modelPath = ['model'];
            if (lodash.has(vm.options, 'dataSchemaPath')) {
                modelPath.push(vm.options.dataSchemaPath);
            }
            return modelPath;
        }

        const datasource = new kendo.data.DataSource({
            data: (lodash.has(vm.options, 'dataSchemaPath')) ? vm.model[vm.options.dataSchemaPath] : vm.model
        });

        vm.options.list.dataSource = datasource;
        vm.options.list.change = function(e) {
            vm.setModel(vm.refs.list.dataItem(this.select()));
            $scope.$apply();
        };
        vm.options.list.selectable = true;

        vm.getModel = function() {
            const data = datasource.data();
            if (lodash.has(vm.options, 'dataSchemaPath')) {
                const model = angular.copy(vm.model);
                lodash.set(model, vm.options.dataSchemaPath, data);
                return model;
            } else {
                return data;
            }
        };

    }
})();
(function () {
    'use strict';

    rmsListFilterStatusSelectionCtrl.$inject = ['lodash', 'rmsListFilterStatusSelectionFactory', '$scope', 'GenericModel', '$q', '$compile', '$element', '$templateCache', '$timeout', 'ListFilterStateFactory'];
    angular
        .module('rms.common')
        .directive('rmsListFilterStatusSelection', rmsListFilterStatusSelection);

    function rmsListFilterStatusSelection() {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            controller: rmsListFilterStatusSelectionCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function rmsListFilterStatusSelectionCtrl(lodash, rmsListFilterStatusSelectionFactory, $scope, GenericModel, $q, $compile, $element, $templateCache, $timeout, ListFilterStateFactory) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');
            rmsListFilterStatusSelectionFactory.sync(vm);
            $scope.$on('$destroy', function () {
                rmsListFilterStatusSelectionFactory.destroy();
            });
            syncFilters();

            let templateUrl = 'common/app/components/list-filter-status-selection/list-filter-status-selection';
            if (lodash.has(vm.options, 'templateUrl')) {
                templateUrl = vm.options.templateUrl;
            }
            const template = $templateCache.get(templateUrl);
            $element.html(template);
            $compile($element.contents())($scope);

            vm.selectStatus = selectStatus;
            vm.refreshData = setData;
            vm.isActive = isActive;
        }

        function syncFilters() {
            $timeout(function () {
                //ListFilterService.getFilterService().syncActiveFilter(vm);
                $scope.listFilterService = ListFilterStateFactory.get($scope.listFilterIdentifier);
                vm.listFilterData = {};
                $scope.listFilterService.sync(vm.listFilterData);
                vm.activeFilters = $scope.listFilterService.getFilterService().getActiveFilters();
                $scope.listFilterService.updateToolbarButtons(status);

                $scope.$watch(function () {
                    return $scope.listFilterService.getFilterService().getActiveFilters();
                }, function () {
                    vm.activeFilters = $scope.listFilterService.getFilterService().getActiveFilters();
                    $scope.listFilterService.updateToolbarButtons(status);
                });
            });
        }

        function isActive(status) {
            var pipelineValue = lodash.get(vm.activeFilters, 'pipeline[0].value', 0);
            pipelineValue = pipelineValue.map(function (_pipelineValue) {
                return _pipelineValue.toString();
            });

            //check if any of the status values is equal to pipeline valuesg
            return pipelineValue.some(function (_value) {
                return status.value.findIndex(function (_statusValue) {
                    return _value === _statusValue.toString();
                }) !== -1;
            });
        }

        function selectStatus(status) {

            var detailPanelAlwaysOn = lodash.get(vm.options, 'detail_panel.always_on', false);

            var canMassSelect = lodash.get(status, 'can_mass_select', false);

            var resetToOne = false;
            if ((vm.selectedStatus !== status.value)) {
                if (!detailPanelAlwaysOn) {
                    $scope.listFilterService.closeDetailPanel();
                }
                // $scope.listFilterService.setPage(1);
                $scope.listFilterService.clearSelected();
                resetToOne = true;
            }

            let template = lodash.get(status, 'filter_template_override', null);
            if (template === null) {
                template = vm.options.status_selection.filter_template;
            }
            // template = lodash.isNull(template) ? vm.options.status_selection.filter_template : template;
            $timeout(function () {
                if (!lodash.isEmpty(template)) {
                    $scope.listFilterService.getFilterService().setActiveFilter('pipeline', [angular.merge({}, template, {value: status.value})]);
                    $scope.listFilterService.refreshGrid(resetToOne);
                    $scope.listFilterService.toggleSelectable(canMassSelect);
                }
                if (lodash.isEmpty(template)) {
                    $scope.listFilterService.getFilterService().setActiveFilter('pipeline', [{value: status.value}]);
                    $scope.listFilterService.refreshGrid(resetToOne);
                    $scope.listFilterService.toggleSelectable(canMassSelect);
                }
            });

        }

        function setData() {
            $timeout(function () {
                $q.when(fetchData()).then(function (res) {
                    vm.data = res;
                    $scope.listFilterService.setPipelineData(res);
                });
            });
        }

        function fetchData() {
            if (lodash.has(vm.options.status_selection, 'datasource.url') && !lodash.has(vm.options.status_selection, 'datasource.data')) {
                const path = vm.options.status_selection.datasource.url;
                const method = lodash.get(vm.options.status_selection, 'datasource.method', 'get');
                var model = new GenericModel(path);
                const params = $scope.listFilterService.generateResourceOption({}, {
                    data: {filter: $scope.listFilterService.getFilterService().getAppliedFilters()}
                }, method);

                return model[method]({}, params).$promise.then(function (res) {
                    return res.data;
                });
            }
            if (!lodash.has(vm.options.status_selection, 'datasource.url') && lodash.has(vm.options.status_selection, 'datasource.data')) {
                return vm.options.status_selection.datasource.data;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('rmsListFilterStatusSelectionFactory', rmsListFilterStatusSelectionFactory);

    function rmsListFilterStatusSelectionFactory() {
        // singleton. Don't foresee that a page will have 2 of these for now.
        const ref = {};
        return {
            sync: function(vm) {
                ref.vm = vm;
            },
            get: function() {
                return ref.vm;
            },
            destroy: function() {
                ref.vm = null;
            }
        };
    }
})();


(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'rmsListFilterStatusSelectionFactory'];
    angular
        .module('rms.common')
        .factory('action-rms-refresh-list-filter-status', actionFunc);

    function actionFunc($q, rmsListFilterStatusSelectionFactory) {
        return function() {
            $q.when(run());
            function run() {
                const vm = rmsListFilterStatusSelectionFactory.get();
                if (!vm) return false;
                return vm.refreshData();
            }
        };
    }
})();

(function () {
    'use strict';

    rmsListTemplateView.$inject = ['lodash'];
    rmsListTemplateViewCtrl.$inject = ['$scope', 'ListTemplateViewStateService', '$compile', '$element', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsListTemplateView', rmsListTemplateView);

    /**
     * Receives options
     * - Includes templates per list-item, datasource/data, and others
     * Receives Model
     * - Set selection of list-item
     * Expose Events
     * - Refresh by external factors
     * Expose Model
     * - Get selection of list-item
     */
    function rmsListTemplateView(lodash) {
        return {
            restrict: 'E',
            scope: {
                options: '=', // options of the kendo-listview
                // model: '=', // get/set model
                refresh: '=',
                change: '&?ngChange'
            },
            require:'ngModel',
            controller: rmsListTemplateViewCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: rmsListTemplateViewLink
        };

        function rmsListTemplateViewLink(scope, elem, attr, ctrl) {
            var vm = scope.vm;

            ctrl.$formatters.push(function(_item) {
               if (!lodash.has(_item, 'selected')) {
                   _item.selected = [];
               }
               return _item;
            });

            ctrl.$render = function() {
                lodash.set(vm.stateData, 'model', ctrl.$viewValue);
            }

            lodash.set(vm.stateData, 'events.onChange', function() {
                ctrl.$setViewValue(vm.stateData.model);
                if (typeof vm.change == typeof function() {}) {
                    vm.change();
                }
            });
        }
    }

    function rmsListTemplateViewCtrl($scope, ListTemplateViewStateService, $compile, $element, lodash, $timeout) {
        const vm = this;
        this.$onInit = function() {
            // If not templates, just exit. No point trying to load the directive
            if (!lodash.has(vm.options, 'templates') && !lodash.has(vm.options, 'templateUrl')) {
                return;
            }

            // setting the $id of this directive. In case this directive is used multiple times in a view.
            vm.rmsListTemplateView = $scope.$id;

            // initialise the service
            ListTemplateViewStateService.init(vm, vm.rmsListTemplateView, vm.options || {});
            if (vm.model) {
                vm.service().syncModel(vm);
            }
            vm.service().syncState(vm);


            // preparing the various events listener that the templates can listen to
            vm.events = {
                refreshDatasource: vm.service().refreshDatasource,
                toggleSelected: vm.service().toggleSelected,
                action: vm.service().action,
                clearSelection: vm.service().clearSelection,
                hasNoSelection: vm.service().hasNoSelection,
            };

            vm.refresh = vm.events.refreshDatasource;

            $element.html(vm.stateData.listOptions.templates);
            const cloneElement = $compile($element.contents())($scope);

            // proper garbage collection
            $scope.$on('destroy', () => {
                ListTemplateViewStateService.destroy(vm.rmsListTemplateView);
                cloneElement.off();
            });
        }
    }
})();
(function () {
    'use strict';

    listTiles.$inject = ['lodash'];
    listTilesCtrl.$inject = ['$scope', '$element', '$compile'];
    angular
        .module('rms.common')
        .directive('listTiles', listTiles);

    function listTiles(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: "=",
            },
            controller: listTilesCtrl,
            link: function (scope, elem, attr, ctrl) {
                scope.scopeModel = [];
                ctrl.$render = function() {
                    scope.scopeModel = ctrl.$viewValue;
                }

                scope.events = {
                    action: action
                };

                function action(event_type, dataItem) {
                    var event_prefix = lodash.get(scope.options, 'event_prefix', '');
                    if (!!event_prefix) {
                        scope.$emit(event_prefix + '.' + event_type, dataItem);
                    }
                }

            },

        };
    }

    function listTilesCtrl($scope, $element, $compile) {
        this.$onInit = function() {
            $element.html($scope.options.template);
            var cloneElement = $compile($element.contents())($scope);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsManageFormField', rmsManageFormField);

    function rmsManageFormField() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {},
            templateUrl: 'common/app/components/manage-form/field',
            link: function(scope, elem, attr, ctrl) {
                scope.changeValue = changeValue;
                scope.toggleChildrenView = toggleChildrenView;

                scope.isOpen = false;

                ctrl.$render = function() {
                    scope.fieldModel = ctrl.$viewValue;
                };

                function changeValue(value) {
                    scope.fieldModel.value = value;
                    ctrl.$setViewValue(scope.fieldModel);
                }

                function toggleChildrenView() {
                    scope.isOpen = !scope.isOpen;
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsManageForm', rmsManageForm);

    function rmsManageForm() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: '=',
            },
            templateUrl: 'common/app/components/manage-form/manage-form',
            link: function(scope, elem, attr,ctrl) {
                ctrl.$render = function() {
                    scope.model = ctrl.$viewValue;
                }
            }
        };
    }
})();

(function () {
    'use strict';

    rmsFieldSectionCounterCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('rmsFieldSectionCounter', rmsFieldSectionCounter);

    function rmsFieldSectionCounter() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                max: '=?',
            },
            templateUrl: 'common/app/components/manage-form/section-counter',
            link: function(scope, elem, attr, ctrl) {
                var _ctrl = scope.ctrl;
                _ctrl.increment = increment;
                _ctrl.decrement = decrement;

                if (!scope.max) {
                    scope.max = 20;
                }

                _ctrl.value = 0;

                ctrl.$render = function () {
                    _ctrl.value = ctrl.$viewValue || 0;
                }

                function increment() {
                    if (_ctrl.value >= scope.max) {
                        return;
                    }
                    _ctrl.value += 1;
                    ctrl.$setViewValue(_ctrl.value);
                }

                function decrement() {
                    if (_ctrl.value > 0) {
                        _ctrl.value -= 1;
                        ctrl.$setViewValue(_ctrl.value);
                    }
                }
            },
            controller: rmsFieldSectionCounterCtrl,
            controllerAs: 'ctrl',
            bindToController: true,
        };
    }

    function rmsFieldSectionCounterCtrl($scope) {

    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsManageQuestionnaire', rmsManageQuestionnaire);

    function rmsManageQuestionnaire() {
        return {
            restrict: 'E',
            require: 'ngModel',
            templateUrl: 'common/app/components/manage-questionnaire/manage-questionnaire',
            scope: { options: '=?' },
            link: function(scope, elem, attr,ctrl) {
                ctrl.$render = function() {
                    scope.model = ctrl.$viewValue;
                }
            }
        };
    }
})();
(function () {
    'use strict';

    rmsPermissionCtrl.$inject = ['PermissionService', '$scope', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsPermission', rmsPermission);

    function rmsPermission() {
        return {
            restrict: 'E',
            controller: rmsPermissionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/permissions/main',
            scope: {
                options: '=?',
                selectedUser: '=?',
                model: '=?',
                getModel: '=',
                selectorForm: '=?'
            }
        };
    }

    function rmsPermissionCtrl(PermissionService, $scope, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.selectedItem = null;
            vm.showDescription = false;
            vm.service = new PermissionService();
            vm.service.initModel(vm.model);

            vm.onItemClick = function (item) {
                vm.selectedItem = item;
            };
            $timeout(function() {
                if (lodash.has(vm.options, 'trigger.on_load')) {
                    $scope.$emit(vm.options.trigger.on_load);
                }
            });

            vm.getModel = function (type) {
                if (type === 'entity-selector') {
                    return lodash.get(vm.options, 'entity_selector.model', {});
                }
                return vm.service.getModel();
            };

            $scope.$watch(function () {
                return vm.model;
            }, function () {
                vm.service.initModel(vm.model);
            });

            $scope.$watch(function() {
                return vm.options.permission_sections;
            }, function() {
                if (vm.options.permission_sections) {
                    vm.selectedItem = vm.options.permission_sections[0];
                } else {
                    vm.selectedItem = null;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    PermissionService.$inject = ['lodash'];
    angular
        .module('rms.common')
        .factory('PermissionService', PermissionService);

    function PermissionService(lodash) {
        return function() {
            let model = defaultModel();
            return {
                toggle: toggle,
                initModel: initModel,
                getModel: getModel,
                getModelReadOnly: getModelReadOnly,
                initItem: initItem,
            };

            function toggle(item) {
                const path = ['permissions', item.select_id, 'value'].join('.');
                lodash.set(model, path, !lodash.get(model, path, false));
            }

            function initModel(m) {
                model = m || defaultModel();
            }

            function getModel(item) {
                if (!item) {
                    return model;
                }
                return lodash.get(model, ['permissions', item.select_id, 'value'].join('.'), false);
            }

            function getModelReadOnly(item) {
                if (!item) {
                    return model;
                }
                return lodash.get(model, ['permissions', item.select_id, 'readonly'].join('.'), false);
            }

            function initItem(item) {
                const path = ['permissions', item.select_id, 'value'].join('.');
                if (!lodash.has(model, path)) {
                    lodash.set(model, path, false);
                }
            }

            function defaultModel() {
                return {
                }
            }
        };
    }
})();
(function () {
    'use strict';

    simpleProductSelectorConfirmLabel.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('simpleProductSelectorConfirmLabel', simpleProductSelectorConfirmLabel);

    function simpleProductSelectorConfirmLabel(lodash) {
        return {
            scope: {
                options: '=',
                selectedValue: '=',
                labelKey: '@',
            },
            templateUrl: 'common/app/components/product-selector/simple-product-selector-confirm-label',
            link: function(scope) {
                scope.sps = {
                    label: '',
                };
                scope.$watch('selectedValue', function() {
                    if (scope.selectedValue) {
                        var selectedProduct = lodash.find(scope.options.products, { id: scope.selectedValue });
                        scope.sps.label = lodash.get(selectedProduct, 'labels.' + scope.labelKey, '');
                    }
                })
            }
        };
    }
})();
(function () {
    'use strict';

    simpleProductSelector.$inject = ['CommonHelper', '$timeout', 'lodash'];
    angular
        .module('rms.common')
        .directive('simpleProductSelector', simpleProductSelector);

    function simpleProductSelector(CommonHelper, $timeout, lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                options: "=",
            },
            link: function (scope, elem, attr, ctrl) {
                scope.sps = {};

                ctrl.render = function () {
                    if (CommonHelper.isEmpty(ctrl.$viewValue)) {
                        scope.sps.selected_id = null;
                    } else {
                        scope.sps.selected_id = ctrl.$viewValue;
                    }
                };

                scope.sps.selectProduct = selectProduct;
                scope.sps.products = scope.options.products;
                $timeout(function() {

                    if (!scope.sps.selected_id) {
                        var first_enabled_product = lodash.find(scope.sps.products, {enabled: 1});
                        if (first_enabled_product) {
                            selectProduct(first_enabled_product);
                        }
                    }
                });
                // scope.sps.products = [
                //     {
                //         'id': 1,
                //         'name': 'RP Parser',
                //         'price': {
                //             'value': 'Free',
                //         }
                //     },
                //     {
                //         'id': 2,
                //         'name': 'Sovren',
                //         'price': {
                //             'value': '$5',
                //             'unit': 'per request'
                //         }
                //     },
                // ];

                function selectProduct(product) {
                    scope.sps.selected_id = product.id;
                    ctrl.$setViewValue(scope.sps.selected_id);
                }

            },
            templateUrl: 'common/app/components/product-selector/simple-product-selector',
        };
    }
})();
(function () {
    'use strict';

    RecruiterSelectionDialogCtrl.$inject = ['close', '$timeout', 'dialogOptions', 'lodash'];
    angular
        .module('rms.common')
        .controller('RecruiterSelectionDialogCtrl', RecruiterSelectionDialogCtrl);

    function RecruiterSelectionDialogCtrl(close, $timeout, dialogOptions, lodash) {
        const vm = this;
        vm.options = dialogOptions.options;
        vm.recruiter = dialogOptions.recruiter;
        vm.events = {
            toggleSelection: toggleSelection,
            selectionIsActive: selectionIsActive,
        };

        vm.selected_contacts = dialogOptions.selected_contacts || [];
        vm.is_selected = dialogOptions.is_selected;
        vm.dismiss = function () {
            close(false);
        };

        vm.confirm = function () {
            if (!!vm.recruiter.contacts && vm.recruiter.contacts.length > 0) {
                close({
                    selected_contacts: vm.selected_contacts
                });
            } else {
                close(true);
            }
        };

        function toggleSelection(contact) {
            var filtered = lodash.filter(vm.selected_contacts, function (_item) {
                return _item.select_id == contact.select_id;
            });
            if (filtered.length > 0) {
                vm.selected_contacts = lodash.filter(vm.selected_contacts, function (_item2) {
                    return _item2.select_id != contact.select_id;
                });
            } else {
                vm.selected_contacts.push(contact);
            }
        }

        function selectionIsActive(contact) {
            return lodash.filter(vm.selected_contacts, function (_item) {
                return _item.select_id == contact.select_id;
            }).length > 0;
        }

        $timeout(function () {
            vm.show = true;
        });
    }
})();
(function () {
    'use strict';

    RecruitmentSelectionController.$inject = ['$scope', 'lodash', 'GenericModel', '$q', 'ActionManager', '$timeout'];
    angular
        .module('rms.common')
        .controller('RecruitmentSelectionController', RecruitmentSelectionController);

    function RecruitmentSelectionController($scope, lodash, GenericModel, $q, ActionManager, $timeout) {
        const panelCtrl = getPanelCtrl($scope);
        const panelState = lodash.get(panelCtrl, 'panelState', null);
        const panelOption = lodash.get(panelState, 'structure.options', null);
        const panelModel = lodash.get(panelState, 'model', null);
        const panelForm = lodash.get(panelState, 'structure.component', null);


        // load preferred ds
        panelState.loading = true;
        $q.all([
            loadDs('preferredListing', panelOption.preferred_listing.datasource),
            loadDs('companyListing', panelOption.company_listing.datasource)
        ]).then(function (test) {
            $timeout(function () {
                panelState.loading = false;
            });
        });

        panelState.events = {
            select: select,
            isSelected: isSelected,
            getPreferredItem: getPreferredItem,
            getCompanyItem: getCompanyItem,
            getCompanyEmailItem: getCompanyEmailItem,
            removeContact: removeContact,
            removeSelected: removeSelected,
        };

        $scope.$on('$destroy', function () {
            ActionManager('dm-close-dialog', {});
        });

        function select(type, item) {
            // when select, need show dialog. dialog will allow selection of contacts.
            const selected = isSelected(type, item);
            let selected_contacts = null;

            if (type == 'preferred' && selected) {
                return;
            }

            if (type == 'company') {
                if (lodash.isEmpty(item.contacts) && selected) {
                    return;
                }

                const contact_field_name = 'selected_contacts_' + type;
                selected_contacts = lodash.get(panelModel[contact_field_name], item.select_id, []);
            }

            return $q.when(ActionManager('dm-open-dialog', {
                    controller: 'RecruiterSelectionDialogCtrl',
                    templateUrl: 'tms/templates/jobs/recruiter-selection-dialog',
                    dialog_options: {

                        recruiter: lodash.assign(item, {banner_options: panelOption.banner_options}),
                        hideModalHeader: true,
                        selected_contacts: selected_contacts,
                        is_selected: selected,
                        options: panelOption.dialog_options,
                    }
                }),

                function (res) {
                    res.modal.closed.then(function (dialogResult) {
                        if (dialogResult !== false) {
                            addSelected(type, item);
                            if (dialogResult !== true) {
                                addContacts(type, item, dialogResult.selected_contacts);
                            }
                        }
                    });
                }
            )
                ;
        }

        function isSelected(type, item) {
            const field_name = 'selected_' + type;
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                return _item.select_id === item.select_id;
            });
            return filtered.length > 0;
        }

        function addSelected(type, provider) {
            const field_name = 'selected_' + type;
            const existingValue = lodash.get(panelModel, field_name, []);
            const filtered = lodash.filter(existingValue, function (_item) {
                return _item.select_id === provider.select_id;
            });
            if (filtered.length > 0) {
                return;
            }

            if (!panelModel[field_name]) {
                panelModel[field_name] = [];
            }

            panelModel[field_name].push({
                id: provider.id,
                select_id: provider.select_id,
            });
        }

        function removeSelected(type, provider) {
            const field_name = 'selected_' + type;
            const contact_field_name = 'selected_contacts_' + type;
            const existingValue = lodash.get(panelModel, field_name, []);

            panelModel[field_name] = lodash.filter(existingValue, function (_item) {
                return _item.select_id !== provider.select_id;
            });
            delete panelModel[contact_field_name][provider.select_id];
        }

        function addContacts(type, provider, contacts) {
            const contact_field_name = 'selected_contacts_' + type;
            if (!panelModel[contact_field_name]) {
                panelModel[contact_field_name] = {};
            }
            panelModel[contact_field_name][provider.select_id] = contacts.map(function (_contact) {
                return {
                    id: _contact.id,
                    select_id: _contact.select_id,
                }
            });
        }

        function removeContact(type, provider, contact) {
            const contact_field_name = 'selected_contacts_' + type;
            panelModel[contact_field_name][provider.select_id] = lodash.filter(panelModel[contact_field_name][provider.select_id], function (_contact) {
                return _contact.select_id != contact.select_id;
            });
        }

        function getPreferredItem(item) {
            if (lodash.has(panelState, 'preferredListing')) {
                return lodash.find(panelState.preferredListing, {select_id: item.select_id});
            }
            return null;
        }

        function getCompanyItem(item) {
            if (lodash.has(panelState, 'companyListing')) {
                return lodash.find(panelState.companyListing, {select_id: item.select_id});
            }
            return null;
        }

        function getCompanyEmailItem(provider, email) {
            return lodash.find(provider.contacts, {
                select_id: email.select_id,
            });
        }

        function loadDs(name, _datasource) {
            const url = lodash.get(_datasource, 'url');
            const method = lodash.get(_datasource, 'method', 'get');
            const model = new GenericModel(url);
            const promise = model[method]().$promise.then(function (res) {
                panelState[name] = res.rows;
                return res.rows;
            });
            return promise;
        }

        function getPanelCtrl(_scope) {
            const _vm = lodash.get(_scope, 'vm', null);
            if (!!_vm && _vm.constructor.name == 'asyncPanelCtrl') {
                return _vm;
            }
            if (lodash.has(_scope, '$parent')) {
                return getPanelCtrl(_scope.$parent);
            }
            return null;
        }
    }
})();
(function () {
    'use strict';

    rmsRecruitmentRateDetailCtrl.$inject = ['lodash', 'QB_CONSTANTS'];
    angular
        .module('rms.common')
        .directive('rmsRecruitmentRateDetail', rmsRecruitmentRateDetail);

    function rmsRecruitmentRateDetail() {
        return {
            restrict: 'E',
            controller: rmsRecruitmentRateDetailCtrl,
            scope: {
                options: '=',
                model: '=',
                getModel: '=',
            },
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms/templates/company/recruitment-rate-details',
        };
    }

    function rmsRecruitmentRateDetailCtrl(lodash, QB_CONSTANTS) {
        var vm = this;
        this.$onInit = function() {
            vm.getModel = getModel;

            init();
        }

        function init() {
            if (lodash.has(vm.options, 'detail_form')) {
                vm.detail_form_model = vm.model.detail_form;
            }
            if (lodash.has(vm.options, 'charges_form')) {
                vm.charge_form_model = vm.model.charge_form;
            }

            vm.queryBuilder = {};
            // vm.columns = ['FirstName', 'LastName', 'Age', 'Gender', 'DOB', 'Major', 'School'];
            vm.columns = [
                {
                    'label': 'First Name',
                    'identifier': 'first_name'
                },
                {
                    'label': 'Last Name',
                    'identifier': 'last_name'
                },
                {
                    'label': 'Age',
                    'identifier': 'age'
                },
            ];
            vm.queryBuilderOptions = {
                expressionValuePrefix: '@',
                jointOperators: ['+', '-', '*', '/'],
                showBrackets: false,
                mode: QB_CONSTANTS.EQUATION_MODE,
                allowCustomQuery: QB_CONSTANTS.DISALLOW_CUSTOM_QUERY
            };
        }

        function getModel() {
            var detailFormModel = {}, chargeFormModel = {};
            if (lodash.has(vm.options, 'detail_form')) {
                detailFormModel = vm.getDetailFormModel();
            }
            if (lodash.has(vm.options, 'charges_form')) {
                chargeFormModel = vm.getChargesFormModel();
            }

            return angular.merge(vm.model, {'detail_form':detailFormModel}, {'charge_form':chargeFormModel});
        }
    }
})();
(function () {
    'use strict';

    reportBuilder.$inject = ['$timeout', 'lodash', 'FILTER_OPERATOR_CONSTANT'];
    reportBuilderCtrl.$inject = ['lodash', 'RequestHelper', 'FormBuilderService', '$q'];
    angular
        .module('rms.common')
        .directive('reportBuilder', reportBuilder);

    function reportBuilder($timeout, lodash, FILTER_OPERATOR_CONSTANT) {
        return {
            restrict: 'E',
            controller: reportBuilderCtrl,
            controllerAs: 'vm',
            bindToController: true,
            require: 'ngModel',
            scope: {
                options: '=',
                getModel: '=?'
            },
            templateUrl: 'common/app/components/report-builder',
            link: function (scope, elem, attr, ctrl) {
                var vm = scope.vm;
                vm.modelCtrl = ctrl;
                var firstLoad = true;
                $timeout(function () {
                    vm.getColumns();
                    vm.refreshQuery();

                    if (lodash.get(vm, 'options.watch_entity_type', false)) {
                        scope.$watch(vm.getEntityType, function (newVal, oldVal) {
                            if (firstLoad || (oldVal == newVal)) {
                                firstLoad = false;
                                return;
                            }

                            vm.options.columnsOptions.options = [];
                            vm.refreshColumnOptions();
                            var formData = lodash.get(vm.component_data, 'form', {});
                            vm.component_data.columns = [];
                            vm.component_data.filters = [];
                            vm.component_data.sort = [];
                            vm.resetQuery();

                            vm.saveDraft({
                                columns: [],
                                filters: [],
                                form: formData
                            });
                        });
                    }
                });

                ctrl.$formatters.push(function (modelValue) {
                    return modelValue;
                });

                ctrl.$render = function () {
                    scope.vm.component_data = ctrl.$viewValue;
                    $timeout(function () {
                        vm.setFilterQueries(scope.vm.component_data.filters);
                    });
                }
            }
        };
    }

    function reportBuilderCtrl(lodash, RequestHelper, FormBuilderService, $q) {
        var vm = this;
        this.$onInit = function() {
            vm._records = 0;
            vm.loading = false;
            vm.openPreview = openPreview;
            vm.hidePreview = hidePreview;
            vm.getComponentData = getComponentData;
            vm.generate = generate;
            vm.getModel = getComponentData;
            vm.getEntityType = getEntityType;
            vm.getColumns = getColumns;
            vm.getFilters = getFilters;
            vm.saveDraft = saveDraft;
            vm.setFormValidation = setFormValidation;
            vm.clearFormValidation = clearFormValidation;

            vm.component_data = {
                columns: [],
                filters: [],
                sort: [],
                form: {},
                schedule: {},
            };
        }


        function saveDraft(data) {
            vm.loading = true;
            var draftDs = lodash.get(vm, 'options.draft_datasource', null);
            if (!draftDs) {
                return;
            }

            RequestHelper.prepareDatasource(draftDs, data).then(function (res) {
                // get columns

                // get filters
                // vm.getColumns();
                // getFilters();
                console.log(res);
                vm.setFormModel(lodash.get(res, 'data.form', {}));

                //below code was added by Backend Coder
                vm.component_data.columns = lodash.get(res, 'data.columns', vm.component_data.columns);
                vm.component_data.filters = lodash.get(res, 'data.filters', vm.component_data.filters);
                vm.component_data.sort = lodash.get(res, 'data.sort', vm.component_data.sort);
                vm.component_data.rules = lodash.get(res, 'data.rules', vm.component_data.rules);
                vm.component_data.schedule = lodash.get(res, 'data.schedule', vm.component_data.schedule);
                vm.setFilterQueries(vm.component_data.filters);

                //end of Backend Coder Code

                $q.all([vm.getColumns(), vm.refreshQuery()]).then(function () {
                    vm.loading = false;
                })

            });
        }

        function getColumns() {
            var columnsDs = lodash.get(vm, 'options.columnsOptions.datasource', null);
            if (!columnsDs) {
                return;
            }
            var promise = RequestHelper.prepareDatasource(columnsDs, {})
            promise.then(function (res) {
                vm.options.columnsOptions.options = res.data;
                vm.refreshColumnOptions();
                // console.log(res);
            });

            return promise;
        }

        function getFilters() {
            var filterDs = lodash.get(vm, 'options.filterOptions.types.filter.datasource.init', null);

            if (!filterDs) {
                return;
            }

            var promise = RequestHelper.prepareDatasource(filterDs, {});

            promise.then(function (res) {
                // vm.options.columnsOptions.options = res.data;
                // console.log(res);
            });

            return promise;
        }

        function getEntityType() {
            if (!vm.getFormModel) {
                return false;
            }
            const formData = vm.getFormModel();
            return lodash.get(formData, vm.options.watch_entity_type, false);
        }

        function openPreview() {
            console.log('report builder open preview is clicked');
            if (!vm.preview_is_active) {
                vm.generate();
                vm.preview_is_active = true;
            }
        };

        function hidePreview() {
            vm.preview_is_active = false;
        };

        function getComponentData() {
            var data = angular.copy(vm.component_data);
            data.filters = (vm.getQuery) ? vm.getQuery() : [];
            data.form = vm.getFormModel();
            return data;
        }

        function generate() {
            var config = vm.getComponentData();
            vm.options.previewOptions = {
                columns: [{
                    title: "#",
                    field: '_index',
                    headerAttributes: {
                        'class': 'first-column text-right'
                    },
                    width: 65,
                    attributes: {
                        'class': 'first-column text-right',
                    }
                }].concat(lodash.sortBy(config.columns, lodash.get(vm.options, 'columnsOptions.sortField', 'position')).map(function (column) {
                    column.width = '120px';
                    return column;
                })),
                dataSource: lodash.fill(Array(100), null).map(function (value, index) {
                    return config.columns.reduce(function (result, column) {
                        result[column.field] = column.title + ' ' + (index + 1);
                        return result;
                    }, {_index: (index + 1)});
                }),
                dataBinding: function () {
                    vm._records = (this.dataSource.page() - 1) * this.dataSource.pageSize();
                },
                scrollable: true
            };
            console.log(config);
            // vm.previewGrid.setOptions(vm.options.previewOptions);
            // vm.preview_is_active = true;
        }


        function setFormValidation(form_validation_rules) {
            const formId = lodash.get(vm, 'options.form.name', false);
            if (!formId) return false;

            const fbService = FormBuilderService.get(formId);
            if (lodash.has(fbService, 'elementsService.setValidationRules')) {
                fbService.elementsService.setValidationRules(form_validation_rules, null, true);
            }
        }

        function clearFormValidation() {
            const formId = lodash.get(vm, 'options.form.name', false);
            if (!formId) return false;

            const fbService = FormBuilderService.get(formId);
            if (lodash.has(fbService, 'elementsService.setValidationRules')) {
                fbService.elementsService.setValidationRules(null, null, true);
            }
        }
    }
})();
(function () {
    'use strict';

    rmsSchedulerCtrl.$inject = ['lodash', 'GenericModel', '$timeout', '$scope'];
    angular
        .module('rms.common')
        .directive('rmsScheduler', rmsScheduler);

    function rmsScheduler() {
        return {
            restrict: 'E',
            controller: rmsSchedulerCtrl,
            controllerAs: 'schCtrl',
            scope: {
                options: '=',
                datasources: '=?',
                getModel: '=?',
                refresh: '=?',
                reload: '=?'
            },
            bindToController: true,
            templateUrl: 'common/app/components/scheduler/scheduler',
            // template:
            link: rmsSchedulerLink,
        };

        function rmsSchedulerLink(scope, elem) {

        }
    }

    function rmsSchedulerCtrl(lodash, GenericModel, $timeout, $scope) {
        var schCtrl = this;
        var date_format = 'YYYY-M-D';
        var time_format = 'h:mm A';
        this.$onInit = function() {
            schCtrl.reloads = false;

            schCtrl.timeslotpickerChange = timeslotpickerChange;
            schCtrl.getModel = getModel;
            schCtrl.refresh = refresh;
            schCtrl.reload = reload;
            schCtrl.form_display_type = 'inline';

            date_format = lodash.get(schCtrl.options, 'scheduler_settings.date_format', 'YYYY-M-D');
            time_format = lodash.get(schCtrl.options, 'scheduler_settings.time_format', 'h:mm A');
            // const date_time_format = date_format + ' ' + time_format;
            // let default_start_date = moment();
            // let default_end_date = moment().minutes(30);

            // if (lodash.has(schCtrl.options, 'scheduler_settings.start')) {
            //     default_start_date = moment(schCtrl.options.scheduler_settings.start, date_time_format);
            //     if (lodash.has(schCtrl.options, 'scheduler_settings.end')) {
            //         default_end_date = moment(schCtrl.options.scheduler_settings.end, date_time_format);
            //     } else {
            //         default_end_date = default_start_date.minutes(30);
            //     }
            // }

            // schCtrl.model = {
            //     start_date: default_start_date.format(date_format),
            //     start_time: default_start_date.format(time_format),
            //     end_date: default_end_date.format(date_format),
            //     end_time: default_end_date.format(time_format),
            //     time_zone: lodash.get(schCtrl.options, 'scheduler_settings.time_zone', ''),
            // };

            schCtrl.model = {
                start_date: '',
                start_time: '',
                end_date: '',
                end_time: '',
                time_zone: lodash.get(schCtrl.options, 'scheduler_settings.time_zone', ''),
            };

            schCtrl.time_slot_picker_options = lodash.get(schCtrl.options, 'scheduler_settings.time_slot_picker_options', {});

            schCtrl.scheduler_datasources = getDataSources();

            //this determines if we retrieve current date or range; set null for range
            schCtrl.current_date = new Date().toISOString();

            if (lodash.has(schCtrl.options, 'resources') && schCtrl.options.resources.length > 0) {
                angular.forEach(schCtrl.options.resources, function (resource) {
                    resource.dataSource = lodash.get(schCtrl.scheduler_datasources, resource.dataSource, {});
                });
            }
            setSchedulerOptions();
        }

        function getDataSources() {
            return lodash.reduce(schCtrl.datasources, function (result, datasource, index) {
                const ds = angular.copy(datasource);
                if (lodash.has(ds, 'transport.read')) {
                    if (lodash.has(ds.transport.read, 'url')) {
                        ds.transport.read = function (readOptions) {
                            var method = lodash.get(datasource.transport.read, 'method', 'query');
                            var url = lodash.get(datasource.transport.read, 'url', '');
                            var params = lodash.get(datasource.transport.read, 'params', {});
                            params.current_date = schCtrl.current_date;
                            var data = generateResourceOption(readOptions.data, params, method);
                            data.time_zone = schCtrl.model.time_zone;
                            var model = new GenericModel(url);
                            model[method](data).$promise.then(function (res) {
                                readOptions.success(res.data);
                            }, function (res) {
                                readOptions.error(res);
                            });
                        };
                    }
                }
                result[index] = ds;
                return result;
            }, {});
        }



        // if (lodash.has(vm.scheduler_datasources, vm.options.dataSource)) {
        //     vm.options.dataSource = vm.scheduler_datasources[vm.options.dataSource];
        // }

        function setSchedulerOptions() {
            var dateTimeConfig = {};
            if (lodash.has(schCtrl.options, 'workDayStart')) {
                dateTimeConfig.workDayStart = new Date(schCtrl.options.workDayStart);
            }
            if (lodash.has(schCtrl.options, 'workDayEnd')) {
                dateTimeConfig.workDayEnd = new Date(schCtrl.options.workDayEnd);
            }

            schCtrl.scheduler_options = angular.extend(
                {
                    change: function (eData) {
                        if (lodash.isEmpty(eData.resources.ownerId.toString())) {
                            setModel(eData);
                        }
                    },
                    navigate: function (e) {
                        schCtrl.current_date = e.date.toISOString();
                        refresh();
                    }
                },
                schCtrl.options,
                {
                    dataSource: lodash.get(schCtrl.scheduler_datasources, schCtrl.options.dataSource, {
                        data: [],
                    })
                },
                dateTimeConfig
            );
        }

        function generateResourceOption(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);
            if (method == 'search') {
                params = {'data': params};
            }
            return params;
        }

        function timeslotpickerChange() {
            // var start = moment(schCtrl.model.start_date + ' ' + schCtrl.model.start_time, date_time_format);
            // var end = moment(schCtrl.model.end_date + ' ' + schCtrl.model.end_time, date_time_format);
            // schCtrl.schedulerObj.select({
            //     start: start.toDate(),
            //     end: end.toDate(),
            //     resources: [0]
            // })
        }

        function setModel(schedulerDatetimeObj) {
            $scope.$apply(function () {
                var start = moment(schedulerDatetimeObj.start);
                var end = moment(schedulerDatetimeObj.end);
                schCtrl.model.start_date = start.format(date_format);
                schCtrl.model.start_time = start.format(time_format);
                schCtrl.model.end_date = end.format(date_format);
                schCtrl.model.end_time = end.format(time_format);
                schCtrl.render();
            });
        }

        function getModel() {
            return schCtrl.model;
        }

        function refresh() {
            // schCtrl.reloads = true;
            schCtrl.schedulerObj.dataSource.read().then(function (e) {
                // $timeout(function () {
                //     schCtrl.reloads = false;
                // })
            })
        }

        function reload() {
            schCtrl.reloads = true;
            $timeout(function () {
                setSchedulerOptions();
                schCtrl.reloads = false;
            });
        }
    }
})();
(function() {
  "use strict";

  rmsSkillsetManager.$inject = ['lodash', '$document', '$timeout'];
  rmsSkillsetManagerCtrl.$inject = ['lodash', 'GenericModel'];
  angular
    .module("rms.common")
    .directive("rmsSkillsetManager", rmsSkillsetManager);

  function rmsSkillsetManager(lodash, $document, $timeout) {
    return {
      restrict: "E",
      require: ["ngModel"],
      scope: {
        options: "=",
        refresh: "=?",
        readonly: "=?",
        hasError: "=?",
        errorMessage: "=?"
      },
      controller: rmsSkillsetManagerCtrl,
      controllerAs: "vm",
      bindToController: true,
      templateUrl: "common/app/components/skillset-manager",
      link: {
        post: function(scope, elem, attr, ctrl) {
          var vm = scope.vm;
          var ngModelCtrl = ctrl[0];

          init();

          // scope.$watch(function (scope) {
          //     return scope.vm.state.filteredSkills;
          // }, handleWatch, true);

          function init() {
            ngModelCtrl.$formatters.push(function(value) {
              return value.map(function(item) {
                var formatted = item;

                if (item.proficiency_id) {
                  var proficiency = lodash.find(vm.state.proficiencies, {
                    value: item.proficiency_id
                  });

                  formatted["level"] = lodash.findIndex(
                    vm.state.proficiencies,
                    {
                      value: item.proficiency_id
                    }
                  );

                  formatted["proficiency_label"] = proficiency
                    ? proficiency.label
                    : "";
                } else {
                  formatted["proficiency_id"] = null;
                }

                if (vm.state.mode === "review_skills") {
                  var expected = getProficiencyLabel(
                    item.expected_proficiency_id
                  );

                  formatted["expected_proficiency_label"] = expected;

                  var declared = getProficiencyLabel(
                    item.declared_proficiency_id
                  );

                  formatted["declared_proficiency_label"] = declared;
                }

                return formatted;
              });
            });

            ngModelCtrl.$parsers.push(function(value) {
              return value.map(function(item) {
                return lodash.pick(item, [
                  "id",
                  "category_id",
                  "proficiency_id",
                  "select_id",
                  "user_created",
                  "not_applicable",
                  "label"
                ]);
              });
            });

            ngModelCtrl.$render = function() {
              vm.state.createdSkills = ngModelCtrl.$viewValue.filter(function(
                item
              ) {
                return item.user_created;
              });

              vm.state.selectedSkills = ngModelCtrl.$viewValue.filter(function(
                item
              ) {
                return !item.user_created;
              });

              vm.state.combinedSkills = vm.state.requiredSkills.concat(
                  vm.state.selectedSkills.concat(vm.state.createdSkills)
              );
            };

            $document.on("click", function(e) {
              var hasParent = angular.element(e.target).parents('.skillset-manager');
              if (hasParent.length > 0) {
                return;
              }
              $timeout(function() {
                vm.closeDropdown();
              });
            });
          }

          vm.ngModelCtrl = ngModelCtrl;
          vm.handleKeyPress = handleKeyPress;
          vm.handleMouseOver = handleMouseOver;
          vm.handleMouseLeave = handleMouseLeave;
          vm.handleNA = handleNA;
          vm.handleProficiency = handleProficiency;

          // function handleWatch(newVal, oldVal) {
          //     $('.search-result-text').each(function (index) {
          //         var input = vm.state.searchInput;
          //         var original = $(this).html();
          //         console.log('original: ', original);
          //         var replacement = original.replace(new RegExp(`/${input}/`), `<strong>${input}</strong>`);
          //
          //         console.log('replacement:', replacement);
          //         $(this).html(replacement);
          //     })
          // }

          function handleKeyPress(e) {
            var key = e.key.toLowerCase();
            var filteredLength = vm.state.filteredSkills.length - 1;
            var filteredIds = lodash.map(vm.state.filteredSkills, "select_id");
            var currentHighlight = filteredIds.indexOf(vm.state.highlighted);
            var nextHighlight;

            switch (key) {
              case "enter":
                e.preventDefault();
                var currentSkill = lodash.find(vm.state.filteredSkills, {
                  select_id: vm.state.highlighted
                });
                vm.selectSkill(currentSkill);
              case "arrowup":
                nextHighlight = currentHighlight - 1;
                break;
              case "arrowdown":
                nextHighlight = currentHighlight + 1;
                break;
              default:
                return;
            }

            var inBound = nextHighlight >= 0 && nextHighlight <= filteredLength;

            if (!inBound) return;

            vm.highlightSkill(filteredIds[nextHighlight]);
            var active = $("#skill-search-dropdown .active");
            var highlighted = key === "arrowup" ? active.prev() : active.next();
            return highlighted.get(0).scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "end"
            });
          }

          function handleMouseOver(tooltip, $index, $event) {
            vm.setProficiencyTooltip(tooltip, $index);
            var currentTarget = $($event.currentTarget);
            var rowItems = currentTarget.parents(".selectors").children();

            var currentValue = parseInt(currentTarget.data("value"), 10);

            rowItems.each(function(index) {
              var item = $(this);
              var icon = item.children("i").first();

              if (index <= currentValue) {
                toggleIcon(icon, true);
              } else {
                toggleIcon(icon, false);
              }
            });
          }

          function handleMouseLeave(skill, $event) {
            vm.closeProficiencyTooltip();
            var level = skill ? skill.level : -1;
            var currentTarget = $($event.currentTarget);
            var buttons = currentTarget.find("button");

            return resetIcons(buttons, level);
          }

          function handleProficiency(skill, level) {
            vm.toggleProficiency(skill, level);
          }

          function handleNA(skill, $event, label) {
            vm.toggleProficiency(skill, null, label);
            var level = -1;
            var currentTarget = $($event.currentTarget);
            var siblingRow = currentTarget.prev();
            var buttons = siblingRow.children("button");

            return resetIcons(buttons, level);
          }

          function resetIcons(buttons, level) {
            buttons.each(function(index) {
              var icon = $(this)
                .children()
                .first();
              if (level >= index) {
                toggleIcon(icon, true);
              } else {
                toggleIcon(icon, false);
              }
            });
          }

          function toggleIcon(icon, state) {
            if (state) {
              icon.removeClass("fa-circle-thin");
              icon.addClass("fa-circle");
            } else {
              icon.removeClass("fa-circle");
              icon.addClass("fa-circle-thin");
            }
          }

          function getProficiencyLabel(id) {
            if (!id) return "-";

            var target = vm.state.proficiencies.filter(function(item) {
              return item.value === id;
            });

            if (target.length > 0) return target[0].label;
          }
        }
      }
    };
  }

  function rmsSkillsetManagerCtrl(lodash, GenericModel) {
    var vm = this;
    this.$onInit = function() {
      vm.state = {
      loading: false,
      no_result: false,
      mode: vm.options.options.mode,
      config: null,
      proficiencies: vm.options.options.proficiencies,
      dropdownActive: false,
      searchInput: "",
      highlighted: null,
      searchResults: [],
      requiredSkills: [],
      selectedSkills: [],
      createdSkills: [],
      combinedSkills: [],
      filteredSkills: [],
      previous: [],
      searchRequestInstance: null,
      searchModelOptions: lodash.get(vm.options, 'options.searchModelOptions', {
        debounce: 600
      }),
      proficiencyTooltip: {
        row: -1,
        text: "Level"
      }
    };

      vm.openDropdown = openDropdown;
      vm.closeDropdown = closeDropdown;
      vm.handleSearch = handleSearch;
      vm.filterSearch = filterSearch;
      vm.clearSearch = clearSearch;
      vm.selectSkill = selectSkill;
      vm.highlightSkill = highlightSkill;
      vm.removeSkill = removeSkill;
      vm.updateSkills = updateSkills;
      vm.toggleProficiency = toggleProficiency;
      vm.setProficiencyTooltip = setProficiencyTooltip;
      vm.closeProficiencyTooltip = closeProficiencyTooltip;

      init();

    }

    function init() {
      vm.state.config = getOptions(vm.state.mode);
      // console.log(vm.state.config);
      prepareSearchEndpoint();
    }

    function openDropdown() {
      vm.state.dropdownActive = true;
      if (vm.state.filteredSkills.length > 0) {
        highlightSkill(vm.state.filteredSkills[0].select_id);
      }

    }

    function closeDropdown() {
      vm.state.dropdownActive = false;
    }

    function handleSearch(e) {
      var retain = e && e.type === "click";
      vm.state.dropdownActive = true;
      if (vm.state.searchInput.length > 0)
        return filterSearch(vm.state.searchInput, retain);
      return closeDropdown();
    }

    function formatResults(data, input, retain) {
      var selected = vm.state.selectedSkills;
      var deduped = lodash.differenceBy(data, selected, "label");
      var labels = lodash.map(deduped, function(item) {
        return item.label.toLowerCase();
      });
      var exactMatch = lodash.filter(labels, function(label) {
        return label === input.toLowerCase();
      });

      var exactMatchSelected = lodash.filter(selected, function(_selected) {
        return _selected.label.toLowerCase() === input.toLowerCase();
      });

      // vm.state.filteredSkills[0]["hidden"] = exactMatch.length > 0;
      var result = retain ? deduped : sort(deduped, input);
      if ((exactMatch.length == 0) && (exactMatchSelected.length == 0)) {
        result = [new Skill(input)].concat(result);
      }
      return result;
    }

    function filterSearch(input, retain) {
      console.log('filtersearch retain', retain, input);
      if (retain) {
        // var previous = vm.state.filteredSkills.splice(1);
        vm.state.filteredSkills = formatResults(vm.state.previous, input, retain);

        openDropdown();
      } else {
        requestSearch(input);
      }
    }

    function requestSearch(input) {
      vm.state.no_result = false;
      vm.state.loading = true;
      resetSearchResult();
      if (!vm.search_resource) {
        vm.state.filteredSkills.unshift(new Skill(input));

        vm.state.loading = false;
        return;
      }
      vm.state.previous.length = 0;

      if (!!vm.state.searchRequestInstance) {
        vm.state.searchRequestInstance.$cancelRequest();
      }

      vm.state.searchRequestInstance = vm.search_resource[vm.search_method]({
        query: input
      });

      vm.state.searchRequestInstance.$promise.then(function(res) {
        resetSearchResult();
        var results = res.data;
        if (results.length > 0) {
          vm.state.previous = results;
        } else {
          vm.state.no_result = true;
        }
        var formatted = formatResults(vm.state.previous, input);
        // vm.state.filteredSkills.unshift(new Skill(input));
        vm.state.filteredSkills = vm.state.filteredSkills.concat(formatted);
        vm.state.loading = false;
        openDropdown();
        vm.state.searchRequestInstance = null;
      });
    }

    function sort(data, input) {
      return matchSorter.default(data, input, {
        keys: ["label"]
      });
    }

    function clearSearch() {
      vm.state.searchInput = "";
      vm.state.no_result = false;
      resetSearchResult();
      vm.state.previous.length = 0;
      return closeDropdown();
    }

    function resetSearchResult() {
      vm.state.filteredSkills.length = 0;
    }

    function highlightSkill(select_id) {
      vm.state.highlighted = select_id;
    }

    function selectSkill(skill) {
      var isDupe =
        lodash.findIndex(vm.state.combinedSkills, { label: skill.label }) >= 0;

      // if (skill.user_created && !isDupe) {
      //   vm.state.createdSkills.push(skill);
      // }

      if (!isDupe) {
        vm.state.selectedSkills.unshift(angular.copy(skill));
      }

      updateSkills();

      return closeDropdown();
    }

    function removeSkill(skill) {
      var selectedList = vm.state.selectedSkills;
      var createdList = vm.state.createdSkills;

      var selectedPos = selectedList.indexOf(skill);
      var createdPos = createdList.indexOf(skill);

      if (selectedPos !== -1) {
        selectedList.splice(selectedPos, 1);
      } else if (createdPos !== -1) {
        createdList.splice(createdPos, 1);
      }

      return updateSkills();
    }

    function updateSkills() {
      vm.state.combinedSkills = vm.state.requiredSkills.concat(
        vm.state.selectedSkills.concat(vm.state.createdSkills)
      );
      vm.ngModelCtrl.$setViewValue(vm.state.combinedSkills);
    }

    function toggleProficiency(skill, level, label) {
      if (level !== null) {
        skill.proficiency_id = vm.state.proficiencies[level].value;
        skill.proficiency_label = vm.state.proficiencies[level].label;
        skill.level = level;
        skill.not_applicable = false;
      } else {
        skill.proficiency_id = -1; // -1 required for validation check
        skill.level = -1;
        skill.proficiency_label = label;
        skill.not_applicable = true;
      }

      // clone to trigger $setViewValue..
      var copy = lodash.clone(vm.state.combinedSkills);

      vm.ngModelCtrl.$setViewValue(copy);
    }

    function setProficiencyTooltip(value, row) {
      vm.state.proficiencyTooltip.text = value;
      vm.state.proficiencyTooltip.row = row;
    }

    function closeProficiencyTooltip() {
      return (vm.state.proficiencyTooltip.row = -1);
    }

    function prepareSearchEndpoint() {
      // var url = lodash.get(vm.opt)
      if (!vm.search_resource) {
        var url = lodash.get(vm.options, "options.search.url", null);

        vm.search_resource = url ? new GenericModel(url) : null;
        vm.search_method = lodash.get(
          vm.options,
          "options.search.method",
          "query"
        );
      }
    }

    function Skill(input) {
      this.id = null;
      this.label = input;
      this.proficiency_id = null;
      this.select_id = Date.now();
      this.category_name = null;
      this.category_id = null;
      this.user_created = true;
      this.not_applicable = false;
    }

    function Config(options) {
      this.showSearch = options.showSearch;
      this.showRemove = options.showRemove;
      this.showReview = options.showReview;
      this.showDivider = options.showDivider;
      this.showNA = options.showNA;
    }

    function getOptions(mode) {
      var options = {};
      switch (mode) {
        case "add_skills":
          options.showSearch = true;
          options.showRemove = true;
          options.showReview = false;
          options.showNA = false;
          options.showDivider = false;
          break;
        case "required_skills":
          options.showSearch = false;
          options.showRemove = false;
          options.showReview = false;
          options.showNA = true;
          options.showDivider = false;
          break;
        case "review_skills":
          options.showSearch = false;
          options.showRemove = false;
          options.showReview = true;
          options.showNA = true;
          options.showDivider = true;
          break;
      }
      return new Config(options);
    }
  }
})();

(function() {
    'use strict';

    PersonaSelectionController.$inject = ['$scope', 'lodash'];
    angular
        .module('rms.common')
        .controller('PersonaSelectionController', PersonaSelectionController);

    function PersonaSelectionController($scope, lodash) {
        const panelCtrl = $scope.vm;
        const panelState = lodash.get(panelCtrl, 'options', null);
        const panelOption = lodash.get(panelState, 'structure.options', null);
        const panelModel = lodash.get(panelState, 'model', null);

        var selectedPersona = null;

        toggleButtonDisable();

        console.log({panelCtrl, panelState, panelOption, panelModel});

        panelCtrl.getModel = function () {
            return {selected_persona: selectedPersona};
        }

        panelCtrl.events = {
            selectItem: selectItem,
            isSelected: isSelected,
            hasSelection: hasSelection,
            onLoadItems: onLoadItems,
        }

        function onLoadItems() {
            var selected = lodash.get(panelOption, 'selected', null);
            selectedPersona = lodash.find(panelModel.suggestion_info.suggestion_data, {
                select_id: selected,
            });
            toggleButtonDisable();
        }


        function selectItem(item) {
            selectedPersona = item;
            toggleButtonDisable();
        }

        function isSelected(item) {
            if (hasSelection()) return item.select_id === selectedPersona.select_id;
        }

        function hasSelection() {
            return (selectedPersona);
        }

        function toggleButtonDisable() {
            if (!hasSelection()) {
                panelOption.buttons.confirm_btn.attr.disabled = true;
            } else {
                panelOption.buttons.confirm_btn.attr.disabled = false;
            }
        }
    }
})();
(function () {
    'use strict';

    treeViewItemCtrl.$inject = ['$compile', '$element', '$scope'];
    angular
        .module('rms.common')
        .directive('treeViewItem', treeViewItem);

    function treeViewItem() {
        return {
            restrict: 'E',
            controller: treeViewItemCtrl,
            controllerAs: 'vm',
            scope: {
                item: '=',
                template: '=',
                handleClick: '=',
            },
            bindToController: true
        };
    }

    function treeViewItemCtrl($compile, $element, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.open = true;
            vm.toggle = function() {
                vm.open = !vm.open;
            };

            $element.html(vm.template);
            var cloneElem = $compile($element.contents())($scope);
            $scope.$on('destroy', function() {
                if (cloneElem != null) {
                    cloneElem.off();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    rmsTreeViewCtrl.$inject = ['$templateCache', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsTreeView', rmsTreeView);

    function rmsTreeView() {
        return {
            restrict: 'E',
            controller: rmsTreeViewCtrl,
            controllerAs: 'vm',
            scope: {
                items: '=',
                options: '=',
                onItemClick: '&?',
            },
            bindToController: true,
            templateUrl: 'common/app/components/treeview/treeview'
        };
    }

    function rmsTreeViewCtrl($templateCache, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.handleClick = function(item) {
                vm.onItemClick({ item: item });
            };

            if (lodash.has(vm.options, 'template')) {
                vm.template = vm.options.template;
            } else {
                if (lodash.has(vm.options, 'templateUrl')) {
                    vm.template = $templateCache.get(vm.options.templateUrl);
                } else {
                    vm.template = $templateCache.get('common/app/components/treeview/treeview-item');
                }
            }
        }
    }
})();
(function () {
    'use strict';

    rmsDocumentDownloadLinkCtrl.$inject = ['ActionManager'];
    angular
        .module('rms.common')
        .directive('rmsDocumentDownloadLink', rmsDocumentDownloadLink);

    function rmsDocumentDownloadLink() {
        return {
            restrict: 'E',
            controller: rmsDocumentDownloadLinkCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                downloadUrl: '=',
                downloadLabel: '@?',
                notifyLabel: '@?',
            },
            template: '<a ng-click="vm.click()" class="position-left" ng-bind-html="(vm.downloadLabel || \'Download\') | trustAsHtml"></a>',
        };
    }

    function rmsDocumentDownloadLinkCtrl(ActionManager) {
        const vm = this;
        this.$onInit = function() {
            vm.click = click;
        }

        function click() {
            ActionManager('notify', {
                'template': vm.notifyLabel || 'Please wait while we prepare your download...',
                'hasDelay': true,
                'delay'   : 2000,
                'type'    : 'success',
                'position': 'top center'
            });
            ActionManager('download', { route: vm.downloadUrl });
        }
    }
})();
(function () {
    'use strict';

    documentLibraryPreviewActionBar.$inject = ['lodash', '$templateCache'];
    documentLibraryPreviewActionBarCtrl.$inject = ['ListFilterStateFactory', '$timeout', 'lodash'];
    angular
        .module('rms.common')
        .directive('documentLibraryPreviewActionBar', documentLibraryPreviewActionBar);

    function documentLibraryPreviewActionBar(lodash, $templateCache) {
        return {
            restrict: 'E',
            controller: documentLibraryPreviewActionBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=?',
                options: '=?',
            },
            template: function(elem, attr) {
                var templateUrl = lodash.get(attr, 'templateUrl', '');
                if (templateUrl.length > 0) {
                    var template = $templateCache.get(templateUrl);
                    if (lodash.isEmpty(template)) {
                        return $templateCache.get('common/app/components/document-library/preview-action-bar');
                    }
                    return template;
                }

                return $templateCache.get('common/app/components/document-library/preview-action-bar');
            }
        };
    }

    function documentLibraryPreviewActionBarCtrl(ListFilterStateFactory, $timeout, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.showList = showList;

            $timeout(function() {
                init();
            });
        }

        function init() {
            var listFilterService = ListFilterStateFactory.get();
            listFilterService.sync(vm);
        }

        function showList() {
            var listFilterIdentifier = lodash.get(vm.options, 'identifier', null);

            var listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
            listFilterService.hideDetailView();
        }
    }
})();
(function () {
    'use strict';

    rmsDocumentViewerDialogCtrl.$inject = ['DialogManager', '$templateCache', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsDocumentViewerDialog', rmsDocumentViewerDialog);

    function rmsDocumentViewerDialog() {
        return {
            restrict: 'E',
            controller: rmsDocumentViewerDialogCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                name: '=',
                mimeType: '=',
                fileUrl: '=',
                downloadUrl: '=?',
                label: '@'
            },
            template: '<a ng-if="vm.fileUrl" ng-bind-html="vm.label | trustAsHtml" ng-click="vm.click()"></a>',
        };
    }

    function rmsDocumentViewerDialogCtrl(DialogManager, $templateCache, lodash) {
        var vm = this;
        var dialogOptions = {};
        this.$onInit = function() {
            vm.click = click;

            dialogOptions = {
                // functionality shouldn't change regardless of view. So we Hardcode the Controller
                // Otherwise, options can override it.
                controller: ['close', '$timeout', 'dialogOptions', function (close, $timeout, dialogOptions) {
                    const vm = this;
                    vm.options = dialogOptions;
                    $timeout(function () {
                        vm.show = true;
                    });
                    vm.dismiss = function () {
                        close();
                    }
                }],
                template: $templateCache.get('common/app/components/document-library/document-viewer-dialog'),
                dialog_options: {
                    modalSize: 'large modal-height-restrict-without-footer ' + ((vm.downloadUrl) ? 'google-doc-viewer-with-action' : 'google-doc-viewer-wrapper'),
                    classes: {
                        wrapper: ''
                    },
                    title: vm.name,
                    mimeType: vm.mimeType,
                    fileUrl: vm.fileUrl,
                    downloadUrl: vm.downloadUrl,
                }
            };
        }

        function click() {
            DialogManager.init(vm.fileUrl, dialogOptions);
        }
    }
})();
(function () {
	'use strict';
	placementTab.$inject = ['lodash'];
	angular
		.module('rms.common')
		.directive('placementTab', placementTab);

	function placementTab(lodash) {
		return {
			restrict: 'E',
			templateUrl: 'rms/templates/shared/placement-tab',
			link: function(scope) {
				var vm = scope.vm;
				var placement_datasource = {};

				scope.component_data = {
					isActive: isActive,
					current_view: getCurrentView(),
					setView: setView,
					placement_datasource: placement_datasource
				};



				function getCurrentView() {
					if (lodash.has(scope.vm.panelState.structure, 'options.default_view')) {
						return scope.vm.panelState.structure.options.default_view;
					}
					return (vm.panelState.structure.options.has_details) ? 'details' : 'history';
				}

				function setView(view) {
					scope.component_data.current_view = view;
				}

				function isActive(type) {
					return type == scope.component_data.current_view;
				}
			}
		};
	}

})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsWorkOrderClientDetails', rmsWorkOrderClientDetails);

    function rmsWorkOrderClientDetails() {
        return {
            restrict: 'E',
            scope: {
                details: "=",
                rates: '=?',
            },
            controller: rmsWorkOrderClientDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms/templates/work-orders/work-order-client-details'
        };
    }

    function rmsWorkOrderClientDetailsCtrl() {}
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsWorkOrderJobDetails', rmsWorkOrderJobDetails);

    function rmsWorkOrderJobDetails() {
        return {
            restrict: 'E',
            scope: {
                details: "="
            },
            controller: rmsWorkOrderJobDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms/templates/work-orders/work-order-job-details'
        };
    }

    function rmsWorkOrderJobDetailsCtrl() {}
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsWorkOrderPortalDetails', rmsWorkOrderPortalDetails);

    function rmsWorkOrderPortalDetails() {
        return {
            restrict: 'E',
            scope: {
                details: "="
            },
            controller: rmsWorkOrderPortalDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms/templates/work-orders/work-order-portal-details'
        };
    }

    function rmsWorkOrderPortalDetailsCtrl() {}
})();
(function () {
    'use strict';

    woProfileTab.$inject = ['lodash', 'customDropdownButtonService'];
    angular
        .module('rms.common')
        .directive('candidateProfileTab', woProfileTab);

    var templateUrl = 'rms/templates/candidates/profile-tab';

    function woProfileTab(lodash, customDropdownButtonService) {
        return {
            restrict: 'E',
            controller: ['$scope', '$compile', '$templateCache', '$element', function($scope, $compile, $templateCache, $element) {
                var vm = $scope.vm;
                this.$onInit = function() {
                    var template = $templateCache.get(templateUrl);
                    if (lodash.has(vm.panelState, 'structure.options.template')) {
                        template = vm.panelState.structure.options.template;
                    }

                    $element.html(template);
                    const elementClone = $compile($element.contents())($scope);
                    $scope.$on('$destroy', () => {
                        elementClone.off();
                    });
                }
            }],
            link: function(scope) {
                var vm = scope.vm;
                var profile_datasource = vm.panelState.structure.options.profile_datasource;


                scope.component_data = {
                    setView: setView,
                    selectDocument: selectDocument,
                    selectProfile: selectProfile,
                    selectItem: selectItem,
                    current_view: getCurrentView(),
                    isActive: isActive,
                    profile_datasource: profile_datasource,
                    printProfile: printProfile,
                };

                init();

                function init() {
                    switch (scope.component_data.current_view) {
                        case "resume":
                            selectDocument('resume', getFirstAttachment('resumes'));
                            break;
                        case "recruiter":
                        case "client":
                            setView(scope.component_data.current_view);
                            break;
                        case "attachment":
                            selectDocument('attachment', getFirstAttachment('attachments'));
                            break;
                    }
                }

                function getCurrentView() {
                    if (lodash.has(scope.vm.panelState.structure, 'options.default_view')) {
                        return scope.vm.panelState.structure.options.default_view;
                    }
                    if (lodash.has(scope.vm.panelState.structure, 'options.resumes')) {
                        return 'resume';
                    }
                    return 'profile';
                }

                function selectDocument(type, document) {
                    scope.component_data.active_document = document;

                    setView(type);
                }

                function selectProfile(item) {
                    customDropdownButtonService.closeAll();
                    scope.component_data.active_document = null;
                    if (lodash.has(item, 'document')) {
                        scope.component_data.active_document = item.document;
                    }
                    setView(item.value);
                }

                function selectItem(item) {
                    if (['attachment', 'resume'].indexOf(scope.component_data.current_view) >= 0) {
                        selectDocument(scope.component_data.current_view, item);
                    } else {
                        selectProfile(item);
                    }
                }

                function setView(view) {
                    if (!(['attachment', 'resume'].indexOf(view) >= 0)) {
                        var selected_profile = lodash.find(profile_datasource, { value: view});
                        scope.component_data.visibility = lodash.get(scope.vm.panelState.structure, 'options.visibility.' + view, {});
                        scope.component_data.selected_datasource = angular.copy(profile_datasource);
                        scope.component_data.current_selected_text = '<span>' + selected_profile.name + ' <i class="fa fa-caret-down"></i></span>';
                    } else {
                        if (view === 'attachment') {
                            scope.component_data.selected_datasource =  angular.copy(getAttachmentDs('attachments'));
                        }
                        if (view === 'resume') {
                            scope.component_data.selected_datasource = angular.copy(getAttachmentDs('resumes'));
                        }
                        scope.component_data.current_selected_text = '<span>' + scope.component_data.active_document.name + ' <i class="fa fa-caret-down"></i></span>';
                    }
                    if (scope.component_data.active_document !== null) {
                        if (typeof scope.component_data.refreshDocViewer == typeof function() {}) {
                            scope.component_data.refreshDocViewer();
                        }
                    }
                    scope.component_data.current_view = view;
                }

                function isActive(type) {
                    if (type === 'profile') {
                        return lodash.find(profile_datasource, { value: scope.component_data.current_view});
                    }
                    return type == scope.component_data.current_view;
                }

                function getAttachmentDs(type) {
                    var key = lodash.get(vm ,'panelState.structure.options.config.attachment_datasource_key', 'structure.options');
                    return lodash.get(vm.panelState, [key, type].join('.'), []);
                }

                function getFirstAttachment(type) {
                    var ds= getAttachmentDs(type);
                    return ds.length > 0 ? ds[0] : null;
                }

                function printProfile() {
                    // var ifr = document.createElement('iframe');
                    // ifr.style='height: 0px; width: 0px; position: absolute';
                    // ifr.onload = function() {
                    //
                    // };
                    // document.body.appendChild(ifr);
                    // $("<link/>",
                    //     { rel: "stylesheet", href: 'http://cdn.coolbeans.test/assets/css/rms.css', type: "text/css" }
                    // ).appendTo(ifr.contentDocument.head);
                    //
                    //
                    // $('.candidate-profile').clone().appendTo(ifr.contentDocument.body);
                    // ifr.contentDocument.body.className = 'rms-common';
                    // ifr.contentWindow.print();

                    // ifr.parentElement.removeChild(ifr);
                    var printElement =  document.createElement('div');
                    $(printElement).addClass('printSection');
                    document.body.append(printElement);
                    $('.candidate-profile').clone().appendTo(printElement);
                    var originalTitle = document.title;
                    var candidateName = $('.candidate-profile-detail-panel-header > span').text().trim();
                    if (candidateName.length === 0) {
                        $('div[ng-bind="profile_data.profile_overview.full_name"]').each(function () {
                            candidateName = $(this).text();
                        });
                    }
                    document.title = (candidateName || 'Candidate Profile').match(/\w+/g).join(' ');
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    window.print();
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    document.title = originalTitle;
                    $('.printSection').remove();
                }
            }
        };
    }
})();
(function () {
    'use strict';

    rmsActivityInputComponent.$inject = ['lodash'];
    rmsActivityInputComponentCtrl.$inject = ['$scope', 'lodash', 'ActivityInputService'];
    angular
        .module('rms.common')
        .directive('rmsActivityInput', rmsActivityInputComponent);

    function rmsActivityInputComponent(lodash) {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getModel: '=?',
                reset: '=?',
                defaultModel: '=?',
                preview: '=?',
                onDiscard: '=?',
            },
            templateUrl: 'common/app/components/activities/activity-input/activity-input',
            controller: rmsActivityInputComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope, elem, attr) {
                const vm = scope.vm;
                vm.hideAddAttachment = lodash.has(attr, 'hideAddAttachment');
            }
        };
    }

    var regexSignature = /(<div\sclass=['"]signature-wrapper['"]>[\S\s]*<\/div>|<p>&nbsp;<\/p>|<p><\/p>)/g;
    function rmsActivityInputComponentCtrl($scope, lodash, ActivityInputService) {
        var vm = this;
        this.$onInit = function() {
            const defaultModel = lodash.get(vm, 'defaultModel', {});
            vm.model = angular.copy(defaultModel);

            vm.getModel = getModel;
            vm.reset = reset;
            vm.handleOnChange = handleOnChange;
        }

        function getModel() {
            return vm.model;
        }

        function reset() {
            // vm.model = {};
            // vm.model = vm.defaultModel;
            // angular.merge(vm.model, angular.copy(defaultModel));
            var elements = vm.options.options.elements;
            lodash.forIn(vm.model, function(value, key) {
               var element = lodash.find(elements, {name: key});
               if (element) {
                   vm.model[key] = ActivityInputService.getTypeDefaultValue(element);
               }
            });
        }


        $scope.$watch('vm.options.options.value', function() {
           console.log('type changed');
            if (vm.options.options.value !== 'email') {
                const fieldName = lodash.get(vm.options, 'inputOptions.signatureSettings.fieldName', false);
                if (fieldName !== false && fieldName !== null) {
                    if (lodash.has(vm.model, fieldName)) {
                        vm.model[fieldName] = vm.model[fieldName].replace(regexSignature,'');
                    // } else {
                        // lodash.set(vm.model, fieldName, re)
                    }

                }
            }
        });

        function handleOnChange(name, value) {
            console.log('handleOnChange', name, value, vm.options);
            const instructions = lodash.get(vm.options, 'inputOptions.onChangeInstructions', null);
            if (!!instructions) {
                const instruction = lodash.find(instructions, {name: name});
                if (!!instruction) {
                    execOnChangeInstructions(instruction.type, value);
                }
            }
        }

        function execOnChangeInstructions(type, data) {
            switch (type) {
                case 'setSignature': {
                    setSignature(data);
                    break;
                }
                default: {
                    break;
                }
            }
        }

        function setSignature(data) {
            // get the txt description field
            const fieldName = lodash.get(vm.options, 'inputOptions.signatureSettings.fieldName', false);
            if (!!fieldName) {
                let newData = '';
                let previousData = lodash.get(vm.model, fieldName, '');
                if (!previousData) {
                    previousData = '';
                }
                previousData = previousData.replace(regexSignature,'');

                // get signature
                const signatureId = lodash.get(data, 'signature.default', null);
                const signatureLists = lodash.get(data, 'signature.list', []);
                const signature = lodash.find(signatureLists, {id: signatureId});
                if (!!signature) {
                    const signatureHtml = '<p></p><div class="signature-wrapper">' + signature.signature + '</div>';
                    newData = previousData + signatureHtml;
                } else {
                    newData = previousData;
                }

                lodash.set(vm.model, fieldName, newData);

                // $rootScope.$apply();
            }
        }


        // $scope.$watch(function() {
        //     return vm.model.sel_email_from;
        // }, function() {
        //     console.log(vm);
        //
        // })
    }
})();
(function () {
    'use strict';

    offlinePaymentMethod.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('offlinePaymentMethod', offlinePaymentMethod);

    function offlinePaymentMethod(lodash) {
        return {
            retrict: 'E',
            scope: {
                options: '=?',
            },
            require: 'ngModel',
            templateUrl: 'common/app/components/billing/offline-payment-methods',
            link: function (scope, iElement, iAttrs, ngModelCtrl) {

                ngModelCtrl.$formatters.push(function(modelValue) {

                    if (!lodash.get(modelValue, 'payment_method', false)) {
                        modelValue.payment_method = getFirstTypeValue();
                    }

                    if (!lodash.get(modelValue, 'formDetails', false)) {
                        modelValue.form_details = initFormDetail();
                    }

                    return modelValue;
                });

                ngModelCtrl.$render = function() {
                    scope.ppModel = ngModelCtrl.$viewValue;
                };

                function setModel() {
                    ngModelCtrl.$setViewValue(scope.ppModel);
                }

                function getFirstTypeValue() {
                    if (lodash.has(scope.options, 'types')
                        && scope.options.types instanceof Array
                        && scope.options.types.length > 0) {
                        return scope.options.types[0].value;
                    }
                    return false;
                }

                function initFormDetail() {

                    if (getFirstTypeValue()) {
                        return scope.options.types.reduce(function(result, type) {
                            result[type.value] = {};
                            return result;
                        }, {});
                    }
                    return {};
                }
            },
        };
    }
})();
(function () {
    'use strict';

    pendingPayments.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('pendingPayments', pendingPayments);

    function pendingPayments(lodash) {
        pendingPaymentsCtrl.$inject = ['$scope', 'GenericModel'];
        return {
            retrict: 'E',
            scope: {
                options: '=?',
                getModel: '=',
            },
            templateUrl: 'common/app/components/billing/pending-payments',
            controller: pendingPaymentsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, iElement, iAttrs, ngModelCtrl) {

            },
        };

        function pendingPaymentsCtrl($scope, GenericModel) {
            var vm = this;

            // functions
            this.$onInit = function() {
                vm.getSelectedPendingPaymentsEntity = getSelectedPendingPaymentsEntity;
                vm.setSelectedPendingPaymentsEntity = setSelectedPendingPaymentsEntity;
                vm.addPendingPaymentsForPurchaseOrder = addPendingPaymentsForPurchaseOrder;
                vm.removePendingPaymentsForPurchaseOrder = removePendingPaymentsForPurchaseOrder;
                vm.hasPendingPaymentsForPurchaseOrder = hasPendingPaymentsForPurchaseOrder;
                vm.getTotalPendingPaymentsForPurchaseOrder = getTotalPendingPaymentsForPurchaseOrder;
                vm.getCurrency = getCurrency;
                vm.getModel = getModel;

                // init
                vm.selectedPendingPaymentsEntity = null;
                vm.pendingPaymentsForPurchaseOrder = [];

                init();
            }

            function init() {
                // callRemoteApi(lodash.get(vm, 'options.datasource.pending_payments_entities', {}))
                //     .then(function (res) {
                //         vm.pendingPaymentEntities = res || [];
                //         setSelectedPendingPaymentsEntity(lodash.get(lodash.head(vm.pendingPaymentEntities), 'entity', null));
                //     });

                // $scope.$watch('vm.selectedPendingPaymentsEntity', function () {
                //     resetPendingPaymentsForPurchaseOrder();
                    callRemoteApi(lodash.get(vm, 'options.datasource.pending_payments_entity', {}))
                        .then(function (res) {
                            vm.pendingPaymentEntity = res.rows || [];
                        });
                // });

                $scope.$watch('vm.pendingPaymentsForPurchaseOrder', function () {
                    lodash.set(vm, 'options.submit_button.attr.disabled', vm.pendingPaymentsForPurchaseOrder.length === 0);
                })
            }

            function setSelectedPendingPaymentsEntity(pendingPaymentsEntity) {
                vm.selectedPendingPaymentsEntity = pendingPaymentsEntity;
            }
            
            function getSelectedPendingPaymentsEntity() {
                var foundSelectedPendingPaymentsEntity = lodash.find(vm.pendingPaymentEntities, { entity: vm.selectedPendingPaymentsEntity });
                return foundSelectedPendingPaymentsEntity;
            }

            function resetPendingPaymentsForPurchaseOrder() {
                vm.pendingPaymentsForPurchaseOrder = [];
            }

            function addPendingPaymentsForPurchaseOrder(pendingPayment) {
                vm.pendingPaymentsForPurchaseOrder = vm.pendingPaymentsForPurchaseOrder.concat([ pendingPayment ]);
            }

            function removePendingPaymentsForPurchaseOrder(pendingPayment) {
                var foundIndex = lodash.findIndex(vm.pendingPaymentsForPurchaseOrder, { id: pendingPayment.id });

                if (foundIndex >= 0) {
                    vm.pendingPaymentsForPurchaseOrder = vm.pendingPaymentsForPurchaseOrder
                        .slice(0, foundIndex)
                        .concat(vm.pendingPaymentsForPurchaseOrder.slice(foundIndex + 1));
                }
            }

            function hasPendingPaymentsForPurchaseOrder(pendingPayment) {
                var foundIndex = lodash.findIndex(vm.pendingPaymentsForPurchaseOrder, { id: pendingPayment.id });

                if (foundIndex >= 0) return true;
                return false;
            }
            
            function getTotalPendingPaymentsForPurchaseOrder() {
                return lodash.reduce(vm.pendingPaymentsForPurchaseOrder, function (sum, oPendingPaymentsForPurchaseOrder) {
                    return lodash.get(oPendingPaymentsForPurchaseOrder, 'amount', 0) + sum;
                }, 0);
            }

            function getCurrency() {
                return lodash.get(lodash.head(vm.pendingPaymentEntity), 'currency', null);
            }

            function getModel() {
                return lodash.map(vm.pendingPaymentsForPurchaseOrder, function (pendingPaymentForPurchaseOrder) {
                    return { id: lodash.get(pendingPaymentForPurchaseOrder, 'id') };
                });
            }

            function callRemoteApi(datasource, postData) {
                var model = new GenericModel(datasource.url);
                var method = lodash.get(datasource, 'method', 'get');

                var queries = postData;
                var params = {};

                if (method !== 'get') {
                    queries = {};
                    params = {
                        data: postData,
                    }
                }

                return model[method](queries, params).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {

                        return res;
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(err) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(err); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    purchaseOrders.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('purchaseOrders', purchaseOrders);

    function purchaseOrders(lodash) {
        purchaseOrdersCtrl.$inject = ['$scope', 'GenericModel'];
        return {
            retrict: 'E',
            scope: {
                options: '=?',
            },
            templateUrl: 'common/app/components/billing/purchase-orders',
            controller: purchaseOrdersCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, iElement, iAttrs, ngModelCtrl) {

            },
        };

        function purchaseOrdersCtrl($scope, GenericModel) {
            var vm = this;

            // functions
            this.$onInit = function() {
                vm.handlePendingPayments = handlePendingPayments;

                // init
                vm.purchaseOrders = [];

                init();
            }
            function init() {
                callRemoteApi(lodash.get(vm, 'options.datasource.pending_payments_entity', {}), { entity: vm.selectedPendingPaymentsEntity })
                    .then(function (res) {
                        vm.purchaseOrders = res || [];
                    });
            }

            function handlePendingPayments(singlePendingPaymentEntity) {
                var pendingPaymentsButton = lodash.get(vm, 'options.row_item_buttons.pending_payments', {});
                var event = lodash.get(pendingPaymentsButton, 'event.click', '');

                $scope.$emit(event, singlePendingPaymentEntity);
            }

            function callRemoteApi(datasource, postData) {
                var model = new GenericModel(datasource.url);
                var method = lodash.get(datasource, 'method', 'get');

                var queries = postData;
                var params = {};

                if (method !== 'get') {
                    queries = {};
                    params = {
                        data: postData,
                    }
                }

                return model[method](queries, params).$promise.then(function(res) { //res
                    if (res.success && res.status_code == 200) {

                        return lodash.get(res, 'rows', []);
                    } else {
                        console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return null;
                    }
                }, function(err) {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(err); // eslint-disable-line no-console
                    return null;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    rmsActivitiesActionCtrl.$inject = ['ActivitiesService', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsActivitiesAction', rmsActivitiesAction);

    function rmsActivitiesAction() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/list-panel/activities-action',
            controller: rmsActivitiesActionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {}
        };
    }

    function rmsActivitiesActionCtrl(ActivitiesService, $timeout) {
        var vm = this;
        this.$onInit = function() {
            init();

            vm.add = add;
            vm.discard = ActivitiesService.discard;
        }

        function init() {
            ActivitiesService.sync(vm);
            console.log('activity actions', vm);
        }

        function add() {
            $timeout(() => {
                ActivitiesService.save();
            });
        }
    }
})();
(function () {
    'use strict';

    rmsActivitiesPanelListCtrl.$inject = ['ActivitiesService', 'lodash', 'filterBarAdapter', 'GenericModel', '$timeout', 'EventsRunner'];
    angular
        .module('rms.common')
        .directive('rmsActivitiesPanelList', rmsActivitiesPanelList);

    function rmsActivitiesPanelList() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/list-panel/activities-panel-list',
            controller: rmsActivitiesPanelListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {}
        };
    }

    function rmsActivitiesPanelListCtrl(ActivitiesService, lodash, filterBarAdapter, GenericModel, $timeout, EventsRunner) {
        var vm = this;
        this.$onInit = function() {

            ActivitiesService.sync(vm);
            lodash.set(vm.pageData.options, 'activities.reply_options.submitReply', submitReply);

            vm.refreshActivities = ActivitiesService.refreshActivities;
            vm.resetFilters = resetFilters;

            init();
        }

        function init() {
            if (lodash.has(vm.pageData.options, 'activities.filters')) {
                vm.filterOptions = lodash.get(vm.pageData.options, 'activities.filters', {});
            }

            if (lodash.has(vm.pageData.options, 'activities.datasource')) {
                vm.listDataSource = angular.merge(
                    {},
                    {
                        transport: {
                            read: dataSourceRead
                        }

                    },
                    lodash.get(vm.pageData.options, 'activities.datasourceOptions', {})
                );
            }

            vm.gridOptions = angular.merge(
                {
                    height: 'auto',
                    // dataBound: () => {
                    //     angular.element(".k-group-col,.k-group-cell").remove();
                    //     var spanCells = angular.element(".k-grouping-row").children("td");
                    //     spanCells.attr("colspan", spanCells.attr("colspan") - 1);
                    //
                    //
                    // },
                    dataBound: function(e) {
                        angular.element(".k-group-col,.k-group-cell").remove();
                        var spanCells = angular.element(".k-grouping-row").children("td");
                        spanCells.attr("colspan", spanCells.attr("colspan") - 1);
                    },
                    pageable: {
                        refresh: true
                    },
                    scrollable:{
                        virtual:true
                    }
                },
                lodash.get(vm.pageData.options, 'activities.gridOptions')
            );
        }

        function resetFilters() {
            vm.resetQuery();
        }

        function dataSourceRead(readOptions) {
            let filters = {};
            if (typeof vm.getQuery == typeof function() {}) {
                filters = { filter: filterBarAdapter(vm.getQuery()) };
            } 
            if (lodash.has(vm.pageData.options, 'activities.data')) {
                $timeout(() => {
                    readOptions.success(vm.pageData.options.activities.data);
                }, 1200);
            } else {
                let model, method;
                if ((!lodash.has(filters, 'filter') || filters.filter.length == 0) && lodash.isEmpty(filters.sort)) {
                    model = new GenericModel('/' + vm.pageData.options.activities.datasource.read.url);
                    method = lodash.get(vm.pageData.options.activities.datasource, 'read.method', 'get');
                } else {
                    model = new GenericModel('/' + vm.pageData.options.activities.datasource.filter.url);
                    method = lodash.get(vm.pageData.options.activities.datasource, 'filter.method', 'get');
                }

                // {data: params} applied in generateResourceOption
                // const data = generateResourceOption(readOptions.data, myOptions, method);
                const data = generateResourceOption(readOptions.data, filters, method);
                model[method](data).$promise.then((res) => {
                    readOptions.success(res);
                }, (err)=> {
                    readOptions.error(err);
                });
            }
        }

        function generateResourceOption(resourceData, myData, method) {
            var params = {};
            params = angular.merge(params, resourceData, myData);

            if (method != 'get') {
                params = {'data': params};
            }
            return params;
        }

        function submitReply(data) {
            const promise = EventsRunner(vm.pageData.options.activities.reply_options.events, vm.pageData.options.activities.reply_options.event_trigger.submit_reply, data);
            return promise;
        }
    }
})();

(function () {
    'use strict';

    rmsActivitiesCtrl.$inject = ['ActivitiesService', '$scope'];
    angular
        .module('rms.common')
        .directive('rmsActivities', rmsActivities);

    function rmsActivities() {
        return {
            restrict: 'E',
            scope: {
                activityOptions: '='
            },
            templateUrl: 'common/app/components/activities/list-panel/activities-wrapper',
            controller: rmsActivitiesCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function rmsActivitiesCtrl(ActivitiesService, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.inputModel = {};
            ActivitiesService.init(vm, vm.activityOptions);

            $scope.$on('$destroy', function() {
                ActivitiesService.destroy();
            });
        }
    }
})();
(function () {
    'use strict';

    rmsActivityWrapperCtrl.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('rmsActivityWrapper', rmsActivityWrapper);

    function rmsActivityWrapper() {
        return {
            restrict: 'E',
            scope: {
                item: '='
            },
            controller: rmsActivityWrapperCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: true,
            templateUrl: 'common/app/components/activities/list-panel/activity-wrapper'
        };
    }

    function rmsActivityWrapperCtrl(lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.getIcon = () => {
                if (lodash.has(vm.item, 'typeIcon')) {
                    return vm.item.typeIcon;
                }
                switch (vm.item.type) {
                    case "email":
                        return 'fa-envelope';
                    case "log":
                        return 'fa-user';
                    case "schedule":
                        return 'fa-calendar';
                    case 'task':
                        return 'fa-thumb-tack';
                    case 'note':
                        return 'fa-sticky-note-o';
                }
            };
        }
    }
})();
(function () {
    'use strict';

    rmsActivity.$inject = ['$timeout'];
    rmsActivityCtrl.$inject = ['$scope', '$element', '$compile', '$templateCache', 'ActivitiesService', 'lodash', '$timeout', 'ActionManager'];
    angular
        .module('rms.common')
        .directive('rmsActivity', rmsActivity);

    function rmsActivity($timeout) {
        return {
            restrict: 'E',
            scope: {
                item: '=',
                options: '=?',
                conversation: '=?'
            },
            controller: rmsActivityCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: rmsActivityLink
        };

        function rmsActivityLink(scope, elem) {
            if (scope.vm.item.type == 'schedule') {
                $timeout(function () {
                    elem.find('.activity-schedule-right').css('minHeight', 'calc(' + elem.find('.activity-schedule-left').height() + 'px + 2rem');
                });
            }
        }
    }

    function rmsActivityCtrl($scope, $element, $compile, $templateCache, ActivitiesService, lodash, $timeout, ActionManager) {
        const vm = this;
        this.$onInit = function() {
            ActivitiesService.sync(vm);

            vm.labels = lodash.get(vm, 'options.labels', lodash.get(vm.pageData, 'options.activities.labels', {}));

            if (vm.item.type === 'email') {
                initEmailFunctions();
            }

            const templateUrl = `common/app/components/activities/list-panel/activity-type/${vm.item.type}`;

            const template = $templateCache.get(templateUrl);
            $element.html(template);
            const elementClone = $compile($element.contents())($scope);
            $scope.$on('$destroy', () => {
                elementClone.off();
            });
        }

        function initEmailFunctions() {
            vm.emailModel = getNewEmailReplyModel();

            var activityTypes = lodash.get(vm.pageData,'options.activityTypes',null);
            if (activityTypes !== null) {
                vm.elements = lodash.find(vm.pageData.options.activityTypes, {value: 'email'}).elements;
            }
            vm.showActivityContentInput = false;
            vm.showCC = false;
            vm.showBcc = false;
            vm.errors = {};
            vm.toggleInput = function (type) {
                vm.showActivityContentInput = true;
                lodash.set(vm.emailModel, 'type', type);

                $timeout(function () {
                    const inputContentElem = $element.find('.activity-content-input');
                    angular.element('.grid-detail-content').animate({
                        scrollTop: inputContentElem.offset().top - 250
                    }, 500);
                });
            };
            vm.toggleReply = function(toggle) {
                vm.showEmailContent = toggle;
                if (typeof vm.previewResize === typeof function() {}) {
                    $timeout(function() {
                        vm.previewResize();
                    });
                }
            };
            vm.showEmailContent = false;

            vm.submitEmail = function () {
                vm.submitting = true;
                if (lodash.has(vm.options, 'submitReply')) {
                    vm.options.submitReply(vm.emailModel).then(function(res) {
                        vm.submitting = false;
                        if (!!res && !(lodash.has(res, 'status') && res.status === 422)) {
                            vm.emailModel = getNewEmailReplyModel();
                            ActivitiesService.refreshActivities();
                            vm.showActivityContentInput = false;
                        }
                        if (!!res && (lodash.has(res, 'status') && res.status === 422)) {
                            console.log('show validation error');
                            vm.errors = res.data.rules;
                            console.log(vm.errors);
                        }
                    })
                }
            };

            vm.getErrors = function() {
                return lodash.flatten(lodash.valuesIn(vm.errors)).join(', ')
            };

            vm.hideActivityContentInput = function () {
                vm.showActivityContentInput = false;
            };
            vm.toggleCC = function () {
                vm.showCss = true;
            };
            vm.toggleBCC = function () {
                vm.showBcc = true;
            };

            vm.onAddAttachmentClick = function () {
                const docLibOptions = lodash.get(vm.pageData, 'options.attachmentOptions', {});
                ActionManager('open-document-library',docLibOptions).then(function (result) {
                    result.modal.closed.then(function (res) {
                        if (res !== false) {
                            vm.emailModel.attachments = vm.emailModel.attachments.concat(res);
                        }
                    });
                });
            };

            vm.removeAttachment = function (attachment) {
                const index = lodash.findIndex(vm.emailModel.attachments, {id: attachment.id});
                vm.emailModel.attachments.splice(index, 1);
            };
        }

        function getNewEmailReplyModel() {
            return {
                attachments: [],
                hid_row_ref_id: vm.item.id,
                conversation_id: vm.item.conversation_id
            };
        }
    }
})();
(function() {
    'use strict';

    rmsActivitiesAttachmentListCtrl.$inject = ['ActivitiesService', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsActivitiesAttachmentList', rmsActivitiesAttachmentList);

    function rmsActivitiesAttachmentList() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsActivitiesAttachmentListCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/list-panel/activities-attachments-list'
        };
    }

    function rmsActivitiesAttachmentListCtrl(ActivitiesService, lodash) {
        const vm = this;
        this.$onInit = function() {
            vm.removeAttachment = removeAttachment;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function removeAttachment(attachment) {
            const index = lodash.findIndex(vm.pageData.inputData.model.attachments, {select_id: attachment.select_id});
            vm.pageData.inputData.model.attachments.splice(index, 1);
        }
    }
})();
(function() {
    'use strict';

    directiveFuncCtrl.$inject = ['ActivitiesService', 'ActionManager', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsActivitiesBottomActions', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                test: '='
            },
            controller: directiveFuncCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/list-panel/activities-bottom-actions',
            link: directiveLink
        };

        function directiveLink(scope) {
            const vm = scope.vm;
            scope.$watch(function() { return vm.pageData.currentActivityType; }, function() {
                if (typeof vm.refreshPlaceholderSelect === typeof function() {}) {
                    vm.refreshPlaceholderSelect({}, {type: vm.pageData.currentActivityType});
                }
            });
        }
    }

    function directiveFuncCtrl(ActivitiesService, ActionManager, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.onSelectTemplatePlaceholder = onSelectTemplatePlaceholder;
            vm.onAddAttachmentClick = onAddAttachmentClick;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function onSelectTemplatePlaceholder(label, value) {
            tinymce.activeEditor.insertContent(' <u data="non-editable" data-value="' + value + '">' + label + '</u> ');
        }

        function onAddAttachmentClick() {
            const docLibOptions = lodash.get(vm.pageData, 'options.attachmentOptions', {});
            ActionManager('open-document-library', docLibOptions).then(function(result) {
                result.modal.closed.then(function(res) {
                    if (res !== false) {
                        // add to model
                        if (lodash.has(vm.pageData.inputData.model, 'attachments')) {
                            vm.pageData.inputData.model.attachments = vm.pageData.inputData.model.attachments.concat(res);
                        } else {
                            vm.pageData.inputData.model.attachments = res;
                        }
                    }
                });
            });
        }
    }
})();
(function() {
    'use strict';

    directiveFuncCtrl.$inject = ['ActivitiesService', 'ActionManager'];
    angular
        .module('rms.common')
        .directive('rmsActivitiesTopActions', directiveFunc);

    function directiveFunc() {
        return {
            restrict: 'E',
            scope: {
                test: '='
            },
            controller: directiveFuncCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/list-panel/activities-top-actions'
        };
    }

    function directiveFuncCtrl(ActivitiesService, ActionManager) {
        var vm = this;
        this.$onInit = function() {
            vm.onSelectTemplate = onSelectTemplate;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function onSelectTemplate(description, title) {
            ActivitiesService.setModel(vm.pageData.options.templateOptions.targetModel.description, description);
            ActivitiesService.setModel(vm.pageData.options.templateOptions.targetModel.title, title);
        }
    }
})();
(function () {
    'use strict';

    rmsActivitiesTypeSelectorCtrl.$inject = ['ActivitiesService'];
    angular
        .module('rms.common')
        .directive('rmsActivitiesTypeSelector', rmsActivitiesTypeSelector);

    function rmsActivitiesTypeSelector() {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'common/app/components/activities/list-panel/activities-type-selector',
            controller: rmsActivitiesTypeSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function rmsActivitiesTypeSelectorCtrl(ActivitiesService) {
        var vm = this;
        this.$onInit = function() {
            vm.selectType = selectType;

            init();
        }

        function init() {
            ActivitiesService.sync(vm);
        }

        function selectType(type) {
            ActivitiesService.selectType(type);
        }
    }
})();
(function () {
    'use strict';

    EmailTemplateService.$inject = ['lodash'];
    angular
        .module('rms.common')
        .factory('EmailTemplateService', EmailTemplateService);

    function EmailTemplateService(lodash) {
        return {
            getDefaultTinyMCEOptions: getDefaultTinyMCEOptions,
        };

        function getDefaultTinyMCEOptions() {
            return {
                plugins: ['link', 'image', 'autoresize', 'paste', 'noneditable'].join(' '),
                menubar: false,
                toolbar: [
                    ['undo', 'redo'].join(' '),
                    ['bold', 'italic', 'underline'].join(' '),
                    ['bullist', 'numlist'].join(' '),
                    ['outdent', 'indent'].join(' '),
                    ['alignleft', 'aligncenter', 'alignright'].join(' '),
                    ['link'].join(' '),
                ].join(' | '),
                min_height: 300,
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
                paste_preprocess: function (plugin, args) {
                    var html_content = args.content;

                    var unclean_dom = $('<div />').html(html_content);
                    unclean_dom.find('*').removeAttr('class').removeAttr('id');
                    var replace_html_value = unclean_dom.html();

                    args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                }
            };
        }
        // return {
        //     generateOptions: generateOptions,
        //     getDefaultMessageInputOptions: getDefaultMessageInputOptions,
        //     initDefaultModelField: initDefaultModelField
        // };
        //
        // function generateOptions(option) {
        //     return angular.merge(
        //         {},
        //         getDefaultOptions(),
        //         option
        //     );
        // }
        //
        // function getDefaultOptions() {
        //     return {
        //         messageInput: getDefaultMessageInputOptions()
        //     };
        // }
        //
        // function initDefaultModelField(inputoptions) {
        //     delete inputoptions.model.attachments;
        //     if (!lodash.has(inputoptions.model, 'type')) {
        //         lodash.set(inputoptions, 'model.type', inputoptions.options.value);
        //     }
        //     if (lodash.has(inputoptions, 'options.elements')) {
        //         // if (lodash.isEmpty(inputoptions.model)) {
        //         //     lodash.set(inputoptions, 'model.type' ,inputoptions.options.value);
        //         // }
        //
        //         angular.forEach(inputoptions.options.elements, function (val, idx) {
        //             if (lodash.has(inputoptions.model, val.name)) {
        //                 lodash.set(inputoptions.model, val.name, val.value);
        //             }
        //         });
        //     }
        // }
        //
        // function getDefaultMessageInputOptions() {
        //     return {
        //         plugins: ['link', 'image', 'autoresize', 'paste', 'noneditable'].join(' '),
        //         // plugins: 'link image autoresize paste noneditable code',
        //         menubar: false,
        //         toolbar: [
        //             ['undo', 'redo'].join(' '),
        //             ['bold', 'italic', 'underline'].join(' '),
        //             ['bullist', 'numlist'].join(' '),
        //             ['outdent', 'indent'].join(' '),
        //             ['alignleft', 'aligncenter', 'alignright'].join(' '),
        //             ['link'].join(' '),
        //         ].join(' | '),
        //         // toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent | alignleft aligncenter alignright | link',
        //         preview_styles: false,
        //         resize: true,
        //         statusbar: false,
        //         autoresize_bottom_margin: 0,
        //         content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
        //         noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
        //         // paste_as_text: true,
        //         // paste_word_valid_elements: "b,strong,i,em,h1,h2",
        //         paste_preprocess: function (plugin, args) {
        //             var html_content = args.content;
        //
        //             var unclean_dom = $('<div />').html(html_content);
        //             unclean_dom.find('*').removeAttr('class').removeAttr('id');
        //             var replace_html_value = unclean_dom.html();
        //
        //             args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
        //         }
        //     };
        // }
    }
})();
(function () {
    'use strict';

    rmsEmailTemplateComponent.$inject = ['lodash'];
    rmsEmailTemplateComponentCtrl.$inject = ['GenericModel', 'EmailTemplateService', 'lodash', '$scope', '$timeout', '$element'];
    angular
        .module('rms.common')
        .directive('rmsEmailTemplate', rmsEmailTemplateComponent);

    function rmsEmailTemplateComponent(lodash) {
        return {
            retrict: 'E',
            scope: {
                options: '=',
            },
            require: 'ngModel',
            templateUrl: function (elem, attrs) {
                if (attrs.template) {
                    return 'common/app/components/email-template/' + attrs.template;
                }

                return 'common/app/components/email-template/index-email-template';
            },
            controller: rmsEmailTemplateComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, iElement, iAttrs, ngModelCtrl) {
                var vm = scope.vm;

                ngModelCtrl.$render = function() {
                    vm.model = ngModelCtrl.$viewValue;
                };

                scope.$watch(function() {
                    return lodash.isEqual(vm.model,ngModelCtrl.$viewValue);
                }, function() {
                    ngModelCtrl.$setViewValue(vm.model);
                });
            },
        };
    }

    function rmsEmailTemplateComponentCtrl(GenericModel, EmailTemplateService, lodash, $scope, $timeout, $element) {
        var vm = this;

        this.$onInit = function() {
            vm.getInstance = getInstance;
            vm.handlePlaceholder = handlePlaceholder;
            vm.generateToolTipPlaceholder = generateToolTipPlaceholder;
            vm.getLastActiveEditor = getLastActiveEditor;

            init();
        }

        function init() {
            // ajax calls
            getTemplateTypes();

            // init SODTMCESubjectOptions
            initSODTMCESubjectEditor();

            // watchers
            watchTemplateType();

            // set TemplateType Selectize
            vm.templateTypeSelectizeConfig = {
                create: false,
                valueField: 'value',
                labelField: 'label',
                searchField: 'label',
                delimiter: '|',
                placeholder: '',
                maxItems: 1,
            };
            vm.templateTypeSelectizeOptions = [];
            vm.templatePlaceholders = [];

            // set tinyMCE
            const additional = generateAdditional();
            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            additional.setup = function(editor) {
                vm.tinyMceInst = editor;
                editor.on('init', function () {
                    $timeout(function () {
                        var em = $element.find('.mce-toolbar-grp');
                        $element.remove('.mce-toolbar-grp');
                        $element.find('.mce-edit-area').after(em);
                    });
                });
                editor.on('Blur', function (e) {
                    setLastActiveEditor(vm.getInstance());
                });

                editor.on('ExecCommand', function(e) {
                    const command = e.value;
                    const execCommandOption = lodash.get(vm, 'options.messageInput.tinyMCEAdditionalOptions.execCommandOption', []);
                    const foundCommand = lodash.find(execCommandOption, { command: command });

                    if (foundCommand) {
                        const node = editor.selection.getNode();

                        const criteria = lodash.get(foundCommand, 'criteria', []);
                        const transformedCriteria = lodash.map(criteria, function (singleCriteria) {
                            const property = lodash.get(singleCriteria, 'property', undefined);

                            const conditionType = lodash.get(singleCriteria, 'condition.type', '');
                            const conditionRegex = lodash.get(singleCriteria, 'condition.regex', '');

                            switch (conditionType) {
                                case 'string':
                                    return (new RegExp(conditionRegex)).test(node[property]);
                            }
                        });
                        const passedCriteria = lodash.every(transformedCriteria, Boolean);

                        if (passedCriteria) {
                            const run = lodash.get(foundCommand, 'run', []);

                            lodash.forEach(run, function (singleRun) {
                                const type = lodash.get(singleRun, 'type', '');

                                switch(type) {
                                    case 'style':
                                        const value = lodash.get(singleRun, 'value', '');
                                        const className = lodash.get(singleRun, 'className', '');
                                        const camelCasedClassName = lodash.camelCase(className);

                                        const hasValueBeenSet = node.style[camelCasedClassName] === value;
                                        tinymce.DOM.setStyle(node, className, hasValueBeenSet ? '' : value);
                                        break;
                                }
                            });
                        }
                    }
                });
            };
            additional.content_css = cdnEp + '/assets/css/rms-tinymce.css';
            additional.body_class = 'activity-description-input';

            const remoteOptions = lodash.get(vm, 'options.messageInput', {});
            const defaultOptions = EmailTemplateService.getDefaultTinyMCEOptions();
            vm.tmceOptions = angular.merge({}, defaultOptions, remoteOptions, additional);
        }

        function generateAdditional() {
            const result = {};

            if (lodash.has(vm, 'options.messageInput.tinyMCEAdditionalOptions')) {
                const defaultOptions = EmailTemplateService.getDefaultTinyMCEOptions();
                const messageInputNested = lodash.get(vm, 'options.messageInput.tinyMCEAdditionalOptions');

                if (lodash.has(messageInputNested, 'plugins')) {
                    const defaultPlugins = defaultOptions.plugins.split(' ');
                    const additionalPlugins = lodash.get(messageInputNested, 'plugins');

                    const mergesPlugins = lodash.concat(defaultPlugins, additionalPlugins);
                    result.plugins = mergesPlugins.join(' ');
                }

                if (lodash.has(messageInputNested, 'toolbar')) {
                    const defaultToolbarSections = defaultOptions.toolbar.split(' | ');
                    const defaultToolbar = lodash.map(defaultToolbarSections, function (defaultToolbarSection) {
                        return defaultToolbarSection.split(' ');
                    });
                    const additionalToolbar = lodash.get(messageInputNested, 'toolbar');

                    const mergesToolbar = lodash.concat(defaultToolbar, additionalToolbar);
                    const joinedMergesToolbarSections = lodash.map(mergesToolbar, function (singleMergesToolbar) {
                        return singleMergesToolbar.join(' ');
                    });
                    const joinedMergesToolbar = joinedMergesToolbarSections.join(' | ');
                    result.toolbar = joinedMergesToolbar;

                    // loading of available templates without the content
                    const hasSODTemplateType = joinedMergesToolbar.indexOf('SODTemplateType') >= 0;
                    const hasSodTemplate = lodash.has(vm, 'options.sodTemplates.datasource.getEmailTemplatesWithType.url');
                    if (hasSODTemplateType && hasSodTemplate) {
                        callRemoteApi(lodash.get(vm, 'options.sodTemplates.datasource.getEmailTemplatesWithType'))
                            .then(function (res) {
                                populateSODTemplateType(res);
                            });
                    }
                }
            }

            return result;
        }

        function initSODTMCESubjectEditor() {
            vm.SODTMCESubjectOptions = {
                plugins: ['noneditable', 'paste'],
                menubar: false,
                toolbar: false,
                preview_styles: false,
                resize: false,
                statusbar: false,
                autoresize_bottom_margin: 0,
                paste_as_text: true,
                content_style: '.mceNonEditable { line-height: 1em; text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*s>([\s\w]*)<\/u>/g],
                // paste_preprocess: function (plugin, args) {
                //     console.log('paste_preprocess');
                //     var html_content = args.content;
                //
                //     var unclean_dom = $('<div />').html(html_content);
                //     unclean_dom.find('*').removeAttr('class').removeAttr('id');
                //     var replace_html_value = unclean_dom.html();
                //
                //     args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                // },
                setup: function(editor) {
                    vm.tinyMceSubjectInst = editor;
                    editor.SODTMCESubject = true;

                    editor.on('Blur', function (e) {
                        setLastActiveEditor(getSODTMCESubjectEditor());
                    });

                    var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
                    editor.on('keydown', function (e) {
                        if(e.keyCode == 13){
                            e.preventDefault();
                        }
                        if (allowedKeys.indexOf(e.keyCode) != -1) return true;
                        var len = editor.contentDocument.body.innerText.length;
                        if (len + 1 > this.settings.max_chars) {
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }
                        return true;
                    });
                },
            };
        }

        function getInstance() {
            return vm.tinyMceInst;
        }

        function getSODTMCESubjectEditor() {
            return vm.tinyMceSubjectInst;
        }

        function getLastActiveEditor() {
            return vm.lastActiveEditor || getInstance();
        }

        function setLastActiveEditor(lastActiveEditor) {
            vm.lastActiveEditor = lastActiveEditor;
        }

        function watchTemplateType() {
            $scope.$watch(function () {
                return lodash.get(vm, 'model[' + lodash.get(vm, 'options.field_map.template_type') + ']', undefined);
            }, function () {
                setTemplateType();
            });
        }

        function setTemplateType() {
            $timeout(function () {
                $scope.$apply(function() {
                    const templateTypeValue = lodash.get(vm, 'model[' + lodash.get(vm, 'options.field_map.template_type') + ']', undefined);
                    const foundTemplateTypeObject = lodash.find(vm.templateTypeSelectizeOptions, { value: parseInt(templateTypeValue) });
                    vm.templatePlaceholders = lodash.values(lodash.get(foundTemplateTypeObject, 'placeholders', {}));
                });
            }, 100);
        }

        function getTemplateTypes() {
            const templateTypeDs = lodash.get(vm, 'options.datasource.email_template_type_list', {});

            vm.fetchingTemplateType = true;
            callRemoteApi(templateTypeDs)
                .then(function (data) {
                    vm.fetchingTemplateType = false;

                    vm.templateTypeSelectizeOptions = data;
                    setTemplateType();
                })
                .catch(function (error) {
                    vm.fetchingTemplateType = false;

                    console.error(error);
                });
        }

        function handlePlaceholder(placeholder) {
            const editor = getLastActiveEditor();
            editor.insertContent(
                [
                    '<span class="mceNonEditable" data-id="' + placeholder.value +  '">',
                    placeholder.label,
                    '</span>'
                ].join('')
            );
        }

        function generateToolTipPlaceholder() {
            return [
                '<div class="tooltip-tag">',
                '<div class="tooltip-tag_header">',
                'Applicant Name',
                '</div>',
                '<div class="tooltip-tag_content">',
                '<p>Tool tip description on how to use</p>',
                '<p><b>For Example: </b></p>',
                '<p><i>John Doe</i></p>',
                '</div>',
                '</div>',
            ].join('');
        }

        function callRemoteApi(datasource, postData) {
            var model = new GenericModel(datasource.url);
            var method = lodash.get(datasource, 'method', 'get');

            var queries = postData;
            var params = {};

            if (method !== 'get') {
                queries = {};
                params = {
                    data: postData,
                }
            }

            return model[method](queries, params).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    if (lodash.has(res, 'selected')) {
                        vm.modelContent = res.selected;
                        vm.ngModelCtrl.$setViewValue(res.selected);
                    }
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function(res) {
                console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();
(function () {
    'use strict';

    rmsActivityMainInputPanelComponentCtrl.$inject = ['ActivitiesService', '$timeout', 'lodash', 'ActivityInputService', 'GenericModel', '$scope'];
    angular
        .module('rms.common')
        .directive('rmsActivityMainInputPanel', rmsActivityMainInputPanelComponent);

    function rmsActivityMainInputPanelComponent() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
            },
            templateUrl: function(elem, attrs) {
                if (attrs.template) {
                    return 'common/app/components/activities/activity-input-panel/' + attrs.template;
                }
                return 'common/app/components/activities/activity-input-panel/activity-main-input-panel';
            },
            controller: rmsActivityMainInputPanelComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsActivityMainInputPanelComponentCtrl(ActivitiesService, $timeout, lodash, ActivityInputService, GenericModel, $scope) {
        var vm = this;

        this.$onInit = function() {
            vm.currentData = {};

            init();

            vm.add = add;
            vm.discard = discard;
            vm.selectType = selectType;
        }

        function init() {
            vm.selectedActivityType = vm.options.activityTypes[0];
            vm.currentData = ActivityInputService.initInputOptions(
                vm.currentData,
                vm.selectedActivityType,
                vm.options.inputOptions,
                lodash.get(vm.options, 'attachmentOptions', {})
            );

            if (lodash.has(vm.options, 'selection')) {
                vm.currentData.selection = vm.options.selection;
            }

            vm.defaultModel = lodash.get(vm.options, 'defaultModel', {});
        }

        function add() {
            $timeout(function() {
                vm.submitting = true;
                var promise = ActivitiesService.save(vm.getModel(), vm.selectedActivityType, vm.options.inputOptions);
                promise.$promise.then(function(res) {

                    if (lodash.has(vm.options, 'events.add_success')) {
                        $scope.$emit(vm.options.events.add_success, res);
                    }
                    vm.inputValidationErrorMessage = '';
                    vm.submitting = false;
                    vm.discard();
                    ActivitiesService.refreshActivities();
                }, function(err) {
                    switch (err.status) {
                        case 422:
                            vm.inputValidationErrorMessage = lodash.flatMap(err.data.rules).join(', ');
                            break;
                    }
                    // mem.inputValidationError = err.data;
                    console.warn(err); // eslint-disable-line no-console
                    vm.submitting = false;
                });
            });
        }

        function selectType(type) {
            vm.selectedActivityType = type;
            vm.currentData = ActivityInputService.initInputOptions(vm.currentData, vm.selectedActivityType, vm.options.inputOptions);
        }

        function discard() {
            vm.reset();
            vm.inputValidationErrorMessage = '';

            if (lodash.has(vm, 'onDiscard')) {
                vm.onDiscard();
            }
        }
    }
})();
(function () {
    'use strict';

    rmsActivityReplyInputPanelComponentCtrl.$inject = ['ActivitiesService', '$timeout', 'lodash', 'ActivityInputService'];
    angular
        .module('rms.common')
        .directive('rmsActivityReplyInputPanel', rmsActivityReplyInputPanelComponent);

    function rmsActivityReplyInputPanelComponent() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                original: '=?',
                closeReply: '&?'
            },
            templateUrl: 'common/app/components/activities/activity-input-panel/activity-reply-input-panel',
            controller: rmsActivityReplyInputPanelComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsActivityReplyInputPanelComponentCtrl(ActivitiesService, $timeout, lodash, ActivityInputService) {
        var vm = this;
        var inputOptions = {};

        this.$onInit = function() {
            vm.currentData = {};

            inputOptions = vm.options.inputOptions;

            lodash.set(inputOptions, 'onChangeInstructions', [
                {name: 'sel_email_from', type: 'setSignature'}
            ]);

            lodash.set(inputOptions, 'signatureSettings', {
                fieldName: 'txtbox_description'
            });

            // console.log(inputOptions);

            init();

            vm.add = add;
            vm.discard = discard;
            vm.hideReply = function() {
                if (vm.closeReply && typeof vm.closeReply === typeof function() {}) {
                    vm.closeReply();
                }
            };
        }

        function init() {
            vm.selectedActivityType = vm.options.activityType;
            vm.currentData = ActivityInputService.initInputOptions(
                vm.currentData,
                vm.selectedActivityType,
                inputOptions,
                lodash.get(vm.options, 'attachmentOptions', {})
            );
            vm.options.attachmentOptions = ActivitiesService.getAttachmentOptions();
            prepareDefaultModel();
        }

        function add() {
            $timeout(function() {
                vm.submitting = true;
                var promise = ActivitiesService.save(vm.getModel(), vm.selectedActivityType, inputOptions);
                promise.$promise.then(function(res) {
                    vm.inputValidationErrorMessage = '';
                    vm.submitting = false;
                    vm.discard();
                    ActivitiesService.refreshActivities();
                }, function(err) {
                    switch (err.status) {
                        case 422:
                            vm.inputValidationErrorMessage = lodash.flatMap(err.data.rules).join(', ');
                            break;
                    }
                    // mem.inputValidationError = err.data;
                    console.warn(err); // eslint-disable-line no-console
                    vm.submitting = false;
                });
            });
        }

        function discard() {
            vm.reset();
            vm.inputValidationErrorMessage = '';
        }

        function prepareDefaultModel() {
            const defaultModel = {};
            if (lodash.has(vm.options, 'subjectPrefix')) {
                defaultModel[vm.options.subjectPrefix.modelField] = vm.options.subjectPrefix.value + lodash.get(vm, 'original.' + vm.options.subjectPrefix.sourcePath, '')
            }
            vm.defaultModel = defaultModel;
        }
    }
})();
(function () {
    'use strict';

    rmsActivityWorkflowPipelineInputComponentCtrl.$inject = ['ActivityInputService', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsActivityWorkflowPipelineInput', rmsActivityWorkflowPipelineInputComponent);

    function rmsActivityWorkflowPipelineInputComponent() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                getModel: '=?',
                inputValidationErrorMessage: '=?'
            },
            templateUrl: 'common/app/components/activities/activity-input-panel/activity-workflow-pipeline-input',
            controller: rmsActivityWorkflowPipelineInputComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsActivityWorkflowPipelineInputComponentCtrl(ActivityInputService, lodash) {
        var vm = this;
        var inputOptions = {};
        this.$onInit = function() {
            vm.currentData = {};
            inputOptions = vm.options.inputOptions;

            lodash.set(inputOptions, 'onChangeInstructions', [
                {name: 'sel_email_from', type: 'setSignature'}
            ]);

            lodash.set(inputOptions, 'signatureSettings', {
                fieldName: 'txtbox_description'
            });

            init();
            vm.discard = discard;
        }

        function init() {
            vm.selectedActivityType = vm.options.activityTypes[0];
            vm.currentData = ActivityInputService.initInputOptions(
                vm.currentData,
                vm.selectedActivityType,
                inputOptions,
                lodash.get(vm.options, 'attachmentOptions', {})
            );
        }

        function discard() {
            vm.reset();
            vm.inputValidationErrorMessage = '';
        }
    }
})();
(function () {
    'use strict';

    rmsConversationCtrl.$inject = ['GenericModel', 'lodash', 'EventsRunner'];
    angular
        .module('rms.common')
        .directive('rmsConversation', rmsConversation);

    function rmsConversation() {
        return {
            restrict: 'E',
            scope: {
                refresh: '=?',
                options: '='
            },
            controller: rmsConversationCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/conversation',
        };
    }

    function rmsConversationCtrl(GenericModel, lodash, EventsRunner) {
        var vm = this;
        this.$onInit = function() {
            vm.refresh = refresh;

            lodash.set(vm.options, 'conversation_option.submitReply', submitReply);
        }

        function refresh(dataItem) {
            vm.dataItem = dataItem;

            const ds = decodeURI(vm.options.datasource.url).replace(new RegExp('<conversation_id>', 'g'), vm.dataItem.id);
            const method = lodash.get(vm.options.datasource, 'method', 'get');
            const rsc = GenericModel(ds);
            rsc[method]().$promise.then(function(res) {
                vm.data = res.rows;
            });
        }

        function submitReply(data) {
            const promise = EventsRunner(vm.options.events, vm.options.event_trigger.submit_reply, data);
            promise.then(function(res) {
                if (!!res && !(lodash.has(res, 'status') && res.status === 422)) {
                    refresh(vm.dataItem);
                    angular.element('.grid-detail-content').animate({
                        scrollTop: 0
                    }, 500);
                }
            });
            return promise;
        }
    }
})();
(function () {
    'use strict';

    filterBarAppliedFilter.$inject = ['lodash', '$filter', 'FILTER_OPERATOR_CONSTANT'];
    angular
        .module('rms.common')
        .filter('filterBarAppliedFilter', filterBarAppliedFilter);

    function filterBarAppliedFilter(lodash, $filter, FILTER_OPERATOR_CONSTANT) {
        return function(filter, labels) {
            if (!lodash.has(filter, 'displayTemplate')) {
                filter.displayTemplate = '{0} {1} {2}';
            }

            let displayValue = filter.option_value || lodash.get(labels, 'value_empty', '<  >');
            if (lodash.has(filter, 'option_value')) {
                if ([FILTER_OPERATOR_CONSTANT.IN, FILTER_OPERATOR_CONSTANT.NOT_IN].indexOf(filter.operator) >= 0) {
                    var type = lodash.get(filter, 'type');
                    var isMultipleEnumType = $filter('isMultipleEnumType')(type);

                    var reduceFilterLabelArr = function (filterOptionsData) {
                        return function(accum, _value) {
                            var filteredOption = lodash.find(filterOptionsData, function(_filterOptionsData) {
                                var _filterOptionsDataValue = lodash.get(_filterOptionsData, 'value');
                                return _filterOptionsDataValue == _value;
                            });

                            var filteredOptionLabel = lodash.get(filteredOption, 'label');
                            if (filteredOptionLabel) {
                                accum.push(filteredOptionLabel);
                            }
                            
                            return accum;
                        }
                    }

                    if (isMultipleEnumType) {
                        var optionValueKeys = Object.keys(filter.option_value);
                        displayValue = optionValueKeys.reduce(function(result, optionValueKey) {
                            var _optionValue = lodash.get(filter.option_value, optionValueKey);
                            _optionValue = lodash.isArray(_optionValue) ? _optionValue : [_optionValue];
                            
                            var alternativeFilterOptionData = lodash.get(filter.options, ['data', optionValueKey].join('.'));
                            var filterOptionData = lodash.get(filter.options, [optionValueKey, 'data'].join('.'), alternativeFilterOptionData);
                            var singleFilterAccum = _optionValue.reduce(reduceFilterLabelArr(filterOptionData), []);
                            result = result.concat([singleFilterAccum.join(', ')]);

                            return result;
                        }, []);
                        displayValue = displayValue.join(' & ');
                    } else {
                        displayValue = filter.option_value.reduce(reduceFilterLabelArr(filter.options.data), []);
                        displayValue = displayValue.join(', ');
                    }

                }
                if ([ FILTER_OPERATOR_CONSTANT.IS].indexOf(filter.operator) >= 0) {
                    displayValue = filter.option_label;
                }
                if (filter.type === 'date') {
                    if ([FILTER_OPERATOR_CONSTANT.BETWEEN, FILTER_OPERATOR_CONSTANT.RANGE].indexOf(filter.operator) >= 0) {
                        displayValue = [
                            $filter('date')(displayValue.lower, lodash.get(filter, 'format', 'dd/MM/yyyy')),
                            'and',
                            $filter('date')(displayValue.upper, lodash.get(filter, 'format', 'dd/MM/yyyy')),
                        ].join(' ');
                    } else {
                        displayValue = $filter('date')(displayValue, lodash.get(filter, 'format', 'dd/MM/yyyy'));
                    }
                }
                if (filter.type === 'number') {
                    if ([FILTER_OPERATOR_CONSTANT.BETWEEN].indexOf(filter.operator) >= 0) {
                        displayValue = [
                            $filter('number')(displayValue.lower),
                            'to',
                            $filter('number')(displayValue.upper),
                        ].join(' ');
                    }
                    if ([FILTER_OPERATOR_CONSTANT.EXISTS, FILTER_OPERATOR_CONSTANT.NOT_EXISTS].indexOf(filter.operator) >= 0) {
                        displayValue = '';
                        $filter('number')(displayValue);
                    }
                }
            }
            return $filter('stringFormat')(filter.displayTemplate, [filter.label, filter.operator_label, displayValue]);

        };
    }
})();
(function () {
    'use strict';

    selectedSort.$inject = ['$filter'];
    angular
        .module('rms.common')
        .filter('selectedSort', selectedSort);

    function selectedSort($filter) {
        return function(sort, applied, template) {
            if (!applied) return sort.label;
            if (sort.name != applied.field) return sort.label;
            var icon = (applied.dir == 'asc') ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc';
            return $filter('stringFormat')(template, [sort.label, icon]);
        };
    }
})();
(function () {
    'use strict';

    rmsFilterBarAppliedFilter.$inject = ['lodash'];
    rmsFilterBarAppliedFilterCtrl.$inject = ['MainFilterBarService', '$scope', '$filter', '$timeout', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarAppliedFilter', rmsFilterBarAppliedFilter);

    function rmsFilterBarAppliedFilter(lodash) {
        return {
            restrict: 'E',
            scope: {
                filter: '='
            },
            controller: rmsFilterBarAppliedFilterCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/applied-filter',
            link: rmsFilterBarAppliedFilterLink
        };


        function rmsFilterBarAppliedFilterLink(scope, elem) {

            elem.on('click', '.remove-applied-filter', function () {
                if (lodash.get(scope.vm.filter, 'rules.can_remove', true) === true) {
                    scope.vm.removeAppliedFilter();
                    scope.$apply();
                }
            });

            scope.$on('$destroy', () => {
                elem.off('click', '.remove-applied-filter');
            });


        }
    }

    function rmsFilterBarAppliedFilterCtrl(MainFilterBarService, $scope, $filter, $timeout, lodash) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.constructQueryText = constructQueryText;
            vm.removeAppliedFilter = removeAppliedFilter;
            vm.onPopoverClose = onPopoverClose;
            vm.onPopoverOpen = onPopoverOpen;
            vm.applyFilter = applyFilter;
            vm.cancel = cancel;
            vm.validateFilterClass = validateFilterClass;

            init();
            // will show the popover when the applied filter is added into the list.
            $timeout(function () {
                if (!vm.filter._hide_on_load) {
                    vm.togglePopover();
                }
            });
        }

        function init() {
        }

        function constructQueryText() {
            const label = $filter('filterBarAppliedFilter')(vm.filter, vm.filterBarService().getLabels());
            const can_remove = lodash.get(vm.filter, 'rules.can_remove', true) && !lodash.get(vm.filter.settings, 'required', false);
            const remove_filter_icon = can_remove ? '<i class="fa fa-times position-left remove-applied-filter"></i>' : '';
            return `<span class="label default  cursor-pointer">${label} ${remove_filter_icon}</span>`;
        }

        function removeAppliedFilter() {
            vm.filterBarService().removeApplied(vm.filter);
        }

        function applyFilter() {
            const result = vm.filterBarService().applyFilter(vm.filter, vm.options);
            if (result.success) {
                vm.errorMessage = null;
                vm.togglePopover();
            } else {
                vm.errorMessage = result.message;
            }
        }

        function cancel() {
            vm.errorMessage = null;
            vm.togglePopover();
        }

        function onPopoverClose() {
            vm.options = [];
            // reset temp data;
        }

        function onPopoverOpen() {
            vm.options = vm.filterBarService().getFilterTypeOption(vm.filter);
        }

        function validateFilterClass() {
            if (vm.filter.incomplete) {
                return 'has-issue';
            }
        }


    }
})();

(function () {
    'use strict';

    rmsFilterBarAppliedFiltersCtrl.$inject = ['$scope', 'MainFilterBarService', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarAppliedFilters', rmsFilterBarAppliedFilters);

    function rmsFilterBarAppliedFilters() {
        return {
            restrict: 'E',
            scope: {
                list: '=',
                identifier: '=?'
            },
            controller: rmsFilterBarAppliedFiltersCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/applied-filters'
        };
    }

    function rmsFilterBarAppliedFiltersCtrl($scope, MainFilterBarService, lodash, $timeout) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = vm.identifier || $scope.$parent.vm.filterBarIdentifier;

            if (vm.identifier) {
                $timeout(function() {
                    init();
                });
            } else {
                init();
            }
        }

        function init() {
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();
            vm.state = vm.filterBarService().getState();
            vm.show_empty_state = lodash.get(vm.filterBarService().getFilterBarOptions(), 'show_empty_state', false);
            vm.empty_state_message = vm.filterBarService().getMessageLabel('empty_state');
        }
    }
})();
(function () {
    'use strict';

    rmsFilterBarToolbarCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarToolbar', rmsFilterBarToolbar);

    function rmsFilterBarToolbar() {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            controller: rmsFilterBarToolbarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/toolbar'
        };
    }

    function rmsFilterBarToolbarCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier; // still required in this directive as the child directive will reference this.
        }

    }
})();
/**
 * Note To Self for improvement: Should have create a common state management that is reusable.
 */
(function () {
    'use strict';

    FilterBarCtrlService.$inject = ['lodash', 'GenericModel', 'FILTER_OPERATOR_CONSTANT', 'CommonHelper', '$filter'];
    angular
        .module('rms.common')
        .factory('FilterBarCtrlService', FilterBarCtrlService);

    function FilterBarCtrlService(lodash, GenericModel, FILTER_OPERATOR_CONSTANT, CommonHelper, $filter) {
        return function (options) {
            let state = {
                applied_filters: []
            };
            const events = {};
            init();
            return ExposedMethods;

            function ExposedMethods() {
                return {
                    // Common Methods
                    hasType: hasType,
                    getMessageLabel: getMessageLabel,
                    getGeneratedQuery: getGeneratedQuery,
                    registerEvent: registerEvent,
                    getOptions: getOptions,
                    reset: reset,
                    refresh: refresh,
                    setQuery: setQuery,
                    getLabels: getLabels,
                    getFilterBarOptions: getFilterBarOptions,

                    // Filters Methods
                    getState: getState,
                    addFilter: addFilter,
                    removeApplied: removeApplied,
                    getFilterTypeOption: getFilterTypeOption,
                    applyFilter: applyFilter,
                    validateFilter: validateFilter,

                    // Sorting
                    applySort: applySort,

                    // Search
                    applySearch: applySearch
                };
            }

            function init() {
                //initTestData();

                var loadFiltersOnLoad = lodash.get(options, 'types.get_filters_on_init', true);
                if (loadFiltersOnLoad) {
                    getFilterList();
                }
            }

            function refresh() {
                return getFilterList();
            }

            function getFilterList() {
                var url = options.types.filter.datasource.init.url;
                var method = options.types.filter.datasource.init.method;
                var model = new GenericModel(url);
                var promise = model[method]().$promise.then(function (res) {
                    lodash.set(state, 'filter_fields', res.types);
                    lodash.set(state, 'filter_options', res.options);

                    // check if there are no existing applied filters
                    // and that there are no filter_temp for processing
                    // set default_filters as filter temp for processing
                    if (lodash.get(state, 'applied_filters', []).length === 0
                        && lodash.get(state, 'filter_temp', []).length === 0) {
                        lodash.set(state, 'filter_temp', lodash.get(res, 'default_filters.filters', []));
                    }

                    setFiltersFromTemp();
                }, function (res) {
                    console.warn(res); // eslint-disable-line no-console
                });

                return promise
            }

            function hasType(type) {
                return !!options.types[type];
            }

            function registerEvent(eventName, func) {
                events[eventName] = func;
            }

            function callEvent(eventName) {
                if (lodash.has(events, eventName)) {
                    events[eventName]();
                }
            }

            function getOptions(type) {
                return lodash.get(options.types, type, {});
            }

            function addFilter(filter) {
                const filterCopy = angular.copy(filter);
                filterCopy.incomplete = true;
                state.applied_filters.push(filterCopy);
                if (lodash.has(filter, 'operator') && !lodash.isEmpty(filter.operator)) {
                    if (['in', 'not_in'].indexOf(filter.operator)) {
                        callEvent('refreshGrid');
                    } else {
                        if (lodash.has(filter, 'value') && !lodash.isEmpty(filter.value)) {
                            callEvent('refreshGrid');
                        }
                    }

                }
            }

            function getState() {
                return state;
            }

            function removeApplied(filter) {
                const index = lodash.findIndex(state.applied_filters, {$$hashKey: filter.$$hashKey});
                state.applied_filters.splice(index, 1);
                callEvent('refreshGrid');
            }

            function applyFilter(filter, options) {
                const result = validateFilter(filter, options);
                if (!result.success) return result;

                const selectedOptions = lodash.find(options, {operator: filter.operator});

                filter.option_value = selectedOptions.value;
                filter.option_label = selectedOptions.value_label;
                filter.operator_label = selectedOptions.label;
                filter.incomplete = false;
                callEvent('refreshGrid');
                return {success: true};
            }

            function validateFilter(filter, options) {
                if (!lodash.has(filter, 'operator')) {
                    return {success: false, message: getMessageLabel('no_operator_selected')};
                }

                const selectedOptions = lodash.find(options, {operator: filter.operator});

                // check if multiple enum type, if yes check for all values is filled
                var type = lodash.get(filter, 'type')
                if ($filter('isMultipleEnumType')(type)) {
                    var currentFilterOptions = lodash.get(filter, 'options', {});
                    var currentFilterOptionKeys = lodash.keys(currentFilterOptions);

                    const value = lodash.get(selectedOptions, 'value', {});
                    const cleansedValue = $filter('cleanseValue')(value);

                    var valueKeys = lodash.keys(cleansedValue);
                    var uniqueValueKeys = lodash.xor(valueKeys, currentFilterOptionKeys);
                    if (uniqueValueKeys.length !== 0) {
                        return {success: false, message: getMessageLabel('no_value_set')};
                    }
                }

                if ([FILTER_OPERATOR_CONSTANT.EXISTS, FILTER_OPERATOR_CONSTANT.NOT_EXISTS].indexOf(selectedOptions.operator) < 0) {
                    if (!(lodash.has(selectedOptions, 'value')) || CommonHelper.isEmpty(selectedOptions.value)) {
                        return {success: false, message: getMessageLabel('no_value_set')};
                    }
                }
                return {success: true};
            }

            function getFilterTypeOption(filter) {
                var filterObj = lodash.find(state.filter_fields, {name: filter.name});
                var filterSettings = lodash.get(filterObj, 'settings', {});

                let standardFilterOptions = [];
                var typedFilterOptions = lodash.get(state, 'filter_options.form.' + filter.type + '.options', []);
                if (lodash.has(filterObj, 'settings.appendStandardOptions') && filterObj.settings.appendStandardOptions === true) {
                    standardFilterOptions = lodash.get(state, 'filter_options.standard', []);
                }
                var filterOptions = angular.copy(typedFilterOptions.concat(standardFilterOptions));
                if (lodash.has(filter, 'operator') && lodash.has(filter, 'option_value')) {
                    var appliedOption = lodash.find(filterOptions, {operator: filter.operator});
                    appliedOption.value = filter.option_value;
                }
                if (lodash.get(filterSettings, 'hasAllOperator', false) === false) {
                    filterOptions = filterOptions.filter(function (_filter) {
                        var operator = lodash.get(_filter, 'operator');
                        return operator.indexOf('_all') < 0;
                    });
                }
                return filterOptions;
            }

            function getMessageLabel(key) {
                return lodash.get(options, ['labels', key].join('.'), '');
            }

            function getLabels() {
                return lodash.get(options, 'labels', {});
            }

            function applySearch() {
                callEvent('refreshGrid');
            }

            function applySort(sort) {
                if (!lodash.has(state, 'applied_sort')) {
                    state.applied_sort = {
                        field: sort.name,
                        dir: lodash.get(state, 'applied_sort', 'asc')
                    };
                } else {
                    if (state.applied_sort.field == sort.name) {
                        state.applied_sort = {
                            field: sort.name,
                            dir: state.applied_sort.dir == 'asc' ? 'desc' : 'asc'
                        };
                    } else {
                        state.applied_sort = {
                            field: sort.name,
                            dir: sort.default_direction
                        };
                    }
                }
                callEvent('refreshGrid');
            }

            function getGeneratedQuery() {
                const query = {
                    search: null,
                    order_by: null
                };

                if (lodash.has(state, 'filter_temp')) {
                    query.filters = state.filter_temp;
                } else {
                    query.filters = state.applied_filters.reduce((result, filter) => {
                        // if (lodash.has(filter, 'operator')) {
                        result.push({
                            name: filter.name,
                            operator: filter.operator,
                            type: filter.type,
                            value: filter.option_value || false // exists and not exists might have have. Unless we want to cater for that also.
                        });
                        // }
                        return result;
                    }, []);
                }

                if (lodash.has(state, 'search_text') && !CommonHelper.isEmpty(state.search_text)) {
                    query.search = state.search_text;
                }

                if (lodash.has(state, 'applied_sort') || !CommonHelper.isEmpty(state.applied_sort)) {
                    query.order_by = state.applied_sort;
                }

                return query;
            }

            function setQuery(query) {
                lodash.set(state, 'search_text', lodash.get(query, 'search', ''));
                if (lodash.has(query, 'order_by') && !CommonHelper.isEmpty(query.order_by)) {
                    lodash.set(state, 'applied_sort', lodash.get(query, 'order_by', null));
                }
                var filters = lodash.get(query, 'filters', null) || lodash.get(state, 'default_filters')

                lodash.set(state, 'filter_temp', filters);
            }

            function setFiltersFromTemp() {

                if (!CommonHelper.isEmpty(lodash.get(state, 'filter_temp', null))) {
                    lodash.set(state, 'applied_filters', lodash.get(state, 'filter_temp', []).map(function (filter) {
                        var filterOptions = getFilterTypeOption(filter);
                        // var filter_obj = lodash.find(filterOptions, '')
                        var filterObj = lodash.find(state.filter_fields, {name: filter.name});
                        var filterOption = lodash.find(filterOptions, {operator: filter.operator});
                        var option_label = '';
                        if (lodash.has(filterOption, 'options.data')) {
                            var selectedOption = lodash.find(filterOption.options.data, {value: filter.value});
                            option_label = selectedOption.label;
                        }
                        return {
                            label: filterObj.label,
                            operator_label: filterOption.label,
                            operator: filter.operator,
                            options: filterObj.options,
                            option_value: filter.value,
                            option_label: option_label,
                            type: filter.type,
                            name: filter.name,
                            _hide_on_load: true,
                            rules: filter.rules,
                            settings: filterObj.settings,
                        };
                    }));
                }
                delete state.filter_temp;
            }

            function reset(retain_default) {
                if (retain_default) {
                    state.applied_filters = lodash
                        .intersectionBy(state.applied_filters, state.filter_fields, 'name')
                        .reduce(function (carry, filter) {
                            if (lodash.get(filter, 'settings.required', false)) {
                                carry.push(filter);
                            }
                            return carry;
                        }, []);
                } else {
                    state.applied_filters = [];
                }
                state.search_text = '';
                state.applied_sort = {};
                callEvent('refreshGrid');
            }

            function getFilterBarOptions() {
                return options;
            }
        };
    }
})();


(function () {
    'use strict';

    MainFilterBarService.$inject = ['lodash', 'FilterBarCtrlService'];
    angular
        .module('rms.common')
        .factory('MainFilterBarService', MainFilterBarService);

    function MainFilterBarService(lodash, FilterBarCtrlService) {
        const mem = {};
        return {
            init: init,
            sync: sync,
            destroy: destroy,
            getAll: getAll,
        };

        function init(vm, identifier, options) {
            lodash.set(mem, identifier, new FilterBarCtrlService(options));
            sync(vm, identifier);
        }

        function sync(vm, identifier) {
            if (lodash.has(mem, identifier)) {
                vm.filterBarService = mem[identifier];
            }
        }

        function destroy(identifier) {
            delete mem[identifier];
        }

        function getAll() {
            return mem;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('FilterComposer', FilterComposer);

    function FilterComposer() {
        return {
            constructFilter: constructFilter,
            editFilter: editFilter
        };

        function constructFilter(filterName, operator, value, data) {
            var filter = {
                field: filterName,
                operator: operator,
                value: value
            };

            // Fix ENUM REMOTE
            if (data) {
                filter = Object.assign(filter, { data: data });
            }

            return filter;
        }

        function editFilter(filter, operator, value, data) {
            filter.operator = operator;
            filter.value = value;

            // Fix ENUM REMOTE
            if (data) {
                filter.data = data;
            }
        }
    }
})();
(function () {
    'use strict';

    FilterListFilterService.$inject = ['lodash', 'FILTER_STEP_CONSTANT', 'FILTER_OPERATOR_CONSTANT', 'FilterComposer', 'GenericModel', 'ActionCommon', 'ActionManager', '$q', '$filter'];
    angular
        .module('rms.common')
        .factory('FilterListFilterService', FilterListFilterService);
    var urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.

    function FilterListFilterService(lodash, FILTER_STEP_CONSTANT, FILTER_OPERATOR_CONSTANT, FilterComposer, GenericModel, ActionCommon, ActionManager, $q, $filter) {
        return function (mem) {
            return {
                init: init,
                getFilterList: getFilterList,
                goToNext: goToNext,
                backToPrevious: backToPrevious,
                selectFilter: selectFilter,
                applyFilter: applyFilter,
                clearCurrentFilter: clearCurrentFilter,
                resetCurrent: resetCurrent,
                clearFilters: clearFilters,
                prepareFilterOptionValues: prepareFilterOptionValues,
                getFilterOptionValues: getFilterOptionValues,
                getFilterOptionInputConfig: getFilterOptionInputConfig,
                getAppliedFilters: getAppliedFilters,
                hasAppliedFilters: hasAppliedFilters,
                getFilter: getFilter,
                getAppliedFilter: getAppliedFilter,
                getLabel: getLabel,
                editFilter: editFilter,
                removeFilter: removeFilter,
                applyView: applyView,
                createView: createView,
                updateView: updateView,
                deleteView: deleteView,
                getFilterData: getFilterData,
                setActiveFilter: setActiveFilter,
                setAppliedFilters: setAppliedFilters,
                getActiveFilters: getActiveFilters,
                hasFilter: hasFilter,
            };

            function init() {
                mem.pageData.filters = mem.options.filters;


                if (mem.pageData.filters.active_filters instanceof Array || lodash.isEmpty(mem.pageData.filters.active_filters)) {
                    mem.pageData.filters.active_filters = {};
                }
                if (!lodash.has(mem.pageData.filters, 'active_filters.applied')) {
                    lodash.set(mem.pageData, 'filters.active_filters.applied', []);
                }

                if (!lodash.isEmpty(mem.pageData.filters.active_filters.applied)) {
                    mem.pageData.sidebar_active = true;
                }

                if (lodash.has(mem.options, 'status_selection.default')) {
                    // var default_pipeline = mem.options.status_selection.default;

                    // if (!lodash.isEqual(default_pipeline, skip_pipeline)) {

                        lodash.set(mem, 'pageData.filters.active_filters.pipeline', [angular.merge({}, {value: mem.options.status_selection.default}, mem.options.status_selection.filter_template)]);
                    // }
                }
                if (lodash.has(mem.pageData.filters, 'active_filters.search')) {
                    const firstSearchValue = lodash.first(mem.pageData.filters.active_filters.search);
                    if (firstSearchValue) {
                        setSearchBar(firstSearchValue.value);
                    }
                }

                const sidebar_active_option = lodash.get(mem.options, 'filters.sidebar_active', false);
                if (!mem.pageData.sidebar_active) {
                    mem.pageData.sidebar_active = sidebar_active_option;
                }

            }

            function getFilter(fieldName) {
                return lodash.find(mem.pageData.filters.list, {name: fieldName});
            }

            function getAppliedFilter(fieldName) {
                return lodash.find(mem.pageData.filters.active_filters.applied, {field: fieldName});
            }

            function getAppliedFilterList() {
                var appliedFilters = lodash.get(mem, 'options.filters.active_filters.applied', []);

                var appliedFilterPromises = lodash.map(appliedFilters, function (appliedFilter) {
                    var filter = lodash.find(lodash.get(mem, 'options.filters.list', []), { name: appliedFilter.field }, {});
                    var filterOptionDatasource = lodash.get(filter, 'options.datasource', {});
                    var url = filterOptionDatasource.url;
                    var method = filterOptionDatasource.method;
                    var model = new GenericModel(url);
                    var data = {};
                    if (lodash.get(filterOptionDatasource, 'limited', false) === true && !lodash.isEmpty(appliedFilter.value)) {
                        data = {
                            data: {
                                applied_filter: appliedFilter.value
                            }
                        }
                    }

                    if(model && method){
                        return model[method](data).$promise;
                    }
                });

                $q.all(appliedFilterPromises)
                    .then(function (appliedFilterResponses) {
                        lodash.forEach(appliedFilters, function (appliedFilter, appliedFilterIndex) {
                            var listFilterIndex = lodash.findIndex(lodash.get(mem, 'options.filters.list', []), { name: appliedFilter.field });

                            if (listFilterIndex >= 0) {
                                lodash.set(mem, 'options.filters.list[' + listFilterIndex + '].options.data', appliedFilterResponses[appliedFilterIndex].data);
                            }
                        });
                    });
            }

            function getFilterList() {
                if (lodash.has(mem.options.filters, 'datasource.init')) {
                    var url = mem.options.filters.datasource.init.url;
                    var method = mem.options.filters.datasource.init.method;
                    var model = new GenericModel(url);

                    lodash.set(mem.pageData, 'filters.loading', true);
                    model[method]().$promise.then(function (res) {
                        lodash.set(mem.pageData, 'filters.list', res.types);
                        lodash.set(mem.pageData, 'filters.filter_options', res.options);
                        if (!lodash.isEmpty(lodash.get(mem.pageData, 'view_options', false))) {
                            if (lodash.has(res, 'saved_views.options')) {
                                lodash.set(mem.pageData, 'view_options.data', res.saved_views.options);
                                const selectedView = lodash.find(res.saved_views.options, {select_id: _.get(mem.pageData.filters, 'active_filters.view.select_id', null)});
                                if (selectedView) {
                                    mem.pageData.view_options.selected_view = selectedView;
                                } else {
                                    mem.pageData.view_options.selected_view = null;
                                }
                            }
                        }
                        lodash.set(mem.pageData, 'filters.permission.shared_to_everyone', lodash.get(res.saved_views, 'shared_to_everyone_visibility'));
                        lodash.set(mem.pageData, 'filters.title', lodash.get(res.saved_views, 'title'));
                        lodash.set(mem.pageData, 'filters.loading', false);
                        getAppliedFilterList();
                    }, function (res) {
                        console.warn(res); // eslint-disable-line no-console
                    });
                }
            }

            function getRemoteEnumData() {

            }

            function getLabel(name, overrideKey) {
                if (overrideKey && lodash.has(mem.pageData.filters.label, 'applied_filter_label_override.' + overrideKey)) {
                    return mem.pageData.filters.label.applied_filter_label_override[overrideKey];
                }
                return lodash.get(mem.pageData, ['filters', 'label', name].join('.'), '');
            }

            function goToNext() {
                // testing function
                switch (mem.pageData.filters.step) {
                    case FILTER_STEP_CONSTANT.LIST:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.PROPERTY;
                        break;
                    case FILTER_STEP_CONSTANT.PROPERTY:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.VALUES;
                        break;
                    case FILTER_STEP_CONSTANT.VALUES:
                    default:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.LIST;
                        break;
                }
            }

            function backToPrevious() {
                switch (mem.pageData.filters.step) {
                    case FILTER_STEP_CONSTANT.PROPERTY:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.LIST;
                        // clear filter property stuff
                        break;
                    case FILTER_STEP_CONSTANT.VALUES:
                        mem.pageData.filters.step = FILTER_STEP_CONSTANT.PROPERTY;
                        break;
                    default:
                        break;
                }
            }

            function selectFilter(filter) {
                mem.pageData.filters.current = angular.copy(filter);
                goToNext();
            }

            function clearCurrentFilter() {
                mem.pageData.filters.current = null;
            }

            function applyFilter() {
                var currentOperator = lodash.get(mem.pageData.filters, 'current.operator', false);
                var field = lodash.get(mem.pageData.filters, 'current.name', '');
                var filterType = lodash.get(mem.pageData.filters, 'current.type', '');

                if (!currentOperator) {
                    return false;
                }
                var currentOption = lodash.find(mem.pageData.filters.currentOptions, {operator: currentOperator});

                var value = lodash.get(currentOption, 'value', false);
                if ($filter('isMultipleEnumType')(filterType)) {
                    var currentFilter = lodash.get(mem.pageData.filters, 'current');
                    var currentFilterSubSettings = lodash.get(currentFilter, 'settings.sub_settings', {});
                    var currentFilterSubKeys = lodash.keys(currentFilterSubSettings);

                    // fix if selected any and then removing aka []
                    const cleansedValue = $filter('cleanseValue')(value);

                    
                    var valueKeys = lodash.keys(cleansedValue);
                    var uniqueValueKeys = lodash.xor(valueKeys, currentFilterSubKeys);
                    if (uniqueValueKeys.length !== 0) {
                        return false;
                    }
                }

                if ([FILTER_OPERATOR_CONSTANT.EXISTS, FILTER_OPERATOR_CONSTANT.NOT_EXISTS, FILTER_OPERATOR_CONSTANT.IS, FILTER_OPERATOR_CONSTANT.BETWEEN].indexOf(currentOperator) < 0) {
                    switch(filterType) {
                        case 'number':
                            if (isNaN(value)) {
                                return false;
                            }
                            break;
                        case 'date':
                            if (!lodash.isDate(value)) {
                                return false;
                            }
                            break;
                        default:
                            if (lodash.isEmpty(value)) {
                                return false;
                            }
                            break;
                    }
                }
                if ([FILTER_OPERATOR_CONSTANT.BETWEEN].indexOf(currentOperator) >= 0) {
                    if (filterType === 'number') {
                        if (isNaN(value.lower) || isNaN(value.upper)) {
                            return false;
                        }
                    }
                    if (filterType === 'date') {
                        if (!lodash.isDate(value.lower) || !lodash.isDate(value.upper)) {
                            return false;
                        }
                    }
                }

                // Fix ENUM REMOTE
                var hasDatasource = Boolean(lodash.get(mem.pageData.filters, 'current.options.datasource', false));
                var filterData = lodash.get(mem.pageData.filters, 'current.options.data', false);

                var filterEdit = lodash.get(mem.pageData, 'filters.filterEdit', false);
                if (filterEdit) {
                    FilterComposer.editFilter(
                        filterEdit,
                        currentOperator,
                        value,
                        hasDatasource && filterData ? filterData : null
                    );
                } else {
                    var filter = FilterComposer.constructFilter(
                        field,
                        currentOperator,
                        value,
                        hasDatasource && filterData ? filterData : null
                    );
                    // var exists = lodash.find(mem.pageData.filters.active_filters.applied, filter);
                    // var type = lodash.get(mem.pageData.filters, 'current.type', false);

                    // if (type == 'enum') {
                    //     var appliedFilter = getAppliedFilter(field);
                    //     if (appliedFilter) {
                    //         appliedFilter.value = value;
                    //         appliedFilter.operator = currentOperator;
                    //     } else {
                    //         mem.pageData.filters.active_filters.applied.push(filter);
                    //     }
                    // } else {
                    //     if (exists) {
                    //         ActionCommon.show_floating_notifier(mem.pageData.filters.notifier.exists);
                    //         // {
                    //         //     template: 'Filter already exists',
                    //         //         hasDelay: true,
                    //         //     delay: 70000,
                    //         //     type: 'warning', // default success warning info error
                    //         //     position: 'top right'
                    //         // }
                    //     } else {
                    mem.pageData.filters.active_filters.applied.push(filter);
                        // }
                    // }
                }
                return true;
            }

            function resetCurrent() {
                mem.pageData.filters.step = -1;
                mem.pageData.filters.current = null;
                mem.pageData.filters.currentOptions = null;
                mem.pageData.filters.editing = false;
                lodash.set(mem.pageData, 'filters.filterEdit', false);
                goToNext();
            }

            function clearFilters() {
                mem.pageData.filters.active_filters.applied = [];
                delete mem.pageData.filters.active_filters.view;
                // delete mem.pageData.filters.active_filters.pipeline;
                delete mem.pageData.filters.active_filters.search;
                clearSearchBar();
                mem.pageData.view_options.selected_view = null;
                resetCurrent();
            }

            function editFilter(filter) {
                if (filter.lock) {
                    return;
                }
                lodash.set(mem.pageData, 'filters.filterEdit', filter);
                mem.pageData.filters.editing = true;
                // need to get the filter from filterList,
                mem.pageData.filters.current = angular.copy(lodash.find(mem.pageData.filters.list, {name: filter.field}));

                // if (lodash.has(mem.pageData.filters.current.options, 'datasource') && lodash.get(mem.pageData.filters.current.options, 'datasource.limited', false)) {
                //     lodash.set(mem.pageData.filters.current.options, 'data', lodash.get(filter, 'data', []))
                // }

                mem.pageData.filters.current.operator = filter.operator;

                // need to get the currentOptions,
                //prepareFilterOptionValues();


                // need to set the step = 3. Setting to PROPERTY here as gotoNext() will cause it to go to VALUES
                mem.pageData.filters.step = FILTER_STEP_CONSTANT.PROPERTY;
                goToNext();
            }

            function removeFilter(filter) {
                var index = mem.pageData.filters.active_filters.applied.indexOf(filter);
                mem.pageData.filters.active_filters.applied.splice(index, 1);
            }

            function prepareFilterOptionValues() {
                var type = lodash.get(mem.pageData.filters, 'current.type', '');
                var typedFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.form.' + type + '.options', []);
                var standardFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.standard', []);
                var filterSettings = lodash.get(mem.pageData.filters.current, 'settings', {});

                var currentOptions = angular.copy(typedFilterOptions);
                if (lodash.get(filterSettings, 'appendStandardOptions', true) === true) {
                    currentOptions = currentOptions.concat(angular.copy(standardFilterOptions));
                }

                if (lodash.get(filterSettings, 'hasAllOperator', false) === false) {
                    currentOptions = currentOptions.filter((_filter) => {
                        const operator = lodash.get(_filter, 'operator');
                        return operator.indexOf('_all') < 0;
                    });
                }

                if (lodash.has(filterSettings, 'filter_display_override')) {
                    currentOptions = currentOptions.map(function (option) {
                        const label = lodash.get(filterSettings.filter_display_override, option.operator, null);
                        if (!!label) {
                            option.label = lodash.get(mem.pageData.filters.label, 'operator_override.' + label, option.label);
                        }
                        return option;
                    });
                }

                mem.pageData.filters.currentOptions = currentOptions;

                // FOR EDITING OF FILTERS
                var filterEdit = lodash.get(mem.pageData, 'filters.filterEdit', false);
                if (filterEdit) {
                    // need to set the value in currentOptions
                    var currentOptionIndex = lodash.findIndex(mem.pageData.filters.currentOptions, {operator: filterEdit.operator});
                    mem.pageData.filters.currentOptions[currentOptionIndex].value = filterEdit.value;
                    //mem.pageData.filters.current.operator = mem.pageData.filters.currentOptions[currentOptionIndex].operator;
                }
                // else {
                //     if (type == 'enum') {
                //         var appliedFilter = getAppliedFilter(lodash.get(mem.pageData.filters, 'current.name', ''));
                //         if (appliedFilter) {
                //             var appliedOption = lodash.find(mem.pageData.filters.currentOptions, {operator: appliedFilter.operator});
                //             appliedOption.value = appliedFilter.value;
                //
                //             lodash.set(mem.pageData.filters, 'current.operator', appliedFilter.operator);
                //         }
                //     }
                // }
            }

            function getFilterOptionValues(type) {
                var typedFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.form.' + type + '.options', []);
                var standardFilterOptions = lodash.get(mem.pageData.filters, 'filter_options.standard', []);
                return angular.copy(typedFilterOptions.concat(standardFilterOptions));
            }

            function getFilterOptionInputConfig(type) {
                var inputType = '';
                switch (type) {
                    case 'date':
                        inputType = 'datepicker';
                        break;
                    case 'enum':
                        inputType = 'select';
                        break;
                }
                return lodash.get(mem.pageData.filters, 'filter_options.form.' + type + '.config.' + inputType, {});
            }

            function getAppliedFilters() {
                // return lodash.get(mem.pageData.filters, 'applied', []);
                const filters = angular.copy(lodash.get(mem.pageData.filters, 'active_filters', {}));

                if (lodash.has(mem.pageData, 'view_options.selected_view') && !lodash.isEmpty(mem.pageData.view_options.selected_view)) {
                    filters.view = lodash.pick(mem.pageData.view_options.selected_view, ['select_id']);
                }

                delete filters.search;
                if (lodash.has(mem.pageData, 'toolbar.searchText') && !lodash.isEmpty(mem.pageData.toolbar.searchText)) {
                    filters.search = [
                        {
                            field: 'filter_search_text',
                            operator: 'contains',
                            value: mem.pageData.toolbar.searchText
                        }
                    ]
                }
                if ((lodash.has(mem.pageData, 'toolbar.searchData.items') && (mem.pageData.toolbar.searchData.items.length > 0))) {
                    filters.search = [
                        {
                            field: 'filter_search_array',
                            operator: 'search_array',
                            value: mem.pageData.toolbar.searchData
                        }
                    ]
                }

                if (lodash.has(mem.pageData, 'toolbar.filter')) {
                    if (this.getFilterBarQuery && (typeof this.getFilterBarQuery === typeof function() {})) {
                        console.log(this.getFilterBarQuery());
                        var filterbarFilters = this.getFilterBarQuery();

                        if (lodash.has(filters, 'applied')) {
                            filters.applied.concat(filterbarFilters.filters);
                        } else {
                            filters.applied = filterbarFilters.filters;
                        }
                    }
                }

                if (lodash.has(mem.options, 'status_selection.skip_pipeline')) {
                    var skip_pipeline = lodash.get(mem.options, 'status_selection.skip_pipeline');
                    filters.pipeline = filters.pipeline.reduce(function(result, item) {
                        if (!lodash.isEqual(skip_pipeline, item.value)) {
                            result.push(item);
                        }
                        return result;
                    }, []);
                }

                // if (lodash.has(mem, 'pageData.view_options_filters')) {
                //     const viewOptionsFilterOperator = lodash.get(mem.pageData, 'filter_options.operator', 'eq');
                //     lodash.forIn(mem.pageData.view_options_filters, function(viewOption, key) {
                //         console.log(viewOption, key);
                //         appliedFilters.push({
                //             field: key,
                //             operator: viewOptionsFilterOperator,
                //             value: viewOption
                //         })
                //     });
                // }

                return filters;
            }

            function hasAppliedFilters(includePipeline) {
                var filterbarFilters = [];
                if (this.getFilterBarQuery && (typeof this.getFilterBarQuery === typeof function() {})) {
                    console.log(this.getFilterBarQuery());
                    var filterbarQuery = this.getFilterBarQuery();
                    filterbarFilters = filterbarQuery.filters;
                }


                var conditions = [
                    (lodash.has(mem.pageData, 'filters.active_filters.applied') && (mem.pageData.filters.active_filters.applied.length > 0)),
                    // (lodash.has(mem.pageData.filters, 'active_filters.search.value') && !lodash.isEmpty(mem.pageData.filters.search.value)),
                    (lodash.has(mem.pageData, 'toolbar.searchText') && (mem.pageData.toolbar.searchText.length > 0)),
                    (lodash.has(mem.pageData, 'toolbar.searchData.items') && (mem.pageData.toolbar.searchData.items.length > 0)),
                    (lodash.has(mem.pageData, 'view_options.selected_view') && !lodash.isEmpty(mem.pageData.view_options.selected_view)),
                    filterbarFilters.length > 0
                ];

                if (includePipeline) {
                    conditions.push(lodash.has(mem.pageData, 'filters.active_filters.pipeline') && (mem.pageData.filters.active_filters.pipeline.length > 0) );
                }

                return lodash.compact(conditions).length > 0;
            }

            function setAppliedFilters(filters) {
                lodash.set(mem.pageData.filters, 'active_filters', filters);
                // if (lodash.has(mem.pageData.filters, 'active_filters.view.select_id')) {
                //     lodash.set(mem.pageData, 'view_options.selected_view', lodash.find(lodash.get(mem.pageData, 'view_options.data', []), {select_id: mem.pageData.filters.active_filters.view.select_id}));
                // }

                if (lodash.has(mem.pageData.filters, 'active_filters.search')) {
                    const firstSearchValue = lodash.first(mem.pageData.filters.active_filters.search);
                    // vm.pageData.toolbar.searchBarConfig.simple

                    if (firstSearchValue) {
                        setSearchBar(firstSearchValue.value);
                    }

                } else {
                    clearSearchBar();
                }
            }

            function getFilterData() {
                return mem.pageData.filters;
            }

            function applyView() {
                const selectedView = mem.pageData.view_options.selected_view;
                const ds = mem.pageData.filters.datasource.saved_view.get;
                const url = decodeURI(ds.url).replace(urlReplacerRegex, (match, submatch) => {
                    return lodash.get(selectedView, submatch, '');
                });
                const method = lodash.get(ds, 'method', 'get');
                const resource = GenericModel(url);

                resource[method]({ filter_id: selectedView.id }).$promise.then(function(res) {
                    if(res.data.active_status == 'del'){
                        clearFilters();
                        mem.currentScope.listFilterService.refreshGrid(true);
                    }else{
                        setAppliedFilters(res.data.filter);
                        mem.pageData.grid.dataSource.page(1);
                        lodash.set(mem.pageData.filters, 'active_filters.view.select_id', res.data.select_id);
                    }
                    refreshView();
                }, function(res) {
                    // Todo: show notification
                });
            }

            function refreshView() {
                const ds = mem.pageData.filters.datasource.saved_view.getArray;
                const url = decodeURI(ds.url).replace(urlReplacerRegex, () => {
                    return '';
                });
                const method = lodash.get(ds, 'method', 'get');
                const params = lodash.get(ds, 'params', {});
                const resource = GenericModel(url);
                resource[method](params).$promise.then(function(res) {
                    lodash.set(mem.pageData, 'view_options.data', res.rows);
                    const selectedView = lodash.find(res.rows, { select_id: _.get(mem.pageData.filters, 'active_filters.view.select_id', null)});
                    if (selectedView) {
                        mem.pageData.view_options.selected_view = selectedView;
                    } else {
                        mem.pageData.view_options.selected_view = null;
                    }
                }, function(err) {
                    // Todo: show err notification
                    console.log(err);
                });
            }

            function createView() {
                $q.when(ActionManager('dm-open-dialog', {
                    controller: 'ListFilterSaveViewFormCtrl',
                    templateUrl: 'common/app/components/list-filter/save-view-form',
                    dialog_options: {
                        viewName: '',
                        shareWithAll: false,
                        shareToEveryoneVisibility: mem.pageData.filters.permission.shared_to_everyone,
                        title: mem.pageData.filters.title
                    }
                }), function(res) {
                    res.modal.closed.then(function(resViewName) {
                        if (resViewName !== false) {
                            const appliedFilters = getAppliedFilters();
                            const ds = mem.pageData.filters.datasource.saved_view.create;
                            const url = ds.url;
                            const method = lodash.get(ds, 'method', 'post');
                            const params = lodash.merge({
                                saved_view_name: resViewName.saved_view_name,
                                shared_with_all: resViewName.shared_with_all,
                                filter: appliedFilters
                            }, lodash.get(ds, 'params', {}));

                            const resource = GenericModel(url);
                            resource[method]({ data: params }).$promise.then(function(res) {
                                if (lodash.has(res, 'select_id')) {
                                    lodash.set(mem.pageData.filters, 'active_filters.view.select_id', res.select_id);
                                }
                                refreshView();
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.create.success', {
                                    template: 'create success',
                                }))
                            }, function(res) {
                               console.log('error res', res);
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.create.error', {
                                    template: 'create error',
                                }))
                            });
                        }
                    });
                });
            }

            function updateView() {
                const selectedView = mem.pageData.view_options.selected_view;
                $q.when(ActionManager('dm-open-dialog', {
                    controller: 'ListFilterSaveViewFormCtrl',
                    templateUrl: 'common/app/components/list-filter/save-view-form',
                    dialog_options: {
                        viewName: selectedView.label,
                        shareWithAll: selectedView.shared_with_all,
                        shareToEveryoneVisibility: mem.pageData.filters.permission.shared_to_everyone,
                        title: mem.pageData.filters.title
                    }
                }), function(res) {
                    res.modal.closed.then(function(resViewName) {
                        if (resViewName !== false) {
                            const appliedFilters = getAppliedFilters();
                            const ds = mem.pageData.filters.datasource.saved_view.update;
                            const url = decodeURI(ds.url).replace(urlReplacerRegex, (match, submatch) => {
                                return lodash.get(selectedView, submatch, '');
                            });
                            const method = lodash.get(ds, 'method', 'put');
                            const params = lodash.merge({
                                saved_view_name: resViewName.saved_view_name,
                                shared_with_all: resViewName.shared_with_all,
                                filter: appliedFilters
                            }, lodash.get(ds, 'params', {}));

                            const resource = GenericModel(url);
                            resource[method]({ data: params }).$promise.then(function() {
                                refreshView();

                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.update.success', {
                                    template: 'update success',
                                }))
                            }, function(res) {
                                console.warn('error res', res);
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.update.error', {
                                    template: 'update error',
                                }))
                            });
                        }
                    });
                });
            }

            function deleteView() {
                $q.when(ActionManager('dm-open-dialog', {
                    template: mem.options.view_options.onDelete.dialogTemplate,
                    controller: 'ConfirmationDialogCtrl',
                    controllerAs: 'vm',
                    appendElement: angular.element('.modal-wrapper'),
                    inputs: {
                        dialogOptions: {}
                    }
                }), function(am) {
                    am.modal.closed.then(function(res) {
                        if (res) {
                            const selectedView = mem.pageData.view_options.selected_view;
                            const ds = mem.pageData.filters.datasource.saved_view.delete;
                            const url = decodeURI(ds.url).replace(urlReplacerRegex, (match, submatch) => {
                                return lodash.get(selectedView, submatch, '');
                            });
                            const method = lodash.get(ds, 'method', 'delete');
                            const resource = GenericModel(url);
                            resource[method]().$promise.then(function (res) {
                                clearFilters();
                                refreshView();

                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.delete.success', {
                                    template: 'delete success',
                                }))
                            }, function (res) {
                                ActionManager('notify', lodash.get(mem.options, 'view_options.notification.delete.error', {
                                    template: 'delete error',
                                }))
                            });
                        }
                    });
                });
            }

            function setActiveFilter(type, value) {
                lodash.set(mem.pageData.filters, 'active_filters.' + type, value);
            }

            function getActiveFilters() {
                const activeFilters = lodash.get(mem.pageData.filters, 'active_filters', {});
                return lodash.isEmpty(activeFilters) ? null : activeFilters;
            }

            function setSearchBar(value) {
                var isSimpleSearch = lodash.get(mem, 'pageData.toolbar.searchBarConfig.simple', true);
                if (isSimpleSearch) {
                    mem.pageData.toolbar.searchText = value;
                } else {
                    mem.pageData.toolbar.searchData.condition = value.condition;
                    // mem.pageData.toolbar.searchData.items = value.items;
                    // console.log('mem.pageData.toolbar.searchData.items', mem.pageData.toolbar.searchData.items);
                    mem.pageData.toolbar.searchBarInstance.setValue(value.items, true);
                    mem.pageData.toolbar.searchBarOptions = value.items.map(function(item) {
                        return {text:item, value: item};
                    });
                    lodash.set(mem.pageData, 'toolbar.searchDataTemp.items', value.items);
                    lodash.set(mem.pageData, 'toolbar.searchData.items', value.items);
                    // mem.pageData.toolbar.searchBarInstance.refreshItems();

                }
            }

            function clearSearchBar() {
                var isSimpleSearch = lodash.get(mem, 'pageData.toolbar.searchBarConfig.simple', true);
                if (isSimpleSearch) {
                    mem.pageData.toolbar.searchText = '';
                } else {
                    mem.pageData.toolbar.searchData.condition = 'and';
                    mem.pageData.toolbar.searchData.items = [];
                    mem.pageData.toolbar.searchBarOptions = [];
                    // mem.pageData.toolbar.searchBarInstance.refreshItems()
                }
            }

            function hasFilter(appliedFilter) {
                return !!getFilter(appliedFilter.field);
            }
        };
    }
})();

(function () {
    'use strict';

    ListFilterService.$inject = ['lodash', 'GenericModel', 'SELECT_CONSTANT', 'SelectListFilterService', 'FilterListFilterService', '$timeout', '$location'];
    angular
        .module('rms.common')
        .factory('ListFilterService', ListFilterService);

    function ListFilterService(lodash, GenericModel, SELECT_CONSTANT, SelectListFilterService, FilterListFilterService, $timeout, $location) {
        return function () {
            var mem = {},
                selectService = null,
                filterService = null;
            return {
                init: init,
                destroy: destroy,
                sync: sync,
                toggleSelectRow: toggleSelectRow,
                toggleSelectAll: toggleSelectAll,
                getFilterService: getFilterService,
                refreshGrid: refreshGrid,
                getSelectedModel: getSelectedModel,
                getSelectedModelKeys: getSelectedModelKeys,
                clearSelected: clearSelected,
                closeDetailPanel: closeDetailPanel,
                showDetailView: showDetailView,
                hideDetailView: hideDetailView,
                emitDataItemEvent: emitDataItemEvent,
                getRowButtonVisibility: getRowButtonVisibility,
                getChildInfoVisibility: getChildInfoVisibility,
                updateToolbarButtons: updateToolbarButtons,
                setExternalGridRefreshFunc: setExternalGridRefreshFunc,
                getData: getData,
                setData: setData,
                updateRecord: updateRecord,
                getAllDataItems: getAllDataItems,
                setExternalStatus: setExternalStatus,
                getExternalStatus: getExternalStatus,
                generateResourceOption: generateResourceOption,
                setDatasourceUrl: setDatasourceUrl,
                getGrid: getGrid,
                setSearchText: setSearchText,
                toggleSelectable: toggleSelectable,
                setPage: setPage,
                getCurrentPipeline: getCurrentPipeline,
                setPipelineData: setPipelineData,
                getPipelineData: getPipelineData,
                getHasPipeline: getHasPipeline,
                toggleFilterSidebar: toggleFilterSidebar,
            };

            // <editor-fold desc='Init Stuff'>
            function init(pageData, listFilterOption, $scope) {
                mem = {
                    pageData: pageData,
                    options: listFilterOption,
                    currentPage: {
                        selected: [],
                        total: 0,
                    },
                    currentScope: $scope
                };


                if (lodash.has(mem, 'options.toolbar') && mem.options.toolbar !== false) {
                    const selectionButtons = lodash.get(listFilterOption.toolbar, 'selection.buttons', []);
                    const additionalButtons = lodash.get(listFilterOption.toolbar, 'selection.additionals', []);
                    const conditionalButtons = lodash.get(listFilterOption.toolbar, 'selection.conditionals', []);
                    const searchBarConfig = lodash.get(listFilterOption.toolbar, 'searchBarConfig', {
                        simple: true,
                    });

                    lodash.set(
                        mem.pageData,
                        'toolbar',
                        angular.merge(
                            {
                                activated: true,
                                selection: {
                                    selectAllFlag: SELECT_CONSTANT.NONE,
                                    selected: [],
                                    select_all: false,
                                },
                                hasSelectionButton: (!lodash.isEmpty(selectionButtons) || !lodash.isEmpty(additionalButtons) || !lodash.isEmpty(conditionalButtons)),
                                // searchBarConfig: searchBarConfig,
                            },
                            listFilterOption.toolbar || {}
                        )
                    );
                    // if (lodash.has(mem, 'options.status_selection')) {
                    //     lodash.set(mem.pageData.toolbar, 'selection.buttons', []);
                    //     delete(mem.pageData.toolbar.selection.additional);
                    // }
                    selectService = new SelectListFilterService(mem);
                }

                if (!lodash.isEmpty(lodash.get(listFilterOption, 'view_options', false))) {
                    lodash.set(mem, 'pageData.view_options', listFilterOption.view_options);
                }

                filterService = new FilterListFilterService(mem);
                if (lodash.has(mem, 'options.filters')) {
                    filterService.init();
                    filterService.getFilterList();

                    // TODO: @JAG
                    // mem.pageData.filters.label.total_count = "{0} Clients";
                    // mem.pageData.filters.label.view_create = "Create view";
                    // mem.pageData.filters.label.view_clone = "Clone view";
                    // mem.pageData.filters.label.view_make_default = "Make this view default";
                    // mem.pageData.filters.label.view_export = "Export all in view";
                    // mem.pageData.filters.label.view_report = "Create report from view";
                }

                // mem.pageData.filter_options = {
                //   options: [
                //       { name: 'test1', label: 'test 1' },
                //       { name: 'test2', label: 'test 2' },
                //       { name: 'test3', label: 'test 3' },
                //       { name: 'test4', label: 'test 4' },
                //   ],
                //   operator: 'eq'
                // };

                if (lodash.has(mem, 'options.no_record_options')) {
                    lodash.set(mem, 'pageData.no_record_options', mem.options.no_record_options);
                }

                initDetailPanel();
                initViewOptions();
                initGrid();
                initFilterView();
                initSelectOnRowButton();
                $timeout(function () {
                    if (mem.pageData.detailPanel.toggleState === true) {
                        if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                            mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                                mem.pageData.grid.hideColumn(fieldName);
                            });
                        }
                    }
                })
            }

            function initViewOptions() {
                if (lodash.has(mem.options, 'filter_options.options')) {
                    lodash.set(mem.pageData, 'filter_options', mem.options.filter_options);
                    lodash.forEach(mem.options.filter_options.options, function (filterViewOption) {
                        lodash.set(mem.pageData.view_options_filters, filterViewOption.name, filterViewOption.default || false);
                    });
                }
                if (lodash.has(mem.options, 'entity_view')) {
                    lodash.set(mem, 'pageData.entity_view', mem.options.entity_view);
                }
            }

            function emitDataItemEvent(actionName, dataItem) {
                const prefix = lodash.get(mem.options, 'dataitem_event_prefix', 'action.list-filter.dataitem.action');
                const eventName = [prefix, actionName].join('.');
                mem.currentScope.$emit(eventName, dataItem);

                var selectOnRowButtonListeners = lodash.get(mem, 'options.selectOnRowButtonListeners', []);
                lodash.forEach(selectOnRowButtonListeners, function (selectOnRowButtonListener) {
                    selectOnRowButtonListener(actionName, dataItem);
                });
            }

            function getRowButtonVisibility(type, dataItem) {
                const rules = lodash.get(mem.options, 'row_button_rules', {});
                if (!lodash.has(rules, type)) return true;
                const rule = rules[type];

                if (typeof rule === 'string') {
                    return lodash.get(dataItem, rules[type], false);
                }
                if (typeof rule === typeof {}) {
                    const key = lodash.get(rule, 'key', '');
                    const value = lodash.get(dataItem, key, false);
                    if (lodash.has(rule, 'matches')) {
                        return value === rule.matches;
                    }
                    return !!value;
                }
                return true;

            }

            function getChildInfoVisibility(valueKey, ruleCheck, dataItem) {
                if (!valueKey || !ruleCheck) return false;
                if (typeof valueKey !== 'string' || typeof ruleCheck !== 'string') return false;

                var hasValue = lodash.get(dataItem, valueKey, false);
                var hasRule = lodash.get(dataItem, ruleCheck, false);

                if (!hasValue || !hasRule) return false;

                return true;
            }

            function destroy() {
                mem = {};
                selectService = null;
                filterService = null;
            }

            function sync(vm) {
                vm.pageData = mem.pageData;
            }

            function initFilterView() {
                mem.pageData.filterView = lodash.get(mem, 'options.filter_options', false);
            }

            function initDetailPanel() {
                mem.pageData.detailPanel = lodash.get(mem, 'options.detail_panel', false);
                if (!mem.pageData.detailPanel) {
                    return false;
                }
                if (typeof mem.pageData.detailPanel === typeof false) {
                    mem.pageData.detailPanel = {
                        toggleState: false
                    };
                } else {
                    const alwaysOn = lodash.get(mem, 'options.detail_panel.always_on', false);
                    lodash.set(mem.pageData, 'detailPanel.toggleState', alwaysOn);
                    lodash.set(mem.pageData, 'detailPanel.alwaysOn', alwaysOn);
                }
            }


            function initGrid() {
                const gridClass = lodash.get(mem.options, 'grid.options.classes', {});
                if (lodash.has(mem.options, 'grid.options.showHeader')) {
                    if (!mem.options.grid.options.showHeader) {
                        const hideGridHeaderClass = ' hide-grid-header';
                        if (lodash.has(gridClass, 'grid')) {
                            lodash.set(gridClass, 'grid', gridClass.grid + hideGridHeaderClass);
                        } else {
                            lodash.set(gridClass, 'grid', hideGridHeaderClass);
                        }
                    }
                }
                lodash.set(mem.pageData, 'classes', gridClass);

                mem.pageData.gridOption = angular.merge(
                    prepareGridOption(mem.options.grid.options),
                    {
                        dataSource: prepareDatasource(mem.options.grid.datasource)
                    },
                    {
                        // please remove this object after sorting is implemented,
                        // things to take note.
                        // 1. Columns without "field" key will automatically treated as not sortable by kendo
                        // 2. Columns can contain field "sortable" with value "false" for it not to be sortable
                        // 3. May need a different design to tell user that this column is not sortable.
                        dataSource: {
                            serverSorting: true
                        },
                        dataBound: lodash.get(mem, 'options.grid.options.serverGrouping') ?
                            function (e) {
                            } : function (e) {
                                $timeout(function () {
                                    renderActive();
                                }, 300);
                                $('.k-i-collapse').click(function (e) {
                                    var dirtyGroupText = $(e.target).parent().text().trim();
                                    var splitGroupText = dirtyGroupText.split(':');
                                    var groupValue = lodash.last(splitGroupText).trim();

                                    var hasRows = $('tr[role-group*="' + groupValue + '"]').length;
                                    if (hasRows) {
                                        var firstRow = $('tr[role-group*="' + groupValue + '"]');
                                        var isCurrentlyHidden = firstRow.css('display') === 'none';

                                        if (isCurrentlyHidden) {
                                            $('tr[role-group*="' + groupValue + '"]').show();
                                        } else {
                                            $('tr[role-group*="' + groupValue + '"]').hide();
                                        }
                                    }
                                });
                            },
                        // ,
                        // sortable: {
                        //     allowUnsort: true
                        // }

                    }
                );
            }

            function initSelectOnRowButton() {
                if (lodash.has(mem, 'options.select_on_row_button')) {
                    var selectOnRowButton = lodash.get(mem, 'options.select_on_row_button', {});
                    var select = lodash.get(selectOnRowButton, 'select', null);
                    var listener = lodash.get(selectOnRowButton, 'listener', null);
                    var clearQueryParams = lodash.get(selectOnRowButton, 'clear_query_params', []);

                    if (!!select && !!listener) {
                        var rowButtonRules = lodash.get(mem, 'options.row_button_rules', []);

                        if (typeof listener === 'string') {
                            listener = lodash.keys(rowButtonRules);
                        }

                        listener = lodash.pull(listener, select);

                        var selectOnRowButtonListeners = lodash.map(listener, function (oListener) {
                            return (function (select, oListener, clearQueryParams) {
                                return function (action, dataItem) {
                                    if (action === oListener) {

                                        var currentDataItemId = lodash.get(mem, 'pageData.detailPanel.dataItem.id', -1);
                                        var isSameDataItem = currentDataItemId === lodash.get(dataItem, 'id', -2);

                                        if (select === 'preview' && !isSameDataItem) {
                                            _.forEach(clearQueryParams, function (clearQueryParam) {
                                                $location.search(clearQueryParam, null);
                                            });
                                            showDetailView(dataItem);
                                        }
                                        emitDataItemEvent(select, dataItem);
                                    }
                                };
                            })(select, oListener, clearQueryParams);
                        });
                        mem.options.selectOnRowButtonListeners = selectOnRowButtonListeners;
                    }
                }
            }

            // </editor-fold>

            // <editor-fold desc='Grid Stuff'>
            function readGrid(readOptions) {
                mem.pageData.grid_refreshing = true;
                triggerExternalGridRefreshFunc();
                var isFirstLoad = lodash.get(mem, 'currentPage.init', true);
                mem.currentPage = {
                    selected: [],
                    total: 0,
                };

                // getAppliedFilters();
                // if (lodash.has(mem, 'pageData.filters.pipeline') && (mem.pageData.filters.pipeline !== null)) {
                //     // if (mem.pageData.filters.pipeline.value !== ['all']) {
                //     const selectValues = lodash.difference(mem.pageData.filters.pipeline.value, ['all']);
                //     if (selectValues.length > 0) {
                //         const selectFilter = angular.extend({}, mem.pageData.filters.pipeline, {
                //             value: selectValues
                //         });
                //         appliedFilters.push(selectFilter);
                //     }
                // }
                //
                // var myOptions = {
                //     filter: {
                //         applied: appliedFilters,
                //         pipeline: mem.pageData.filters.pipeline || {},
                //     },
                // };

                var myOptions = {
                    filter: filterService.getAppliedFilters(),
                };


                if (typeof filterService.getSort === typeof function () {
                }) {
                    myOptions.sort = filterService.getSort();
                } else {
                    // filterService.getSort will be null on load. This is to apply default sort on load
                    if (lodash.has(mem.options, 'toolbar.sort.default')) {
                        myOptions.sort = [mem.options.toolbar.sort.default];
                    }
                }

                var method = '', datasource = '';
                var includePipeline = true;
                if (filterService.hasAppliedFilters(includePipeline)) {
                    if (lodash.has(mem.options, 'filters.datasource')) {
                        method = mem.options.filters.datasource.filter.method;
                        datasource = mem.options.filters.datasource.filter.url;
                    } else {
                        method = 'search';
                        datasource = mem.url + "/filter";
                    }
                } else {
                    var clearFilter = lodash.get(mem.options.filters, 'datasource.clear_filter', null);
                    if(clearFilter){
                        method = clearFilter.method;
                        datasource = clearFilter.url;
                    }else{
                        method = 'query';
                        datasource = mem.url;
                    }
                }


                var data = generateResourceOption(readOptions.data, myOptions, method);

                var model = new GenericModel(datasource);
                model[method](data).$promise.then(function (res) {
                    if (lodash.has(mem, 'options.toolbar') && !!mem.options.toolbar) {
                        selectService.prepareSelected(res);
                    }

                    var rows = lodash.get(res, 'rows', []);
                    var hasRows = rows.length;
                    var isAlwaysOn = lodash.get(mem, 'options.detail_panel.always_on', false);
                    var smartDetailPanel = lodash.get(mem, 'options.detail_panel.smart_detail_panel', false);
                    if (isAlwaysOn || smartDetailPanel) {
                        if (hasRows) {
                            var currentlySelectedID = lodash.get(mem, 'pageData.detailPanel.dataItem.select_id', null);
                            var rowExist = lodash.findIndex(rows, {select_id: currentlySelectedID}) >= 0;

                            if (smartDetailPanel) {
                                if (!rowExist && mem.pageData.detailPanel.dataItem) {
                                    loadDetailPanelWithLatestRow(rows);
                                }
                            } else {
                                if (!rowExist) {
                                    loadDetailPanelWithLatestRow(rows);
                                } else {
                                    renderActive();
                                }
                            }
                        } else {
                            mem.pageData.detailPanel.dataItem = null;
                            mem.pageData.detailPanel.title = '';
                        }
                    }


                    readOptions.success(res);
                    mem.pageData.grid.testFilter = true;

                    mem.pageData.grid_refreshing = false;
                    // mem.pageData.grid.resize();
                    if (selectService) {
                        selectService.reconcileSelected(res);
                    }
                }, function (res) {
                    readOptions.error(res);
                });
            }

            function loadDetailPanelWithLatestRow(rows) {
                showDetailView(lodash.first(rows));
                emitDataItemEvent('preview', lodash.first(rows));
            }

            function prepareDatasource(datasource) {
                if (lodash.has(datasource, 'transport.read')) {
                    if (lodash.has(datasource.transport.read, 'url')) {
                        mem.url = datasource.transport.read.url;
                        datasource.transport.read = readGrid;
                    }
                }
                return datasource;
            }

            function setDatasourceUrl(url) {
                mem.url = url;
            }

            function prepareGridOption(gridOption) {
                if (lodash.has(mem, 'options.toolbar')) {
                    const hideColumns = lodash.get(mem, 'options.toolbar.hideSelection', false);
                    if (!hideColumns) {
                        gridOption.columns = addSelectColumn(gridOption.columns);
                    }
                }

                if (lodash.has(gridOption, 'rowTemplate') && gridOption.columns.length === 0) {
                    gridOption.columns.push({field: 'template'});
                }


                if (lodash.has(mem, 'options.detail_panel') && mem.options.detail_panel) {
                    gridOption.change = gridChange;
                    gridOption.selectable = lodash.get(gridOption, 'selectable', 'row');

                }
                gridOption.dataBound = gridDataBoundDetailPanel;

                //}
                return gridOption;
            }

            function gridDataBoundDetailPanel(e) {
                // closeDetailPanel();
                if (lodash.has(mem, 'options.detail_panel') && mem.options.detail_panel) {
                    if (!lodash.isEmpty(mem.pageData.detailPanel.dataItem)) {
                        const updated = lodash.find(this._data, {select_id: mem.pageData.detailPanel.dataItem.select_id});
                        if (updated) {
                            mem.pageData.detailPanel.dataItem = updated;
                        }
                    }
                }
            }

            function gridChange(e) {
                const previousState = mem.pageData.detailPanel.toggleState;
                mem.pageData.detailPanel.toggleState = true;
                // get the selected data
                mem.pageData.detailPanel.dataItem = mem.pageData.grid.dataItem(this.select());
                mem.pageData.detailPanel.title = lodash.get(mem.pageData.detailPanel.dataItem, mem.pageData.detailPanel.titleField, '');
                if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                    mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                        mem.pageData.grid.hideColumn(fieldName);
                    });
                }
                e.sender.$angular_scope.$apply();

                if (previousState) {
                    $timeout(function () {
                        mem.pageData.detailPanel.refresh();
                    });
                }
            }

            function showDetailView(dataItem) {
                const previousState = mem.pageData.detailPanel.toggleState;
                mem.pageData.detailPanel.toggleState = true;
                mem.pageData.detailPanel.dataItem = dataItem;
                mem.pageData.detailPanel.title = lodash.get(mem.pageData.detailPanel.dataItem, mem.pageData.detailPanel.titleField, '');
                if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                    mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                        mem.pageData.grid.hideColumn(fieldName);
                    });
                }
                if (previousState || lodash.get(mem, 'options.detail_panel.always_on', false) === true) {
                    $timeout(function () {
                        mem.pageData.detailPanel.refresh();
                        if (typeof mem.pageData.detailPanel.refreshHeader === typeof function () {
                        }) {
                            mem.pageData.detailPanel.refreshHeader();
                        }
                    });
                }
                angular.element('body').addClass('grid-detail-panel-active');

                renderActive();
            }

            function hideDetailView() {
                closeDetailPanel();
            }

            function renderActive() {
                var data = [];
                if (lodash.has(mem, 'pageData.grid.dataSource.data')) {
                    data = mem.pageData.grid.dataSource.data();

                    var dataItem = lodash.get(mem, 'pageData.detailPanel.dataItem', {});
                    _.forEach(document.querySelectorAll('[data-id]'), (function (data) {
                        return function (oRow) {
                            var elemDataId = oRow.getAttribute('data-id');
                            var foundDataId = lodash.find(data, {select_id: elemDataId});
                            if (!!foundDataId) oRow.className = '';
                        }
                    })(data));

                    var filteredData = lodash.filter(data, {select_id: lodash.get(dataItem, 'select_id', -1)});
                    _.forEach(filteredData, function (oFilterData) {
                        var selectedRow = document.querySelector('[data-id="' + oFilterData.select_id + '"]');
                        if (selectedRow) {
                            selectedRow.className = 'active';
                        }
                    });
                }
            }

            function addSelectColumn(columns) {
                const selectColumns = [];

                if (lodash.get(mem.pageData, 'toolbar.hasSelectionButton', false) && !mem.pageData.toolbar.hideSelectAll) {
                    selectColumns.push({
                        headerTemplate: '<list-filter-select-all flag="vm.pageData.toolbar.selection.selectAllFlag"></list-filter-select-all>',
                        template: '<list-filter-select data-item="dataItem"></list-filter-select>',
                        width: '42px',
                        attributes: {
                            "class": "text-center"
                        },
                        headerAttributes: {
                            "class": "text-center"
                        }
                    });
                }

                return selectColumns.concat(columns);
            }

            function generateResourceOption(resourceData, myData, method) {
                var params = {};
                params = angular.merge(params, resourceData, myData);
                if (method == 'search') {
                    params = {'data': params};
                }
                return params;
            }

            function toggleSelectRow(dataItem) {
                selectService.toggleSelectRow(dataItem);
            }

            function toggleSelectAll() {
                selectService.toggleSelectAll();
            }

            function refreshGrid(resetToPageOne) {
                if (lodash.has(mem.pageData, 'grid.dataSource')) {
                    if (resetToPageOne) {
                        mem.pageData.grid.dataSource.page(1);
                    } else {
                        mem.pageData.grid.dataSource.read().then(function () {
                        });
                    }
                }
            }

            // </editor-fold>

            function getFilterService() {
                return filterService;
            }

            function getSelectedModel(include_select_filters) {
                // Future implementation, schema will determine the data in selected.
                var selected = lodash.get(mem.pageData, 'toolbar.selection.selected', []).map(function (_s) {
                    return {id: _s.id};
                });

                return {
                    selected: selected,
                    selectAllFlag: lodash.get(mem.pageData, 'toolbar.selection.select_all', false),
                    filter: filterService.getAppliedFilters(),
                    isMassSelectedItems: true,
                    selectAllCount: lodash.get(mem.pageData, 'toolbar.selection.selection_count', selected.length),
                };
            }

            function getSelectedModelKeys($keys) {
                // Future implementation, schema will determine the data in selected.
                var selected = lodash.get(mem.pageData, 'toolbar.selection.selected', []).map(function (_s) {
                    return _s;
                });

                return {
                    selected: selected,
                    selectAllFlag: false,
                    filter: filterService.getAppliedFilters(),
                    isMassSelectedItems: true
                };
            }

            function clearSelected() {
                if (selectService) {
                    selectService.unselectAll();
                }
            }

            function closeDetailPanel() {

                if (mem.pageData.detailPanel) {
                    mem.pageData.detailPanel.toggleState = false;
                    mem.pageData.detailPanel.dataItem = null;

                    if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                        mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                            mem.pageData.grid.showColumn(fieldName);
                        });
                    }
                    mem.pageData.grid.resize();
                }
                angular.element('body').removeClass('grid-detail-panel-active');

                renderActive();
            }

            function toggleFilterSidebar() {
                if (mem.pageData.sidebar_active !== undefined) {
                    mem.pageData.sidebar_active = !mem.pageData.sidebar_active;
                    $timeout(function () {
                        vm.pageData.grid.resize();
                    });
                }
            }

            function updateToolbarButtons(status) {
                if (!lodash.has(mem.options, 'status_selection.selection_button_rules')) {
                    return;
                }
                let statusKey = "0";
                if (!!status) {
                    statusKey = status.value.toString();
                }
                const selectedStatus = lodash.find(mem.options.status_selection.selection_button_rules, function (value) {
                    return value.key.toString() === statusKey;
                });
                const selectionButtons = selectedStatus.rules.selection.map(function (actionName) {
                    return lodash.find(mem.options.toolbar.selection.conditionals, {name: actionName});
                });
                const additionals = selectedStatus.rules.additionals.map(function (a) {
                    const additional = Object.assign({}, a);
                    additional.actions = a.actions.map(function (actionName) {
                        return lodash.find(mem.options.toolbar.selection.conditionals, {name: actionName});
                    });
                    return additional;
                });

                const buttons = lodash.get(mem.options.toolbar, 'selection.buttons', []);

                lodash.set(mem.pageData.toolbar.selection, 'buttons', buttons.concat(selectionButtons));
                lodash.set(mem.pageData.toolbar.selection, 'additionals', additionals);
            }

            function setExternalGridRefreshFunc(func) {
                mem.gridRefreshFunc = func;
            }

            function triggerExternalGridRefreshFunc() {
                if (lodash.has(mem, 'gridRefreshFunc') && typeof mem.gridRefreshFunc === typeof function () {
                }) {
                    mem.gridRefreshFunc();
                }
            }

            function getData(path) {
                return lodash.get(mem.pageData, path, null);
            }

            function setData(path, value) {
                return lodash.set(mem.pageData, path, value);
            }

            function updateRecord(record) {
                var data = lodash.find(mem.pageData.grid.dataSource.data(), {[record.record_key]: record.record_id});
                // lodash.set(data, record.data, {});
                if (data) {
                    angular.merge(data, record.data);
                } else {
                    refreshGrid();
                }
                // return mem.pageData.grid.dataSource.pushUpdate(record);
                return true;
            }

            function getAllDataItems() {
                return mem.pageData.grid.dataSource.data();
            }

            function setExternalStatus(status) {
                lodash.set(mem.pageData, 'externalStatus', status);
            }

            function getExternalStatus() {
                return lodash.get(mem.pageData, 'externalStatus', null);
            }

            function getGrid() {
                return mem.pageData.grid;
            }

            function setSearchText(searchText) {
                lodash.set(mem.pageData, 'toolbar.searchText', searchText);
            }

            function toggleSelectable(state) {
                lodash.set(mem.pageData, 'toolbar.hideSelectAll', !state);
                lodash.set(mem.pageData, 'toolbar.hasSelectionButton', state)
            }

            function setPage(page) {
                var grid = this.getGrid();
                if (grid.pager) {
                    grid.pager.page(page);
                }
            }

            function getCurrentPipeline() {
                var applied_filters = filterService.getAppliedFilters();
                return applied_filters.pipeline;
            }

            function setPipelineData($data) {
                mem.pageData.pipelines = $data;
            }

            function getPipelineData() {
                return mem.pageData.pipelines;
            }

            function getHasPipeline() {
                return lodash.has(mem.options, 'status_selection');
            }
        };
    }
})();

(function () {
    'use strict';

    SelectListFilterService.$inject = ['SELECT_CONSTANT', 'lodash', '$timeout'];
    angular
        .module('rms.common')
        .factory('SelectListFilterService', SelectListFilterService);

    function SelectListFilterService(SELECT_CONSTANT, lodash, $timeout) {
        return function (mem) {
            return {
                prepareSelected: prepareSelected,
                toggleSelectRow: toggleSelectRow,
                toggleSelectAll: toggleSelectAll,
                unselectAll: unselectAll,
                reconcileSelected: reconcileSelected,
            };

            function prepareSelected(res) {
                // get the datasource options schema, content
                var dataField = lodash.get(mem.options, 'grid.datasource.schema.data', 'data');
                mem.currentPage.total = res[dataField].length;

                if (mem.currentPage.total > 0) {
                    angular.forEach(res[dataField], function (val) {
                        var existedItem = lodash.find(mem.pageData.toolbar.selection.selected, function (item) {
                            return item.select_id == val.select_id;
                        });
                        if (typeof existedItem !== typeof undefined) {
                            val.selected = SELECT_CONSTANT.SELECTED;
                            mem.currentPage.selected.push(val);
                        } else {
                            val.selected = SELECT_CONSTANT.NOT_SELECTED;
                        }
                    });
                    resolveSelectAll();
                } else {
                    unselectAllInPage();
                }
            }

            function reconcileSelected(res) {
                var dataField = lodash.get(mem.options, 'grid.datasource.schema.data', 'data');
                var data = res[dataField];
                var count = res[dataField].length;
                var toolbarSelected = [];
                var currentPageSelected = [];
                if (count > 0) {
                    angular.forEach(data, function (row) {
                        var match = lodash.find(mem.pageData.toolbar.selection.selected, function (selection) {
                            return selection.select_id === row.select_id;
                        })

                       if (match !== undefined) {
                           row.selected = SELECT_CONSTANT.SELECTED;
                           toolbarSelected.push(row);
                           currentPageSelected.push(row);
                       } else {
                           row.selected = SELECT_CONSTANT.NOT_SELECTED;
                       }

                    });
                }
                mem.pageData.toolbar.selection.selected = toolbarSelected;
                mem.currentPage.selected = currentPageSelected;

                resolveSelectAll();
            }

            function toggleSelectRow(dataItem) {
                var preventSelectionOn = lodash.get(mem.pageData.toolbar.selection, 'prevent_selection_on', null);
                if (!(preventSelectionOn && dataItem[preventSelectionOn])) {

                    if (dataItem.selected === SELECT_CONSTANT.SELECTED) {
                        mem.pageData.toolbar.selection.selected.push(dataItem);
                        mem.currentPage.selected.push(dataItem);
                    } else {
                        var index = lodash.findIndex(mem.pageData.toolbar.selection.selected, function (item) {
                            return item.select_id == dataItem.select_id;
                        });
                        mem.pageData.toolbar.selection.selected.splice(index, 1);
                        var indexCurrentPage = lodash.findIndex(mem.currentPage.selected, function (item) {
                            return item.select_id == dataItem.select_id;
                        });
                        mem.currentPage.selected.splice(indexCurrentPage, 1);
                    }
                }
                resolveSelectAll();
                // handleBulkAction();
            }

            function toggleSelectAll() {
                switch (mem.pageData.toolbar.selection.selectAllFlag) {
                    case SELECT_CONSTANT.ALL:
                        // unselect all
                        $timeout(function() {
                            unselectAllInPage();
                        });

                        break;
                    case SELECT_CONSTANT.SOME:
                    case SELECT_CONSTANT.NONE:
                        // select all
                        selectAllInPage();
                        break;
                    default:
                        break;
                }
            }

            function handleBulkAction() {
                if (mem.pageData.use_bulk_action) {
                    
                    var is_bulk_open =  mem.pageData.bulk_action_active;
                    mem.pageData.bulk_action_active = mem.currentPage.selected.length > 0

                    if(!mem.pageData.bulk_action_active){
                        if(is_bulk_open) {
                            //has been closed, if have filters applied open it, if not set to false
                            mem.pageData.sidebar_active = (lodash.get(mem.pageData, 'filters.active_filters.applied.length', 0) > 0)
                        }
                    }else{
                        mem.pageData.sidebar_active = false;
                    }

                    $timeout(function () {
                        mem.pageData.grid.resize();
                    });
                }
            }

            function unselectAll() {
                unselectAllInPage();
            }

            function resolveSelectAll() {
                if (mem.currentPage.total == mem.currentPage.selected.length) {
                    if (mem.currentPage.total > 0) {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.ALL;
                    } else {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.NONE;
                    }

                } else {
                    if (mem.currentPage.selected.length > 0) {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.SOME;
                    } else {
                        mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.NONE;
                        unselectAll()
                    }
                }
                handleBulkAction();
            }

            function selectAllInPage() {
                var preventSelectionOn = lodash.get(mem.pageData.toolbar.selection, 'prevent_selection_on', null);
                angular.forEach(mem.pageData.grid.dataSource.data(), function (val) {
                    if (preventSelectionOn && val[preventSelectionOn]) {
                        return;
                    }

                    val.selected = SELECT_CONSTANT.SELECTED;
                    var existedItem = lodash.find(mem.pageData.toolbar.selection.selected, function (item) {
                        return item.select_id == val.select_id;
                    });
                    if (typeof existedItem === typeof undefined) {
                        mem.pageData.toolbar.selection.selected.push(val);
                        mem.currentPage.selected.push(val);
                    }
                });
                mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.ALL;

                handleBulkAction()

            }

            function unselectAllInPage() {
                angular.forEach(mem.pageData.grid.dataSource.data(), function (val) {
                    val.selected = SELECT_CONSTANT.NOT_SELECTED;
                    // var index = lodash.findIndex(mem.pageData.toolbar.selection.selected, function (item) {
                    //     return item.select_id == val.select_id;
                    // });
                    // if (index >= 0) {
                    //     mem.pageData.toolbar.selection.selected.splice(index, 1);
                    // }
                });
                mem.pageData.toolbar.selection.selected.splice(0, mem.pageData.toolbar.selection.selected.length); // temporary for now

                mem.currentPage.selected.splice(0, mem.currentPage.selected.length);
                mem.pageData.toolbar.selection.selectAllFlag = SELECT_CONSTANT.NONE;
                // scope.listFilterService.clearSelected();
                lodash.set(mem.pageData, 'toolbar.selection.select_all', false);
                handleBulkAction()

            }
        };
    }
})();

(function () {
    'use strict';

    filterValueCtrl.$inject = ['$scope', 'lodash'];
    angular
        .module('rms.common')
        .directive('filterValue', filterValue);

    function filterValue() {
        return {
            restrict: 'EA',
            scope: {
                filter: '='
            },
            controller: filterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-value'
        };
    }

    function filterValueCtrl($scope, lodash) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};

            vm.settingsOverride = $scope.listFilterService.getFilterService().getFilterOptionInputConfig(lodash.get(vm, 'filter.type', ''));

            $scope.$watch(watchFilter, onFilterChange);
            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
        }

        function watchFilter() {
            return vm.filter;
        }

        function onFilterChange() {
            if (vm.filter) {
                $scope.listFilterService.getFilterService().prepareFilterOptionValues();
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('detailPanelLoadingScreen', detailPanelLoading);

    function detailPanelLoading() {
        return {
            restrict: 'E',
            template: '<div class="detail-panel-loading-screen" ng-if="vm.isRefreshing()"><div class="detail-panel-loading-screen-loader"></div></div>'
        };
    }
})();
(function () {
    'use strict';

    rmsListFilterGridDetailPanel.$inject = ['$timeout'];
    rmsListFilterGridDetailPanelCtrl.$inject = ['$scope', 'lodash', 'PanelManager', '$document', '$timeout', '$window'];
    angular
        .module('rms.common')
        .directive('rmsListFilterGridDetailPanel', rmsListFilterGridDetailPanel);

    function rmsListFilterGridDetailPanel($timeout) {
        return {
            restrict: 'E',
            scope: {
                options: '=?',
                model: '=?' // should comes from the dataItem. Sometimes the dataItem don't contain enough information. May want to get from remote also.
                // We should also attempt to combine both local data and remote data. First fill in local data. Once api responded with data, we can fill up the rest
            },
            controller: rmsListFilterGridDetailPanelCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/grid-detail-panel',
            link: rmsListFilterGridDetailPanelLink
        };

        function rmsListFilterGridDetailPanelLink(scope) {
            const vm = scope.vm;
            $timeout(function() {
                if (typeof vm.submit === typeof function () {}) {
                    vm.showSubmitButton = true;
                }
            });
        }
    }

    function rmsListFilterGridDetailPanelCtrl($scope, lodash, PanelManager, $document, $timeout, $window) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.showSubmitButton = false;
            vm.force_fullwidth = false;
            vm.pageData = {};
            vm.save = save;

            vm.firstRun = true;
            vm.isToggled = false;
            vm.$gridContentWidth = null;

            vm.closePanel = closePanel;
            vm.togglePanel = togglePanel;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
            vm.force_fullwidth = lodash.get(vm.pageData, 'detailPanel.force_fullwidth', false);
            $scope.$watch(function () {
                return $scope.$parent.vm.pageData.sidebar_active || $scope.$parent.vm.pageData.bulk_action_active;
            }, function() {
                $timeout(function() {
                    togglePanel(true);
                }, 150);
            });

            $scope.$watch(function () {
                return  $scope.$parent.vm.pageData.detailPanel.toggleState;
            }, function() {
                $timeout(function() {
                    togglePanel(true);
                }, 150);
            });

            angular.element($window).bind('resize', function(){

                // scope.width = $window.innerWidth;

                // // manuall $digest required as resize event
                // // is outside of angular
                togglePanel(true);
            });
        }

        function save() {
            vm.submit();
        }

        function closePanel() {
            // vm.pageData.detailPanel.toggleState = false;
            $scope.listFilterService.closeDetailPanel();
            if (lodash.has(vm.pageData, 'detailPanel.options.panel_content_id') && lodash.has(vm.pageData, 'detailPanel.options.panel_id')) {
                PanelManager.destroy(vm.pageData.detailPanel.options.panel_id);
            }
        }

        function togglePanel(skipToggle) {
            skipToggle = skipToggle || false;
            // if ($(window).width() < 1000 && vm.firstRun) {
            //     vm.firstRun = false;
            //     return closePanel();
            // }

            vm.firstRun = false;

            if (vm.$gridDetailColumn === undefined) {
                vm.$gridDetailColumn = $('.grid-detail-column');
                vm.$gridContentColumn = vm.$gridDetailColumn.siblings('.grid-content-column');
                vm.$gridContent = vm.$gridContentColumn.find('.k-grid-content');
            }

            var $gridContentWidth = vm.$gridContent.css('width');

            if (vm.force_fullwidth) {
                return;
            }

            // probably need to refactor and figure out what is going on here..
            if (vm.$gridContentWidth === null) {
                vm.$gridContentWidth = $gridContentWidth;
                return;
            }

            if (($gridContentWidth === vm.$gridContentWidth && skipToggle) || lodash.isEmpty(vm.pageData.detailPanel.dataItem)) {
                return;
            }

            vm.$gridContentWidth = $gridContentWidth;
            
            if (!skipToggle) {
                if (!vm.isToggled) {
                    vm.$gridDetailColumn.css('width', 'calc(100% - 30px)');
                } else {
                    vm.$gridDetailColumn.css('width', 'calc(100% - 30px - ' + $gridContentWidth + ')');
                }

                vm.isToggled = !vm.isToggled;
            } else {
                if (!vm.isToggled) {
                    vm.$gridDetailColumn.css('width', 'calc(100% - 30px - ' + $gridContentWidth + ')');
                }
            }
        }
    }
})();
(function () {
    'use strict';

    rmsListFilterGrid.$inject = ['$window', 'lodash'];
    rmsListFilterGridCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('rmsListFilterGrid', rmsListFilterGrid);

    function rmsListFilterGrid($window, lodash) {
        return {
            restrict: 'E',
            scope: {
                grid: '='
            },
            controller: rmsListFilterGridCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/grid',
            link: rmsListFilterGridLink
        };

        function rmsListFilterGridLink(scope, elem) {
            const vm = scope.vm,
                kendoGridObj = vm.pageData.grid;

            angular.element($window).on('resize', () => {
                kendoGridObj.resize();
            });

            if (lodash.has(vm.pageData, 'gridOption.remove_grid_content_height_style') && vm.pageData.gridOption.remove_grid_content_height_style) {
                elem.find('.k-grid-content').removeAttr('style');
            }

            scope.$on('$destroy', () => {
                angular.element($window).off('resize');
            });
        }
    }

    function rmsListFilterGridCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};
            vm.dataItemAction = dataItemAction;
            vm.dataItemClass = dataItemClass;
            vm.showButton = showButton;
            vm.showChildInfo = showChildInfo;
            vm.showSection = showButton;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
        }

        function dataItemAction(action, dataItem) {
            if (action === 'preview') {
                $scope.listFilterService.showDetailView(dataItem);
            } else {
                $scope.listFilterService.emitDataItemEvent(action, dataItem);
            }
        }

        function dataItemClass(action, dataItem) {
            var buttonVisibility = $scope.listFilterService.getRowButtonVisibility(action, dataItem);
            return (buttonVisibility) ? '' : 'grid-cell-icon-hidden';
        }

        function showButton(type, dataItem) {
            return $scope.listFilterService.getRowButtonVisibility(type, dataItem);
        }

        function showChildInfo(valueKey, ruleCheck, dataItem) {
            return $scope.listFilterService.getChildInfoVisibility(valueKey, ruleCheck, dataItem);
        }
    }
})();

(function () {
    'use strict';

    rmsListFilterBuilderCtrl.$inject = ['FILTER_STEP_CONSTANT', '$scope', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsListFilterBuilder', rmsListFilterBuilder);

    function rmsListFilterBuilder() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsListFilterBuilderCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/list-filter-builder'
        };
    }

    function rmsListFilterBuilderCtrl(FILTER_STEP_CONSTANT, $scope, lodash) {
        var vm = this,
            filterService = null;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};

            vm.constant = FILTER_STEP_CONSTANT;
            vm.addFilter = addFilter;
            vm.backToPrevious = backToPrevious;
            vm.selectFilter = selectFilter;
            vm.backToStepProperties = backToStepProperties;
            vm.backToAppliedScreen = backToAppliedScreen;
            vm.compareType = compareType;
            vm.reset = reset;
            vm.saveAsView = saveAsView;
            vm.editFilter = editFilter;
            vm.removeFilter = removeFilter;
            vm.hasAppliedFilters = hasAppliedFilters;
            vm.hasFilter = hasFilter;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
            filterService = $scope.listFilterService.getFilterService();
            vm.pageData.filters.step = FILTER_STEP_CONSTANT.LIST;
        }

        function backToPrevious() {
            filterService.backToPrevious();
        }

        function addFilter() {
            filterService.goToNext();
        }

        function reset() {
            filterService.clearFilters();
            $scope.listFilterService.refreshGrid(true);
        }

        function selectFilter(filter) {
            filterService.selectFilter(filter);
        }

        function backToStepProperties() {
            if (vm.pageData.filters.editing) {
                filterService.resetCurrent();
            } else {
                filterService.clearCurrentFilter();
                backToPrevious();
            }
        }

        function backToAppliedScreen() {
            vm.pageData.filters.searchFilter = {};
            backToPrevious();
        }

        function compareType(filter, type) {
            return filter.type == type;
        }

        function editFilter(filter) {
            if (hasFilter(filter)) {
                filterService.editFilter(filter);
            }
        }

        function removeFilter($event, filter) {
            $event.stopPropagation();
            filterService.removeFilter(filter);
            $scope.listFilterService.refreshGrid(true);
        }

        function saveAsView() {
            (lodash.get(vm.pageData, 'view_options.selected_view.editable', false) === true)
                ? filterService.updateView()
                : filterService.createView();
        }

        function hasAppliedFilters() {
            return filterService.hasAppliedFilters();
        }

        function hasFilter(applied_filter) {
            return filterService.hasFilter(applied_filter);
        }
    }
})();
(function () {
    'use strict';

    rmsListFilterFilterStandAloneCtrl.$inject = ['$scope', 'lodash', '$interval', 'ListFilterStateFactory', 'FormBuilderService'];
    angular
        .module('rms.common')
        .directive('rmsListFilterFilterStandalone', rmsListFilterFilterStandAlone);

    function rmsListFilterFilterStandAlone() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                filterForm: '=?',
            },
            controllerAs: 'vm',
            controller: rmsListFilterFilterStandAloneCtrl,
            bindToController: true,
            templateUrl: function(elem, attr) {
                if (attr.templateFullPath) {
                    return attr.templateFullPath;
                }

                if (attr.template) {
                    return 'common/app/components/list-filter/' + attr.template;
                }
                return 'common/app/components/list-filter/list-filter-filter-standalone-default';
            },
            link: function(scope, elem) {
                const vm = scope.vm;
                const showFilterButton = elem.find('.show-advance-filters');
                const advanceSearch = elem.find('.advanced-search');
                vm.onShowButtonClick = onShowButtonClick;


                function onShowButtonClick() {
                    if (showFilterButton.hasClass('active')) {
                        showFilterButton.removeClass('active');
                        advanceSearch.slideUp();
                    } else {
                        showFilterButton.addClass('active');
                        advanceSearch.slideDown();
                    }
                }
            }
        }
    }

    function rmsListFilterFilterStandAloneCtrl($scope, lodash, $interval, ListFilterStateFactory, FormBuilderService) {
        const vm = this;
        var listFilterIdentifier = 'default';
        this.$onInit = function() {
            listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');

            vm.onSortChange = onSortChange;
            vm.searchTextChanged = searchTextChanged;

            $scope.filterInterval = $interval(function() {
                initListFilterService();
                if (!!$scope.listFilterService) {
                    $interval.cancel($scope.filterInterval);
                    init();
                }
            }, 300);
        }

        function init() {
            $scope.$watch(function () {
                if (!vm.filterForm) return null;
                return FormBuilderService.getModel(vm.filterForm.name);
            }, function () {
                // do refresh grid
                initListFilterService();

                if (lodash.has(vm.filterForm, 'model.search_txt')) {
                    vm.searchText = vm.filterForm.model.search_txt;
                    delete vm.filterForm.model.search_txt;
                    $scope.listFilterService.setSearchText(vm.searchText);
                }

                const filters = generateFilters();
                $scope.listFilterService.getFilterService().setActiveFilter('applied', filters);
                $scope.listFilterService.refreshGrid(true);
            }, true);
        }

        function generateFilters() {
            if (!vm.filterForm) return [];
            const formModel = FormBuilderService.getModel(vm.filterForm.name);
            const formModelNotEmpty = lodash.omitBy(formModel, function(value) {
                if (lodash.isNumber(value)) {
                    return false;
                }
                return lodash.isEmpty(value);
            });
            const modelKeys = lodash.keys(lodash.omit(formModelNotEmpty, ['hid_ref_form']));

            return modelKeys.map(function(key) {
                var modelValue =formModel[key];
                if (!lodash.isArray(modelValue)) {
                    modelValue = [modelValue];
                }
                return {
                    field: key,
                    operator: 'in',
                    value: modelValue,
                };
            });
        }

        function onSortChange() {
            console.log('sort change', vm.sortBy);
            initListFilterService();
            if (vm.sortBy) {
                const sort = vm.sortBy.split('|');
                $scope.listFilterService.getGrid().dataSource.sort({field: sort[0], dir: sort[1]});
            } else {
                $scope.listFilterService.getGrid().dataSource.sort({});
            }
            $scope.listFilterService.refreshGrid(true);
            //$scope.listFilterService.getGrid().dataSource.sort();
        }

        function searchTextChanged() {
            initListFilterService();
            $scope.listFilterService.setSearchText(vm.searchText);
            $scope.listFilterService.refreshGrid(true);
        }

        function initListFilterService() {
            if (!$scope.listFilterService) {
                $scope.listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
            }

        }

    }
})();
(function () {
    'use strict';

    rmsListFilterCtrl.$inject = ['ListFilterService', '$scope', 'lodash', 'ListFilterStateFactory'];
    angular
        .module('rms.common')
        .directive('rmsListFilter', rmsListFilter);

    function rmsListFilter() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                hideFilter: '=?',
                setExternalFilter: '=?',
                gridRefresh: '&?'
            },
            controller: rmsListFilterCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/list-filter'
        };
    }

    function rmsListFilterCtrl(ListFilterService, $scope, lodash, ListFilterStateFactory) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');

            vm.pageData = {
                sidebar_active: false,
                bulk_action_active: false,
                use_bulk_action: lodash.get(vm.options, 'toolbar.side_bulk_action.setting', false),
            };
            vm.setExternalFilter = setExternalFilter;
            vm.hasActiveFilters = hasActiveFilters;

            var hideFilter = lodash.get(vm.options, 'hideFilter', false);

            if (hideFilter === true) {
                vm.hideFilter = hideFilter;
            }

            $scope.$on('$destroy', destroyFunc);
            init();
        }

        function destroyFunc() {
            ListFilterStateFactory.destroy($scope.listFilterIdentifier);
        }

        function init() {
            $scope.listFilterService = new ListFilterService();
            $scope.listFilterService.init(vm.pageData, angular.copy(vm.options), $scope);
            ListFilterStateFactory.create($scope.listFilterService, $scope.listFilterIdentifier);

            if (typeof vm.gridRefresh === typeof function () {
            }) {
                $scope.listFilterService.setExternalGridRefreshFunc(vm.gridRefresh);
            }
        }

        function setExternalFilter(refreshGrid, status) {
            $scope.listFilterService.clearSelected();
            if (status) {
                vm.pageData.filters.active_filters.pipeline = status;
            }
            if (!status) {
                vm.pageData.filters.active_filters.pipeline = null;
            }
            $scope.listFilterService.updateToolbarButtons(status);
            if (refreshGrid) {
                $scope.listFilterService.refreshGrid(true);
            }
        }

        function hasActiveFilters() {
            return $scope.listFilterService.getFilterService().hasAppliedFilters();
        }
    }
})();

(function () {
    'use strict';

    listFilterSelectAllCtrl.$inject = ['SELECT_CONSTANT', '$scope', '$timeout'];
    angular
        .module('rms.common')
        .directive('listFilterSelectAll', listFilterSelectAll);

    function listFilterSelectAll() {
        return {
            restrict: 'E',
            scope: {
                flag: '='
            },
            templateUrl: 'common/components/select-all',
            controller: listFilterSelectAllCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function listFilterSelectAllCtrl(SELECT_CONSTANT, $scope, $timeout) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.constant = SELECT_CONSTANT;

            vm.toggleSelectAll = toggleSelectAll;
        }

        function toggleSelectAll() {
            $scope.listFilterService.toggleSelectAll();
        }
    }
})();
(function () {
    'use strict';

    rmsListFilterGridSelectDataitemCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('rmsListFilterGridSelectDataitem', rmsListFilterGridSelectDataitem);

    function rmsListFilterGridSelectDataitem() {
        return {
            restrict: 'E',
            controller: rmsListFilterGridSelectDataitemCtrl,
            scope: {
                dataItem: '='
            },
            controllerAs: 'vm',
            bindToController: true,
            template: ''
        };
    }

    function rmsListFilterGridSelectDataitemCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;

            vm.pageData = {};

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
        }
    }
})();
(function () {
    'use strict';

    listFilterSelectCtrl.$inject = ['SELECT_CONSTANT', '$scope'];
    angular
        .module('rms.common')
        .directive('listFilterSelect', listFilterSelect);

    function listFilterSelect() {
        return {
            restrict: 'E',
            scope: {
                item: '=',
                disabled: '=?',
            },
            templateUrl: 'common/components/select',
            controller:listFilterSelectCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function listFilterSelectCtrl(SELECT_CONSTANT, $scope) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.constant = SELECT_CONSTANT;

            vm.toggleSelect = toggleSelect;
        }

        function toggleSelect() {
            if (!vm.disabled) {
                vm.item.selected =
                    (vm.item.selected == SELECT_CONSTANT.SELECTED)
                        ? SELECT_CONSTANT.NOT_SELECTED
                        : SELECT_CONSTANT.SELECTED;
                $scope.listFilterService.toggleSelectRow(vm.item);
            }
        }
    }
})();
(function () {
	'use strict';
	rmsListFilterSidebarMinimize.$inject = ['$timeout'];
	angular
		.module('rms.common')
		.directive('rmsListFilterSidebarMinimize', rmsListFilterSidebarMinimize);
	function rmsListFilterSidebarMinimize($timeout) {
		return {
			restrict: 'E',
			templateUrl: 'common/app/components/list-filter/sidebar-minimize',
			link: function(scope, elem) {
				scope.listFilterService = scope.$parent.listFilterService;
				const vm = scope.$parent.vm;
				vm.expandSidebar = expandSidebar;

				function expandSidebar() {
					vm.pageData.sidebar_active = true;
					$timeout(function() {
						vm.pageData.grid.resize();
					});
				}
			}
		};
	}
})();
(function () {
    'use strict';

    rmsBulkActionSideBar.$inject = ['$timeout', 'lodash', '$filter'];
    angular
        .module('rms.common')
        .directive('rmsBulkActionSidebar', rmsBulkActionSideBar);

    function rmsBulkActionSideBar($timeout, lodash, $filter) {
        return {
            restrict: 'E',
            link: rmsBulkActionSideBarLink,
            templateUrl: 'common/app/components/list-filter/sidebar-bulk-action'
        };

        function rmsBulkActionSideBarLink(scope, elem) {
            scope.listFilterService = scope.$parent.listFilterService;
            scope.filterViewWrapperStyle = {bottom: 0};

            var vm = scope.$parent.vm;
            vm.bulkActions = {};

            vm.bulkActions.allowed_select_all_buttons = lodash.get(vm, 'pageData.toolbar.allowed_select_all_button', []);
            vm.bulkActions.hasSelectAll = showSelectAll();
            vm.bulkActions.filterCount = vm.pageData.grid.dataSource.total();

            scope.$watch(function () {
                return vm.pageData.toolbar.selection.selected.length;
            }, getSelectedCount);


            vm.bulkActions.toggleSelectAll = function() {
                vm.pageData.toolbar.selection.select_all = !vm.pageData.toolbar.selection.select_all;
                vm.pageData.toolbar.selection.selection_count = (vm.pageData.toolbar.selection.select_all)
                    ? vm.bulkActions.filterCount
                    : vm.pageData.toolbar.selection.selected.length;
                // vm.bulkActions.select_all = !vm.bulkActions.select_all;
                vm.bulkActions.determineBulkActionButtons();
            }

            vm.bulkActions.hideSidebar = function () {
                scope.listFilterService.clearSelected();
                vm.pageData.toolbar.selection.select_all = false;
                $timeout(function () {
                    vm.pageData.grid.resize();
                });
            };

            vm.bulkActions.determineBulkActionButtons = function () {
                var allowedButtons, currentPipelineValue, bulkActionRules, pipelineData, currentPipeline;
                var selectionButtons = lodash.get(vm, 'pageData.toolbar.selection.buttons') || [];
                var additionalButtons = lodash.get(vm, 'pageData.toolbar.selection.additionals[0].actions') || [];
                var bulkActionButtons = selectionButtons.concat(additionalButtons);
                var hasPipeline = scope.listFilterService.getHasPipeline();

                if (vm.pageData.toolbar.selection.select_all) {
                    bulkActionButtons = lodash.filter(bulkActionButtons, function(button) {
                        return vm.bulkActions.allowed_select_all_buttons.indexOf(button.button_id) >= 0;
                    });
                }

                if (hasPipeline === true) {
                    pipelineData = scope.listFilterService.getPipelineData();
                    currentPipeline = scope.listFilterService.getCurrentPipeline();
                    bulkActionRules = lodash.reduce(pipelineData, function (carry, pipeline) {
                        pipeline.value.forEach(function (value) {
                            carry[value] = pipeline.bulk_actions;
                        });
                        return carry;
                    }, {});

                    currentPipelineValue = lodash.head(lodash.get(currentPipeline, '0.value', []));
                    allowedButtons = lodash.get(bulkActionRules, currentPipelineValue) || [];

                    // if bulk_actions set in pipeline status is true, allow all buttons
                    if (allowedButtons === true) {
                        vm.bulkActions.bulk_action_buttons = bulkActionButtons;
                    }
                    // else determine if there are matching button_ids
                    else if (allowedButtons.length > 0) {
                        vm.bulkActions.bulk_action_buttons = bulkActionButtons.filter(function (button) {
                            return allowedButtons.some(function (allowed) {
                                return allowed === button.button_id;
                            })
                        });
                    } else {
                        vm.bulkActions.bulk_action_buttons = [];
                    }


                } else {
                    // if page doesn't have pipeline, return all buttons.
                    vm.bulkActions.bulk_action_buttons = bulkActionButtons;
                }
            };

            vm.bulkActions.getSelectAllLabel = function() {
                return $filter('stringFormat')(vm.pageData.toolbar.selection.label.select_all, [vm.bulkActions.filterCount]);
            }
            vm.bulkActions.getSelectAllRemarkLabel = function() {
                return $filter('stringFormat')(vm.pageData.toolbar.selection.label.select_all_remark, [vm.bulkActions.filterCount]);
            }

            vm.bulkActions.closeAndOpenFilters = function () {
                vm.bulkActions.hideSidebar();
                vm.expandSidebar();
            };

            function getSelectedCount() {
                vm.bulkActions.selected_count = $filter('stringFormat')(vm.pageData.toolbar.selection.label.selected_count, [vm.bulkActions.filterCount]);
                vm.bulkActions.selected_all_count = $filter('stringFormat')(vm.pageData.toolbar.selection.label.selected_count, [vm.pageData.toolbar.selection.selected.length]);
            }

            // run button filter
            vm.bulkActions.determineBulkActionButtons();

            function showSelectAll() {
                var totalPages = vm.pageData.grid.dataSource.totalPages();
                var actionCounts = vm.bulkActions.allowed_select_all_buttons.length || 0;
                var hasSelectAll = lodash.get(vm, 'pageData.toolbar.hasSelectAll', false);
                if (hasSelectAll) {
                    return ((totalPages > 1) && (actionCounts > 0));
                }
            }

        }
    }
})();
(function () {
    'use strict';

    rmsListFilterSidebar.$inject = ['$timeout'];
    angular
        .module('rms.common')
        .directive('rmsListFilterSidebar', rmsListFilterSidebar);

    function rmsListFilterSidebar($timeout) {
        return {
            restrict: 'E',
            link: rmsListFilterSidebarLink,
            templateUrl: 'common/app/components/list-filter/sidebar'
        };

        function rmsListFilterSidebarLink(scope, elem) {
            scope.listFilterService = scope.$parent.listFilterService;
            const vm = scope.$parent.vm;
            scope.filterViewWrapperStyle = {bottom: 0};

            vm.hideSidebar = function() {
                vm.pageData.sidebar_active = false;
                $timeout(function() {
	                vm.pageData.grid.resize();
                });
            };

            scope.showingFilterView = function() {
                const filterViewControlElem = elem.find('.filter-view-control');
                $timeout(function() {
                    vm.pageData.filterViewWrapperStyle = {
                      bottom: filterViewControlElem.outerHeight() + 'px !important',
                    };
                });
            };

            scope.viewOptionsChanged = function() {
                scope.listFilterService.refreshGrid();
            };

            scope.onViewChange = function() {
                scope.listFilterService.getFilterService().applyView();
            };

            scope.handleDeleteView = function() {
                scope.listFilterService.getFilterService().deleteView();
            };

            scope.handleUpdateView = function() {
                scope.listFilterService.getFilterService().updateView();
            };

            scope.handleSaveNewView = function() {
                scope.listFilterService.getFilterService().createView();
            };

            scope.hasAppliedFilters = function() {
                return scope.listFilterService.getFilterService().hasAppliedFilters();
            };
        }
    }
})();
(function () {
    'use strict';

    simpleFilterBarCtrl.$inject = ['$scope', 'lodash', '$interval', 'ListFilterStateFactory'];
    angular
        .module('rms.common')
        .directive('simpleSortBar', simpleFilterBar);

    function simpleFilterBar() {
        return {
            restrict: 'E',
            controller: simpleFilterBarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/simple-sort-bar',
            scope: {
                options: '='
            }
        };
    }

    function simpleFilterBarCtrl($scope, lodash, $interval, ListFilterStateFactory) {
        const vm = this;
        var listFilterIdentifier = 'default';
        this.$onInit = function() {
            listFilterIdentifier = lodash.get(vm.options, 'identifier', 'default');

            vm.pageData = {};
            vm.currentDirection = null;

            vm.selectGroup = selectGroup;

            $scope.initInterval = $interval(function () {
                initListFilterService();
                if (!!$scope.listFilterService) {
                    $interval.cancel($scope.initInterval);
                    init();
                }
            }, 300);
        }

        function init() {
            console.log('Simple Filter Bar init');
            $scope.listFilterService.sync(vm);
            vm.filterBarService = $scope.listFilterService.getFilterService();
            vm.refreshGrid = $scope.listFilterService.refreshGrid;

            if (lodash.has(vm.options, 'grouping')) {
                vm.groupings = lodash.get(vm.options, 'grouping', []);
                if (vm.groupings.length > 0) {

                    selectGroup(vm.groupings[0]);
                }
            }


            $scope.$watch(function () {
                return $scope.listFilterService.getGrid().dataSource.total();
            }, function () {
                vm.count = $scope.listFilterService.getGrid().dataSource.total();
            });
        }

        function initListFilterService() {
            if (!$scope.listFilterService) {
                $scope.listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
            }
        }

        function selectGroup(group) {
            vm.currentGroup = group;
            if (lodash.isEmpty(vm.currentDirection)) {
                vm.currentDirection = lodash.get(vm.options, 'default_direction', 'asc');
            } else {
                vm.currentDirection = (vm.currentDirection !== 'asc') ? 'asc' : 'desc';
            }
            var order = {
                field: vm.currentGroup.field,
                dir: vm.currentDirection
            };
            if (typeof vm.dropDownToggleOff === typeof function () {
            }) {
                vm.dropDownToggleOff();
            }
            $scope.listFilterService.getGrid().dataSource.group(order);
        }
    }
})();
(function () {
    'use strict';

    rmsListFilterToolbar.$inject = ['$timeout'];
    rmsListFilterToolbarCtrl.$inject = ['$element', '$scope', '$filter', 'lodash'];
    angular
        .module('rms.common')
        .directive('rmsListFilterToolbar', rmsListFilterToolbar);

    function rmsListFilterToolbar($timeout) {
        return {
            restrict: 'E',
            controller: rmsListFilterToolbarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/toolbar',
            scope: {},
            link: function(scope) {
                var vm = scope.vm;
                $timeout(function() {
                    if (vm.refreshFilter && typeof vm.refreshFilter() === typeof function() {}) {
                        vm.refreshFilter();
                    }
                });
            }
        };
    }

    function rmsListFilterToolbarCtrl($element, $scope, $filter, lodash) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};
            vm.selected_count = 0;
            vm.refreshGrid = $scope.listFilterService.refreshGrid;
            vm.showSelectedActions = showSelectedActions;

            init();

            vm.selectCondition = function(condition) {
                vm.togglePopover();
                if (vm.selected_condition.value !== condition.value) {
                    vm.selected_condition = condition;
                    lodash.set(vm.pageData, 'toolbar.searchData.condition', condition.value);
                    vm.selectedConditionHtml = vm.selected_condition.label + ' <i class="fa fa-caret-down"></i>';
                    if (vm.pageData.toolbar.searchData.items && lodash.size(vm.pageData.toolbar.searchData.items) > 1) {
                        vm.refreshGrid(true);
                    }
                }
            };

            vm.onSelectizeChange = function() {
                vm.refreshGrid(true);
                vm.pageData.grid.resize();
            }
        }

        function init() {
            $scope.listFilterService.sync(vm);
            $scope.$watch(watchSelectAllFlag, selectAllFlagChanged);
            vm.filterBarService = $scope.listFilterService.getFilterService();
            initSelectizeConditions();
        }

        function watchSelectAllFlag() {
            return vm.pageData.toolbar.selection.selected.length;
        }

        function selectAllFlagChanged() {
            vm.selected_count = $filter('stringFormat')(vm.pageData.toolbar.selection.label.selected_count, [vm.pageData.toolbar.selection.selected.length]);
            if (vm.pageData.toolbar.selection.selected.length == 0) {
                hideSelectedActions();
            } else {
                showSelectedActions();
            }
        }

        function showSelectedActions() {
            $element.find('.selected-actions').css('display','inline-block');
            // $element.find('.search-text').addClass('position-left');
        }

        function hideSelectedActions() {
            $element.find('.selected-actions').css('display','');
            // $element.find('.search-text').removeClass('position-left');
        }

        function initSelectizeConditions() {
            if (lodash.get(vm.pageData, 'toolbar.searchBarConfig.simple', true) !== true) {
                vm.selected_condition = lodash.find(vm.pageData.toolbar.searchBarConfig.conditions, { value: vm.pageData.toolbar.searchBarConfig.condition_default });
                lodash.set(vm.pageData, 'toolbar.searchData.condition', vm.selected_condition.value);
                vm.selectedConditionHtml =  vm.selected_condition.label + ' <i class="fa fa-caret-down"></i>';

                angular.merge(vm.pageData.toolbar.searchBarConfig, {
                    create: function(input) {
                        return {
                            value: input,
                            text: input
                        }
                    },
                    onInitialize: function(selectize) {
                        vm.pageData.toolbar.searchBarInstance = selectize;
                    }

                });

                $scope.$watch(function() { return lodash.get(vm.pageData, 'toolbar.searchDataTemp.items.length', 0); }, function() {
                    //console.log('searchDataTemp items changed', vm.pageData.toolbar.searchDataTemp.items);
                    //console.log('searchData items changed', vm.pageData.toolbar.searchData.items);
                });
                $scope.$watch(function() { return vm.pageData.toolbar.searchData.condition; }, function() {
                    //console.log('searchData condition changed', vm.pageData.toolbar.searchData.condition);
                    vm.selected_condition = lodash.find(vm.pageData.toolbar.searchBarConfig.conditions, { value: vm.pageData.toolbar.searchData.condition });
                    vm.selectedConditionHtml =  vm.selected_condition.label + ' <i class="fa fa-caret-down"></i>';
                });

            }
        }
    }
})();

(function () {
    'use strict';

    ListTemplateViewCtrlService.$inject = ['lodash', 'GenericModel', '$templateCache'];
    angular
        .module('rms.common')
        .factory('ListTemplateViewCtrlService', ListTemplateViewCtrlService);

    function ListTemplateViewCtrlService(lodash, GenericModel, $templateCache) {
        return function (options) {
            let state = {};
            init();
            return ExposedMethods;

            function ExposedMethods() {
                return {
                    refreshDatasource: refreshDatasource,
                    toggleSelected: toggleSelected,
                    action: action,
                    getState: getState,
                    setState: setState,
                    syncState: syncState,
                    syncModel: syncModel,
                    clearSelection: clearSelection,
                    hasNoSelection: hasNoSelection,
                };
            }

            /**
             * Initialise the Controller
             */
            function init() {
                let template = '<div>No Templates Loaded</div>';
                if (lodash.has(options, 'templateUrl')) {
                    template = $templateCache.get(options.templateUrl);
                } else {
                    if (lodash.has(options, 'templates')) {
                        template = options.templates;
                    }
                }

                var additionalOptions = {};

                if (lodash.has(options, 'noRecordTemplate')) {
                    additionalOptions.dataBound = function(e) {
                        console.log('datasource result changes');
                        if( this.dataSource.data().length == 0){
                            //custom logic

                            this.element.append(options.noRecordTemplate);
                        }
                    }
                }

                const listOptions = {
                    templates: template,
                    attrs: lodash.get(options,'attrs', {wrapper: 'list-templates-item-wrapper'}),
                    dataSource: prepareDatasource(lodash.get(options, 'datasource', {})),
                    additionalOptions: additionalOptions
                };



                lodash.set(state, 'listOptions', listOptions);
            }

            /**
             * Performs calling of api
             */
            function readGrid(readOptions) {
                const myOptions = {};
                const method = 'query';
                const datasource = state.url;

                var data = generateResourceOption(readOptions.data, myOptions, method);

                var model = new GenericModel(datasource);
                model[method](data).$promise.then(function (res) {
                    var dataSchema = lodash.get(options, 'datasource.schema.data', 'data');
                    readOptions.success(res);
                }, function (res) {
                    setState('internalData', []);
                    readOptions.error(res);
                });
            }

            function prepareDatasource(datasource) {
                if (lodash.has(datasource, 'transport.read')) {
                    if (lodash.has(datasource.transport.read, 'url')) {
                        state.url = datasource.transport.read.url;
                        datasource.transport.read = readGrid;
                        datasource.change = bindModel;
                    }
                }
                return datasource;
            }

            function bindModel() {
                // set selected
                const dataItems = this.view();
                if (lodash.has(state, 'model.selected') && !lodash.isEmpty(state.model.selected)) {
                    // lodash.isEmpty works on array, object, set map only. Doesn't work for primitive types
                    angular.forEach(state.model.selected, (_model)=> {
                        const entity = lodash.find(dataItems, {select_id: _model.select_id});
                        if (entity) {
                            entity.selected = true;
                        }
                    });
                }

                // angular.forEach(dataItems, function(dataItem) {
                //     const entity = lodash.find(state, {select_id: dataItem.select_id});
                //     if (!entity) {
                //         toggleSelected(dataItem);
                //     }
                // });
            }

            function generateResourceOption(resourceData, myData, method) {
                var params = {};
                params = angular.merge(params, resourceData, myData);
                if (method == 'search') {
                    params = {'data': params};
                }
                return params;
            }


            /**
             * Calls Kendo List Api to refresh its datasource.
             */
            function refreshDatasource() {
                if (lodash.has(state, 'listObj')) {
                    state.listObj.dataSource.read();
                }
            }

            /**
             * Set the state.
             * @param field
             * @param value
             */
            function setState(field, value) {
                lodash.set(state, field, value);
            }

            function getState() {
                if (arguments.length > 1) {
                    throw new Error('Function ListTemplateViewCtrlService.getState(), Invalid number of arguments');
                }

                if (arguments.length == 1) {
                    return state[arguments[0]];
                }

                return state;
            }

            function syncState(vm) {
                vm.stateData = state;
            }

            function syncModel(vm) {
                if (vm.model instanceof Array) {
                    vm.model = {
                        selected: []
                    };
                }
                state.model = vm.model;
            }

            function toggleSelected(dataItem) {
                if (!dataItem.selectable) return;
                if (dataItem.unselectable) return;
                if (dataItem.disabled) return;
                dataItem.selected = !dataItem.selected;

                if (dataItem.selected) {
                    if (!lodash.has(state.model, 'selected')) {
                        state.model.selected = [];
                    }
                    state.model.selected.push({
                        id: dataItem.id,
                        select_id: dataItem.select_id
                    });
                    toggleChanged();
                }

                if (!dataItem.selected) {
                    const filteredItemIndex = lodash.findIndex(state.model.selected, {select_id: dataItem.select_id});
                    if (filteredItemIndex >= 0) {
                        state.model.selected.splice(filteredItemIndex, 1);
                        toggleChanged();
                    }
                }
            }

            function action(name, dataItem) { // eslint-disable-line no-unused-vars
                // do http request, sending over name of dataItem & dataItam id;
                // run actions on http response
            }

            function clearSelection() {
                state.kendoListObj.dataSource.data().map(function(_item) {
                    _item.selected = false;
                });

                state.model.selected = [];
                toggleChanged();
            }

            function hasNoSelection() {
                return state.model.selected.length === 0;
            }

            function toggleChanged() {
                if (!!state.events.onChange && typeof state.events.onChange === typeof function() {}) {
                    state.events.onChange();
                }
            }
        };


    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q'];
    angular
        .module('rms.common')
        .factory('action-rms-get-listview-dataitem', actionFunc);

    function actionFunc($q) {
        return function() {
            const args = arguments;
            return $q.when(run());
            function run() {
                if (args[2]) {
                    const evtData = args[2];
                    const listObj = evtData.target.parents('.k-listview').data('kendoListView');
                    return listObj.dataItem(evtData.target.parents('div'));
                }
                return null;
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListTemplateViewStateService'];
    angular
        .module('rms.common')
        .factory('action-rms-refresh-list-view', actionFunc);

    function actionFunc($q, ListTemplateViewStateService) {
        return function() {
            return $q.when(run());

            function run() {
                ListTemplateViewStateService.refreshAll();
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    ListTemplateViewStateService.$inject = ['lodash', 'ListTemplateViewCtrlService'];
    angular
        .module('rms.common')
        .factory('ListTemplateViewStateService', ListTemplateViewStateService);

    function ListTemplateViewStateService(lodash, ListTemplateViewCtrlService) {
        const mem = {};
        return {
            init: init,
            sync: sync,
            refreshAll: refreshAll,
            destroy: destroy,
        };

        function init(vm, identifier, options) {
            lodash.set(mem, identifier, new ListTemplateViewCtrlService(options));
            sync(vm, identifier);
        }

        function sync(vm, identifier) {
            if (lodash.has(mem, identifier)) {
                vm.service = mem[identifier];
            }
        }

        function refreshAll() {
            lodash.forIn(mem, function(value) {
               value.refresh();
            });
        }

        function destroy(identifier) {
            delete mem[identifier];
        }
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-close-detail-panel', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.closeDetailPanel();
            }
        };
    }
})();

(function () {
    'use strict';

    displayFilter.$inject = ['FILTER_OPERATOR_CONSTANT', 'lodash', '$filter', 'GenericModel'];
    angular
        .module('rms.common')
        .filter('displayFilter', displayFilter);

    function displayFilter(FILTER_OPERATOR_CONSTANT, lodash, $filter, GenericModel) {
        return function (filter, $scope) {

            var filterService = $scope.listFilterService.getFilterService();
            var selectedFilter = filterService.getFilter(filter.field);
            if (!selectedFilter) {
                var displayValue = lodash.get(filter, 'display_value', null);
                return !!displayValue ? displayValue : '...';
            }

            var filterOptions = $scope.listFilterService.getFilterService().getFilterOptionValues(selectedFilter.type);
            var filterOption = lodash.find(filterOptions, function (item) {
                return item.operator == filter.operator;
            });

            var operatorLabel = filterService.getLabel('operator_label.' + filterOption.operator, lodash.get(selectedFilter, 'settings.filter_display_override.' + filterOption.operator));

            switch (filterOption.operator) {
                case FILTER_OPERATOR_CONSTANT.BETWEEN:
                case FILTER_OPERATOR_CONSTANT.RANGE:
                    if (selectedFilter.type === 'date') {
                        var lowerDateValue = $filter('date')(filter.value.lower, lodash.get(selectedFilter, 'format', 'dd/MM/yyyy'));
                        var upperDateValue = $filter('date')(filter.value.upper, lodash.get(selectedFilter, 'format', 'dd/MM/yyyy'));
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, lowerDateValue, upperDateValue]);
                    } else {
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, filter.value.lower, filter.value.upper]);
                    }
                case FILTER_OPERATOR_CONSTANT.IS:
                case FILTER_OPERATOR_CONSTANT.IN:
                case FILTER_OPERATOR_CONSTANT.NOT_IN:
                case FILTER_OPERATOR_CONSTANT.IN_ALL:
                case FILTER_OPERATOR_CONSTANT.NOT_IN_ALL:
                    var selectedOptionValue = null;
                    if (filterOption.options) {
                        selectedOptionValue = lodash.find(filterOption.options.data, function (item) {
                            return item.value == filter.value;
                        });
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, selectedOptionValue.label]);
                    } else {
                        if (selectedFilter.options) {
                            var labelArray = [];
                            var isDatasource = lodash.has(selectedFilter, 'options.datasource', false);
                            var hasData = lodash.has(selectedFilter, 'options.data', false);

                            var getLabelReducer = function(previous, current) {
                                if (lodash.indexOf(filter.value, current.value.toString()) >= 0) {
                                    previous.push(current.label);
                                }
                                return previous;
                            };

                            // added for multiple enum filter TMS-545
                            var getLabelReducerMultipleFilterValue = function(enumKey) {
                                return function(previous, current) {
                                    var _subSetting = lodash.get(selectedFilter, ['settings', 'sub_settings', enumKey].join('.'), {})
                                    var isHidden = lodash.get(_subSetting, 'hidden', false);
                                    if (isHidden) {
                                        return previous;
                                    }

                                    if (lodash.isArray(filter.value[enumKey])) {
                                        if (lodash.indexOf(filter.value[enumKey], current.value.toString()) >= 0) {
                                            var previousValues = lodash.get(previous, enumKey, []);
                                            lodash.set(previous, enumKey, previousValues.concat(current.label));
                                        }
                                    } else {
                                        if (filter.value[enumKey] == current.value.toString()) {
                                            lodash.set(previous, enumKey, current.label);
                                        }
                                    }
                                    return previous;
                                };
                            };

                            // Fix ENUM REMOTE
                            if (!hasData && isDatasource) {

                                if (filter.data) {
                                    labelArray = filter.data.reduce(getLabelReducer, []);
                                }
                            } else {
                                if (lodash.isArray(selectedFilter.options.data)) { // added for multiple enum filter TMS-545
                                    labelArray = selectedFilter.options.data.reduce(getLabelReducer, []);
                                } else { // added for multiple enum filter TMS-545
                                    var subSettings = angular.copy(lodash.get(selectedFilter, 'settings.sub_settings', {}));
                                    var subSettingsWithKeys = lodash.reduce(subSettings, function(carry, subSetting, _key) {
                                        subSetting['key'] = _key
                                        carry[_key] = subSetting
                                        return carry;
                                    }, {});
                                    var dataKeys = Object.keys(selectedFilter.options.data);

                                    var labelObject = angular.copy(lodash.get(filter, 'value', {}));
                                    labelObject = $filter('objWithoutKeys')(labelObject, dataKeys); // remove value from keys that is going to get the label from
                                    lodash.forEach(dataKeys, function (dataKey) {
                                        labelObject = lodash.reduce(
                                            selectedFilter.options.data[dataKey],
                                            getLabelReducerMultipleFilterValue(dataKey),
                                            labelObject
                                        );
                                    });
                                    var sortedLabelObjectArr = $filter('sortObjArrToArrBySamplingData')(labelObject, subSettingsWithKeys, [['order'], ['asc']], 'key');
                                    labelArray = lodash.map(sortedLabelObjectArr, function(_sortedLabelObjectArr) {
                                        return lodash.isArray(_sortedLabelObjectArr) ? _sortedLabelObjectArr.join(', ') : _sortedLabelObjectArr;
                                    });

                                    var subSettingsKeys = Object.keys(lodash.get(selectedFilter, 'settings.sub_settings', {}));
                                    var sortedSubSettingsKeys = $filter('sortObjArrToArrBySamplingData')(subSettingsKeys, subSettingsWithKeys, [['order'], ['asc']], 'key');
                                    var subSettingsLabels = lodash.map(sortedSubSettingsKeys, function (sortedSubSettingsKey) {
                                        return lodash.get(selectedFilter, ['settings', 'sub_settings', sortedSubSettingsKey, 'label'].join('.'), 'filters.label');
                                    });

                                    return $filter('stringFormat')(
                                        operatorLabel,
                                        // subSettingsLabels.slice(0, 1)
                                        //     .concat(labelArray.slice(0, 1).join(', '))
                                        //     .concat(subSettingsLabels.slice(1))
                                        //     .concat(labelArray.slice(1).join(', '))
                                        // a = ["Language", "Spoken Proficiency", "Written Proficiency"];
                                        // b = ["English", "1 - Noob, 2 - Okay", "3 - Pro, 4 - Godly, 5 - Hacker"]
                                        // Turn into ["Language", "English", "Spoken Proficiency", "1 - Noob, 2 - Okay", "Written Proficiency", "3 - Pro, 4 - Godly, 5 - Hacker"]
                                        // which fulfill {0} is {1} and {2} includes {3} and {4} includes {5}
                                        lodash.flatten(lodash.zip(subSettingsLabels, labelArray)) 
                                    );
                                }
                            }

                            return $filter('stringFormat')(operatorLabel, [selectedFilter.label, labelArray.join(', ')]);
                        } else {
                            return "";
                        }
                    }
                case FILTER_OPERATOR_CONSTANT.EXISTS:
                case FILTER_OPERATOR_CONSTANT.NOT_EXISTS:
                    return $filter('stringFormat')(operatorLabel, [selectedFilter.label]);
                default:
                    if (selectedFilter.type === 'date') {
                        var dateValue = $filter('date')(filter.value, lodash.get(selectedFilter, 'format', 'dd/MM/yyyy'));
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, dateValue]);
                    } else {
                        return $filter('stringFormat')(operatorLabel, [selectedFilter.label, filter.value]);
                    }
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .constant('FILTER_OPERATOR_CONSTANT', {
            'CONTAINS': 'contains',
            'NOT_CONTAINS': 'not_contains',
            'EQUAL': 'eq',
            'NOT_EQUAL': 'neq',
            'IS': 'is',
            'IN': 'in',
            'NOT_IN': 'not_in',
            'IN_ALL': 'in_all',
            'NOT_IN_ALL': 'not_in_all',
            'LESSER_THAN': 'lt',
            'LESSER_THAN_OR_EQUAL': 'lte',
            'GREATER_THAN': 'gt',
            'GREATER_THAN_OR_EQUAL': 'gte',
            'BETWEEN': 'between',
            'RANGE': 'range',
            'EXISTS': 'exists',
            'NOT_EXISTS': 'not_exists'
        });
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-get-current-pipeline', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.getCurrentPipeline();
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-get-list-filter-all-dataitem', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.getAllDataItems();
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-get-list-filter-data', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.getData(options.path);
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q'];
    angular
        .module('rms.common')
        .factory('action-rms-get-list-filter-dataitem', actionFunc);

    function actionFunc($q) {
        return function() {
            const args = arguments;
            return $q.when(run());
            function run() {
                if (args[2]) {
                    const evtData = args[2];
                    const gridObj = evtData.target.parents('.k-grid').data('kendoGrid');
                    return gridObj.dataItem(evtData.target.parents('li'));
                }
                return null;
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-get-selected-dataitems-keys', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.getSelectedModelKeys(options.keys);
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-get-selected-dataitem', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                return listFilterService.getSelectedModel(options.include_select_filters);
            }
        };
    }
})();

(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-list-filter-unselect-all', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            $q.when(run());
            function run() {
                // const listFilterService = ListFilterService.get();
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                listFilterService.clearSelected();
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('rms.common')
        .constant('FILTER_STEP_CONSTANT', {
            'LIST': 1,
            'PROPERTY': 2,
            'VALUES': 3
        });
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-refresh-list-filter', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            return $q.when(run());

            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                if (lodash.has(options, 'url')) {
                    listFilterService.setDatasourceUrl(options.url);
                }
                listFilterService.refreshGrid();
                if (lodash.has(options, 'clearSelected') && options.clearSelected) {
                    listFilterService.clearSelected();
                }
                return true;
            }
        };
    }
})();

(function () {
    'use strict';

    ListFilterSaveViewFormCtrl.$inject = ['close', '$timeout', 'dialogOptions'];
    angular
        .module('rms.common')
        .controller('ListFilterSaveViewFormCtrl', ListFilterSaveViewFormCtrl);

    function ListFilterSaveViewFormCtrl(close, $timeout, dialogOptions) {
        const vm = this;
        vm.name = dialogOptions.viewName;
        vm.share = dialogOptions.shareWithAll;
        vm.shared_visibility = dialogOptions.shareToEveryoneVisibility;
        if(dialogOptions.title){
            vm.options = {
                'title': dialogOptions.title
            };
        }
        vm.dismiss = function() {
            close(false);
        };

        vm.saveView = function() {
            if (!(vm.name.length > 0)) {
                vm.hasError = true;
                return;
            }
            close({
                'saved_view_name': vm.name, 
                'shared_with_all': vm.share
            });
        };

        $timeout( function () {
            vm.show = true;
        } );
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .constant('SELECT_CONSTANT', {
            'NONE': 0,
            'SOME': 1,
            'ALL':2,
            'SELECTED': 10,
            'NOT_SELECTED': 11
        });
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-list-filter-show-filter', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options) {
            $q.when(run());
            function run() {
                // const listFilterService = ListFilterService.get();
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                listFilterService.toggleFilterSidebar();
                return true;
            }
        };
    }
})();
(function () {
    'use strict';

    actionFunc.$inject = ['$q', 'ListFilterStateFactory', 'lodash'];
    angular
        .module('rms.common')
        .factory('action-rms-update-list-filter-record', actionFunc);

    function actionFunc($q, ListFilterStateFactory, lodash) {
        return function(options, eventData, actionResponse) {
            var args = arguments;
            return $q.when(run());
            function run() {
                const listFilterIdentifier = lodash.get(options, 'identifier', null);
                const listFilterService = ListFilterStateFactory.get(listFilterIdentifier);
                if (listFilterService === null) return false;
                console.log('action-rms-update-list-filter-record', args);
                // return true;
                return listFilterService.updateRecord(actionResponse.record);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('permissionsDetailPanel', permissionsDetailPanel);

    function permissionsDetailPanel() {
        return {
            restrict: 'E',
            controller: permissionsDetailPanelCtrl,
            templateUrl: 'common/app/components/permissions/detail-panel'
        };
    }

    function permissionsDetailPanelCtrl() {

    }
})();
(function () {
    'use strict';

    permissionsItemListCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('permissionsItemList', permissionsItemList);

    function permissionsItemList() {
        return {
            restrict: 'E',
            controller: permissionsItemListCtrl,
            controllerAs: 'vm',
            scope: {
                item: '='
            },
            bindToController: true,
            templateUrl: 'common/app/components/permissions/item-list'
        };
    }

    function permissionsItemListCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.service = $scope.$parent.vm.service;
        }
    }
})();
(function () {
    'use strict';

    permissionsItemCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('permissionsItem', permissionsItem);

    function permissionsItem() {
        return {
            restrict: 'E',
            controller: permissionsItemCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                item: '=',
            },
            templateUrl: 'common/app/components/permissions/item'
        };
    }

    function permissionsItemCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.service = $scope.$parent.vm.service;
            vm.toggle = function() {
                if (vm.service.getModelReadOnly(vm.item)) {
                    return;
                }
                vm.service.toggle(vm.item);
            };
            vm.getClass = function() {
                return vm.service.getModel(vm.item) ? 'fa-check-square-o' : 'fa-square-o';
            };
            vm.getReadOnlyClass = function() {
                if (vm.service.getModelReadOnly(vm.item)) {
                    return 'readonly';
                }
                return '';
            };
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('permissionsSection', permissionsSection);

    function permissionsSection() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/permissions/section'
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('permissionsHeader', permissionsHeader);

    function permissionsHeader() {
        return {
            restrict: 'E',
            controller: permissionsHeaderCtrl,
            // controllerAs: 'vm',
            // bindToController: true,
            templateUrl: 'common/app/components/permissions/header'
        };
    }

    function permissionsHeaderCtrl() {
        // var vm = this;

    }
})();
(function () {
    'use strict';

    rmsManageTagsCtrl.$inject = ['lodash', '$scope', '$timeout'];
    angular
        .module('rms.common')
        .directive('rmsManageTags', rmsManageTags);

    function rmsManageTags() {
        return {
            restrict: 'E',
            controller: rmsManageTagsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                submit: '=?'
            },
            templateUrl: 'common/app/components/manage-tags'
        };
    }

    function rmsManageTagsCtrl(lodash, $scope, $timeout) {
        var vm = this;

        this.$onInit = function() {

            vm.add = add;
            vm.remove = remove;
            vm.submit = submit;

            vm.data = [
                // RETURNED DATA MUST BE SORTED ALREADY.
                {value: 'Test2', id: 2, position: 1, editable: false, removable: false},
                {value: 'Test1', id: 1, position: 2, editable: true, removable: false},
                {value: 'Test3', id: 3, position: 3, editable: false, removable: true},
                {value: 'Test5', id: 5, position: 4, editable: true, removable: true},
                {value: 'Test4', id: 4, position: 5, editable: true, removable: true}
            ];

            vm.sortableOptions = angular.merge(
                {},
                {
                    handler: '.sortable-item-handler, .sortable-item-handler .fa',
                    placeholder: function (element) {
                        return element.clone().addClass('rms-manage-tag-item-placeholder');
                    },
                    ignore: 'input,textarea',
                    change: function (e) {
                        if (e) {
                            var itemMoved = vm.data[e.oldIndex];
                            vm.data.splice(e.oldIndex, 1);
                            vm.data.splice(e.newIndex, 0, itemMoved);
                            $scope.$apply();
                        }
                        reorderRowIndex();
                    },
                },
                lodash.get(vm.options, 'sortableOptions', {})
            );
        }

        function add() {
            vm.data.push({
                id: null,
                value: '',
                editable: true,
                removable: true
            });
            reorderRowIndex();
        }

        function remove(id, position) {
            let index = lodash.findIndex(vm.data, {id: id});
            if (index === undefined) {
                index = lodash.findIndex(vm.data, {position: position});
                // after this point, index may still be undefined.
            }

            if (index !== undefined) {
                vm.data.splice(index, 1);
                reorderRowIndex();
            }
        }

        function submit() {
            console.log('submit', vm.data);
        }

        function reorderRowIndex() {
            $timeout(function () {
                angular.forEach(vm.data, (row, index) => {
                    row.position = index;
                });
            });
        }
    }
})();
(function () {
    'use strict';

    activityAddAttachmentComponent.$inject = ['ActivitiesService', 'ActionManager', 'lodash'];
    angular
        .module('rms.common')
        .directive('activityAddAttachment', activityAddAttachmentComponent);

    function activityAddAttachmentComponent(ActivitiesService, ActionManager, lodash) {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/activity-input/activity-add-attachment',
            link: function(scope) {
                const vm = scope.vm;
                const parentVm = scope.$parent.vm;

                scope.$on('onAddAttachmentClick', function () {
                    scope.onAddAttachmentClick();
                });

                scope.onAddAttachmentClick = function() {
                    const docLibOptions = lodash.get(parentVm, 'options.attachmentOptions', {});
                    ActionManager('open-document-library', docLibOptions).then(function(result) {
                        result.modal.closed.then(function(res) {
                            if (res !== false) {
                                // add to model
                                if (lodash.has(vm.model, 'attachments')) {
                                    vm.model.attachments = vm.model.attachments.concat(res);
                                } else {
                                    vm.model.attachments = res;
                                }
                            }
                        });
                    });
                }
            }
        };
    }
})();
(function () {
    'use strict';

    activityAttachmentListComponent.$inject = ['lodash', 'GenericModel'];
    angular
        .module('rms.common')
        .directive('activityAttachmentList', activityAttachmentListComponent);

    function activityAttachmentListComponent(lodash, GenericModel) {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/activity-input/activity-attachment-list',
            link: function(scope) {
                const vm = scope.vm;
                console.log('activityAttachmentList', vm);
                scope.handleRemoveAttachment = function(attachment) {
                    const index = lodash.findIndex(vm.model.attachments, {select_id: attachment.select_id});
                    vm.model.attachments.splice(index, 1);
                };

                scope.preattached = {
                    loading: false
                };

                if (lodash.has(vm.options, 'attachmentOptions.preattached')) {
                    scope.preattached.loading = true;
                    const model = new GenericModel(vm.options.attachmentOptions.preattached.datasource.url);
                    const method = lodash.get(vm.options.attachmentOptions, 'preattached.datasource.method', 'create');
                    const datasourceModel = lodash.get(vm.options.attachmentOptions, 'preattached.datasource.params', {});
                    model[method]({}, {data: datasourceModel}).$promise.then((res) => { // eslint-disable-line no-unused-vars
                        if (lodash.get(vm.options.attachmentOptions, 'preattached.datasource.params.unique', false) === res.unique) {
                            lodash.set(vm.model, 'attachments', res.data);
                        }
                        scope.preattached.loading = false;
                    }, (err)=> {
                        console.log(err);
                        scope.preattached.loading = false;
                    });
                }
            }
        };
    }
})();
(function () {
    'use strict';

    activityFieldGeneratorCtrl.$inject = ['$element', '$compile', '$scope'];
    angular
        .module('rms.common')
        .directive('activityFieldGenerator', activityFieldGenerator);

    function activityFieldGenerator() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                title: '=?',
                model: '=',
                onChange: '&?'
            },
            controller: activityFieldGeneratorCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function activityFieldGeneratorCtrl($element, $compile, $scope) {
        var vm = this;
        this.$onInit = function() {
            $element.html(`<activity-field-${vm.element.type} element="vm.element" ng-model="vm.model" title="vm.title" on-change="vm.onChange({name: name, value: value})"></activity-field-${vm.type}>`);
            const cloneElement = $compile($element.contents())($scope);
            $scope.$on('$destroy', () => {
                cloneElement.off();
            });
        }
    }
})();
(function () {
    'use strict';

    activitiyTypeCtrl.$inject = ['$compile', '$scope', '$element', 'HtmlHelper', 'ActivitiesInputService'];
    angular
        .module('rms.common')
        .directive('activityType', activityType);

    function activityType() {
        return {
            restrict: 'E',
            scope: {
                inputData: '=',
                model: '=',
                onChange: '&?',
            },
            controller: activitiyTypeCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function activitiyTypeCtrl($compile, $scope, $element, HtmlHelper, ActivitiesInputService) {
        var vm = this,
            cloneElem = null;
        this.$onInit = function() {
            init();
        }

        function init() {
            $scope.$watch(watchType, onTypeChange);
            $scope.$on('$destroy', onDestroy);
        }

        function onDestroy() {
            switchOffElem();
        }

        function watchType() {
            return vm.inputData.options.type;
        }

        function onTypeChange() {
            switchOffElem();
            ActivitiesInputService.initDefaultModelField(vm.inputData);
            $element.html(generateHtmlContent());
            cloneElem = $compile($element.contents())($scope);
        }

        function generateHtmlContent() {
            var typeTag = 'activity-input-type-' + vm.inputData.options.type;
            var attrs = [
                {
                    name:'input-data',
                    value: 'vm.inputData'
                },
                {
                    name: 'model',
                    value: 'vm.model'
                },
                {
                    name: 'on-change',
                    value: 'vm.onChange({name: name, value: value})'
                }
            ];

            return HtmlHelper.generateHtmlTag(typeTag, attrs);
        }

        function switchOffElem() {
            if (cloneElem != null) {
                cloneElem.off();
            }
        }
    }
})();
(function () {
    'use strict';

    activityFieldCustomSelect.$inject = ['lodash', 'FbSelectService'];
    angular
        .module('rms.common')
        .directive('activityFieldCustomSelect', activityFieldCustomSelect);

    function activityFieldCustomSelect(lodash, FbSelectService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                element: '=',
                title: '=?',
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/custom-select',
            link: function (scope, elem, attr, ctrl) {
                scope.fieldConfig = {};
                const additionalOptions = {};
                scope.element.placeholder = '';
                scope.fieldConfig.ds = angular.copy(lodash.get(scope.element, 'datasource.data', []));

                FbSelectService.initTemplateCall(scope.element.options, additionalOptions);

                scope.fieldConfig =
                    angular.merge(
                        {
                            highlight: true,
                            create: false,
                            labelField: 'label',
                            valueField: 'value',
                            maxItems: 1,
                            searchField: ['label'],
                            plugins: ['remove_button'],
                            placeholder: 'test',
                            onIntialize: function() {
                                //$element.find('')
                            },
                            onChange: function() {

                            }
                        },
                        lodash.get(scope.element, 'options', {}),
                        additionalOptions
                    );

            }
        };
    }
})();
(function () {
    'use strict';

    activitiesFieldDatepicker.$inject = ['lodash'];
    activitiesFieldDatepickerCtrl.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('activityFieldDatepicker', activitiesFieldDatepicker);

    function activitiesFieldDatepicker(lodash) {
        return {
            restrict: 'E',
            controller: activitiesFieldDatepickerCtrl,
            controllerAs: 'fieldCtrl',
            bindToController: true,
            require: 'ngModel',
            scope: {
                element: '=',
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/datepicker',
            link: function(scope, elem, attr, ngModelCtrl) {
                var fc = scope.fieldCtrl;
                var dp_object = $(elem).find('.date input');
                var tp_object = elem.find('.time input');
                dp_object.datepicker(fc.dateOptions);
                elem.datepair();

                // var new_date = moment().minutes(0).seconds(0);
                // scope.selected_date = new_date.format(fc.moment_format);
                // scope.selected_time = new_date.format(fc.time_display_format);
                updateUI();


                var timeOptions =  angular.extend(
                    {
                        'showDuration': true,
                        'timeFormat': 'g:i a',

                        // 'minTime': '2:00pm',
                    },
                    lodash.get(scope.element, 'options', {})
                );

                tp_object.timepicker(timeOptions);
                tp_object.timepicker('setTime', new Date());


                function updateDateTime() {
                    var date_str = scope.selected_date + ' ' + scope.selected_time;
                    var date_obj = moment(date_str, fc.moment_format + ' ' + fc.time_display_format);
                    console.log('updateDateTime', date_obj);
                    ngModelCtrl.$setViewValue(date_obj.toISOString());
                }

                function updateUI() {
                    console.log('$render', ngModelCtrl.$viewValue);
                    var new_date;

                    if (!ngModelCtrl.$viewValue) {
                        new_date = moment().minutes(0).seconds(0);
                        scope.selected_date = new_date.format(fc.moment_format);
                        scope.selected_time = new_date.format(fc.time_display_format);
                        updateDateTime();
                    }

                    new_date = moment(ngModelCtrl.$viewValue);

                    dp_object.datepicker('setDate', new_date.format(fc.moment_format));
                    tp_object.timepicker('setTime', new_date.format(fc.time_display_format));
                }


                ngModelCtrl.$render = function() {
                    updateUI();
                }

                ngModelCtrl.$formatters.push(function(modelValue) {
                    return moment(modelValue).minutes(0).seconds(0).toISOString();
                    // console.log(modelValue);
                });

                scope.$watch('selected_date + selected_time', function() {
                    console.log('scope watch');
                    updateDateTime();
                });
            }
        };
    }

    function activitiesFieldDatepickerCtrl(lodash) {
        var fieldCtrl = this;
        this.$onInit = function() {
            // fieldCtrl.kendo_parse_format = lodash.get(fieldCtrl.element, 'options.kendo_parse_format', 'dd/MM/yyyy');
            fieldCtrl.picker_format = lodash.get(fieldCtrl.element, 'options.display_format', 'dd/mm/yyyy');
            fieldCtrl.moment_format = 'DD/MM/YYYY';
            fieldCtrl.time_display_format = 'h:mm a';
            fieldCtrl.time_save_format = 'HH:mm:00';

            fieldCtrl.dateOptions = angular.merge({
                    format: fieldCtrl.picker_format,
                    autoclose: true,
                    forceParse: false,
                    orientation: 'bottom',
                },
                generateOptions()
            );
        }

        function generateOptions() {
            var option = {};
            if (lodash.has(fieldCtrl.element, 'options.max')) {
                var now = lodash.get(fieldCtrl.element, 'options.max.now');
                if (now) {
                    option.endDate = new Date();
                } else {
                    var maxObj = fieldCtrl.element.options.max;
                    option.endDate = new Date(maxObj.year, maxObj.month - 1, maxObj.day);
                }
            }

            if (lodash.has(fieldCtrl.element, 'options.min')) {
                var now = lodash.get(fieldCtrl.element, 'options.min.now');
                if (now) {
                    option.startDate = new Date();
                } else {
                    var minObj = fieldCtrl.element.options.min;
                    option.startDate = new Date(minObj.year, minObj.month - 1, minObj.day);
                }
            }

            return option;
        }


    }
})();

(function () {
    'use strict';

    activityFieldDescriptionCtrl.$inject = ['GenericModel', 'ActivitiesInputService', 'lodash', '$element', '$timeout', '$rootScope', '$scope'];
    angular
        .module('rms.common')
        .directive('activityFieldDescription', activityFieldDescription);

    function activityFieldDescription() {
        return {
            restrict: 'E',
            templateUrl: 'common/app/components/activities/activity-input/fields/description',
            controller: activityFieldDescriptionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                inputData: '=?',
                model: '=',
                getInstance: '=?',
                preview: '=?',
                previewModel: '=?',
                onDiscard: '=?',
            }
        };
    }

    function activityFieldDescriptionCtrl(GenericModel, ActivitiesInputService, lodash, $element, $timeout, $rootScope, $scope) {
        var vm = this;
        this.$onInit = function() {
            vm.tinyMceInst = null;

            vm.getInstance = getInstance;
            vm.preview = { execute: preview, setSelectedPreview: setSelectedPreview, previewsList: [] };
            vm.onDiscard = onDiscard;

            init();

            $scope.$on('$destroy', function() {
                var editor = vm.getInstance();
                editor.removed = true;
            });
        }

        function init() {
            const additional = generateAdditional();
            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            additional.setup = function(editor) {
                vm.tinyMceInst = editor;

                editor.addButton('SODAttachment', {
                    text: '',
                    icon: 'paperclip',
                    onclick: function () {
                        $rootScope.$broadcast('onAddAttachmentClick');
                    }
                });

                editor.on('init', function () {
                    $timeout(function () {
                        var em = $element.find('.mce-toolbar-grp');
                        $element.remove('.mce-toolbar-grp');
                        $element.find('.mce-edit-area').after(em);
                    });
                });

                editor.on('blur', (function (editor) {
                    return function (e) {
                        e.preventDefault();
                        vm.model = editor.getContent();
                    };
                })(editor));

                editor.on('ExecCommand', function(e) {
                    const command = e.value;
                    const execCommandOption = lodash.get(vm, 'inputData.options.messageInput.nested.execCommandOption', []);
                    const foundCommand = lodash.find(execCommandOption, { command: command });

                    if (foundCommand) {
                        const node = editor.selection.getNode();

                        const criteria = lodash.get(foundCommand, 'criteria', []);
                        const transformedCriteria = lodash.map(criteria, function (singleCriteria) {
                            const property = lodash.get(singleCriteria, 'property', undefined);

                            const conditionType = lodash.get(singleCriteria, 'condition.type', '');
                            const conditionRegex = lodash.get(singleCriteria, 'condition.regex', '');

                            switch (conditionType) {
                                case 'string':
                                    return (new RegExp(conditionRegex)).test(node[property]);
                            }
                        });
                        const passedCriteria = lodash.every(transformedCriteria, Boolean);

                        if (passedCriteria) {
                            const run = lodash.get(foundCommand, 'run', []);

                            lodash.forEach(run, function (singleRun) {
                                const type = lodash.get(singleRun, 'type', '');

                                switch(type) {
                                    case 'style':
                                        const value = lodash.get(singleRun, 'value', '');
                                        const className = lodash.get(singleRun, 'className', '');
                                        const camelCasedClassName = lodash.camelCase(className);

                                        const hasValueBeenSet = node.style[camelCasedClassName] === value;
                                        tinymce.DOM.setStyle(node, className, hasValueBeenSet ? '' : value);
                                        break;
                                }
                            });
                        }
                    }
                });
            };
            additional.content_css = cdnEp + '/assets/css/rms-tinymce.css';
            additional.body_class = 'activity-description-input';

            const remoteOptions = lodash.get(vm, 'inputData.options.messageInput', {});
            const defaultOptions = ActivitiesInputService.getDefaultMessageInputOptions();
            const tmceOptions = angular.merge({}, defaultOptions, remoteOptions, additional);
            // vm.tmceOptions = angular.merge({}, defaultOptions, remoteOptions, additional);
            if (lodash.has(tmceOptions, 'toolbar1')) {
                delete tmceOptions.toolbar;
            }
            vm.tmceOptions = tmceOptions;

            vm.preview.config = {
                create: false,
                valueField: 'unique_value',
                labelField: 'email',
                delimiter: '',
                placeholder: 'Select Recipient',
                maxItems: 1,
                onChange: function (value) {
                    $timeout(function () {
                        setSelectedPreview();
                    });
                },
                copyClassesToDropdown: true,
            };
        }

        function generateAdditional() {
            const result = {};

            if (lodash.has(vm, 'inputData.options.messageInput.maxHeightResize')) {
                const parentClass = lodash.get(vm.inputData.options.messageInput, 'maxHeightResize.parentsClass', false);
                const parentElem = $element.parents(parentClass);
                if (parentElem.length > 0) {
                    const parentHeight = parentElem.height();
                    const offsetHeight = lodash.get(vm.inputData.options.messageInput, 'maxHeightResize.offsetHeight' , 0);
                    result.autoresize_max_height = parentHeight - offsetHeight;
                }

            }

            if (lodash.has(vm, 'inputData.options.messageInput.nested')) {
                const defaultOptions = ActivitiesInputService.getDefaultMessageInputOptions();
                const messageInputNested = lodash.get(vm, 'inputData.options.messageInput.nested');

                if (lodash.has(messageInputNested, 'plugins')) {
                    const defaultPlugins = defaultOptions.plugins.split(' ');
                    const additionalPlugins = lodash.get(messageInputNested, 'plugins');

                    const mergesPlugins = lodash.concat(defaultPlugins, additionalPlugins);
                    result.plugins = mergesPlugins.join(' ');
                }

                if (lodash.has(messageInputNested, 'toolbar')) {
                    const defaultToolbarSections = defaultOptions.toolbar.split(' | ');
                    const defaultToolbar = lodash.map(defaultToolbarSections, function (defaultToolbarSection) {
                        return defaultToolbarSection.split(' ');
                    });
                    const additionalToolbar = lodash.get(messageInputNested, 'toolbar');

                    const mergesToolbar = lodash.concat(defaultToolbar, additionalToolbar);
                    const joinedMergesToolbarSections = lodash.map(mergesToolbar, function (singleMergesToolbar) {
                        return singleMergesToolbar.join(' ');
                    });
                    const joinedMergesToolbar = joinedMergesToolbarSections.join(' | ');
                    result.toolbar = joinedMergesToolbar;

                    // loading of available templates without the content
                    const hasSODTemplateType = joinedMergesToolbar.indexOf('SODTemplateType') >= 0;
                    const hasSodTemplate = lodash.has(vm, 'inputData.options.sodTemplates.datasource.getEmailTemplatesWithType.url');
                    if (hasSODTemplateType && hasSodTemplate) {
                        callRemoteApi(lodash.get(vm, 'inputData.options.sodTemplates.datasource.getEmailTemplatesWithType'))
                            .then(function (res) {
                                populateSODTemplateType(res);
                            });
                    }
                }
            }

            return result;
        }

        function getInstance() {
            return vm.tinyMceInst;
        }

        function getToolbarGroupIndex(toolbars, needle) {
            const truthyTableToolbarGroup = lodash.map(toolbars, function (toolbar) {
                if (toolbar.indexOf(needle) >= 0) {
                    return true;
                }

                return false;
            });

            return truthyTableToolbarGroup.indexOf(true);
        }

        function populateSODTemplateType(templateWithTypes) {
            const editor = vm.getInstance();
            const editorToolbars = editor.getParam('toolbar').split(' | ');

            editor.SODTemplateEngine = { templateWithTypes: templateWithTypes };

            const toolbarSODTemplateTypeIndex = getToolbarGroupIndex(editorToolbars, 'SODTemplateType');
            if (toolbarSODTemplateTypeIndex >= 0) {
                editor.addButton('SODTemplateType', getSODTemplateTypeButtonConfig());
                rerenderTinyMCEButton('SODTemplateType');
            }

            const toolbarSODTemplateIndex = getToolbarGroupIndex(editorToolbars, 'SODTemplate');
            if (toolbarSODTemplateIndex >= 0) {
                editor.addButton('SODTemplate', getSODTemplateButtonConfig());
                rerenderTinyMCEButton('SODTemplateType');
            }
        }

        function getSODTemplateButtonConfig() {
            const editor = vm.getInstance();

            const selectedTemplate = lodash.get(editor, 'SODTemplateEngine.state.selectedTemplate', undefined);
            const selectedTemplateType = lodash.get(editor, 'SODTemplateEngine.state.selectedTemplateType', undefined);

            const templateWithTypes = editor.SODTemplateEngine.templateWithTypes;
            const templateWithType = lodash.find(templateWithTypes, { value: selectedTemplateType });

            const templates = lodash.get(templateWithType, 'templates', undefined);
            const foundSelectedTemplate = lodash.find(templates, { value: selectedTemplate });

            let updatedTemplates = lodash.filter(templates, function (template) {
                if (selectedTemplate && selectedTemplate === template.value) {
                    return false;
                }

                return true;
            });

            if (updatedTemplates && templates && updatedTemplates.length < templates.length) {
                updatedTemplates = updatedTemplates.concat([{
                    label: 'Clear Template',
                    value: null,
                }]);
            }

            const templatesMenu = lodash.map(updatedTemplates, function (template) {
                return {
                    text: template.label,
                    onclick: (function () {
                        return function () {
                            if (template.value === null) {
                                setSODTMCESubject('');
                                setEditorContentWithCommit('');
                                setSelectedTemplate(null);
                            } else {
                                callRemoteApi(lodash.get(vm, 'inputData.options.sodTemplates.datasource.getEmailTemplate'),{template_id:template.value})
                                    .then(function (data) {
                                        setSODTMCESubject(data.subject);
                                        setEditorContentWithCommit(data.content);
                                        setSelectedTemplate(template.value);
                                    });
                            }
                        };
                    })(template),
                };
            });
            const hasTemplatesMenu = templatesMenu.length > 0;

            return {
                type: 'menubutton',
                text: foundSelectedTemplate ? foundSelectedTemplate.label : lodash.get(vm.inputData, 'options.labels.template', 'Templates'),
                icon: false,
                menu: hasTemplatesMenu ? templatesMenu : [{
                    text: lodash.get(vm.inputData, 'options.labels.template_not_found', 'Templates Not Found'),
                    onclick: function () {},
                }],
            };
        }

        function getSODTemplateTypeButtonConfig() {
            const editor = vm.getInstance();

            const selectedTemplateType = lodash.get(editor, 'SODTemplateEngine.state.selectedTemplateType', undefined);
            const foundSelectedTemplateType = lodash.find(editor.SODTemplateEngine.templateWithTypes, { value: selectedTemplateType });

            const templateWithTypes = editor.SODTemplateEngine.templateWithTypes;
            let updatedTemplateWithTypes = lodash.filter(templateWithTypes, function (templateWithType) {
                if (selectedTemplateType && selectedTemplateType === templateWithType.value) {
                    return false;
                }

                return true;
            });

            if (updatedTemplateWithTypes && templateWithTypes && updatedTemplateWithTypes.length < templateWithTypes.length) {
                updatedTemplateWithTypes = updatedTemplateWithTypes.concat([{
                    label: lodash.get(vm.inputData, 'options.labels.clear_template_type', 'Clear Template Type'),
                    value: null,
                }]);
            }

            const templateWithTypesMenu = lodash.map(updatedTemplateWithTypes, function (templateWithType) {
                return {
                    text: templateWithType.label,
                    onclick: (function () {
                        return function () {
                            updateSelectedTemplateType(templateWithType.value);

                            if (templateWithType.value === null) {
                                setSODTMCESubject('');
                                setEditorContentWithCommit('');
                                setSelectedTemplate(null);
                            }
                        };
                    })(templateWithType),
                };
            });

            const hasTemplateWithTypesMenu = templateWithTypesMenu.length > 0;

            return {
                type: 'menubutton',
                text: foundSelectedTemplateType ? foundSelectedTemplateType.label : lodash.get(vm.inputData, 'options.labels.template_type', 'Template Types'),
                icon: false,
                menu: hasTemplateWithTypesMenu ? templateWithTypesMenu : [{
                    text: 'Template Types Not Found',
                    onclick: function () {},
                }],
            };
        }

        function updateSelectedTemplateType(selectedTemplateType) {
            const editor = vm.getInstance();

            const SODTemplateEngineState = editor.SODTemplateEngine.state;
            editor.SODTemplateEngine.state = Object.assign({}, SODTemplateEngineState, {
                selectedTemplateType: selectedTemplateType,
            });

            editor.buttons['SODTemplateType'] = Object.assign({}, editor.buttons['SODTemplateType'], getSODTemplateTypeButtonConfig());
            rerenderTinyMCEButton('SODTemplateType');

            editor.buttons['SODTemplate'] = Object.assign({}, editor.buttons['SODTemplate'], getSODTemplateButtonConfig());
            rerenderTinyMCEButton('SODTemplate');
        }

        function setSelectedTemplate(selectedTemplate) {
            const editor = vm.getInstance();

            const SODTemplateEngineState = editor.SODTemplateEngine.state;
            editor.SODTemplateEngine.state = Object.assign({}, SODTemplateEngineState, {
                selectedTemplate: selectedTemplate,
            });

            editor.buttons['SODTemplate'] = Object.assign({}, editor.buttons['SODTemplate'], getSODTemplateButtonConfig());
            rerenderTinyMCEButton('SODTemplate');
        }

        function rerenderTinyMCEButton(button) {
            const editor = vm.getInstance();
            const editorToolbars = editor.getParam('toolbar').split(' | ');
            const buttonIndex = getToolbarGroupIndex(editorToolbars, button);

            if (buttonIndex >= 0) {
                const bg = editor.theme.panel.find('toolbar buttongroup')[buttonIndex];
                bg._lastRepaintRect = bg._layoutRect;
                if (bg._items.length > 0) {
                    bg.find('menubutton').each(function (t) {
                        t.remove()
                    });
                }

                const buttons = editorToolbars[buttonIndex].split(' ');
                lodash.forEach(buttons, function (oButton) {
                    bg.append(editor.buttons[oButton]);
                });
            }
        }

        function preview(datasource) {
            $timeout(function () {
                if (lodash.get(vm.preview, 'executing', false)) {
                    return;
                }

                const editor = vm.getInstance();
                let onPreview = lodash.get(vm, 'preview.on', false);
                onPreview = !onPreview;
                if (onPreview) {
                    setEditorReadMode(true);
                    lodash.set(vm.preview, 'executing', true);

                    const postData = angular.copy(lodash.get(vm, 'previewModel', {}));
                    resetPreviewData();
                    callRemoteApi(datasource, postData)
                        .then(function (data) {

                            // const firstData = lodash.head(data);
                            // const originalContent = editor.getContent({ format: 'raw' });
                            // lodash.set(vm, 'preview.originalContent', originalContent);
                            // lodash.set(vm, 'preview.originalSubject', lodash.get(vm, 'previewModel.txt_email_subject', ''));
                            //
                            // setEditorContentWithCommit(lodash.get(firstData, 'body', ''));
                            // setSODTMCEEditorSubjectContentWithCommit(lodash.get(firstData, 'subject', ''));
                            //
                            // lodash.set(vm.preview, 'data', firstData);

                            var previewsList = lodash.map(data, function (oData) {
                                return lodash.head(oData.to);
                            });
                            lodash.set(vm.preview, 'previewsList', previewsList);
                            lodash.set(vm.preview, 'previews', data);
                            setSelectedPreview(lodash.head(data));
                        })
                        .catch(function (error) {
                            resetPreviewData();
                            console.error('error', error);
                        }).finally(function() {
                        lodash.set(vm.preview, 'executing', false);
                        vm.preview.on = onPreview;
                    });
                } else {
                    setEditorReadMode(false);
                    const originalContent = lodash.get(vm, 'preview.originalContent', '');
                    const originalSubject = lodash.get(vm, 'preview.originalSubject', '');
                    setEditorContentWithCommit(originalContent);
                    setSODTMCEEditorSubjectContentWithCommit(originalSubject);

                    vm.preview.on = onPreview;
                }
            }, 300);
        }

        function setSelectedPreview(preview) {
            var selectedId = undefined;
            var hasPreview = lodash.isEmpty(preview);
            if (!hasPreview) {
                selectedId = lodash.get(preview, 'to[0].unique_value');
                lodash.set(vm.preview, 'selected', selectedId);
            } else {
                selectedId = parseInt(lodash.get(vm.preview, 'selected'));
            }

            var previewData = lodash.find(vm.preview.previews, { to: [{ unique_value: selectedId }]});
            previewData = Object.assign(previewData, {
                attachments: angular.copy(lodash.get(vm, 'previewModel.attachments', [])),
            });

            const editor = vm.getInstance();
            const originalContent = editor.getContent({ format: 'raw' });
            lodash.set(vm, 'preview.originalContent', originalContent);
            lodash.set(vm, 'preview.originalSubject', lodash.get(vm, 'previewModel.txt_email_subject', ''));

            // setEditorContentWithCommit(lodash.get(previewData, 'body', ''));
            // setSODTMCEEditorSubjectContentWithCommit(lodash.get(previewData, 'subject', ''));

            lodash.set(vm.preview, 'data', previewData);
        }

        function resetPreviewData() {
            lodash.set(vm.preview, 'data', {
                to: [], from: [], cc: [], bcc: [], body: null, attachments: [],
            });
        }

        function setEditorReadMode(mode) {
            if (mode) {
                $('.mce-tinymce.mce-container').css({
                    'pointer-events': 'none',
                    'opacity': '0.8',
                });
                return;
            }

            $('.mce-tinymce.mce-container').css({
                'pointer-events': 'auto',
                'opacity': '1',
            });
        }

        function setSODTMCEEditorSubjectContentWithCommit(data) {
            const editor = vm.getInstance();

            const SODTMCESubjectEditor = lodash.find(editor.editorManager.editors, { SODTMCESubject: true });
            if (SODTMCESubjectEditor) {
                SODTMCESubjectEditor.setContent(data);
                vm.previewModel.txt_email_subject = data;
                SODTMCESubjectEditor.save();
                SODTMCESubjectEditor.fire('Change');
            }
        }

        function setEditorContentWithCommit(data) {
            const editor = vm.getInstance();

            editor.setContent(data || '');
            vm.model = data;
            editor.save();
            editor.fire('Change');
        }

        function setSODTMCESubject(data) {
            const editor = vm.getInstance();

            const SODTMCESubjectEditor = lodash.find(editor.editorManager.editors, { SODTMCESubject: true });
            if (SODTMCESubjectEditor) {
                SODTMCESubjectEditor.setContent(data);
                vm.previewModel.txt_email_subject = data;
                SODTMCESubjectEditor.save();
                SODTMCESubjectEditor.fire('Change');
            }
        }

        function onDiscard() {
            updateSelectedTemplateType(null);
            setSelectedTemplate(null);
        }

        function callRemoteApi(datasource, postData) {
            var model = new GenericModel(datasource.url);
            var method = lodash.get(datasource, 'method', 'get');

            var queries = postData;
            var params = {};

            if (method !== 'get') {
                queries = {};
                params = {
                    data: postData,
                }
            }

            return model[method](queries, params).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    if (lodash.has(res, 'selected')) {
                        vm.modelContent = res.selected;
                        vm.ngModelCtrl.$setViewValue(res.selected);
                    }
                    return res.data;
                } else {
                    return null;
                }
            }, function(res) {
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldReadonly', activityFieldReadonly);

    function activityFieldReadonly() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                model: '=ngModel',
            },
            require: 'ngModel',
            templateUrl: 'common/app/components/activities/activity-input/fields/readonly',
        };
    }
})();

(function () {
    'use strict';

    activityFieldSelectCtrl.$inject = ['lodash', 'FbSelectService', 'GenericModel', '$scope', '$timeout'];
    angular
        .module('rms.common')
        .directive('activityFieldSelect', activityFieldSelect);

    function activityFieldSelect() {
        return {
            restrict: 'E',
            require: 'ngModel',
            controller: activityFieldSelectCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                element: '=',
                onChange: '&?'
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/select',
            link: function(scope, elem, attr, ctrl) {
                var vm = scope.vm;
                vm.ngModelCtrl = ctrl;

                ctrl.$render = function() {
                    vm.modelContent = ctrl.$viewValue;
                };
            }
        };
    }

    function activityFieldSelectCtrl(lodash, FbSelectService, GenericModel, $scope, $timeout) {
        var vm = this;
        let plugins = {'remove_button': {}};
        let additionalOptions = {};
        var hasInfiniteScrolling = false;
        var require_search = false;

        this.$onInit = function() {vm.modelContent = null;

            hasInfiniteScrolling = (lodash.get(vm.element, 'options.infinite_scrolling', false) !== false);


            //
            if (hasInfiniteScrolling) {
                const infinite_scrolling_options = vm.element.options.infinite_scrolling;
                //
                const sortBy = lodash.get(infinite_scrolling_options, 'customSortBy', '$order');

                angular.merge(additionalOptions, {
                    maxOptions: lodash.get(infinite_scrolling_options, 'maxOptions', 9999),
                    customSortBy: sortBy,
                    allowSameSearch: true,
                    sortField: {field:sortBy, direction:'asc'},
                    // load: function(e) {
                    //     return loadRemoteData(e);
                    // },
                    // type: function(e) {
                    //     return loadRemoteData(e);
                    // }
                    score: function(search) {
                        return function(item) {
                            return (vm._current_count + 1 - item[sortBy]) / (vm._current_count + 2);
                        };
                    },
                });
                //
                plugins['infinite_scroll'] = infinite_scrolling_options;



            }


            FbSelectService.initTemplateCall(vm.element.options, additionalOptions);


            //
            // if (lodash.has(vm.element, 'datasource.data')) {
            //     setStaticDS();
            //     $scope.$watch(
            //         function() { return vm.element.datasource.data; },
            //         function() { setStaticDS(); }
            //     );
            // } else {
            //     loadRemoteData({
            //         skip: 0,
            //         take: 5
            //     });
            // }
            //
            // if (typeof scope.onChange === typeof function() {}) {
            //     additionalOptions.onChange = scope.onChange;
            // }
            //
            require_search = lodash.get(vm.element, 'options.require_search', false);

            vm.config = angular.merge(
                {
                    create: false,
                    labelField: 'label',
                    valueField: 'value',
                    maxItems: 1,
                    searchField: ['label'],
                    plugins: plugins,
                    options: [],
                    onChange: function(selectedValue) {
                        vm.ngModelCtrl.$setViewValue(selectedValue);
                        handleOnChange(selectedValue);
                    },
                    onInitialize: function(selectize){
                        vm.selectize = selectize;
                        if (!hasInfiniteScrolling) {
                            selectize.onSearchChange('');
                        }
                        // loadRemoteData();
                        // $timeout(function() {
                        //     if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                        //         vm.selectize.disable();
                        //     }
                        // });
                    },
                    load: function(query, callback) {
                        if (typeof query === typeof "string") {
                            query = { search: query };
                        }
                        if (hasInfiniteScrolling || require_search) {
                            if (!query.search.length) {
                                vm.selectize.clearOptions();
                                // vm.selectize.refreshOptions(false);
                                return callback([]);
                            }
                        }

                        var model = new GenericModel(vm.element.datasource.url);
                        var datasource = vm.element.datasource;
                        if (lodash.has(datasource, 'data')) {
                            return callback(datasource.data);
                        }

                        var method = lodash.get(datasource, 'method', 'get');

                        var params = angular.extend(lodash.get(datasource, 'params', {}), query || {});

                        var request = (method === 'get') ? model[method](params) : model[method]({}, {data:params});
                        delete params['time'];

                        return request.$promise.then(function(res) { //res
                            if (res.success && res.status_code == 200) {
                                if (lodash.has(res, 'selected')) {
                                    vm.modelContent = res.selected;
                                    vm.ngModelCtrl.$setViewValue(res.selected);
                                }

                                if (lodash.has(vm, 'selectize.setTotal') && typeof vm.selectize.setTotal === typeof function() {}) {
                                    vm.selectize.setTotal(res.total);
                                }

                                if (lodash.has(additionalOptions, 'customSortBy')) {
                                    if (!lodash.has(vm, '_current_count')) {
                                        vm._current_count = 0;
                                    }

                                    angular.forEach(res.data, function(_row) {
                                        _row[additionalOptions.customSortBy] = ++vm._current_count;
                                    });
                                }

                                return callback(res.data);
                            } else {
                                console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                                return callback([]);
                            }
                        }, function(res) {
                            console.warn('Calling ' + vm.element.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                            console.warn(res); // eslint-disable-line no-console
                            // return null;
                            return callback([]);
                        });
                    }
                },
                lodash.get(vm.element, 'options.selectize', {}),
                additionalOptions
            );
        }


        function handleOnChange(selectedValue) {
            if (typeof vm.onChange == typeof function() {}) {
                if (selectedValue instanceof Array) {
                    const values = selectedValue.map(function(v) {
                       return lodash.find(vm.ds, { [vm.config.valueField]: v });
                    });
                    callOnChange(vm.element.name, values);
                } else {
                    const value = lodash.find(vm.ds, { [vm.config.valueField]: selectedValue });
                    callOnChange(vm.element.name, value);
                }
            }
        }

        function callOnChange(name, value) {
            $timeout(function() {
                vm.onChange({name: name, value: value });
            });
        }
    }
})();

(function () {
    'use strict';

    activityFieldText.$inject = ['lodash'];
    activityFieldTextCtrl.$inject = ['$scope', '$timeout', '$element', 'lodash'];
    angular
        .module('rms.common')
        .directive('activityFieldText', activityFieldText);

    function activityFieldText(lodash) {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                // model: '=ngModel',
            },
            require: 'ngModel',
            templateUrl: 'common/app/components/activities/activity-input/fields/text',
            controller: activityFieldTextCtrl,
            link: function (scope, elem, attr, ctrl) {
                // if (!scope.model) {
                //     if (lodash.has(scope.element, 'value')) {
                //         scope.model = scope.element.value;
                //     }
                // }

                scope.state = {};

                ctrl.$formatters.push(function (modelValue) {
                    // if (typeof modelValue === typeof undefined){
                    //
                    // }
                    if (!modelValue) {
                        if (lodash.has(scope.element, 'value')) {
                            modelValue = scope.element.value;
                        }
                    }
                    return modelValue;
                });

                ctrl.$render = function () {
                    scope.state.model = ctrl.$viewValue;
                };

                scope.$watch(function () {
                    return scope.state.model;
                }, function () {
                    ctrl.$setViewValue(scope.state.model);
                })


            }
        };
    }

    function activityFieldTextCtrl($scope, $timeout, $element, lodash) {
        this.$onInit = function() {
            $scope.$on('$destroy', function() {
                var editor = $scope.tinyMceInst;
                editor.removed = true;
            });
            var default_options = {
                plugins: 'noneditable',
                menubar: false,
                toolbar: false,
                preview_styles: false,
                resize: true,
                statusbar: false,
                height: "90",
                autoresize_bottom_margin: 0,
                paste_as_text: true,
                keep_styles: false,
                content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; } p { margin: 0 }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
                paste_preprocess: function (plugin, args) {
                    var html_content = args.content;

                    var unclean_dom = $('<div />').html(html_content);
                    unclean_dom.find('*').removeAttr('class').removeAttr('id');
                    var replace_html_value = unclean_dom.html();

                    args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                },
                setup: function (editor) {
                    $scope.tinyMceInst = editor;
                    editor.SODTMCESubject = true;


                    function setHeight() {
                        var em = $element.find('.mce-tinymce');
                        em.css('max-height', '50px');
                    }

                    editor.on('keydown', function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        }
                    });
                    editor.on('Init', function (e) {
                        //on init setting max-height of subject
                        setHeight();
                    });

                    editor.on('BeforeSetContent', function (e) {
                        var tempDom = $('<div />');
                        tempDom.html(e.content);
                        tempDom.find('[style]').removeAttr('style');
                        e.content = tempDom.html();
                    });

                    editor.on('blur', (function (editor) {
                        return function (e) {
                            e.preventDefault();
                            $scope.model = editor.getContent();
                        };
                    })(editor));
                },
            };

            var remote_option = $scope.element.options;
            if (lodash.isEmpty(remote_option)) {
                remote_option = {}; // in case remote_option is array or null;
            }


            $scope.tmceOptions = angular.merge(default_options, remote_option);
        }
    }
})();

(function () {
    'use strict';

    activitiesFieldTimepicker.$inject = ['lodash'];
    angular
        .module('rms.common')
        .directive('activityFieldTimepicker', activitiesFieldTimepicker);

    function activitiesFieldTimepicker(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                element: '=',
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/timepicker',
            link: function (scope, elem, attr, ctrl) {
                console.log('timepicker', elem);
                var timepickerObj = elem.find('.time input');
                var timeOptions =  angular.extend(
                    {
                        'showDuration': true,
                        'timeFormat': 'g:i a',

                        // 'minTime': '2:00pm',
                    },
                    lodash.get(scope.element, 'options', {})
                );
                scope.selected_time = null;

                timepickerObj.timepicker(timeOptions);

                ctrl.$render = function() {
                    scope.selected_time = ctrl.$viewValue;
                }

                timepickerObj.on('changeTime', function() {
                    // $('#onselectTarget').text($(this).val());
                    ctrl.$setViewValue(scope.selected_time);
                });

                // scope.$watch('selected_time', function() {
                //     console.log('selected_time watch', scope.selected_time);
                //     ctrl.$setViewValue(scope.selected_time);
                // })
            }
        };
    }
})();

(function() {
    ActivityInputService.$inject = ['lodash'];
    angular
        .module('rms.common')
        .factory('ActivityInputService', ActivityInputService);

    function ActivityInputService(lodash) {
        return {
            initInputOptions: initInputOptions,
            getTypeDefaultValue:getTypeDefaultValue,
        };

        function initInputOptions(currentData, activityType, inputOptions, attachmentOptions) {
            const newData = angular.copy(currentData);
            lodash.set(newData, 'model.type', activityType.value);
            lodash.set(newData, 'options', activityType);
            lodash.set(newData, 'inputOptions', inputOptions);
            lodash.set(newData, 'attachmentOptions', attachmentOptions);

            lodash.forIn(newData.options.elements, function (element) {
                const modelFieldName = ['model', element.name].join('.');
                if (!lodash.has(newData, modelFieldName)) {
                    lodash.set(newData, modelFieldName, getTypeDefaultValue(element));
                }
            });
            return newData;
        }

        function getTypeDefaultValue(element) {
            switch (element.type) {
                case 'select':
                    if (lodash.has(element, 'options.maxItems')) {
                        return (element.options.maxItems == null || element.options.maxItems > 1) ? [] : '';
                    } else {
                        return '';
                    }
                case 'datepicker':
                case 'timepicker':
                    return new Date();
                case 'text':
                    return lodash.get(element, 'value', '');
                case 'readonly':
                    return element.value;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityInputTypeEmail', activityInputTypeEmail);

    function activityInputTypeEmail() {
        return {
            restrict: 'E',
            controller: activityInputTypeEmailCtrl,
            scope: {
                inputData: '=',
                model: '=',
                onChange: '&?'
            },
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/activities/activity-input/types/email'
        };
    }

    function activityInputTypeEmailCtrl() {
        var vm = this;
        this.$onInit = function() {
            vm.showCcBcc = showCcBcc;

            init();
        }

        function init() {
            vm.elements = vm.inputData.options.elements;
            vm.labels = vm.inputData.options.labels;
            vm.show = {
                cc: false,
                bcc: false
            };
        }

        function showCcBcc(type) {
            vm.show[type] = true;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityInputTypeScheduler', activityInputTypeScheduler);

    function activityInputTypeScheduler() {
        return {
            restrict: 'E',
            scope: {
                inputData: '=',
                model: '=',
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: activityInputTypeSchedulerCtrl,
            templateUrl: 'common/app/components/activities/activity-input/types/scheduler'
        };
    }

    function activityInputTypeSchedulerCtrl() {
        var vm = this;
        this.$onInit = function() {
            vm.elements = vm.inputData.options.elements;
            vm.labels = vm.inputData.options.labels;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityInputTypeTimestamp', activityInputTypeTimestamp);

    function activityInputTypeTimestamp() {
        return {
            restrict: 'E',
            scope: {
                inputData: '=',
                model: '=',
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: activityInputTypeTimestampCtrl,
            templateUrl: 'common/app/components/activities/activity-input/types/timestamp'
        };
    }

    function activityInputTypeTimestampCtrl() {
        var vm = this;
        this.$onInit = function() {
            vm.elements = vm.inputData.options.elements;
            vm.labels = vm.inputData.options.labels;
        }
    }
})();
(function () {
    'use strict';

    ActivitiesInputService.$inject = ['lodash'];
    angular
        .module('rms.common')
        .factory('ActivitiesInputService', ActivitiesInputService);

    function ActivitiesInputService(lodash) {
        return {
            generateOptions: generateOptions,
            getDefaultMessageInputOptions: getDefaultMessageInputOptions,
            initDefaultModelField: initDefaultModelField
        };

        function generateOptions(option) {
            return angular.merge(
                {},
                getDefaultOptions(),
                option
            );
        }

        function getDefaultOptions() {
            return {
                messageInput: getDefaultMessageInputOptions()
            };
        }

        function initDefaultModelField(inputoptions) {
            delete inputoptions.model.attachments;
            if (!lodash.has(inputoptions.model, 'type')) {
                lodash.set(inputoptions, 'model.type', inputoptions.options.value);
            }
            if (lodash.has(inputoptions, 'options.elements')) {
                // if (lodash.isEmpty(inputoptions.model)) {
                //     lodash.set(inputoptions, 'model.type' ,inputoptions.options.value);
                // }

                angular.forEach(inputoptions.options.elements, function (val, idx) {
                    if (lodash.has(inputoptions.model, val.name)) {
                        lodash.set(inputoptions.model, val.name, val.value);
                    }
                });
            }
        }

        function getDefaultMessageInputOptions() {
            return {
                plugins: ['link', 'image', 'autoresize', 'paste', 'noneditable'].join(' '),
                // plugins: 'link image autoresize paste noneditable code',
                menubar: false,
                toolbar: [
                    ['undo', 'redo'].join(' '),
                    ['bold', 'italic', 'underline'].join(' '),
                    ['bullist', 'numlist'].join(' '),
                    ['outdent', 'indent'].join(' '),
                    ['alignleft', 'aligncenter', 'alignright'].join(' '),
                    ['link'].join(' '),
                ].join(' | '),
                // toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent | alignleft aligncenter alignright | link',
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
                // paste_as_text: true,
                // paste_word_valid_elements: "b,strong,i,em,h1,h2",
                paste_preprocess: function (plugin, args) {
                    var html_content = args.content;

                    var unclean_dom = $('<div />').html(html_content);
                    unclean_dom.find('*').removeAttr('class').removeAttr('id');
                    var replace_html_value = unclean_dom.html();

                    args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                }
            };
        }
    }
})();
(function () {
    'use strict';

    ActivitiesService.$inject = ['lodash', 'GenericModel', '$rootScope'];
    angular
        .module('rms.common')
        .factory('ActivitiesService', ActivitiesService);

    function ActivitiesService(lodash, GenericModel, $rootScope) {
        var mem = {};

        return {
            init: init,
            sync: sync,
            destroy: destroy,
            discard: discard,
            selectType: selectType,
            getActivityType: getActivityType,
            refreshActivities: refreshActivities,
            save: save,
            setModel: setModel,
            inputOnChange: inputOnChange,
            getAttachmentOptions: getAttachmentOptions
        };

        function init(vm, options) {
            sync(vm);
            mem.activities = [];
            mem.options = options;
            lodash.set(mem.options, 'inputOptions.onChangeInstructions', [
                {name: 'sel_email_from', type: 'setSignature'}
            ]);

            lodash.set(mem.options, 'inputOptions.signatureSettings', {
                fieldName: 'txtbox_description'
            });

            prepareInputData();
            initLoadAttachments();

            if (lodash.has(mem, 'options.activityTypes')) {
                selectType(mem.options.activityTypes[0]);
            }
        }

        function initLoadAttachments() {
            // console.log('initLoadAttachments', mem.options);
            //mem.inputData.model.attachments
            if (lodash.has(mem.options, 'attachmentOptions.preattached')) {
                mem.options.attachmentOptions.preattached.loading = true;
                const model = new GenericModel(mem.options.attachmentOptions.preattached.datasource.url);
                const method = lodash.get(mem.options.attachmentOptions.preattached.datasource, 'method', 'create');
                const datasourceModel = lodash.get(mem.options.attachmentOptions.preattached, 'datasource.params', {});
                model[method]({}, {data: datasourceModel}).$promise.then((res) => { // eslint-disable-line no-unused-vars
                    if (mem.options.attachmentOptions.preattached.datasource.params.unique === res.unique) {
                        lodash.set(mem.inputData.model, 'attachments', res.data);
                    }
                    mem.options.attachmentOptions.preattached.loading = false;
                }, (err)=> {
                    console.log(err);
                    mem.options.attachmentOptions.preattached.loading = false;
                });
            }
        }

        function sync(vm) {
            vm.pageData = mem;
        }

        function destroy() {
            mem = {};
        }

        function selectType(activityType) {
            lodash.set(mem.inputData, 'model.type', activityType.value);
            lodash.set(mem.inputData, 'options', getActivityType(activityType.type));
            setModelDefaultValue(mem.inputData.options.elements);
            mem.currentActivityType = activityType;
            return mem.inputData.options;
        }

        function getActivityType(type) {
            return lodash.find(mem.options.activityTypes, function (at) {
                return at.type == type;
            });
        }

        function prepareInputData() {
            mem.inputData = {
                model: {},
                options: {
                    messageInput: {
                        preview_styles: true
                    }
                },
                inputOptions: lodash.get(mem.options, 'inputOptions', {})
            };
        }

        function save2(_model) {
            console.log('save model:', _model);
            mem.submitting = true;
            const activityType = lodash.find(mem.options.activityTypes, {type: mem.inputData.options.type});
            const props = [mem.options.inputOptions.descriptionName || 'description', 'type', 'attachments'].concat(lodash.get(activityType, 'schema', []));

            const modelData = {data: lodash.pick(mem.inputData.model, props)};

            // call remote api from here. API to be provided by the backend
            const model = new GenericModel(mem.options.inputOptions.datasource.url);
            const method = lodash.get(mem.options.inputOptions.datasource, 'method', 'post');
            const datasourceModel = lodash.get(mem.options.inputOptions.datasource, 'model', {});
            model[method](datasourceModel, modelData).$promise.then((res) => { // eslint-disable-line no-unused-vars
                // once submit, clear input model
                // refresh grid (need to store grid's callback in the activity-list side)
                mem.inputValidationErrorMessage = '';
                discard();
                refreshActivities();
                mem.submitting = false;
            }, (err)=> {
                mem.inputValidationErrorMessage = '';
                switch (err.status) {
                    case 422:
                        mem.inputValidationErrorMessage = lodash.flatMap(err.data.rules).join(', ');
                        break;
                }
                // mem.inputValidationError = err.data;
                console.warn(err); // eslint-disable-line no-console
                refreshActivities();
                mem.submitting = false;
            });
        }

        function save(data, type, options) {
            const resource = new GenericModel(options.datasource.url);
            const props = [lodash.get(options, 'descriptionName', 'txtbox_description'), 'attachments', 'hid_linked_id'].concat(lodash.get(type, 'schema', []));
            let model = { data: lodash.merge(lodash.pick(data, props), { type: type.value }) };
            const method = lodash.get(options.datasource, 'method', 'post');
            const params = lodash.get(options.datasource, 'model', {});
            const defaultModel = {data: lodash.get(options.datasource, 'defaultModel', {})};
            model = lodash.merge(defaultModel, model);
            return resource[method](params, model);
        }

        function discard() {
            mem.inputValidationErrorMessage = '';
            // mem.inputData.model = {};
            mem.discard();
        }

        function refreshActivities() {
            if (lodash.has(mem, 'activities.callback')) {
                try {
                    mem.activities.callback.dataSource.read();
                } catch (ex) {
                    console.warn(ex); // eslint-disable-line no-console
                }
            }
        }

        function setModelDefaultValue(elements) {
            lodash.forIn(elements, function (element) {
                const modelFieldName = ['model', element.name].join('.');
                if (!lodash.has(mem.inputData, modelFieldName)) {
                    lodash.set(mem.inputData, modelFieldName, getTypeDefaultValue(element));
                }
            });
        }

        function getTypeDefaultValue(element) {
            switch (element.type) {
                case 'select':
                    if (lodash.has(element, 'options.maxItems')) {
                        return (element.options.maxItems == null || element.options.maxItems > 1) ? [] : '';
                    } else {
                        return '';
                    }
                case 'datepicker':
                case 'timepicker':
                    return new Date();
                case 'text':
                    return lodash.get(element, 'value', '');
                case 'readonly':
                    return element.value;
            }
        }

        function setModel(field, value) {
            lodash.set(mem.inputData.model, field, value);
        }

        function inputOnChange(name, selectedValue) {
            //const inputElementOptions = lodash.get()
            const instructions = lodash.get(mem.options, 'inputOptions.onChangeInstructions', null);
            if (!!instructions) {
                const instruction = lodash.find(instructions, {name: name});
                if (!!instruction) {
                    execOnChangeInstructions(instruction.type, selectedValue);
                }
            }
        }

        function execOnChangeInstructions(type, data) {
            switch (type) {
                case 'setSignature': {
                    setSignature(data);
                    break;
                }
                default: {
                    break;
                }
            }
        }

        function setSignature(data) {
            // get the txt description field
            const regexSignature = /(<div\sclass=['"]signature-wrapper['"]>[\S\s]*<\/div>)/g;
            const fieldName = lodash.get(mem.options, 'inputOptions.signatureSettings.fieldName', false);
            if (!!fieldName) {
                let newData = '';
                let previousData = lodash.get(mem.inputData.model, fieldName, '');
                if (!previousData) {
                    previousData = '';
                }
                previousData = previousData.replace(regexSignature,'');

                // get signature
                const signatureId = lodash.get(data, 'signature.default', null);
                const signatureLists = lodash.get(data, 'signature.list', []);
                const signature = lodash.find(signatureLists, {id: signatureId});
                if (!!signature) {
                    const signatureHtml = '<p></p><div class="signature-wrapper">' + signature.signature + '</div>';
                    newData = previousData + signatureHtml;
                } else {
                    newData = previousData;
                }

                lodash.set(mem.inputData.model, fieldName, newData);

                // $rootScope.$apply();
            }
        }

        function getAttachmentOptions() {
            return lodash.get(mem, 'options.attachmentOptions', {});
        }
    }
})();

// set the datasource for activity list
// lodash.set(mem, 'options.activities', {
//     // data for testing
//     // for now will implement something simple. Will improve upon it once the actual data structure in the backend is finalized.
//     labels: {
//         activity_group_no_records: 'No records matching {0}',
//         cc: 'CC',
//         bcc: 'BCC',
//         guests: 'guests'
//     },
//     gridOptions: {
//         columns: [{
//             field: 'created_on',
//             groupHeaderTemplate: '<div><div class="activity-group-header-wrapper"><div class="activity-group-header" ng-bind="dataItem.value"></div></div><div class="activity-no-records" ng-if="dataItem.items.length == 0" ng-bind="vm.pageData.options.activities.labels.activity_group_no_records|stringFormat:[dataItem.value]"></div></div>',
//             template: '<rms-activity-wrapper item="dataItem"> <rms-activity item="dataItem" type="dataItem.type"></rms-activity> </rms-activity-wrapper>'
//         }],
//         pageable: {
//             pageSize: 2
//         }
//     },
//     data: {
//         total: 4,
//         groups: [
//             {
//                 field: 'created_on',
//                 hasSubGroup: false,
//                 aggregates: [],
//                 value: 'August 2016',
//                 items: [
//                     {
//                         type: 'email',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan'
//                         },
//                         description: '<a>You</a> have sent an email to <b>Fluffy</b> (fluffy@staffondemand.sg)',
//                         content: {
//                             description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                             subject: 'Lorem ipsum dolor sit amet.',
//                             cc: 'Hashy (hashy@staffondemand.sg), Xiao Zhu Zhu (xzz@staffondemand.sg)',
//                             bcc: 'Jagdish (jagdish@staffondemand.sg), Xiao Bupi(bupi@staffondemand.sg)'
//                         }
//
//                     },
//                     {
//                         type: 'log',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan',
//                             email: 'reccy84@gmail.com'
//                         },
//                         description: '<b>Fluffy</b> was shortlisted by <a>You</a> for <a>Pet</a>.'
//                     }
//                 ]
//             },
//             {
//                 field: 'created_on',
//                 hasSubGroup: false,
//                 aggregates: [],
//                 value: 'July 2016',
//                 items: []
//             },
//             {
//                 field: 'created_on',
//                 hasSubGroup: false,
//                 aggregates: [],
//                 value: 'June 2016',
//                 items: [
//                     {
//                         type: 'note',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan'
//                         },
//                         description: '<a>You</a> have created a note for <b>Fluffy</b>',
//                         content: {
//                             description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.'
//                         }
//                     },
//                     {
//                         type: 'schedule',
//                         created_on: '22/08/2016 at 10:42 AM GMT+8',
//                         created_by: {
//                             id: 123,
//                             name: 'Ryan'
//                         },
//                         description: '<a>You</a> have scheduled an interview for <b>Fluffy</b>',
//                         content: {
//                             name: 'Interview with Fluffy',
//                             date: '23/08/2016 at 10:00 AM GMT+8',
//                             description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                             guests: [
//                                 {
//                                     description: 'Ryan (ryan@staffondemand.sg)',
//                                     email: 'reccy84@gmail.com',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Bupi (xbupi@staffondemand.sg)',
//                                     email: 'xbupi@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Fluffy (xfluffy@staffondemand.sg)',
//                                     email: 'xfluffy@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Hashy (xhashy@staffondemand.sg)',
//                                     email: 'xhashy@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Snowy (xsnowy@staffondemand.sg)',
//                                     email: 'xsnowy@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Wahabi (xwahabi@staffondemand.sg)',
//                                     email: 'xwahabi@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Dusty (xdusty@staffondemand.sg)',
//                                     email: 'xdusty@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Zhuzhu (xzhuzhu@staffondemand.sg)',
//                                     email: 'xzhuzhu@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Burrito (xburrito@staffondemand.sg)',
//                                     email: 'xburrito@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Ham (xham@staffondemand.sg)',
//                                     email: 'xham@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Tweenie (xtweenie@staffondemand.sg)',
//                                     email: 'xtweenie@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'HoneyPot (xhoneypot@staffondemand.sg)',
//                                     email: 'xhoneypot@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 },
//                                 {
//                                     description: 'Hearty (xhearty@staffondemand.sg)',
//                                     email: 'xhearty@staffondemand.sg',
//                                     name: 'Ryan',
//                                     image_url: ''
//                                 }
//                             ]
//                         }
//                     }
//                 ]
//             }
//         ]
//     },
//     // actual implementation should use datasource
//     datasource: {
//         read: {},
//         filter: {}
//     },
//     datasourceOptions: {
//         serverGrouping: true,
//         group: {field: 'created_on', dir: 'asc'},
//         schema: {
//             //data: 'content',
//             groups: 'groups',
//             total: 'total'
//         }
//     },
//     filters: {
//         types: {
//             filter: {
//                 datasource: {
//                     init: {
//                         url: 'api/v1/structure/rms/contacts/filter',
//                         method: 'get'
//                     }
//                 }
//             },
//             sort: {
//                 sort_list: [
//                     {label: 'Created On', name: 'created_on', default_direction: 'desc'},
//                     {label: 'Type', name: 'type', default_direction: 'asc'}
//                 ],
//                 selected_sort_template: '<div class="active">{0} <i class="fa {1}"></i></div>'
//             },
//             search: {
//                 field_name: 'filter_search_text',
//                 operator: 'contains',
//                 search_icon: '',
//                 use_icon: true,
//                 icon: 'fa-search',
//                 search_on_change: true,
//                 model_options: {debounce: 300}
//             },
//             reset: true
//         },
//         labels: {
//             'no_operator_selected': 'Can you select something, please?',
//             'no_value_set': 'Can you provide a value, please?',
//             'apply_button': 'Apply',
//             'cancel_button': 'Cancel',
//             'filter': 'Filter',
//             'sort': 'Sort',
//             'search': 'Search'
//         }
//     }
// });


// lodash.set(mem, 'options.activities.data', {
//     total: 4,
//     groups: [
//         {
//             field: 'created_on',
//             hasSubGroup: false,
//             aggregates: [],
//             value: 'August 2016',
//             items: [
//                 {
//                     type: 'email',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan'
//                     },
//                     description: '<a>You</a> have sent an email to <b>Fluffy</b> (fluffy@staffondemand.sg)',
//                     content: {
//                         description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                         subject: 'Lorem ipsum dolor sit amet.',
//                         cc: 'Hashy (hashy@staffondemand.sg), Xiao Zhu Zhu (xzz@staffondemand.sg)',
//                         bcc: 'Jagdish (jagdish@staffondemand.sg), Xiao Bupi(bupi@staffondemand.sg)'
//                     }
//
//                 },
//                 {
//                     type: 'log',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan',
//                         email: 'reccy84@gmail.com'
//                     },
//                     description: '<b>Fluffy</b> was shortlisted by <a>You</a> for <a>Pet</a>.'
//                 }
//             ]
//         },
//         {
//             field: 'created_on',
//             hasSubGroup: false,
//             aggregates: [],
//             value: 'July 2016',
//             items: []
//         },
//         {
//             field: 'created_on',
//             hasSubGroup: false,
//             aggregates: [],
//             value: 'June 2016',
//             items: [
//                 {
//                     type: 'note',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan'
//                     },
//                     description: '<a>You</a> have created a note for <b>Fluffy</b>',
//                     content: {
//                         description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.'
//                     }
//                 },
//                 {
//                     type: 'schedule',
//                     created_on: '22/08/2016 at 10:42 AM GMT+8',
//                     created_by: {
//                         id: 123,
//                         name: 'Ryan'
//                     },
//                     description: '<a>You</a> have scheduled an interview for <b>Fluffy</b>',
//                     content: {
//                         name: 'Interview with Fluffy',
//                         date: '23/08/2016 at 10:00 AM GMT+8',
//                         description: 'Lorem ipsum dolor sit amet, nec rebum error ei, quando contentiones sit in. Ne has homero noluisse honestatis, ius laudem civibus eu. Nisl sumo patrioque sit no. Solum appetere eos at, has amet assueverit no.',
//                         guests: [
//                             {
//                                 description: 'Ryan (ryan@staffondemand.sg)',
//                                 email: 'reccy84@gmail.com',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Bupi (xbupi@staffondemand.sg)',
//                                 email: 'xbupi@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Fluffy (xfluffy@staffondemand.sg)',
//                                 email: 'xfluffy@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Hashy (xhashy@staffondemand.sg)',
//                                 email: 'xhashy@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Snowy (xsnowy@staffondemand.sg)',
//                                 email: 'xsnowy@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Wahabi (xwahabi@staffondemand.sg)',
//                                 email: 'xwahabi@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Dusty (xdusty@staffondemand.sg)',
//                                 email: 'xdusty@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Zhuzhu (xzhuzhu@staffondemand.sg)',
//                                 email: 'xzhuzhu@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Burrito (xburrito@staffondemand.sg)',
//                                 email: 'xburrito@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Ham (xham@staffondemand.sg)',
//                                 email: 'xham@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Tweenie (xtweenie@staffondemand.sg)',
//                                 email: 'xtweenie@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'HoneyPot (xhoneypot@staffondemand.sg)',
//                                 email: 'xhoneypot@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             },
//                             {
//                                 description: 'Hearty (xhearty@staffondemand.sg)',
//                                 email: 'xhearty@staffondemand.sg',
//                                 name: 'Ryan',
//                                 image_url: ''
//                             }
//                         ]
//                     }
//                 }
//             ]
//         }
//     ]
//
// });


// set the input stuff
// input endpoints
// lodash.set(mem, 'options.inputOptions', {
//     datasource: {
//         url: 'abc',
//         method: 'post'
//     },
//     descriptionName: 'txtbox_description'
// });

// if you don't provide activityTypes, The input will never show.
/*lodash.set(mem, 'options.activityTypes', [
 {
 labels: {
 title: 'Email',
 to: 'To',
 from: 'From',
 subject: 'Subject',
 cc: 'CC',
 bcc: 'BCC',
 buttonCreate: 'Send',
 buttonCancel: 'Discard'
 },
 value: 'email',
 icon: 'envelope',
 schema: ['to', 'from', 'cc', 'bcc', 'subject'],
 type: 'email',
 elements: {
 to: {
 name: 'to',
 value: "fluffyxiao@staffondemand.sg",
 type: "text",
 options: {
 readonly: true
 }
 },
 from: {
 name: 'from',
 value: "ryan@staffondemand.sg",
 type: "text",
 options: {
 readonly: true
 }
 },
 subject: {
 name: 'subject',
 type: "text"
 },
 cc: {
 name: 'cc',
 type: "select",
 datasource: {
 data: [
 {label: 'Ryan Oh (ryan@staffondemand.sg)', value: 'test1'},
 {label: 'Jagdish (jagdish@staffondemand.sg)', value: 'test2'},
 {label: 'Fluffy (fluffy@staffondemand.sg)', value: 'test3'},
 {label: 'Hashy (hashy@staffondemand.sg)', value: 'test3'}
 ]
 },
 options: {
 maxItems: null
 }
 },
 bcc: {
 name: 'bcc',
 type: "select",
 datasource: {
 data: [
 {label: 'Ryan Oh (ryan@staffondemand.sg)', value: 'test1'},
 {label: 'Jagdish (jagdish@staffondemand.sg)', value: 'test2'},
 {label: 'Fluffy (fluffy@staffondemand.sg)', value: 'test3'},
 {label: 'Hashy (hashy@staffondemand.sg)', value: 'test3'}
 ]
 },
 options: {
 maxItems: null
 }
 }
 }
 },
 {
 labels: {
 title: 'Log Activity',
 buttonCreate: 'Create',
 buttonCancel: 'Cancel'
 },
 value: 'log',
 icon: 'envelope',
 schema: ['activity_date', 'activity_time', 'log_type'],
 type: 'timestamp',
 elements: {
 select: {
 type: "select",
 label: "Type",
 name: 'log_type',
 datasource: {
 data: [
 {label: 'Test1', value: 'test1'},
 {label: 'Test2', value: 'test2'},
 {label: 'Test3', value: 'test3'}
 ]
 },
 options: {}
 },
 activity_date: {
 name: 'activity_date',
 type: 'datepicker'
 },
 activity_time: {
 name: 'activity_time',
 type: 'timepicker'
 }
 }
 },
 {
 value: 'note', icon: 'envelope', type: 'normal',
 labels: {
 title: 'Note',
 buttonCreate: 'Save Task',
 buttonCancel: 'Cancel'
 }
 },
 {
 value: 'schedule', icon: 'envelope', type: 'scheduler',
 labels: {
 title: 'Schedule',
 eventName: 'Event Name',
 startDateTime: 'Starts',
 endDateTime: 'Ends',
 guests: 'Invitees',
 buttonCreate: 'Create',
 buttonCancel: 'Cancel',
 inputTitle:'Event Description Label'
 },
 schema: ['start_date', 'start_time', 'end_date','end_time','event_name',''],
 // inputTitle: 'Event Description',
 elements: {
 start_date: {
 name: 'start_date',
 type: 'datepicker'
 },
 start_time: {
 name: 'start_time',
 type: 'timepicker'
 },
 end_date: {
 name: 'end_date',
 type: 'datepicker'
 },
 end_time: {
 name: 'end_time',
 type: 'timepicker'
 },
 event_name: {
 name: 'event_name',
 type: "text"
 },
 invitee: {
 type: "custom-select",
 label: "Type",
 name: 'invitee',
 datasource: {
 data: [
 {name: 'Ryan', email: 'ryan@staffondemand.sg', department: 'IT', id: 1},
 {name: 'Jagdish', email: 'jagdish@staffondemand.sg', department: 'IT', id: 2},
 {name: 'Fluffy', email: 'fluffy@staffondemand.sg', department: 'Pet', id: 3},
 {name: 'Bupi', email: 'hashy@staffondemand.sg', department: 'Pet', id: 4},
 {name: 'Hashy', email: 'hashy@staffondemand.sg', department: 'Pet', id: 5},
 {name: 'Snowy', email: 'hashy@staffondemand.sg', department: 'Pet', id: 6},
 {name: 'Dusty', email: 'hashy@staffondemand.sg', department: 'Pet', id: 7},
 {name: 'Wahabi', email: 'hashy@staffondemand.sg', department: 'Pet', id: 8},
 {name: 'Zhuzhu', email: 'hashy@staffondemand.sg', department: 'Pet', id: 9},
 {name: 'Hearty', email: 'hashy@staffondemand.sg', department: 'Pet', id: 10},
 {name: 'Burrito', email: 'hashy@staffondemand.sg', department: 'Pet', id: 11},
 {name: 'HoneyPot', email: 'hashy@staffondemand.sg', department: 'Pet', id: 12},
 {name: 'Tweenie', email: 'hashy@staffondemand.sg', department: 'Pet', id: 13},
 {name: 'Ham', email: 'hashy@staffondemand.sg', department: 'Pet', id: 14}
 ]
 },
 options: {
 maxItems: null,
 labelField: 'email',
 valueField: 'id',
 searchField: ['name', 'email', 'department'],
 placeholder: 'Click here to add invitees',
 template: {
 item: {
 html: '<div>#name# (#email#)</div>',
 schema: ['name', 'email']
 },
 option: {
 html: '<div><h6>#name#</h6><div>#email#</div><div>#department#</div></div>',
 schema: ['name', 'email', 'department']
 }
 }
 }
 }
 }
 }
 ]);
 */

(function () {
    'use strict';

    rmsFilterBarFilterSelectCtrl.$inject = ['$scope', 'MainFilterBarService'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarFilterSelect', rmsFilterBarFilterSelect);

    function rmsFilterBarFilterSelect() {
        return {
            restrict: 'E',
            controller: rmsFilterBarFilterSelectCtrl,
            scope: {},
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/filter-select'
        };
    }

    function rmsFilterBarFilterSelectCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();
            init();

            vm.selectFilter = selectFilter;
        }

        function init() {
            vm.showFilter = vm.filterBarService().hasType('filter');
            vm.state = vm.filterBarService().getState();

            vm.filterDisplayHtml = `<a>${vm.filterBarService().getMessageLabel('filter')} <i class='fa fa-caret-down'></i></a>`;
        }

        function selectFilter(filter) {
            vm.togglePopover();
            vm.filterBarService().addFilter(filter);
        }
    }
})();
(function () {
    'use strict';

    rmsFilterBarFreeTextSearchCtrl.$inject = ['$scope', 'MainFilterBarService'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarFreeTextSearch', rmsFilterBarFreeTextSearch);

    function rmsFilterBarFreeTextSearch() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsFilterBarFreeTextSearchCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/free-text-search'
        };
    }

    function rmsFilterBarFreeTextSearchCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.submit = submit;
            vm.onChange = onChange;

            init();
        }

        function init() {
            vm.state = vm.filterBarService().getState();
            vm.showInput = vm.filterBarService().hasType('search');
            vm.options = vm.filterBarService().getOptions('search');
            if (!vm.options.search_on_change) {
                if (vm.options.use_icon) {
                    vm.buttonLabel = `<i class="fa ${vm.options.icon}"></i>`;
                } else {
                    vm.buttonLabel = `${vm.filterBarService().getMessageLabel('search')}`;
                }
            }
        }

        function submit() {
            vm.filterBarService().applySearch();
        }

        function onChange() {
            if (vm.options.search_on_change) {
                submit();
            }
        }

    }
})();
(function () {
    'use strict';

    rmsFilterBarResetCtrl.$inject = ['$scope', 'MainFilterBarService'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarReset', rmsFilterBarReset);

    function rmsFilterBarReset() {
        return {
            restrict: 'E',
            controller: rmsFilterBarResetCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/reset'
        };
    }

    function rmsFilterBarResetCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.reset = reset;

            init();
        }

        function init() {
            vm.showReset = vm.filterBarService().hasType('reset');
        }

        function reset() {
            vm.filterBarService().reset(true);
        }
    }
})();
(function () {
    'use strict';

    rmsFilterBarSortCtrl.$inject = ['$scope', 'MainFilterBarService'];
    angular
        .module('rms.common')
        .directive('rmsFilterBarSort', rmsFilterBarSort);

    function rmsFilterBarSort() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsFilterBarSortCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/sort'
        };
    }

    function rmsFilterBarSortCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.selectSort = selectSort;

            init();
        }
        function init() {
            vm.showSort = vm.filterBarService().hasType('sort');
            vm.state = vm.filterBarService().getState();
            vm.options = vm.filterBarService().getOptions('sort');

            vm.filterDisplayHtml = `<a>${vm.filterBarService().getMessageLabel('sort')} <i class='fa fa-caret-down'></i></a>`;
        }

        function selectSort(sort) {
            vm.filterBarService().applySort(sort);
            vm.togglePopover();
        }
    }
})();

(function () {
    'use strict';

    filterValueActionCtrl.$inject = ['$scope'];
    angular
        .module('rms.common')
        .directive('filterValueAction', filterValueAction);

    function filterValueAction() {
        return {
            restrict: 'EA',
            templateUrl: 'common/components/filter-values-type/actions',
            controller: filterValueActionCtrl,
            controllerAs: 'vm',
            scope: {},
            bindToController: true
        };
    }

    function filterValueActionCtrl($scope) {
        var vm = this,
            filterService = null;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;

            vm.applyFilter = applyFilter;
            vm.cancel = cancel;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
            filterService = $scope.listFilterService.getFilterService();
        }

        function applyFilter() {
            if (filterService.applyFilter()) {
                vm.pageData.filters.searchFilter = {};
                filterService.resetCurrent();
                $scope.listFilterService.refreshGrid(true);
            }
        }

        function cancel() {
            filterService.resetCurrent();
        }
    }
})();
(function () {
    'use strict';

    dateFilterValue.$inject = ['lodash'];
    dateFilterValueCtrl.$inject = ['lodash', 'FormBuilderService', '$scope'];
    angular
        .module('rms.common')
        .directive('dateFilterValue', dateFilterValue);

    function dateFilterValue(lodash) {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '=',
                type: '=',
                settingsOverride: '=?'
            },
            controller: dateFilterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/date',
            link: function(scope, elem) {
                var vm = scope.vm;
                var dp_obj = elem.find('input');

                dp_obj.datepicker(angular.extend(vm.dateOptions, vm.settingsOverride || {}));

                var vmFilterModel = vm.filterValueModel;
                if(vmFilterModel){
                    var date = moment(vmFilterModel, vm.display_format).format(vm.save_format);
                    dp_obj.datepicker('setDate', date);
                }

                dp_obj.on('change', function(e) {
                    scope.$apply(function() {
                        var save_value = moment(e.target.value, vm.save_format).toDate();
                        console.log('scope apply', save_value);
                        vm.filterValueModel = save_value;
                    });

                });
            }
        };
    }

    function dateFilterValueCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {

            vm.display_format = lodash.get(vm.element, 'options.display_format', 'dd/mm/yyyy');
            vm.save_format = lodash.get(vm.element, 'options.save_format', 'DD/MM/YYYY');

            vm.dateOptions = angular.merge({
                    format: vm.display_format,
                    autoclose: true,
                    forceParse: false,
                    orientation: 'bottom',
                },
                generateOptions()
            );

        }

        function generateOptions() {
            var option = {};
            var lang = angular.element('html').attr('lang');

            if (lang) {
                option.language = lang;
            }

            return option;
        }
    }
})();
(function () {
    'use strict';

    enumFilterValue.$inject = ['lodash', '$filter'];
    enumFilterValueCtrl.$inject = ['FbSelectService', 'lodash', 'GenericModel', '$timeout', '$scope', '$filter'];
    angular
        .module('rms.common')
        .directive('enumFilterValue', enumFilterValue);

    function enumFilterValue(lodash, $filter) {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '=',
                options: '=?',
                type: '=',
                settingsOverride: '=?',
                filterValueLabel: '=?',
                subSettings: '=?',
            },
            controller: enumFilterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/enum',
            link: function (scope, $timeout) {

                if ($filter('isMultipleEnumType')(scope.vm.type)) {
                    // morph options
                    // scope.vm.options = lodash.reduce(
                    //     lodash.get(scope.vm, 'options.data', {}),
                    //     function (accum, oData, oDataKey) {
                    //         lodash.set(accum, oDataKey, { data: oData });
                    //         return accum;
                    //     },
                    //     {}
                    // );

                    lodash.forEach(scope.vm.subFilterKeys, function (subFilterKey) {
                        if (!lodash.has(scope.vm.filterValueModel, subFilterKey)) {
                            lodash.set(scope.vm.filterValueModel, subFilterKey, null)
                        }

                        scope.$watch(function () {
                            return lodash.get(scope.vm.filterValueModel, subFilterKey)
                        }, function (newValue, oldValue) {
                            if (lodash.get(scope.vm.filterValueModel, subFilterKey)
                                && (newValue !== oldValue)
                                && (typeof lodash.get(scope.vm.filterValueLabel, subFilterKey) !== typeof undefined)
                            ) {
                                var selectedOption = lodash.find(lodash.get(scope.vm.ds, subFilterKey), { value: newValue });
                                lodash.set(scope.vm.filterValueLabel, subFilterKey, selectedOption.label);
                            }
                        })
                    });
                } else {
                    scope.$watch(function () {
                        return scope.vm.filterValueModel;
                    }, function (newValue, oldValue) {
                        if (scope.vm.filterValueModel && (newValue !== oldValue) && (typeof scope.vm.filterValueLabel !== typeof undefined)) {
                            var selectedOption = lodash.find(scope.vm.ds, {value: newValue});
                            scope.vm.filterValueLabel = selectedOption.label;
                        }
                    });
                }
            }
        };
    }

    function enumFilterValueCtrl(FbSelectService, lodash, GenericModel, $timeout, $scope, $filter) {
        var vm = this;

        var filterValueLabelPath = 'filterValueLabel';
        var filterValueModelPath = 'filterValueModel';
        var subSettingsPath = 'subSettings';
        var selectizePath = 'selectize';
        var isLoadingPath = 'isLoading';
        var optionsPath = 'options';
        var configPath = 'config';
        var dsPath = 'ds';
        this.$onInit = function() {
            if ($filter('isMultipleEnumType')(vm.type)) {
                var subSettingsWithOrder = Object.keys(vm.subSettings).map(function(subSettingKey) {
                    var subSetting = lodash.get(vm.subSettings, subSettingKey);
                    return {key: subSettingKey, order: lodash.get(subSetting, 'order', 9999)};
                });
                var subSettingsWithOrderSorted = lodash.orderBy(subSettingsWithOrder, ['order', 'asc']);
                vm.subFilterKeys = lodash.map(subSettingsWithOrderSorted, function(subSettingWithOrderSorted) {
                    return lodash.get(subSettingWithOrderSorted, 'key');
                });

                // morph options
                var vmOptionsKeys = Object.keys(vm.options);
                var uniqueValueKeys = lodash.xor(vmOptionsKeys, vm.subFilterKeys);
                var hasBeenMorphed = uniqueValueKeys.length === 0;

                // set additional options
                vm.addConfig = {};
                var config = lodash.get(vm.options, 'config', {});
                Object.keys(config).forEach(function(configKey) {
                    var subConfig = lodash.get(vm, ["addConfig", configKey].join('.'), {});
                    var currentConfig = angular.copy(lodash.get(config, configKey, {}));

                    vm.addConfig[configKey] = Object.assign(subConfig, currentConfig);
                });

                if (!hasBeenMorphed) {
                    vm.options = lodash.reduce(
                        lodash.get(vm, 'options.data', {}),
                        function (accum, oData, oDataKey) {
                            lodash.set(accum, oDataKey, { data: oData });
                            return accum;
                        },
                        {}
                    );
                }

                lodash.forEach(vm.subFilterKeys, function (subFilterKey) {
                    var innerFilterValueLabelPath = [filterValueLabelPath, subFilterKey].join('.');
                    var innerFilterValueModelPath = [filterValueModelPath, subFilterKey].join('.');
                    var innerSubSettingsPath = [subSettingsPath, subFilterKey, 'select_options', 'selectize'].join('.');
                    var innerSelectizePath = [selectizePath, subFilterKey].join('.');
                    var innerIsLoadingPath = [isLoadingPath, subFilterKey].join('.');
                    var innerConfigPath = [configPath, subFilterKey].join('.');

                    var innerOptionsPath = [optionsPath, subFilterKey].join('.');
                    var options = lodash.get(vm, innerOptionsPath, {});

                    var additionalOptionsPath = ['additionalOptions', subFilterKey].join('.');
                    lodash.setWith(vm, additionalOptionsPath, {}, Object);
                    var additionalOptions = lodash.get(vm, additionalOptionsPath);

                    var _config = lodash.get(vm, ['addConfig', subFilterKey].join('.'), {});
                    FbSelectService.initTemplateCall(Object.assign(options, _config), additionalOptions);

                    var innerDsPath = [dsPath, subFilterKey].join('.');

                    if (lodash.has(options, 'data.datasource') && !lodash.get(options, 'data.datasource.limited', false)) {
                        innerOptionsPath = innerOptionsPath + '.data';
                        loadRemoteData(innerOptionsPath, innerDsPath, innerIsLoadingPath, subFilterKey);
                    } else {
                        if (lodash.has(options, 'data')) {
                            lodash.setWith(vm, innerDsPath, lodash.get(options, 'data'), Object);
                        }
                    }

                    if (lodash.has(options, 'data.datasource') && lodash.get(options, 'data.datasource.limited', false)) {
                        lodash.set(
                            vm,
                            [additionalOptionsPath, 'load'].join('.'),
                            additionalOptionsLoad(innerOptionsPath, innerFilterValueModelPath)
                        );

                        lodash.set(
                            vm,
                            [additionalOptionsPath, 'onInitialize'].join('.'),
                            additionalOptionsOnInitialize(innerSelectizePath)
                        );

                        lodash.set(vm, [additionalOptions, 'maxOptions'].join('.'), 10);
                    }

                    lodash.setWith(vm, innerConfigPath, angular.merge(
                        {
                            highlight: true,
                            create: false,
                            labelField: 'label',
                            valueField: 'value',
                            plugins: ['remove_button'],
                            searchField: ['label'],
                        },
                        lodash.get(vm, additionalOptionsPath, {}),
                        lodash.get(vm, innerSelectizePath, {}),
                        lodash.get(vm, innerSubSettingsPath, {})
                    ), Object);
                });
            } else {
                vm.additionalOptions = {};

                FbSelectService.initTemplateCall(vm.options, vm.additionalOptions);

                vm.ds = [];
                if (lodash.has(vm.options, 'datasource') && !lodash.get(vm.options, 'datasource.limited', false)) {
                    loadRemoteData(optionsPath, dsPath);
                } else {
                    if (lodash.has(vm.options, 'data')) {
                        vm.ds = vm.options.data;
                    }
                }

                if (lodash.has(vm.options, 'datasource') && lodash.get(vm.options, 'datasource.limited', false)) {
                    var prevQuery = '';
                    vm.ds = lodash.get(vm.options, 'data', []);

                    var loadFunc = function(query, callback) {
                        if (typeof query === typeof "string") {
                            if (prevQuery === query)
                                return;
                            prevQuery = query;
                            query = {search: query};
                        } else {
                            return;
                        }

                        query.applied_filter = vm.filterValueModel;

                        var datasource = vm.options.datasource;
                        var model = new GenericModel(datasource.url);
                        var method = lodash.get(vm.options.datasource, 'method', 'get');
                        var params = angular.extend(lodash.get(datasource, 'params', {}), query || {});
                        var request = (method === 'get') ? model[method](params) : model[method]({}, {data:params});

                        return request.$promise.then(function(res) { //res
                            if (res.success && res.status_code == 200) {
                                var data = lodash.get(res, 'data', [])
                                vm.options.data = (vm.options.data || []).concat(
                                    lodash.filter(data, function(_data) {
                                        var value = lodash.get(_data, 'value')
                                        return lodash.findIndex(vm.options.data, { value: value }) < 0;
                                    })
                                );
                                vm.ds = vm.options.data;
                                callback(vm.ds);
                                return;
                            } else {
                                console.warn('Calling ' + vm.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                                return callback([]);
                            }
                        }, function(res) {
                            console.warn('Calling ' + vm.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                            console.warn(res); // eslint-disable-line no-console
                            return callback([]);
                        });
                    };
                    var loadDebounceFunc = lodash.debounce(loadFunc, 300);
                    vm.additionalOptions.load = loadDebounceFunc;
                    vm.additionalOptions.onInitialize = function(selectize) {
                        vm.selectize = selectize;
                        $timeout(function() {
                            selectize.onSearchChange({});
                        });

                    }
                    // vm.additionalOptions.maxOptions = 10;

                    $scope.$watch(
                        function() { return vm.filterValueModel; },
                        function(newValue, oldValue) {
                            loadDebounceFunc(newValue, function() {});
                        });
                }


                vm.config = angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        plugins: ['remove_button'],
                        searchField: ['label'],
                    },
                    vm.additionalOptions,
                    vm.options.selectize || {}
                );
            }
        }

        function additionalOptionsOnInitialize(selectizePath) {
            return function(selectize) {
                lodash.set(vm, selectizePath, selectize)
                $timeout(function () {
                    selectize.onSearchChange({});
                });
            }
        }

        function additionalOptionsLoad(optionsPath, filterValueModelPath) {
            return function (query, callback) {
                if (typeof query === typeof "string") {
                    query = { search: query };
                }
                lodash.set(query, 'applied_filter', lodash.get(vm, filterValueModelPath));

                var datasource = lodash.get(vm, [optionsPath, 'datasource'].join('.'));
                var model = new GenericModel(lodash.get(datasource, 'url'));
                var method = lodash.get(datasource, 'method', 'get')

                var params = angular.extend(lodash.get(datasource, 'params', {}), query || {});
                var request = (method === 'get') ? model[method](params) : model[method]({}, { data: params });

                return request.$promise.then(function (res) {
                    if (res.success && res.status_code == 200) { //res
                        return callback(res.data);
                    }
                    else {
                        console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        return callback([]);
                    }
                }, function (res) {
                    console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    console.warn(res); // eslint-disable-line no-console
                    return callback([]);
                });
            }
        }

        function loadRemoteData(optionsPath, dsPath, isLoadingPath, subFilterKey) {
            if (lodash.has(vm, optionsPath, 'datasource.url')) {
                 lodash.set(vm, isLoadingPath, true);

                var callRemoteApiPromise = callRemoteApi(optionsPath);
                callRemoteApiPromise.then(function (res) {
                    if ($filter('isMultipleEnumType')(vm.type)) {
                        lodash.setWith(vm, dsPath, res, Object);

                        var _subSetting = lodash.get(vm, ['subSettings', subFilterKey].join('.'), {});
                        var isAutoFirst = lodash.get(_subSetting, 'auto_first');
                        if (isAutoFirst) {
                            var firstItem = lodash.first(res);
                            var firstItemValue = lodash.get(firstItem, 'value');
                            lodash.setWith(vm, ['filterValueModel', subFilterKey].join('.'), firstItemValue, Object);
                        }
                    } else {
                        lodash.set(vm, dsPath, res);
                    }
                    // Fix ENUM REMOTE
                    lodash.set(vm, [optionsPath, 'data'].join('.'), lodash.get(vm, dsPath));
                    lodash.set(vm, isLoadingPath, false);
                });
            }
        }

        function callRemoteApi(optionsPath) {
            var datasource = lodash.get(vm, [optionsPath, 'datasource'].join('.'));

            var model = new GenericModel(lodash.get(datasource, 'url'));
            var method = lodash.get(datasource, 'method', 'get');

            // var data = {};
            // if (!lodash.get(options, 'data.datasource.limited', false)) {
            //
            // }

            return model[method]({}, {})
                .$promise.then(
                    function (res) { //res
                        if (res.success && res.status_code == 200) {
                            return res.data;
                        } else {
                            console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                            return null;
                        }
                    }, function (res) {
                        console.warn('Calling ' + lodash.get(datasource, 'url') + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                        console.warn(res); // eslint-disable-line no-console
                        return null;
                    }
                );
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('numberFilterValue', numberFilterValue);

    function numberFilterValue() {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '='
            },
            controller: numberFilterValueCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/number',
            link: numberFilterValueLink
        };

        function numberFilterValueLink(scope, elem) {

            elem.on('focus', 'input[type=number]', function () {
                angular.element(this).on('mousewheel.disableScroll', function (e) {
                    e.preventDefault();
                });
            });
            elem.on('blur', 'input[type=number]', function () {
                elem.find('input[type=number]').off('mousewheel.disableScroll');
            });

            scope.$on('$destroy', function() {
               elem.off('blur');
               elem.off('focus');
            });
        }
    }

    function numberFilterValueCtrl() {
    }
})();
(function () {
    'use strict';

    filterValueOptionCtrl.$inject = ['$element', '$compile', '$scope', 'FILTER_OPERATOR_CONSTANT'];
    angular
        .module('rms.common')
        .directive('filterValueOption', filterValueOption);

    function filterValueOption() {
        return {
            restrict: 'EA',
            scope: {
                filter: '=',
                option: '=',
                settingsOverride: '=?'
            },
            controller: filterValueOptionCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/components/filter-values-type/option'
        };
    }

    function filterValueOptionCtrl($element, $compile, $scope, FILTER_OPERATOR_CONSTANT) {
        var vm = this,
            elem = null,
            compiledParent = null;

        this.$onInit = function() {
            compiledParent = $element.find('.filter-value-option-content');
            vm.isActive = isActive;

            init();
        }

        function init() {
            //ng-if="vm.option.selected && (['exists','not_exists].indexOf(vm.option.value) !== true)
            var html = '';
            switch (vm.option.operator) {
                case FILTER_OPERATOR_CONSTANT.BETWEEN:
                case FILTER_OPERATOR_CONSTANT.RANGE:
                    html += '<' + vm.filter.type + '-filter-value filter-value-model="vm.option.value.lower" settings-override="vm.settingsOverride"></' + vm.filter.type + '-filter-value>' +
                        '<div>to</div>' +
                        '<' + vm.filter.type + '-filter-value filter-value-model="vm.option.value.upper" settings-override="vm.settingsOverride"></' + vm.filter.type + '-filter-value>';
                    break;
                case FILTER_OPERATOR_CONSTANT.EXISTS:
                case FILTER_OPERATOR_CONSTANT.NOT_EXISTS:
                    break;
                case FILTER_OPERATOR_CONSTANT.IS:
                    vm.option.value_label = '';
                    html += '<enum-filter-value ng-show="vm.isActive()" filter-value-model="vm.option.value" filter-value-label="vm.option.value_label" options="vm.option.options"  type="vm.filter.type" settings-override="vm.settingsOverride" sub-settings="vm.filter.settings.sub_settings"></enum-filter-value>';
                    break;
                case FILTER_OPERATOR_CONSTANT.IN:
                case FILTER_OPERATOR_CONSTANT.NOT_IN:
                case FILTER_OPERATOR_CONSTANT.IN_ALL:
                case FILTER_OPERATOR_CONSTANT.NOT_IN_ALL:
                    html += '<enum-filter-value ng-show="vm.isActive()" filter-value-model="vm.option.value" options="vm.filter.options" type="vm.filter.type" settings-override="vm.settingsOverride" sub-settings="vm.filter.settings.sub_settings"></enum-filter-value>';
                    break;
                default:
                    html += '<' + vm.filter.type + '-filter-value ng-show="vm.isActive()" filter-value-model="vm.option.value" settings-override="vm.settingsOverride"></' + vm.filter.type + '-filter-value>';
                    break;
            }

            if (html.length > 0) {
                html = '<div class="filter-input" ng-show="vm.isActive()">' + html + '</div>';
            }

            compiledParent.html(html);
            $compile($element.contents())($scope);

            $scope.$on('$destroy', function () {
                if (elem) {
                    elem.off();
                }
            });
        }

        function isActive() {
            if (!vm.filter || !vm.option) {
                return false;
            }
            return vm.option.operator == vm.filter.operator;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('stringFilterValue', stringFilterValue);

    function stringFilterValue() {
        return {
            restrict: 'EA',
            scope: {
                filterValueModel: '='
            },
            controller: stringFilterValueCtrl,
            controllerAs: 'vm',
            bindToController:true,
            templateUrl: 'common/components/filter-values-type/string'
        };
    }

    function stringFilterValueCtrl() {

    }
})();